export const Municipios = [
  {
    codigo: "5200050",
    municipio: "Abadia de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3100104",
    municipio: "Abadia dos Dourados",
    estado_codigo: "31",
  },
  {
    codigo: "5200100",
    municipio: "Abadiânia",
    estado_codigo: "52",
  },
  {
    codigo: "3100203",
    municipio: "Abaeté",
    estado_codigo: "31",
  },
  {
    codigo: "1500107",
    municipio: "Abaetetuba",
    estado_codigo: "15",
  },
  {
    codigo: "2300101",
    municipio: "Abaiara",
    estado_codigo: "23",
  },
  {
    codigo: "2900108",
    municipio: "Abaíra",
    estado_codigo: "29",
  },
  {
    codigo: "2900207",
    municipio: "Abaré",
    estado_codigo: "29",
  },
  {
    codigo: "4100103",
    municipio: "Abatiá",
    estado_codigo: "41",
  },
  {
    codigo: "4200051",
    municipio: "Abdon Batista",
    estado_codigo: "42",
  },
  {
    codigo: "4200101",
    municipio: "Abelardo Luz",
    estado_codigo: "42",
  },
  {
    codigo: "1500131",
    municipio: "Abel Figueiredo",
    estado_codigo: "15",
  },
  {
    codigo: "3100302",
    municipio: "Abre Campo",
    estado_codigo: "31",
  },
  {
    codigo: "2600054",
    municipio: "Abreu e Lima",
    estado_codigo: "26",
  },
  {
    codigo: "1700251",
    municipio: "Abreulândia",
    estado_codigo: "17",
  },
  {
    codigo: "3100401",
    municipio: "Acaiaca",
    estado_codigo: "31",
  },
  {
    codigo: "2100055",
    municipio: "Açailândia",
    estado_codigo: "21",
  },
  {
    codigo: "2900306",
    municipio: "Acajutiba",
    estado_codigo: "29",
  },
  {
    codigo: "1500206",
    municipio: "Acará",
    estado_codigo: "15",
  },
  {
    codigo: "2300150",
    municipio: "Acarape",
    estado_codigo: "23",
  },
  {
    codigo: "2300200",
    municipio: "Acaraú",
    estado_codigo: "23",
  },
  {
    codigo: "2400109",
    municipio: "Acari",
    estado_codigo: "24",
  },
  {
    codigo: "2200053",
    municipio: "Acauã",
    estado_codigo: "22",
  },
  {
    codigo: "4300034",
    municipio: "Aceguá",
    estado_codigo: "43",
  },
  {
    codigo: "2300309",
    municipio: "Acopiara",
    estado_codigo: "23",
  },
  {
    codigo: "5100102",
    municipio: "Acorizal",
    estado_codigo: "51",
  },
  {
    codigo: "1200013",
    municipio: "Acrelândia",
    estado_codigo: "12",
  },
  {
    codigo: "5200134",
    municipio: "Acreúna",
    estado_codigo: "52",
  },
  {
    codigo: "2400208",
    municipio: "Açu",
    estado_codigo: "24",
  },
  {
    codigo: "3100500",
    municipio: "Açucena",
    estado_codigo: "31",
  },
  {
    codigo: "3500105",
    municipio: "Adamantina",
    estado_codigo: "35",
  },
  {
    codigo: "5200159",
    municipio: "Adelândia",
    estado_codigo: "52",
  },
  {
    codigo: "3500204",
    municipio: "Adolfo",
    estado_codigo: "35",
  },
  {
    codigo: "4100202",
    municipio: "Adrianópolis",
    estado_codigo: "41",
  },
  {
    codigo: "2900355",
    municipio: "Adustina",
    estado_codigo: "29",
  },
  {
    codigo: "2600104",
    municipio: "Afogados da Ingazeira",
    estado_codigo: "26",
  },
  {
    codigo: "2400307",
    municipio: "Afonso Bezerra",
    estado_codigo: "24",
  },
  {
    codigo: "3200102",
    municipio: "Afonso Cláudio",
    estado_codigo: "32",
  },
  {
    codigo: "2100105",
    municipio: "Afonso Cunha",
    estado_codigo: "21",
  },
  {
    codigo: "2600203",
    municipio: "Afrânio",
    estado_codigo: "26",
  },
  {
    codigo: "1500305",
    municipio: "Afuá",
    estado_codigo: "15",
  },
  {
    codigo: "2600302",
    municipio: "Agrestina",
    estado_codigo: "26",
  },
  {
    codigo: "2200103",
    municipio: "Agricolândia",
    estado_codigo: "22",
  },
  {
    codigo: "4200200",
    municipio: "Agrolândia",
    estado_codigo: "42",
  },
  {
    codigo: "4200309",
    municipio: "Agronômica",
    estado_codigo: "42",
  },
  {
    codigo: "1500347",
    municipio: "Água Azul do Norte",
    estado_codigo: "15",
  },
  {
    codigo: "5100201",
    municipio: "Água Boa",
    estado_codigo: "51",
  },
  {
    codigo: "3100609",
    municipio: "Água Boa",
    estado_codigo: "31",
  },
  {
    codigo: "2700102",
    municipio: "Água Branca",
    estado_codigo: "27",
  },
  {
    codigo: "2500106",
    municipio: "Água Branca",
    estado_codigo: "25",
  },
  {
    codigo: "2200202",
    municipio: "Água Branca",
    estado_codigo: "22",
  },
  {
    codigo: "5000203",
    municipio: "Água Clara",
    estado_codigo: "50",
  },
  {
    codigo: "3100708",
    municipio: "Água Comprida",
    estado_codigo: "31",
  },
  {
    codigo: "4200408",
    municipio: "Água Doce",
    estado_codigo: "42",
  },
  {
    codigo: "2100154",
    municipio: "Água Doce do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "3200169",
    municipio: "Água Doce do Norte",
    estado_codigo: "32",
  },
  {
    codigo: "2900405",
    municipio: "Água Fria",
    estado_codigo: "29",
  },
  {
    codigo: "5200175",
    municipio: "Água Fria de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3500303",
    municipio: "Aguaí",
    estado_codigo: "35",
  },
  {
    codigo: "5200209",
    municipio: "Água Limpa",
    estado_codigo: "52",
  },
  {
    codigo: "3100807",
    municipio: "Aguanil",
    estado_codigo: "31",
  },
  {
    codigo: "2400406",
    municipio: "Água Nova",
    estado_codigo: "24",
  },
  {
    codigo: "2600401",
    municipio: "Água Preta",
    estado_codigo: "26",
  },
  {
    codigo: "4300059",
    municipio: "Água Santa",
    estado_codigo: "43",
  },
  {
    codigo: "2600500",
    municipio: "Águas Belas",
    estado_codigo: "26",
  },
  {
    codigo: "3500402",
    municipio: "Águas da Prata",
    estado_codigo: "35",
  },
  {
    codigo: "4200507",
    municipio: "Águas de Chapecó",
    estado_codigo: "42",
  },
  {
    codigo: "3500501",
    municipio: "Águas de Lindóia",
    estado_codigo: "35",
  },
  {
    codigo: "3500550",
    municipio: "Águas de Santa Bárbara",
    estado_codigo: "35",
  },
  {
    codigo: "3500600",
    municipio: "Águas de São Pedro",
    estado_codigo: "35",
  },
  {
    codigo: "3100906",
    municipio: "Águas Formosas",
    estado_codigo: "31",
  },
  {
    codigo: "4200556",
    municipio: "Águas Frias",
    estado_codigo: "42",
  },
  {
    codigo: "5200258",
    municipio: "Águas Lindas de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "4200606",
    municipio: "Águas Mornas",
    estado_codigo: "42",
  },
  {
    codigo: "3101003",
    municipio: "Águas Vermelhas",
    estado_codigo: "31",
  },
  {
    codigo: "4300109",
    municipio: "Agudo",
    estado_codigo: "43",
  },
  {
    codigo: "3500709",
    municipio: "Agudos",
    estado_codigo: "35",
  },
  {
    codigo: "4100301",
    municipio: "Agudos do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "3200136",
    municipio: "Águia Branca",
    estado_codigo: "32",
  },
  {
    codigo: "2500205",
    municipio: "Aguiar",
    estado_codigo: "25",
  },
  {
    codigo: "1700301",
    municipio: "Aguiarnópolis",
    estado_codigo: "17",
  },
  {
    codigo: "3101102",
    municipio: "Aimorés",
    estado_codigo: "31",
  },
  {
    codigo: "2900603",
    municipio: "Aiquara",
    estado_codigo: "29",
  },
  {
    codigo: "2300408",
    municipio: "Aiuaba",
    estado_codigo: "23",
  },
  {
    codigo: "3101201",
    municipio: "Aiuruoca",
    estado_codigo: "31",
  },
  {
    codigo: "4300208",
    municipio: "Ajuricaba",
    estado_codigo: "43",
  },
  {
    codigo: "3101300",
    municipio: "Alagoa",
    estado_codigo: "31",
  },
  {
    codigo: "2500304",
    municipio: "Alagoa Grande",
    estado_codigo: "25",
  },
  {
    codigo: "2500403",
    municipio: "Alagoa Nova",
    estado_codigo: "25",
  },
  {
    codigo: "2600609",
    municipio: "Alagoinha",
    estado_codigo: "26",
  },
  {
    codigo: "2500502",
    municipio: "Alagoinha",
    estado_codigo: "25",
  },
  {
    codigo: "2200251",
    municipio: "Alagoinha do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2900702",
    municipio: "Alagoinhas",
    estado_codigo: "29",
  },
  {
    codigo: "3500758",
    municipio: "Alambari",
    estado_codigo: "35",
  },
  {
    codigo: "3101409",
    municipio: "Albertina",
    estado_codigo: "31",
  },
  {
    codigo: "2100204",
    municipio: "Alcântara",
    estado_codigo: "21",
  },
  {
    codigo: "2300507",
    municipio: "Alcântaras",
    estado_codigo: "23",
  },
  {
    codigo: "2500536",
    municipio: "Alcantil",
    estado_codigo: "25",
  },
  {
    codigo: "5000252",
    municipio: "Alcinópolis",
    estado_codigo: "50",
  },
  {
    codigo: "2900801",
    municipio: "Alcobaça",
    estado_codigo: "29",
  },
  {
    codigo: "2100303",
    municipio: "Aldeias Altas",
    estado_codigo: "21",
  },
  {
    codigo: "4300307",
    municipio: "Alecrim",
    estado_codigo: "43",
  },
  {
    codigo: "3200201",
    municipio: "Alegre",
    estado_codigo: "32",
  },
  {
    codigo: "4300406",
    municipio: "Alegrete",
    estado_codigo: "43",
  },
  {
    codigo: "2200277",
    municipio: "Alegrete do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4300455",
    municipio: "Alegria",
    estado_codigo: "43",
  },
  {
    codigo: "3101508",
    municipio: "Além Paraíba",
    estado_codigo: "31",
  },
  {
    codigo: "1500404",
    municipio: "Alenquer",
    estado_codigo: "15",
  },
  {
    codigo: "2400505",
    municipio: "Alexandria",
    estado_codigo: "24",
  },
  {
    codigo: "5200308",
    municipio: "Alexânia",
    estado_codigo: "52",
  },
  {
    codigo: "3101607",
    municipio: "Alfenas",
    estado_codigo: "31",
  },
  {
    codigo: "3200300",
    municipio: "Alfredo Chaves",
    estado_codigo: "32",
  },
  {
    codigo: "3500808",
    municipio: "Alfredo Marcondes",
    estado_codigo: "35",
  },
  {
    codigo: "3101631",
    municipio: "Alfredo Vasconcelos",
    estado_codigo: "31",
  },
  {
    codigo: "4200705",
    municipio: "Alfredo Wagner",
    estado_codigo: "42",
  },
  {
    codigo: "2500577",
    municipio: "Algodão de Jandaíra",
    estado_codigo: "25",
  },
  {
    codigo: "2500601",
    municipio: "Alhandra",
    estado_codigo: "25",
  },
  {
    codigo: "2600708",
    municipio: "Aliança",
    estado_codigo: "26",
  },
  {
    codigo: "1700350",
    municipio: "Aliança do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2900900",
    municipio: "Almadina",
    estado_codigo: "29",
  },
  {
    codigo: "1700400",
    municipio: "Almas",
    estado_codigo: "17",
  },
  {
    codigo: "1500503",
    municipio: "Almeirim",
    estado_codigo: "15",
  },
  {
    codigo: "3101706",
    municipio: "Almenara",
    estado_codigo: "31",
  },
  {
    codigo: "2400604",
    municipio: "Almino Afonso",
    estado_codigo: "24",
  },
  {
    codigo: "4100400",
    municipio: "Almirante Tamandaré",
    estado_codigo: "41",
  },
  {
    codigo: "4300471",
    municipio: "Almirante Tamandaré do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "5200506",
    municipio: "Aloândia",
    estado_codigo: "52",
  },
  {
    codigo: "3101805",
    municipio: "Alpercata",
    estado_codigo: "31",
  },
  {
    codigo: "4300505",
    municipio: "Alpestre",
    estado_codigo: "43",
  },
  {
    codigo: "3101904",
    municipio: "Alpinópolis",
    estado_codigo: "31",
  },
  {
    codigo: "5100250",
    municipio: "Alta Floresta",
    estado_codigo: "51",
  },
  {
    codigo: "1100015",
    municipio: "Alta Floresta D'Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "3500907",
    municipio: "Altair",
    estado_codigo: "35",
  },
  {
    codigo: "1500602",
    municipio: "Altamira",
    estado_codigo: "15",
  },
  {
    codigo: "2100402",
    municipio: "Altamira do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "4100459",
    municipio: "Altamira do Paraná",
    estado_codigo: "41",
  },
  {
    codigo: "2300606",
    municipio: "Altaneira",
    estado_codigo: "23",
  },
  {
    codigo: "3102001",
    municipio: "Alterosa",
    estado_codigo: "31",
  },
  {
    codigo: "2600807",
    municipio: "Altinho",
    estado_codigo: "26",
  },
  {
    codigo: "3501004",
    municipio: "Altinópolis",
    estado_codigo: "35",
  },
  {
    codigo: "1400050",
    municipio: "Alto Alegre",
    estado_codigo: "14",
  },
  {
    codigo: "3501103",
    municipio: "Alto Alegre",
    estado_codigo: "35",
  },
  {
    codigo: "4300554",
    municipio: "Alto Alegre",
    estado_codigo: "43",
  },
  {
    codigo: "2100436",
    municipio: "Alto Alegre do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "2100477",
    municipio: "Alto Alegre do Pindaré",
    estado_codigo: "21",
  },
  {
    codigo: "1100379",
    municipio: "Alto Alegre dos Parecis",
    estado_codigo: "11",
  },
  {
    codigo: "5100300",
    municipio: "Alto Araguaia",
    estado_codigo: "51",
  },
  {
    codigo: "4200754",
    municipio: "Alto Bela Vista",
    estado_codigo: "42",
  },
  {
    codigo: "5100359",
    municipio: "Alto Boa Vista",
    estado_codigo: "51",
  },
  {
    codigo: "3102050",
    municipio: "Alto Caparaó",
    estado_codigo: "31",
  },
  {
    codigo: "2400703",
    municipio: "Alto do Rodrigues",
    estado_codigo: "24",
  },
  {
    codigo: "4300570",
    municipio: "Alto Feliz",
    estado_codigo: "43",
  },
  {
    codigo: "5100409",
    municipio: "Alto Garças",
    estado_codigo: "51",
  },
  {
    codigo: "5200555",
    municipio: "Alto Horizonte",
    estado_codigo: "52",
  },
  {
    codigo: "3153509",
    municipio: "Alto Jequitibá",
    estado_codigo: "31",
  },
  {
    codigo: "2200301",
    municipio: "Alto Longá",
    estado_codigo: "22",
  },
  {
    codigo: "4100509",
    municipio: "Altônia",
    estado_codigo: "41",
  },
  {
    codigo: "5100508",
    municipio: "Alto Paraguai",
    estado_codigo: "51",
  },
  {
    codigo: "4128625",
    municipio: "Alto Paraíso",
    estado_codigo: "41",
  },
  {
    codigo: "1100403",
    municipio: "Alto Paraíso",
    estado_codigo: "11",
  },
  {
    codigo: "5200605",
    municipio: "Alto Paraíso de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "4100608",
    municipio: "Alto Paraná",
    estado_codigo: "41",
  },
  {
    codigo: "2100501",
    municipio: "Alto Parnaíba",
    estado_codigo: "21",
  },
  {
    codigo: "4100707",
    municipio: "Alto Piquiri",
    estado_codigo: "41",
  },
  {
    codigo: "3102100",
    municipio: "Alto Rio Doce",
    estado_codigo: "31",
  },
  {
    codigo: "3200359",
    municipio: "Alto Rio Novo",
    estado_codigo: "32",
  },
  {
    codigo: "2200400",
    municipio: "Altos",
    estado_codigo: "22",
  },
  {
    codigo: "2300705",
    municipio: "Alto Santo",
    estado_codigo: "23",
  },
  {
    codigo: "5100607",
    municipio: "Alto Taquari",
    estado_codigo: "51",
  },
  {
    codigo: "3501152",
    municipio: "Alumínio",
    estado_codigo: "35",
  },
  {
    codigo: "1300029",
    municipio: "Alvarães",
    estado_codigo: "13",
  },
  {
    codigo: "3102209",
    municipio: "Alvarenga",
    estado_codigo: "31",
  },
  {
    codigo: "3501202",
    municipio: "Álvares Florence",
    estado_codigo: "35",
  },
  {
    codigo: "3501301",
    municipio: "Álvares Machado",
    estado_codigo: "35",
  },
  {
    codigo: "3501400",
    municipio: "Álvaro de Carvalho",
    estado_codigo: "35",
  },
  {
    codigo: "3501509",
    municipio: "Alvinlândia",
    estado_codigo: "35",
  },
  {
    codigo: "3102308",
    municipio: "Alvinópolis",
    estado_codigo: "31",
  },
  {
    codigo: "4300604",
    municipio: "Alvorada",
    estado_codigo: "43",
  },
  {
    codigo: "1700707",
    municipio: "Alvorada",
    estado_codigo: "17",
  },
  {
    codigo: "3102407",
    municipio: "Alvorada de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "1100346",
    municipio: "Alvorada D'Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "2200459",
    municipio: "Alvorada do Gurguéia",
    estado_codigo: "22",
  },
  {
    codigo: "5200803",
    municipio: "Alvorada do Norte",
    estado_codigo: "52",
  },
  {
    codigo: "4100806",
    municipio: "Alvorada do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "1400027",
    municipio: "Amajari",
    estado_codigo: "14",
  },
  {
    codigo: "5000609",
    municipio: "Amambaí",
    estado_codigo: "50",
  },
  {
    codigo: "1600105",
    municipio: "Amapá",
    estado_codigo: "16",
  },
  {
    codigo: "2100550",
    municipio: "Amapá do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "4100905",
    municipio: "Amaporã",
    estado_codigo: "41",
  },
  {
    codigo: "2600906",
    municipio: "Amaraji",
    estado_codigo: "26",
  },
  {
    codigo: "4300638",
    municipio: "Amaral Ferrador",
    estado_codigo: "43",
  },
  {
    codigo: "5200829",
    municipio: "Amaralina",
    estado_codigo: "52",
  },
  {
    codigo: "2200509",
    municipio: "Amarante",
    estado_codigo: "22",
  },
  {
    codigo: "2100600",
    municipio: "Amarante do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "2901007",
    municipio: "Amargosa",
    estado_codigo: "29",
  },
  {
    codigo: "1300060",
    municipio: "Amaturá",
    estado_codigo: "13",
  },
  {
    codigo: "2901106",
    municipio: "Amélia Rodrigues",
    estado_codigo: "29",
  },
  {
    codigo: "2901155",
    municipio: "América Dourada",
    estado_codigo: "29",
  },
  {
    codigo: "3501608",
    municipio: "Americana",
    estado_codigo: "35",
  },
  {
    codigo: "5200852",
    municipio: "Americano do Brasil",
    estado_codigo: "52",
  },
  {
    codigo: "3501707",
    municipio: "Américo Brasiliense",
    estado_codigo: "35",
  },
  {
    codigo: "3501806",
    municipio: "Américo de Campos",
    estado_codigo: "35",
  },
  {
    codigo: "4300646",
    municipio: "Ametista do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2300754",
    municipio: "Amontada",
    estado_codigo: "23",
  },
  {
    codigo: "5200902",
    municipio: "Amorinópolis",
    estado_codigo: "52",
  },
  {
    codigo: "3501905",
    municipio: "Amparo",
    estado_codigo: "35",
  },
  {
    codigo: "2500734",
    municipio: "Amparo",
    estado_codigo: "25",
  },
  {
    codigo: "2800100",
    municipio: "Amparo de São Francisco",
    estado_codigo: "28",
  },
  {
    codigo: "3102506",
    municipio: "Amparo do Serra",
    estado_codigo: "31",
  },
  {
    codigo: "4101002",
    municipio: "Ampére",
    estado_codigo: "41",
  },
  {
    codigo: "2700201",
    municipio: "Anadia",
    estado_codigo: "27",
  },
  {
    codigo: "2901205",
    municipio: "Anagé",
    estado_codigo: "29",
  },
  {
    codigo: "4101051",
    municipio: "Anahy",
    estado_codigo: "41",
  },
  {
    codigo: "1500701",
    municipio: "Anajás",
    estado_codigo: "15",
  },
  {
    codigo: "2100709",
    municipio: "Anajatuba",
    estado_codigo: "21",
  },
  {
    codigo: "3502002",
    municipio: "Analândia",
    estado_codigo: "35",
  },
  {
    codigo: "1300086",
    municipio: "Anamã",
    estado_codigo: "13",
  },
  {
    codigo: "1701002",
    municipio: "Ananás",
    estado_codigo: "17",
  },
  {
    codigo: "1500800",
    municipio: "Ananindeua",
    estado_codigo: "15",
  },
  {
    codigo: "5201108",
    municipio: "Anápolis",
    estado_codigo: "52",
  },
  {
    codigo: "1500859",
    municipio: "Anapu",
    estado_codigo: "15",
  },
  {
    codigo: "2100808",
    municipio: "Anapurus",
    estado_codigo: "21",
  },
  {
    codigo: "5000708",
    municipio: "Anastácio",
    estado_codigo: "50",
  },
  {
    codigo: "5000807",
    municipio: "Anaurilândia",
    estado_codigo: "50",
  },
  {
    codigo: "3200409",
    municipio: "Anchieta",
    estado_codigo: "32",
  },
  {
    codigo: "4200804",
    municipio: "Anchieta",
    estado_codigo: "42",
  },
  {
    codigo: "2901304",
    municipio: "Andaraí",
    estado_codigo: "29",
  },
  {
    codigo: "4101101",
    municipio: "Andirá",
    estado_codigo: "41",
  },
  {
    codigo: "2901353",
    municipio: "Andorinha",
    estado_codigo: "29",
  },
  {
    codigo: "3102605",
    municipio: "Andradas",
    estado_codigo: "31",
  },
  {
    codigo: "3502101",
    municipio: "Andradina",
    estado_codigo: "35",
  },
  {
    codigo: "4300661",
    municipio: "André da Rocha",
    estado_codigo: "43",
  },
  {
    codigo: "3102803",
    municipio: "Andrelândia",
    estado_codigo: "31",
  },
  {
    codigo: "3502200",
    municipio: "Angatuba",
    estado_codigo: "35",
  },
  {
    codigo: "3102852",
    municipio: "Angelândia",
    estado_codigo: "31",
  },
  {
    codigo: "5000856",
    municipio: "Angélica",
    estado_codigo: "50",
  },
  {
    codigo: "2601003",
    municipio: "Angelim",
    estado_codigo: "26",
  },
  {
    codigo: "4200903",
    municipio: "Angelina",
    estado_codigo: "42",
  },
  {
    codigo: "2901403",
    municipio: "Angical",
    estado_codigo: "29",
  },
  {
    codigo: "2200608",
    municipio: "Angical do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "1701051",
    municipio: "Angico",
    estado_codigo: "17",
  },
  {
    codigo: "2400802",
    municipio: "Angicos",
    estado_codigo: "24",
  },
  {
    codigo: "3300100",
    municipio: "Angra dos Reis",
    estado_codigo: "33",
  },
  {
    codigo: "2901502",
    municipio: "Anguera",
    estado_codigo: "29",
  },
  {
    codigo: "4101150",
    municipio: "Ângulo",
    estado_codigo: "41",
  },
  {
    codigo: "5201207",
    municipio: "Anhanguera",
    estado_codigo: "52",
  },
  {
    codigo: "3502309",
    municipio: "Anhembi",
    estado_codigo: "35",
  },
  {
    codigo: "3502408",
    municipio: "Anhumas",
    estado_codigo: "35",
  },
  {
    codigo: "5201306",
    municipio: "Anicuns",
    estado_codigo: "52",
  },
  {
    codigo: "2200707",
    municipio: "Anísio de Abreu",
    estado_codigo: "22",
  },
  {
    codigo: "4201000",
    municipio: "Anita Garibaldi",
    estado_codigo: "42",
  },
  {
    codigo: "4201109",
    municipio: "Anitápolis",
    estado_codigo: "42",
  },
  {
    codigo: "1300102",
    municipio: "Anori",
    estado_codigo: "13",
  },
  {
    codigo: "4300703",
    municipio: "Anta Gorda",
    estado_codigo: "43",
  },
  {
    codigo: "2901601",
    municipio: "Antas",
    estado_codigo: "29",
  },
  {
    codigo: "4101200",
    municipio: "Antonina",
    estado_codigo: "41",
  },
  {
    codigo: "2300804",
    municipio: "Antonina do Norte",
    estado_codigo: "23",
  },
  {
    codigo: "2200806",
    municipio: "Antônio Almeida",
    estado_codigo: "22",
  },
  {
    codigo: "2901700",
    municipio: "Antônio Cardoso",
    estado_codigo: "29",
  },
  {
    codigo: "4201208",
    municipio: "Antônio Carlos",
    estado_codigo: "42",
  },
  {
    codigo: "3102902",
    municipio: "Antônio Carlos",
    estado_codigo: "31",
  },
  {
    codigo: "3103009",
    municipio: "Antônio Dias",
    estado_codigo: "31",
  },
  {
    codigo: "2901809",
    municipio: "Antônio Gonçalves",
    estado_codigo: "29",
  },
  {
    codigo: "5000906",
    municipio: "Antônio João",
    estado_codigo: "50",
  },
  {
    codigo: "2400901",
    municipio: "Antônio Martins",
    estado_codigo: "24",
  },
  {
    codigo: "4101309",
    municipio: "Antônio Olinto",
    estado_codigo: "41",
  },
  {
    codigo: "4300802",
    municipio: "Antônio Prado",
    estado_codigo: "43",
  },
  {
    codigo: "3103108",
    municipio: "Antônio Prado de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2500775",
    municipio: "Aparecida",
    estado_codigo: "25",
  },
  {
    codigo: "3502507",
    municipio: "Aparecida",
    estado_codigo: "35",
  },
  {
    codigo: "5201405",
    municipio: "Aparecida de Goiânia",
    estado_codigo: "52",
  },
  {
    codigo: "3502606",
    municipio: "Aparecida d'Oeste",
    estado_codigo: "35",
  },
  {
    codigo: "5201454",
    municipio: "Aparecida do Rio Doce",
    estado_codigo: "52",
  },
  {
    codigo: "1701101",
    municipio: "Aparecida do Rio Negro",
    estado_codigo: "17",
  },
  {
    codigo: "5001003",
    municipio: "Aparecida do Taboado",
    estado_codigo: "50",
  },
  {
    codigo: "3300159",
    municipio: "Aperibé",
    estado_codigo: "33",
  },
  {
    codigo: "3200508",
    municipio: "Apiacá",
    estado_codigo: "32",
  },
  {
    codigo: "5100805",
    municipio: "Apiacás",
    estado_codigo: "51",
  },
  {
    codigo: "3502705",
    municipio: "Apiaí",
    estado_codigo: "35",
  },
  {
    codigo: "2100832",
    municipio: "Apicum-Açu",
    estado_codigo: "21",
  },
  {
    codigo: "4201257",
    municipio: "Apiúna",
    estado_codigo: "42",
  },
  {
    codigo: "2401008",
    municipio: "Apodi",
    estado_codigo: "24",
  },
  {
    codigo: "2901908",
    municipio: "Aporá",
    estado_codigo: "29",
  },
  {
    codigo: "5201504",
    municipio: "Aporé",
    estado_codigo: "52",
  },
  {
    codigo: "2901957",
    municipio: "Apuarema",
    estado_codigo: "29",
  },
  {
    codigo: "4101408",
    municipio: "Apucarana",
    estado_codigo: "41",
  },
  {
    codigo: "1300144",
    municipio: "Apuí",
    estado_codigo: "13",
  },
  {
    codigo: "2300903",
    municipio: "Apuiarés",
    estado_codigo: "23",
  },
  {
    codigo: "2800209",
    municipio: "Aquidabã",
    estado_codigo: "28",
  },
  {
    codigo: "5001102",
    municipio: "Aquidauana",
    estado_codigo: "50",
  },
  {
    codigo: "2301000",
    municipio: "Aquiraz",
    estado_codigo: "23",
  },
  {
    codigo: "4201273",
    municipio: "Arabutã",
    estado_codigo: "42",
  },
  {
    codigo: "2500809",
    municipio: "Araçagi",
    estado_codigo: "25",
  },
  {
    codigo: "3103207",
    municipio: "Araçaí",
    estado_codigo: "31",
  },
  {
    codigo: "2800308",
    municipio: "Aracaju",
    estado_codigo: "28",
  },
  {
    codigo: "3502754",
    municipio: "Araçariguama",
    estado_codigo: "35",
  },
  {
    codigo: "2902054",
    municipio: "Araças",
    estado_codigo: "29",
  },
  {
    codigo: "2301109",
    municipio: "Aracati",
    estado_codigo: "23",
  },
  {
    codigo: "2902005",
    municipio: "Aracatu",
    estado_codigo: "29",
  },
  {
    codigo: "3502804",
    municipio: "Araçatuba",
    estado_codigo: "35",
  },
  {
    codigo: "2902104",
    municipio: "Araci",
    estado_codigo: "29",
  },
  {
    codigo: "3103306",
    municipio: "Aracitaba",
    estado_codigo: "31",
  },
  {
    codigo: "2301208",
    municipio: "Aracoiaba",
    estado_codigo: "23",
  },
  {
    codigo: "2601052",
    municipio: "Araçoiaba",
    estado_codigo: "26",
  },
  {
    codigo: "3502903",
    municipio: "Araçoiaba da Serra",
    estado_codigo: "35",
  },
  {
    codigo: "3200607",
    municipio: "Aracruz",
    estado_codigo: "32",
  },
  {
    codigo: "5201603",
    municipio: "Araçu",
    estado_codigo: "52",
  },
  {
    codigo: "3103405",
    municipio: "Araçuaí",
    estado_codigo: "31",
  },
  {
    codigo: "5201702",
    municipio: "Aragarças",
    estado_codigo: "52",
  },
  {
    codigo: "5201801",
    municipio: "Aragoiânia",
    estado_codigo: "52",
  },
  {
    codigo: "1701309",
    municipio: "Aragominas",
    estado_codigo: "17",
  },
  {
    codigo: "1701903",
    municipio: "Araguacema",
    estado_codigo: "17",
  },
  {
    codigo: "1702000",
    municipio: "Araguaçu",
    estado_codigo: "17",
  },
  {
    codigo: "5101001",
    municipio: "Araguaiana",
    estado_codigo: "51",
  },
  {
    codigo: "1702109",
    municipio: "Araguaína",
    estado_codigo: "17",
  },
  {
    codigo: "5101209",
    municipio: "Araguainha",
    estado_codigo: "51",
  },
  {
    codigo: "1702158",
    municipio: "Araguanã",
    estado_codigo: "17",
  },
  {
    codigo: "2100873",
    municipio: "Araguanã",
    estado_codigo: "21",
  },
  {
    codigo: "5202155",
    municipio: "Araguapaz",
    estado_codigo: "52",
  },
  {
    codigo: "3103504",
    municipio: "Araguari",
    estado_codigo: "31",
  },
  {
    codigo: "1702208",
    municipio: "Araguatins",
    estado_codigo: "17",
  },
  {
    codigo: "2100907",
    municipio: "Araioses",
    estado_codigo: "21",
  },
  {
    codigo: "5001243",
    municipio: "Aral Moreira",
    estado_codigo: "50",
  },
  {
    codigo: "2902203",
    municipio: "Aramari",
    estado_codigo: "29",
  },
  {
    codigo: "4300851",
    municipio: "Arambaré",
    estado_codigo: "43",
  },
  {
    codigo: "2100956",
    municipio: "Arame",
    estado_codigo: "21",
  },
  {
    codigo: "3503000",
    municipio: "Aramina",
    estado_codigo: "35",
  },
  {
    codigo: "3503109",
    municipio: "Arandu",
    estado_codigo: "35",
  },
  {
    codigo: "3103603",
    municipio: "Arantina",
    estado_codigo: "31",
  },
  {
    codigo: "3503158",
    municipio: "Arapeí",
    estado_codigo: "35",
  },
  {
    codigo: "2700300",
    municipio: "Arapiraca",
    estado_codigo: "27",
  },
  {
    codigo: "1702307",
    municipio: "Arapoema",
    estado_codigo: "17",
  },
  {
    codigo: "3103702",
    municipio: "Araponga",
    estado_codigo: "31",
  },
  {
    codigo: "4101507",
    municipio: "Arapongas",
    estado_codigo: "41",
  },
  {
    codigo: "3103751",
    municipio: "Araporã",
    estado_codigo: "31",
  },
  {
    codigo: "4101606",
    municipio: "Arapoti",
    estado_codigo: "41",
  },
  {
    codigo: "3103801",
    municipio: "Arapuá",
    estado_codigo: "31",
  },
  {
    codigo: "4101655",
    municipio: "Arapuã",
    estado_codigo: "41",
  },
  {
    codigo: "5101258",
    municipio: "Araputanga",
    estado_codigo: "51",
  },
  {
    codigo: "4201307",
    municipio: "Araquari",
    estado_codigo: "42",
  },
  {
    codigo: "2500908",
    municipio: "Arara",
    estado_codigo: "25",
  },
  {
    codigo: "4201406",
    municipio: "Araranguá",
    estado_codigo: "42",
  },
  {
    codigo: "3503208",
    municipio: "Araraquara",
    estado_codigo: "35",
  },
  {
    codigo: "3503307",
    municipio: "Araras",
    estado_codigo: "35",
  },
  {
    codigo: "2301257",
    municipio: "Ararendá",
    estado_codigo: "23",
  },
  {
    codigo: "2101004",
    municipio: "Arari",
    estado_codigo: "21",
  },
  {
    codigo: "4300877",
    municipio: "Araricá",
    estado_codigo: "43",
  },
  {
    codigo: "2301307",
    municipio: "Araripe",
    estado_codigo: "23",
  },
  {
    codigo: "2601102",
    municipio: "Araripina",
    estado_codigo: "26",
  },
  {
    codigo: "3300209",
    municipio: "Araruama",
    estado_codigo: "33",
  },
  {
    codigo: "4101705",
    municipio: "Araruna",
    estado_codigo: "41",
  },
  {
    codigo: "2501005",
    municipio: "Araruna",
    estado_codigo: "25",
  },
  {
    codigo: "2902252",
    municipio: "Arataca",
    estado_codigo: "29",
  },
  {
    codigo: "4300901",
    municipio: "Aratiba",
    estado_codigo: "43",
  },
  {
    codigo: "2301406",
    municipio: "Aratuba",
    estado_codigo: "23",
  },
  {
    codigo: "2902302",
    municipio: "Aratuípe",
    estado_codigo: "29",
  },
  {
    codigo: "2800407",
    municipio: "Arauá",
    estado_codigo: "28",
  },
  {
    codigo: "4101804",
    municipio: "Araucária",
    estado_codigo: "41",
  },
  {
    codigo: "3103900",
    municipio: "Araújos",
    estado_codigo: "31",
  },
  {
    codigo: "3104007",
    municipio: "Araxá",
    estado_codigo: "31",
  },
  {
    codigo: "3104106",
    municipio: "Arceburgo",
    estado_codigo: "31",
  },
  {
    codigo: "3503356",
    municipio: "Arco-Íris",
    estado_codigo: "35",
  },
  {
    codigo: "3104205",
    municipio: "Arcos",
    estado_codigo: "31",
  },
  {
    codigo: "2601201",
    municipio: "Arcoverde",
    estado_codigo: "26",
  },
  {
    codigo: "3104304",
    municipio: "Areado",
    estado_codigo: "31",
  },
  {
    codigo: "3300225",
    municipio: "Areal",
    estado_codigo: "33",
  },
  {
    codigo: "3503406",
    municipio: "Arealva",
    estado_codigo: "35",
  },
  {
    codigo: "2501104",
    municipio: "Areia",
    estado_codigo: "25",
  },
  {
    codigo: "2401107",
    municipio: "Areia Branca",
    estado_codigo: "24",
  },
  {
    codigo: "2800506",
    municipio: "Areia Branca",
    estado_codigo: "28",
  },
  {
    codigo: "2501153",
    municipio: "Areia de Baraúnas",
    estado_codigo: "25",
  },
  {
    codigo: "2501203",
    municipio: "Areial",
    estado_codigo: "25",
  },
  {
    codigo: "3503505",
    municipio: "Areias",
    estado_codigo: "35",
  },
  {
    codigo: "3503604",
    municipio: "Areiópolis",
    estado_codigo: "35",
  },
  {
    codigo: "5101308",
    municipio: "Arenápolis",
    estado_codigo: "51",
  },
  {
    codigo: "5202353",
    municipio: "Arenópolis",
    estado_codigo: "52",
  },
  {
    codigo: "2401206",
    municipio: "Arês",
    estado_codigo: "24",
  },
  {
    codigo: "3104403",
    municipio: "Argirita",
    estado_codigo: "31",
  },
  {
    codigo: "3104452",
    municipio: "Aricanduva",
    estado_codigo: "31",
  },
  {
    codigo: "3104502",
    municipio: "Arinos",
    estado_codigo: "31",
  },
  {
    codigo: "5101407",
    municipio: "Aripuanã",
    estado_codigo: "51",
  },
  {
    codigo: "1100023",
    municipio: "Ariquemes",
    estado_codigo: "11",
  },
  {
    codigo: "3503703",
    municipio: "Ariranha",
    estado_codigo: "35",
  },
  {
    codigo: "4101853",
    municipio: "Ariranha do Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "3300233",
    municipio: "Armação dos Búzios",
    estado_codigo: "33",
  },
  {
    codigo: "4201505",
    municipio: "Armazém",
    estado_codigo: "42",
  },
  {
    codigo: "2301505",
    municipio: "Arneiroz",
    estado_codigo: "23",
  },
  {
    codigo: "2200905",
    municipio: "Aroazes",
    estado_codigo: "22",
  },
  {
    codigo: "2501302",
    municipio: "Aroeiras",
    estado_codigo: "25",
  },
  {
    codigo: "2200954",
    municipio: "Aroeiras do Itaim",
    estado_codigo: "22",
  },
  {
    codigo: "2201002",
    municipio: "Arraial",
    estado_codigo: "22",
  },
  {
    codigo: "3300258",
    municipio: "Arraial do Cabo",
    estado_codigo: "33",
  },
  {
    codigo: "1702406",
    municipio: "Arraias",
    estado_codigo: "17",
  },
  {
    codigo: "4301008",
    municipio: "Arroio do Meio",
    estado_codigo: "43",
  },
  {
    codigo: "4301073",
    municipio: "Arroio do Padre",
    estado_codigo: "43",
  },
  {
    codigo: "4301057",
    municipio: "Arroio do Sal",
    estado_codigo: "43",
  },
  {
    codigo: "4301107",
    municipio: "Arroio dos Ratos",
    estado_codigo: "43",
  },
  {
    codigo: "4301206",
    municipio: "Arroio do Tigre",
    estado_codigo: "43",
  },
  {
    codigo: "4301305",
    municipio: "Arroio Grande",
    estado_codigo: "43",
  },
  {
    codigo: "4201604",
    municipio: "Arroio Trinta",
    estado_codigo: "42",
  },
  {
    codigo: "3503802",
    municipio: "Artur Nogueira",
    estado_codigo: "35",
  },
  {
    codigo: "5202502",
    municipio: "Aruanã",
    estado_codigo: "52",
  },
  {
    codigo: "3503901",
    municipio: "Arujá",
    estado_codigo: "35",
  },
  {
    codigo: "4201653",
    municipio: "Arvoredo",
    estado_codigo: "42",
  },
  {
    codigo: "4301404",
    municipio: "Arvorezinha",
    estado_codigo: "43",
  },
  {
    codigo: "4201703",
    municipio: "Ascurra",
    estado_codigo: "42",
  },
  {
    codigo: "3503950",
    municipio: "Aspásia",
    estado_codigo: "35",
  },
  {
    codigo: "4101903",
    municipio: "Assaí",
    estado_codigo: "41",
  },
  {
    codigo: "2301604",
    municipio: "Assaré",
    estado_codigo: "23",
  },
  {
    codigo: "3504008",
    municipio: "Assis",
    estado_codigo: "35",
  },
  {
    codigo: "1200054",
    municipio: "Assis Brasil",
    estado_codigo: "12",
  },
  {
    codigo: "4102000",
    municipio: "Assis Chateaubriand",
    estado_codigo: "41",
  },
  {
    codigo: "2501351",
    municipio: "Assunção",
    estado_codigo: "25",
  },
  {
    codigo: "2201051",
    municipio: "Assunção do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3104601",
    municipio: "Astolfo Dutra",
    estado_codigo: "31",
  },
  {
    codigo: "4102109",
    municipio: "Astorga",
    estado_codigo: "41",
  },
  {
    codigo: "4102208",
    municipio: "Atalaia",
    estado_codigo: "41",
  },
  {
    codigo: "2700409",
    municipio: "Atalaia",
    estado_codigo: "27",
  },
  {
    codigo: "1300201",
    municipio: "Atalaia do Norte",
    estado_codigo: "13",
  },
  {
    codigo: "4201802",
    municipio: "Atalanta",
    estado_codigo: "42",
  },
  {
    codigo: "3104700",
    municipio: "Ataléia",
    estado_codigo: "31",
  },
  {
    codigo: "3504107",
    municipio: "Atibaia",
    estado_codigo: "35",
  },
  {
    codigo: "3200706",
    municipio: "Atilio Vivacqua",
    estado_codigo: "32",
  },
  {
    codigo: "1702554",
    municipio: "Augustinópolis",
    estado_codigo: "17",
  },
  {
    codigo: "1500909",
    municipio: "Augusto Corrêa",
    estado_codigo: "15",
  },
  {
    codigo: "3104809",
    municipio: "Augusto de Lima",
    estado_codigo: "31",
  },
  {
    codigo: "4301503",
    municipio: "Augusto Pestana",
    estado_codigo: "43",
  },
  {
    codigo: "2401305",
    municipio: "Augusto Severo",
    estado_codigo: "24",
  },
  {
    codigo: "4301552",
    municipio: "Áurea",
    estado_codigo: "43",
  },
  {
    codigo: "2902401",
    municipio: "Aurelino Leal",
    estado_codigo: "29",
  },
  {
    codigo: "3504206",
    municipio: "Auriflama",
    estado_codigo: "35",
  },
  {
    codigo: "5202601",
    municipio: "Aurilândia",
    estado_codigo: "52",
  },
  {
    codigo: "4201901",
    municipio: "Aurora",
    estado_codigo: "42",
  },
  {
    codigo: "2301703",
    municipio: "Aurora",
    estado_codigo: "23",
  },
  {
    codigo: "1500958",
    municipio: "Aurora do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "1702703",
    municipio: "Aurora do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "1300300",
    municipio: "Autazes",
    estado_codigo: "13",
  },
  {
    codigo: "3504305",
    municipio: "Avaí",
    estado_codigo: "35",
  },
  {
    codigo: "3504404",
    municipio: "Avanhandava",
    estado_codigo: "35",
  },
  {
    codigo: "3504503",
    municipio: "Avaré",
    estado_codigo: "35",
  },
  {
    codigo: "1501006",
    municipio: "Aveiro",
    estado_codigo: "15",
  },
  {
    codigo: "2201101",
    municipio: "Avelino Lopes",
    estado_codigo: "22",
  },
  {
    codigo: "5202809",
    municipio: "Avelinópolis",
    estado_codigo: "52",
  },
  {
    codigo: "2101103",
    municipio: "Axixá",
    estado_codigo: "21",
  },
  {
    codigo: "1702901",
    municipio: "Axixá do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "1703008",
    municipio: "Babaçulândia",
    estado_codigo: "17",
  },
  {
    codigo: "2101202",
    municipio: "Bacabal",
    estado_codigo: "21",
  },
  {
    codigo: "2101251",
    municipio: "Bacabeira",
    estado_codigo: "21",
  },
  {
    codigo: "2101301",
    municipio: "Bacuri",
    estado_codigo: "21",
  },
  {
    codigo: "2101350",
    municipio: "Bacurituba",
    estado_codigo: "21",
  },
  {
    codigo: "3504602",
    municipio: "Bady Bassitt",
    estado_codigo: "35",
  },
  {
    codigo: "3104908",
    municipio: "Baependi",
    estado_codigo: "31",
  },
  {
    codigo: "4301602",
    municipio: "Bagé",
    estado_codigo: "43",
  },
  {
    codigo: "1501105",
    municipio: "Bagre",
    estado_codigo: "15",
  },
  {
    codigo: "2501401",
    municipio: "Baía da Traição",
    estado_codigo: "25",
  },
  {
    codigo: "2401404",
    municipio: "Baía Formosa",
    estado_codigo: "24",
  },
  {
    codigo: "2902500",
    municipio: "Baianópolis",
    estado_codigo: "29",
  },
  {
    codigo: "1501204",
    municipio: "Baião",
    estado_codigo: "15",
  },
  {
    codigo: "2902609",
    municipio: "Baixa Grande",
    estado_codigo: "29",
  },
  {
    codigo: "2201150",
    municipio: "Baixa Grande do Ribeiro",
    estado_codigo: "22",
  },
  {
    codigo: "2301802",
    municipio: "Baixio",
    estado_codigo: "23",
  },
  {
    codigo: "3200805",
    municipio: "Baixo Guandu",
    estado_codigo: "32",
  },
  {
    codigo: "3504701",
    municipio: "Balbinos",
    estado_codigo: "35",
  },
  {
    codigo: "3105004",
    municipio: "Baldim",
    estado_codigo: "31",
  },
  {
    codigo: "5203104",
    municipio: "Baliza",
    estado_codigo: "52",
  },
  {
    codigo: "4201950",
    municipio: "Balneário Arroio do Silva",
    estado_codigo: "42",
  },
  {
    codigo: "4202057",
    municipio: "Balneário Barra do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "4202008",
    municipio: "Balneário Camboriú",
    estado_codigo: "42",
  },
  {
    codigo: "4202073",
    municipio: "Balneário Gaivota",
    estado_codigo: "42",
  },
  {
    codigo: "4212809",
    municipio: "Balneário Piçarras",
    estado_codigo: "42",
  },
  {
    codigo: "4301636",
    municipio: "Balneário Pinhal",
    estado_codigo: "43",
  },
  {
    codigo: "4220000",
    municipio: "Balneário Rincão",
    estado_codigo: "42",
  },
  {
    codigo: "3504800",
    municipio: "Bálsamo",
    estado_codigo: "35",
  },
  {
    codigo: "4102307",
    municipio: "Balsa Nova",
    estado_codigo: "41",
  },
  {
    codigo: "2101400",
    municipio: "Balsas",
    estado_codigo: "21",
  },
  {
    codigo: "3105103",
    municipio: "Bambuí",
    estado_codigo: "31",
  },
  {
    codigo: "2301851",
    municipio: "Banabuiú",
    estado_codigo: "23",
  },
  {
    codigo: "3504909",
    municipio: "Bananal",
    estado_codigo: "35",
  },
  {
    codigo: "2501500",
    municipio: "Bananeiras",
    estado_codigo: "25",
  },
  {
    codigo: "3105202",
    municipio: "Bandeira",
    estado_codigo: "31",
  },
  {
    codigo: "3105301",
    municipio: "Bandeira do Sul",
    estado_codigo: "31",
  },
  {
    codigo: "4202081",
    municipio: "Bandeirante",
    estado_codigo: "42",
  },
  {
    codigo: "4102406",
    municipio: "Bandeirantes",
    estado_codigo: "41",
  },
  {
    codigo: "5001508",
    municipio: "Bandeirantes",
    estado_codigo: "50",
  },
  {
    codigo: "1703057",
    municipio: "Bandeirantes do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "1501253",
    municipio: "Bannach",
    estado_codigo: "15",
  },
  {
    codigo: "2902658",
    municipio: "Banzaê",
    estado_codigo: "29",
  },
  {
    codigo: "4301651",
    municipio: "Barão",
    estado_codigo: "43",
  },
  {
    codigo: "3505005",
    municipio: "Barão de Antonina",
    estado_codigo: "35",
  },
  {
    codigo: "3105400",
    municipio: "Barão de Cocais",
    estado_codigo: "31",
  },
  {
    codigo: "4301701",
    municipio: "Barão de Cotegipe",
    estado_codigo: "43",
  },
  {
    codigo: "2101509",
    municipio: "Barão de Grajaú",
    estado_codigo: "21",
  },
  {
    codigo: "5101605",
    municipio: "Barão de Melgaço",
    estado_codigo: "51",
  },
  {
    codigo: "3105509",
    municipio: "Barão de Monte Alto",
    estado_codigo: "31",
  },
  {
    codigo: "4301750",
    municipio: "Barão do Triunfo",
    estado_codigo: "43",
  },
  {
    codigo: "2501534",
    municipio: "Baraúna",
    estado_codigo: "25",
  },
  {
    codigo: "2401453",
    municipio: "Baraúna",
    estado_codigo: "24",
  },
  {
    codigo: "3105608",
    municipio: "Barbacena",
    estado_codigo: "31",
  },
  {
    codigo: "2301901",
    municipio: "Barbalha",
    estado_codigo: "23",
  },
  {
    codigo: "3505104",
    municipio: "Barbosa",
    estado_codigo: "35",
  },
  {
    codigo: "4102505",
    municipio: "Barbosa Ferraz",
    estado_codigo: "41",
  },
  {
    codigo: "1501303",
    municipio: "Barcarena",
    estado_codigo: "15",
  },
  {
    codigo: "2401503",
    municipio: "Barcelona",
    estado_codigo: "24",
  },
  {
    codigo: "1300409",
    municipio: "Barcelos",
    estado_codigo: "13",
  },
  {
    codigo: "3505203",
    municipio: "Bariri",
    estado_codigo: "35",
  },
  {
    codigo: "2902708",
    municipio: "Barra",
    estado_codigo: "29",
  },
  {
    codigo: "3505302",
    municipio: "Barra Bonita",
    estado_codigo: "35",
  },
  {
    codigo: "4202099",
    municipio: "Barra Bonita",
    estado_codigo: "42",
  },
  {
    codigo: "4102604",
    municipio: "Barracão",
    estado_codigo: "41",
  },
  {
    codigo: "4301800",
    municipio: "Barracão",
    estado_codigo: "43",
  },
  {
    codigo: "2902807",
    municipio: "Barra da Estiva",
    estado_codigo: "29",
  },
  {
    codigo: "2201176",
    municipio: "Barra D'Alcântara",
    estado_codigo: "22",
  },
  {
    codigo: "2601300",
    municipio: "Barra de Guabiraba",
    estado_codigo: "26",
  },
  {
    codigo: "2501575",
    municipio: "Barra de Santana",
    estado_codigo: "25",
  },
  {
    codigo: "2501609",
    municipio: "Barra de Santa Rosa",
    estado_codigo: "25",
  },
  {
    codigo: "2700508",
    municipio: "Barra de Santo Antônio",
    estado_codigo: "27",
  },
  {
    codigo: "3200904",
    municipio: "Barra de São Francisco",
    estado_codigo: "32",
  },
  {
    codigo: "2700607",
    municipio: "Barra de São Miguel",
    estado_codigo: "27",
  },
  {
    codigo: "2501708",
    municipio: "Barra de São Miguel",
    estado_codigo: "25",
  },
  {
    codigo: "5101704",
    municipio: "Barra do Bugres",
    estado_codigo: "51",
  },
  {
    codigo: "3505351",
    municipio: "Barra do Chapéu",
    estado_codigo: "35",
  },
  {
    codigo: "2902906",
    municipio: "Barra do Choça",
    estado_codigo: "29",
  },
  {
    codigo: "2101608",
    municipio: "Barra do Corda",
    estado_codigo: "21",
  },
  {
    codigo: "5101803",
    municipio: "Barra do Garças",
    estado_codigo: "51",
  },
  {
    codigo: "4301859",
    municipio: "Barra do Guarita",
    estado_codigo: "43",
  },
  {
    codigo: "4102703",
    municipio: "Barra do Jacaré",
    estado_codigo: "41",
  },
  {
    codigo: "2903003",
    municipio: "Barra do Mendes",
    estado_codigo: "29",
  },
  {
    codigo: "1703073",
    municipio: "Barra do Ouro",
    estado_codigo: "17",
  },
  {
    codigo: "3300308",
    municipio: "Barra do Piraí",
    estado_codigo: "33",
  },
  {
    codigo: "4301875",
    municipio: "Barra do Quaraí",
    estado_codigo: "43",
  },
  {
    codigo: "4301909",
    municipio: "Barra do Ribeiro",
    estado_codigo: "43",
  },
  {
    codigo: "4301925",
    municipio: "Barra do Rio Azul",
    estado_codigo: "43",
  },
  {
    codigo: "2903102",
    municipio: "Barra do Rocha",
    estado_codigo: "29",
  },
  {
    codigo: "2800605",
    municipio: "Barra dos Coqueiros",
    estado_codigo: "28",
  },
  {
    codigo: "3505401",
    municipio: "Barra do Turvo",
    estado_codigo: "35",
  },
  {
    codigo: "4301958",
    municipio: "Barra Funda",
    estado_codigo: "43",
  },
  {
    codigo: "3105707",
    municipio: "Barra Longa",
    estado_codigo: "31",
  },
  {
    codigo: "3300407",
    municipio: "Barra Mansa",
    estado_codigo: "33",
  },
  {
    codigo: "2201200",
    municipio: "Barras",
    estado_codigo: "22",
  },
  {
    codigo: "4202107",
    municipio: "Barra Velha",
    estado_codigo: "42",
  },
  {
    codigo: "2301950",
    municipio: "Barreira",
    estado_codigo: "23",
  },
  {
    codigo: "2903201",
    municipio: "Barreiras",
    estado_codigo: "29",
  },
  {
    codigo: "2201309",
    municipio: "Barreiras do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "1300508",
    municipio: "Barreirinha",
    estado_codigo: "13",
  },
  {
    codigo: "2101707",
    municipio: "Barreirinhas",
    estado_codigo: "21",
  },
  {
    codigo: "2601409",
    municipio: "Barreiros",
    estado_codigo: "26",
  },
  {
    codigo: "3505500",
    municipio: "Barretos",
    estado_codigo: "35",
  },
  {
    codigo: "3505609",
    municipio: "Barrinha",
    estado_codigo: "35",
  },
  {
    codigo: "2302008",
    municipio: "Barro",
    estado_codigo: "23",
  },
  {
    codigo: "5203203",
    municipio: "Barro Alto",
    estado_codigo: "52",
  },
  {
    codigo: "2903235",
    municipio: "Barro Alto",
    estado_codigo: "29",
  },
  {
    codigo: "2903276",
    municipio: "Barrocas",
    estado_codigo: "29",
  },
  {
    codigo: "2201408",
    municipio: "Barro Duro",
    estado_codigo: "22",
  },
  {
    codigo: "1703107",
    municipio: "Barrolândia",
    estado_codigo: "17",
  },
  {
    codigo: "2903300",
    municipio: "Barro Preto",
    estado_codigo: "29",
  },
  {
    codigo: "2302057",
    municipio: "Barroquinha",
    estado_codigo: "23",
  },
  {
    codigo: "4302006",
    municipio: "Barros Cassal",
    estado_codigo: "43",
  },
  {
    codigo: "3105905",
    municipio: "Barroso",
    estado_codigo: "31",
  },
  {
    codigo: "3505708",
    municipio: "Barueri",
    estado_codigo: "35",
  },
  {
    codigo: "3505807",
    municipio: "Bastos",
    estado_codigo: "35",
  },
  {
    codigo: "5001904",
    municipio: "Bataguassu",
    estado_codigo: "50",
  },
  {
    codigo: "2700706",
    municipio: "Batalha",
    estado_codigo: "27",
  },
  {
    codigo: "2201507",
    municipio: "Batalha",
    estado_codigo: "22",
  },
  {
    codigo: "3505906",
    municipio: "Batatais",
    estado_codigo: "35",
  },
  {
    codigo: "5002001",
    municipio: "Batayporã",
    estado_codigo: "50",
  },
  {
    codigo: "2302107",
    municipio: "Baturité",
    estado_codigo: "23",
  },
  {
    codigo: "3506003",
    municipio: "Bauru",
    estado_codigo: "35",
  },
  {
    codigo: "2501807",
    municipio: "Bayeux",
    estado_codigo: "25",
  },
  {
    codigo: "3506102",
    municipio: "Bebedouro",
    estado_codigo: "35",
  },
  {
    codigo: "2302206",
    municipio: "Beberibe",
    estado_codigo: "23",
  },
  {
    codigo: "2302305",
    municipio: "Bela Cruz",
    estado_codigo: "23",
  },
  {
    codigo: "2101731",
    municipio: "Belágua",
    estado_codigo: "21",
  },
  {
    codigo: "5002100",
    municipio: "Bela Vista",
    estado_codigo: "50",
  },
  {
    codigo: "4102752",
    municipio: "Bela Vista da Caroba",
    estado_codigo: "41",
  },
  {
    codigo: "5203302",
    municipio: "Bela Vista de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3106002",
    municipio: "Bela Vista de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2101772",
    municipio: "Bela Vista do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "4102802",
    municipio: "Bela Vista do Paraíso",
    estado_codigo: "41",
  },
  {
    codigo: "2201556",
    municipio: "Bela Vista do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4202131",
    municipio: "Bela Vista do Toldo",
    estado_codigo: "42",
  },
  {
    codigo: "2700805",
    municipio: "Belém",
    estado_codigo: "27",
  },
  {
    codigo: "2501906",
    municipio: "Belém",
    estado_codigo: "25",
  },
  {
    codigo: "1501402",
    municipio: "Belém",
    estado_codigo: "15",
  },
  {
    codigo: "2601508",
    municipio: "Belém de Maria",
    estado_codigo: "26",
  },
  {
    codigo: "2601607",
    municipio: "Belém de São Francisco",
    estado_codigo: "26",
  },
  {
    codigo: "2502003",
    municipio: "Belém do Brejo do Cruz",
    estado_codigo: "25",
  },
  {
    codigo: "2201572",
    municipio: "Belém do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3300456",
    municipio: "Belford Roxo",
    estado_codigo: "33",
  },
  {
    codigo: "3106101",
    municipio: "Belmiro Braga",
    estado_codigo: "31",
  },
  {
    codigo: "4202156",
    municipio: "Belmonte",
    estado_codigo: "42",
  },
  {
    codigo: "2903409",
    municipio: "Belmonte",
    estado_codigo: "29",
  },
  {
    codigo: "2903508",
    municipio: "Belo Campo",
    estado_codigo: "29",
  },
  {
    codigo: "3106200",
    municipio: "Belo Horizonte",
    estado_codigo: "31",
  },
  {
    codigo: "2601706",
    municipio: "Belo Jardim",
    estado_codigo: "26",
  },
  {
    codigo: "2700904",
    municipio: "Belo Monte",
    estado_codigo: "27",
  },
  {
    codigo: "3106309",
    municipio: "Belo Oriente",
    estado_codigo: "31",
  },
  {
    codigo: "3106408",
    municipio: "Belo Vale",
    estado_codigo: "31",
  },
  {
    codigo: "1501451",
    municipio: "Belterra",
    estado_codigo: "15",
  },
  {
    codigo: "2201606",
    municipio: "Beneditinos",
    estado_codigo: "22",
  },
  {
    codigo: "2101806",
    municipio: "Benedito Leite",
    estado_codigo: "21",
  },
  {
    codigo: "4202206",
    municipio: "Benedito Novo",
    estado_codigo: "42",
  },
  {
    codigo: "1501501",
    municipio: "Benevides",
    estado_codigo: "15",
  },
  {
    codigo: "1300607",
    municipio: "Benjamin Constant",
    estado_codigo: "13",
  },
  {
    codigo: "4302055",
    municipio: "Benjamin Constant do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3506201",
    municipio: "Bento de Abreu",
    estado_codigo: "35",
  },
  {
    codigo: "2401602",
    municipio: "Bento Fernandes",
    estado_codigo: "24",
  },
  {
    codigo: "4302105",
    municipio: "Bento Gonçalves",
    estado_codigo: "43",
  },
  {
    codigo: "2101905",
    municipio: "Bequimão",
    estado_codigo: "21",
  },
  {
    codigo: "3106507",
    municipio: "Berilo",
    estado_codigo: "31",
  },
  {
    codigo: "3106655",
    municipio: "Berizal",
    estado_codigo: "31",
  },
  {
    codigo: "2502052",
    municipio: "Bernardino Batista",
    estado_codigo: "25",
  },
  {
    codigo: "3506300",
    municipio: "Bernardino de Campos",
    estado_codigo: "35",
  },
  {
    codigo: "2101939",
    municipio: "Bernardo do Mearim",
    estado_codigo: "21",
  },
  {
    codigo: "1703206",
    municipio: "Bernardo Sayão",
    estado_codigo: "17",
  },
  {
    codigo: "3506359",
    municipio: "Bertioga",
    estado_codigo: "35",
  },
  {
    codigo: "2201705",
    municipio: "Bertolínia",
    estado_codigo: "22",
  },
  {
    codigo: "3106606",
    municipio: "Bertópolis",
    estado_codigo: "31",
  },
  {
    codigo: "1300631",
    municipio: "Beruri",
    estado_codigo: "13",
  },
  {
    codigo: "2601805",
    municipio: "Betânia",
    estado_codigo: "26",
  },
  {
    codigo: "2201739",
    municipio: "Betânia do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3106705",
    municipio: "Betim",
    estado_codigo: "31",
  },
  {
    codigo: "2601904",
    municipio: "Bezerros",
    estado_codigo: "26",
  },
  {
    codigo: "3106804",
    municipio: "Bias Fortes",
    estado_codigo: "31",
  },
  {
    codigo: "3106903",
    municipio: "Bicas",
    estado_codigo: "31",
  },
  {
    codigo: "4202305",
    municipio: "Biguaçu",
    estado_codigo: "42",
  },
  {
    codigo: "3506409",
    municipio: "Bilac",
    estado_codigo: "35",
  },
  {
    codigo: "3107000",
    municipio: "Biquinhas",
    estado_codigo: "31",
  },
  {
    codigo: "3506508",
    municipio: "Birigui",
    estado_codigo: "35",
  },
  {
    codigo: "3506607",
    municipio: "Biritiba-Mirim",
    estado_codigo: "35",
  },
  {
    codigo: "2903607",
    municipio: "Biritinga",
    estado_codigo: "29",
  },
  {
    codigo: "4102901",
    municipio: "Bituruna",
    estado_codigo: "41",
  },
  {
    codigo: "4202404",
    municipio: "Blumenau",
    estado_codigo: "42",
  },
  {
    codigo: "3107109",
    municipio: "Boa Esperança",
    estado_codigo: "31",
  },
  {
    codigo: "3201001",
    municipio: "Boa Esperança",
    estado_codigo: "32",
  },
  {
    codigo: "4103008",
    municipio: "Boa Esperança",
    estado_codigo: "41",
  },
  {
    codigo: "4103024",
    municipio: "Boa Esperança do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "3506706",
    municipio: "Boa Esperança do Sul",
    estado_codigo: "35",
  },
  {
    codigo: "2201770",
    municipio: "Boa Hora",
    estado_codigo: "22",
  },
  {
    codigo: "2903706",
    municipio: "Boa Nova",
    estado_codigo: "29",
  },
  {
    codigo: "2502102",
    municipio: "Boa Ventura",
    estado_codigo: "25",
  },
  {
    codigo: "4103040",
    municipio: "Boa Ventura de São Roque",
    estado_codigo: "41",
  },
  {
    codigo: "2302404",
    municipio: "Boa Viagem",
    estado_codigo: "23",
  },
  {
    codigo: "1400100",
    municipio: "Boa Vista",
    estado_codigo: "14",
  },
  {
    codigo: "2502151",
    municipio: "Boa Vista",
    estado_codigo: "25",
  },
  {
    codigo: "4103057",
    municipio: "Boa Vista da Aparecida",
    estado_codigo: "41",
  },
  {
    codigo: "4302154",
    municipio: "Boa Vista das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "4302204",
    municipio: "Boa Vista do Buricá",
    estado_codigo: "43",
  },
  {
    codigo: "4302220",
    municipio: "Boa Vista do Cadeado",
    estado_codigo: "43",
  },
  {
    codigo: "2101970",
    municipio: "Boa Vista do Gurupi",
    estado_codigo: "21",
  },
  {
    codigo: "4302238",
    municipio: "Boa Vista do Incra",
    estado_codigo: "43",
  },
  {
    codigo: "1300680",
    municipio: "Boa Vista do Ramos",
    estado_codigo: "13",
  },
  {
    codigo: "4302253",
    municipio: "Boa Vista do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2903805",
    municipio: "Boa Vista do Tupim",
    estado_codigo: "29",
  },
  {
    codigo: "2701001",
    municipio: "Boca da Mata",
    estado_codigo: "27",
  },
  {
    codigo: "1300706",
    municipio: "Boca do Acre",
    estado_codigo: "13",
  },
  {
    codigo: "2201804",
    municipio: "Bocaina",
    estado_codigo: "22",
  },
  {
    codigo: "3506805",
    municipio: "Bocaina",
    estado_codigo: "35",
  },
  {
    codigo: "3107208",
    municipio: "Bocaina de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4202438",
    municipio: "Bocaina do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "3107307",
    municipio: "Bocaiúva",
    estado_codigo: "31",
  },
  {
    codigo: "4103107",
    municipio: "Bocaiúva do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "2401651",
    municipio: "Bodó",
    estado_codigo: "24",
  },
  {
    codigo: "2602001",
    municipio: "Bodocó",
    estado_codigo: "26",
  },
  {
    codigo: "5002159",
    municipio: "Bodoquena",
    estado_codigo: "50",
  },
  {
    codigo: "3506904",
    municipio: "Bofete",
    estado_codigo: "35",
  },
  {
    codigo: "3507001",
    municipio: "Boituva",
    estado_codigo: "35",
  },
  {
    codigo: "4202453",
    municipio: "Bombinhas",
    estado_codigo: "42",
  },
  {
    codigo: "2602100",
    municipio: "Bom Conselho",
    estado_codigo: "26",
  },
  {
    codigo: "3107406",
    municipio: "Bom Despacho",
    estado_codigo: "31",
  },
  {
    codigo: "2602209",
    municipio: "Bom Jardim",
    estado_codigo: "26",
  },
  {
    codigo: "3300506",
    municipio: "Bom Jardim",
    estado_codigo: "33",
  },
  {
    codigo: "2102002",
    municipio: "Bom Jardim",
    estado_codigo: "21",
  },
  {
    codigo: "4202503",
    municipio: "Bom Jardim da Serra",
    estado_codigo: "42",
  },
  {
    codigo: "5203401",
    municipio: "Bom Jardim de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3107505",
    municipio: "Bom Jardim de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2401701",
    municipio: "Bom Jesus",
    estado_codigo: "24",
  },
  {
    codigo: "4302303",
    municipio: "Bom Jesus",
    estado_codigo: "43",
  },
  {
    codigo: "2201903",
    municipio: "Bom Jesus",
    estado_codigo: "22",
  },
  {
    codigo: "2502201",
    municipio: "Bom Jesus",
    estado_codigo: "25",
  },
  {
    codigo: "4202537",
    municipio: "Bom Jesus",
    estado_codigo: "42",
  },
  {
    codigo: "2903904",
    municipio: "Bom Jesus da Lapa",
    estado_codigo: "29",
  },
  {
    codigo: "3107604",
    municipio: "Bom Jesus da Penha",
    estado_codigo: "31",
  },
  {
    codigo: "2903953",
    municipio: "Bom Jesus da Serra",
    estado_codigo: "29",
  },
  {
    codigo: "2102036",
    municipio: "Bom Jesus das Selvas",
    estado_codigo: "21",
  },
  {
    codigo: "5203500",
    municipio: "Bom Jesus de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3107703",
    municipio: "Bom Jesus do Amparo",
    estado_codigo: "31",
  },
  {
    codigo: "5101852",
    municipio: "Bom Jesus do Araguaia",
    estado_codigo: "51",
  },
  {
    codigo: "3107802",
    municipio: "Bom Jesus do Galho",
    estado_codigo: "31",
  },
  {
    codigo: "3300605",
    municipio: "Bom Jesus do Itabapoana",
    estado_codigo: "33",
  },
  {
    codigo: "3201100",
    municipio: "Bom Jesus do Norte",
    estado_codigo: "32",
  },
  {
    codigo: "4202578",
    municipio: "Bom Jesus do Oeste",
    estado_codigo: "42",
  },
  {
    codigo: "3507100",
    municipio: "Bom Jesus dos Perdões",
    estado_codigo: "35",
  },
  {
    codigo: "4103156",
    municipio: "Bom Jesus do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "1501576",
    municipio: "Bom Jesus do Tocantins",
    estado_codigo: "15",
  },
  {
    codigo: "1703305",
    municipio: "Bom Jesus do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2102077",
    municipio: "Bom Lugar",
    estado_codigo: "21",
  },
  {
    codigo: "4302352",
    municipio: "Bom Princípio",
    estado_codigo: "43",
  },
  {
    codigo: "2201919",
    municipio: "Bom Princípio do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4302378",
    municipio: "Bom Progresso",
    estado_codigo: "43",
  },
  {
    codigo: "3107901",
    municipio: "Bom Repouso",
    estado_codigo: "31",
  },
  {
    codigo: "4202602",
    municipio: "Bom Retiro",
    estado_codigo: "42",
  },
  {
    codigo: "4302402",
    municipio: "Bom Retiro do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2502300",
    municipio: "Bom Sucesso",
    estado_codigo: "25",
  },
  {
    codigo: "4103206",
    municipio: "Bom Sucesso",
    estado_codigo: "41",
  },
  {
    codigo: "3108008",
    municipio: "Bom Sucesso",
    estado_codigo: "31",
  },
  {
    codigo: "3507159",
    municipio: "Bom Sucesso de Itararé",
    estado_codigo: "35",
  },
  {
    codigo: "4103222",
    municipio: "Bom Sucesso do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "3108107",
    municipio: "Bonfim",
    estado_codigo: "31",
  },
  {
    codigo: "1400159",
    municipio: "Bonfim",
    estado_codigo: "14",
  },
  {
    codigo: "2201929",
    municipio: "Bonfim do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "5203559",
    municipio: "Bonfinópolis",
    estado_codigo: "52",
  },
  {
    codigo: "3108206",
    municipio: "Bonfinópolis de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2904001",
    municipio: "Boninal",
    estado_codigo: "29",
  },
  {
    codigo: "2904050",
    municipio: "Bonito",
    estado_codigo: "29",
  },
  {
    codigo: "2602308",
    municipio: "Bonito",
    estado_codigo: "26",
  },
  {
    codigo: "5002209",
    municipio: "Bonito",
    estado_codigo: "50",
  },
  {
    codigo: "1501600",
    municipio: "Bonito",
    estado_codigo: "15",
  },
  {
    codigo: "3108255",
    municipio: "Bonito de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2502409",
    municipio: "Bonito de Santa Fé",
    estado_codigo: "25",
  },
  {
    codigo: "5203575",
    municipio: "Bonópolis",
    estado_codigo: "52",
  },
  {
    codigo: "2502508",
    municipio: "Boqueirão",
    estado_codigo: "25",
  },
  {
    codigo: "4302451",
    municipio: "Boqueirão do Leão",
    estado_codigo: "43",
  },
  {
    codigo: "2201945",
    municipio: "Boqueirão do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2800670",
    municipio: "Boquim",
    estado_codigo: "28",
  },
  {
    codigo: "2904100",
    municipio: "Boquira",
    estado_codigo: "29",
  },
  {
    codigo: "3507209",
    municipio: "Borá",
    estado_codigo: "35",
  },
  {
    codigo: "3507308",
    municipio: "Boracéia",
    estado_codigo: "35",
  },
  {
    codigo: "1300805",
    municipio: "Borba",
    estado_codigo: "13",
  },
  {
    codigo: "3507407",
    municipio: "Borborema",
    estado_codigo: "35",
  },
  {
    codigo: "2502706",
    municipio: "Borborema",
    estado_codigo: "25",
  },
  {
    codigo: "3108305",
    municipio: "Borda da Mata",
    estado_codigo: "31",
  },
  {
    codigo: "3507456",
    municipio: "Borebi",
    estado_codigo: "35",
  },
  {
    codigo: "4103305",
    municipio: "Borrazópolis",
    estado_codigo: "41",
  },
  {
    codigo: "4302501",
    municipio: "Bossoroca",
    estado_codigo: "43",
  },
  {
    codigo: "3108404",
    municipio: "Botelhos",
    estado_codigo: "31",
  },
  {
    codigo: "3507506",
    municipio: "Botucatu",
    estado_codigo: "35",
  },
  {
    codigo: "3108503",
    municipio: "Botumirim",
    estado_codigo: "31",
  },
  {
    codigo: "2904209",
    municipio: "Botuporã",
    estado_codigo: "29",
  },
  {
    codigo: "4202701",
    municipio: "Botuverá",
    estado_codigo: "42",
  },
  {
    codigo: "4302584",
    municipio: "Bozano",
    estado_codigo: "43",
  },
  {
    codigo: "4202800",
    municipio: "Braço do Norte",
    estado_codigo: "42",
  },
  {
    codigo: "4202859",
    municipio: "Braço do Trombudo",
    estado_codigo: "42",
  },
  {
    codigo: "4302600",
    municipio: "Braga",
    estado_codigo: "43",
  },
  {
    codigo: "1501709",
    municipio: "Bragança",
    estado_codigo: "15",
  },
  {
    codigo: "3507605",
    municipio: "Bragança Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4103354",
    municipio: "Braganey",
    estado_codigo: "41",
  },
  {
    codigo: "2701100",
    municipio: "Branquinha",
    estado_codigo: "27",
  },
  {
    codigo: "5002308",
    municipio: "Brasilândia",
    estado_codigo: "50",
  },
  {
    codigo: "3108552",
    municipio: "Brasilândia de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4103370",
    municipio: "Brasilândia do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "1703602",
    municipio: "Brasilândia do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "1200104",
    municipio: "Brasiléia",
    estado_codigo: "12",
  },
  {
    codigo: "2201960",
    municipio: "Brasileira",
    estado_codigo: "22",
  },
  {
    codigo: "5300108",
    municipio: "Brasília",
    estado_codigo: "53",
  },
  {
    codigo: "3108602",
    municipio: "Brasília de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "1501725",
    municipio: "Brasil Novo",
    estado_codigo: "15",
  },
  {
    codigo: "5101902",
    municipio: "Brasnorte",
    estado_codigo: "51",
  },
  {
    codigo: "3108909",
    municipio: "Brasópolis",
    estado_codigo: "31",
  },
  {
    codigo: "3108701",
    municipio: "Brás Pires",
    estado_codigo: "31",
  },
  {
    codigo: "3507704",
    municipio: "Braúna",
    estado_codigo: "35",
  },
  {
    codigo: "3108800",
    municipio: "Braúnas",
    estado_codigo: "31",
  },
  {
    codigo: "5203609",
    municipio: "Brazabrantes",
    estado_codigo: "52",
  },
  {
    codigo: "2602407",
    municipio: "Brejão",
    estado_codigo: "26",
  },
  {
    codigo: "3201159",
    municipio: "Brejetuba",
    estado_codigo: "32",
  },
  {
    codigo: "2401800",
    municipio: "Brejinho",
    estado_codigo: "24",
  },
  {
    codigo: "2602506",
    municipio: "Brejinho",
    estado_codigo: "26",
  },
  {
    codigo: "1703701",
    municipio: "Brejinho de Nazaré",
    estado_codigo: "17",
  },
  {
    codigo: "2102101",
    municipio: "Brejo",
    estado_codigo: "21",
  },
  {
    codigo: "3507753",
    municipio: "Brejo Alegre",
    estado_codigo: "35",
  },
  {
    codigo: "2602605",
    municipio: "Brejo da Madre de Deus",
    estado_codigo: "26",
  },
  {
    codigo: "2102150",
    municipio: "Brejo de Areia",
    estado_codigo: "21",
  },
  {
    codigo: "2502805",
    municipio: "Brejo do Cruz",
    estado_codigo: "25",
  },
  {
    codigo: "2201988",
    municipio: "Brejo do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2502904",
    municipio: "Brejo dos Santos",
    estado_codigo: "25",
  },
  {
    codigo: "2904308",
    municipio: "Brejões",
    estado_codigo: "29",
  },
  {
    codigo: "2800704",
    municipio: "Brejo Grande",
    estado_codigo: "28",
  },
  {
    codigo: "1501758",
    municipio: "Brejo Grande do Araguaia",
    estado_codigo: "15",
  },
  {
    codigo: "2904407",
    municipio: "Brejolândia",
    estado_codigo: "29",
  },
  {
    codigo: "2302503",
    municipio: "Brejo Santo",
    estado_codigo: "23",
  },
  {
    codigo: "1501782",
    municipio: "Breu Branco",
    estado_codigo: "15",
  },
  {
    codigo: "1501808",
    municipio: "Breves",
    estado_codigo: "15",
  },
  {
    codigo: "5203807",
    municipio: "Britânia",
    estado_codigo: "52",
  },
  {
    codigo: "4302659",
    municipio: "Brochier",
    estado_codigo: "43",
  },
  {
    codigo: "3507803",
    municipio: "Brodowski",
    estado_codigo: "35",
  },
  {
    codigo: "3507902",
    municipio: "Brotas",
    estado_codigo: "35",
  },
  {
    codigo: "2904506",
    municipio: "Brotas de Macaúbas",
    estado_codigo: "29",
  },
  {
    codigo: "3109006",
    municipio: "Brumadinho",
    estado_codigo: "31",
  },
  {
    codigo: "2904605",
    municipio: "Brumado",
    estado_codigo: "29",
  },
  {
    codigo: "4202875",
    municipio: "Brunópolis",
    estado_codigo: "42",
  },
  {
    codigo: "4202909",
    municipio: "Brusque",
    estado_codigo: "42",
  },
  {
    codigo: "3109105",
    municipio: "Bueno Brandão",
    estado_codigo: "31",
  },
  {
    codigo: "3109204",
    municipio: "Buenópolis",
    estado_codigo: "31",
  },
  {
    codigo: "2602704",
    municipio: "Buenos Aires",
    estado_codigo: "26",
  },
  {
    codigo: "2904704",
    municipio: "Buerarema",
    estado_codigo: "29",
  },
  {
    codigo: "3109253",
    municipio: "Bugre",
    estado_codigo: "31",
  },
  {
    codigo: "2602803",
    municipio: "Buíque",
    estado_codigo: "26",
  },
  {
    codigo: "1200138",
    municipio: "Bujari",
    estado_codigo: "12",
  },
  {
    codigo: "1501907",
    municipio: "Bujaru",
    estado_codigo: "15",
  },
  {
    codigo: "3508009",
    municipio: "Buri",
    estado_codigo: "35",
  },
  {
    codigo: "3508108",
    municipio: "Buritama",
    estado_codigo: "35",
  },
  {
    codigo: "2102200",
    municipio: "Buriti",
    estado_codigo: "21",
  },
  {
    codigo: "5203906",
    municipio: "Buriti Alegre",
    estado_codigo: "52",
  },
  {
    codigo: "2102309",
    municipio: "Buriti Bravo",
    estado_codigo: "21",
  },
  {
    codigo: "2102325",
    municipio: "Buriticupu",
    estado_codigo: "21",
  },
  {
    codigo: "5203939",
    municipio: "Buriti de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "2202000",
    municipio: "Buriti dos Lopes",
    estado_codigo: "22",
  },
  {
    codigo: "2202026",
    municipio: "Buriti dos Montes",
    estado_codigo: "22",
  },
  {
    codigo: "1703800",
    municipio: "Buriti do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "5203962",
    municipio: "Buritinópolis",
    estado_codigo: "52",
  },
  {
    codigo: "2904753",
    municipio: "Buritirama",
    estado_codigo: "29",
  },
  {
    codigo: "2102358",
    municipio: "Buritirana",
    estado_codigo: "21",
  },
  {
    codigo: "1100452",
    municipio: "Buritis",
    estado_codigo: "11",
  },
  {
    codigo: "3109303",
    municipio: "Buritis",
    estado_codigo: "31",
  },
  {
    codigo: "3508207",
    municipio: "Buritizal",
    estado_codigo: "35",
  },
  {
    codigo: "3109402",
    municipio: "Buritizeiro",
    estado_codigo: "31",
  },
  {
    codigo: "4302709",
    municipio: "Butiá",
    estado_codigo: "43",
  },
  {
    codigo: "1300839",
    municipio: "Caapiranga",
    estado_codigo: "13",
  },
  {
    codigo: "2503001",
    municipio: "Caaporã",
    estado_codigo: "25",
  },
  {
    codigo: "5002407",
    municipio: "Caarapó",
    estado_codigo: "50",
  },
  {
    codigo: "2904803",
    municipio: "Caatiba",
    estado_codigo: "29",
  },
  {
    codigo: "2503100",
    municipio: "Cabaceiras",
    estado_codigo: "25",
  },
  {
    codigo: "2904852",
    municipio: "Cabaceiras do Paraguaçu",
    estado_codigo: "29",
  },
  {
    codigo: "3109451",
    municipio: "Cabeceira Grande",
    estado_codigo: "31",
  },
  {
    codigo: "5204003",
    municipio: "Cabeceiras",
    estado_codigo: "52",
  },
  {
    codigo: "2202059",
    municipio: "Cabeceiras do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2503209",
    municipio: "Cabedelo",
    estado_codigo: "25",
  },
  {
    codigo: "1100031",
    municipio: "Cabixi",
    estado_codigo: "11",
  },
  {
    codigo: "2602902",
    municipio: "Cabo de Santo Agostinho",
    estado_codigo: "26",
  },
  {
    codigo: "3300704",
    municipio: "Cabo Frio",
    estado_codigo: "33",
  },
  {
    codigo: "3109501",
    municipio: "Cabo Verde",
    estado_codigo: "31",
  },
  {
    codigo: "3508306",
    municipio: "Cabrália Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "3508405",
    municipio: "Cabreúva",
    estado_codigo: "35",
  },
  {
    codigo: "2603009",
    municipio: "Cabrobó",
    estado_codigo: "26",
  },
  {
    codigo: "4203006",
    municipio: "Caçador",
    estado_codigo: "42",
  },
  {
    codigo: "3508504",
    municipio: "Caçapava",
    estado_codigo: "35",
  },
  {
    codigo: "4302808",
    municipio: "Caçapava do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "1100601",
    municipio: "Cacaulândia",
    estado_codigo: "11",
  },
  {
    codigo: "4302907",
    municipio: "Cacequi",
    estado_codigo: "43",
  },
  {
    codigo: "5102504",
    municipio: "Cáceres",
    estado_codigo: "51",
  },
  {
    codigo: "2904902",
    municipio: "Cachoeira",
    estado_codigo: "29",
  },
  {
    codigo: "5204102",
    municipio: "Cachoeira Alta",
    estado_codigo: "52",
  },
  {
    codigo: "3109600",
    municipio: "Cachoeira da Prata",
    estado_codigo: "31",
  },
  {
    codigo: "5204201",
    municipio: "Cachoeira de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3109709",
    municipio: "Cachoeira de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "3102704",
    municipio: "Cachoeira de Pajeú",
    estado_codigo: "31",
  },
  {
    codigo: "1502004",
    municipio: "Cachoeira do Arari",
    estado_codigo: "15",
  },
  {
    codigo: "1501956",
    municipio: "Cachoeira do Piriá",
    estado_codigo: "15",
  },
  {
    codigo: "2503308",
    municipio: "Cachoeira dos Índios",
    estado_codigo: "25",
  },
  {
    codigo: "4303004",
    municipio: "Cachoeira do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "5204250",
    municipio: "Cachoeira Dourada",
    estado_codigo: "52",
  },
  {
    codigo: "3109808",
    municipio: "Cachoeira Dourada",
    estado_codigo: "31",
  },
  {
    codigo: "2102374",
    municipio: "Cachoeira Grande",
    estado_codigo: "21",
  },
  {
    codigo: "3508603",
    municipio: "Cachoeira Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "3300803",
    municipio: "Cachoeiras de Macacu",
    estado_codigo: "33",
  },
  {
    codigo: "4303103",
    municipio: "Cachoeirinha",
    estado_codigo: "43",
  },
  {
    codigo: "2603108",
    municipio: "Cachoeirinha",
    estado_codigo: "26",
  },
  {
    codigo: "1703826",
    municipio: "Cachoeirinha",
    estado_codigo: "17",
  },
  {
    codigo: "3201209",
    municipio: "Cachoeiro de Itapemirim",
    estado_codigo: "32",
  },
  {
    codigo: "2503407",
    municipio: "Cacimba de Areia",
    estado_codigo: "25",
  },
  {
    codigo: "2503506",
    municipio: "Cacimba de Dentro",
    estado_codigo: "25",
  },
  {
    codigo: "2503555",
    municipio: "Cacimbas",
    estado_codigo: "25",
  },
  {
    codigo: "2701209",
    municipio: "Cacimbinhas",
    estado_codigo: "27",
  },
  {
    codigo: "4303202",
    municipio: "Cacique Doble",
    estado_codigo: "43",
  },
  {
    codigo: "1100049",
    municipio: "Cacoal",
    estado_codigo: "11",
  },
  {
    codigo: "3508702",
    municipio: "Caconde",
    estado_codigo: "35",
  },
  {
    codigo: "5204300",
    municipio: "Caçu",
    estado_codigo: "52",
  },
  {
    codigo: "2905008",
    municipio: "Caculé",
    estado_codigo: "29",
  },
  {
    codigo: "2905107",
    municipio: "Caém",
    estado_codigo: "29",
  },
  {
    codigo: "3109907",
    municipio: "Caetanópolis",
    estado_codigo: "31",
  },
  {
    codigo: "2905156",
    municipio: "Caetanos",
    estado_codigo: "29",
  },
  {
    codigo: "3110004",
    municipio: "Caeté",
    estado_codigo: "31",
  },
  {
    codigo: "2603207",
    municipio: "Caetés",
    estado_codigo: "26",
  },
  {
    codigo: "2905206",
    municipio: "Caetité",
    estado_codigo: "29",
  },
  {
    codigo: "2905305",
    municipio: "Cafarnaum",
    estado_codigo: "29",
  },
  {
    codigo: "4103404",
    municipio: "Cafeara",
    estado_codigo: "41",
  },
  {
    codigo: "3508801",
    municipio: "Cafelândia",
    estado_codigo: "35",
  },
  {
    codigo: "4103453",
    municipio: "Cafelândia",
    estado_codigo: "41",
  },
  {
    codigo: "4103479",
    municipio: "Cafezal do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "3508900",
    municipio: "Caiabu",
    estado_codigo: "35",
  },
  {
    codigo: "3110103",
    municipio: "Caiana",
    estado_codigo: "31",
  },
  {
    codigo: "5204409",
    municipio: "Caiapônia",
    estado_codigo: "52",
  },
  {
    codigo: "4303301",
    municipio: "Caibaté",
    estado_codigo: "43",
  },
  {
    codigo: "4203105",
    municipio: "Caibi",
    estado_codigo: "42",
  },
  {
    codigo: "2503605",
    municipio: "Caiçara",
    estado_codigo: "25",
  },
  {
    codigo: "4303400",
    municipio: "Caiçara",
    estado_codigo: "43",
  },
  {
    codigo: "2401859",
    municipio: "Caiçara do Norte",
    estado_codigo: "24",
  },
  {
    codigo: "2401909",
    municipio: "Caiçara do Rio do Vento",
    estado_codigo: "24",
  },
  {
    codigo: "2402006",
    municipio: "Caicó",
    estado_codigo: "24",
  },
  {
    codigo: "3509007",
    municipio: "Caieiras",
    estado_codigo: "35",
  },
  {
    codigo: "2905404",
    municipio: "Cairu",
    estado_codigo: "29",
  },
  {
    codigo: "3509106",
    municipio: "Caiuá",
    estado_codigo: "35",
  },
  {
    codigo: "3509205",
    municipio: "Cajamar",
    estado_codigo: "35",
  },
  {
    codigo: "2102408",
    municipio: "Cajapió",
    estado_codigo: "21",
  },
  {
    codigo: "2102507",
    municipio: "Cajari",
    estado_codigo: "21",
  },
  {
    codigo: "3509254",
    municipio: "Cajati",
    estado_codigo: "35",
  },
  {
    codigo: "2503704",
    municipio: "Cajazeiras",
    estado_codigo: "25",
  },
  {
    codigo: "2202075",
    municipio: "Cajazeiras do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2503753",
    municipio: "Cajazeirinhas",
    estado_codigo: "25",
  },
  {
    codigo: "3509304",
    municipio: "Cajobi",
    estado_codigo: "35",
  },
  {
    codigo: "2701308",
    municipio: "Cajueiro",
    estado_codigo: "27",
  },
  {
    codigo: "2202083",
    municipio: "Cajueiro da Praia",
    estado_codigo: "22",
  },
  {
    codigo: "3110202",
    municipio: "Cajuri",
    estado_codigo: "31",
  },
  {
    codigo: "3509403",
    municipio: "Cajuru",
    estado_codigo: "35",
  },
  {
    codigo: "2603306",
    municipio: "Calçado",
    estado_codigo: "26",
  },
  {
    codigo: "1600204",
    municipio: "Calçoene",
    estado_codigo: "16",
  },
  {
    codigo: "3110301",
    municipio: "Caldas",
    estado_codigo: "31",
  },
  {
    codigo: "2503803",
    municipio: "Caldas Brandão",
    estado_codigo: "25",
  },
  {
    codigo: "5204508",
    municipio: "Caldas Novas",
    estado_codigo: "52",
  },
  {
    codigo: "5204557",
    municipio: "Caldazinha",
    estado_codigo: "52",
  },
  {
    codigo: "2905503",
    municipio: "Caldeirão Grande",
    estado_codigo: "29",
  },
  {
    codigo: "2202091",
    municipio: "Caldeirão Grande do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4103503",
    municipio: "Califórnia",
    estado_codigo: "41",
  },
  {
    codigo: "4203154",
    municipio: "Calmon",
    estado_codigo: "42",
  },
  {
    codigo: "2603405",
    municipio: "Calumbi",
    estado_codigo: "26",
  },
  {
    codigo: "2905602",
    municipio: "Camacan",
    estado_codigo: "29",
  },
  {
    codigo: "2905701",
    municipio: "Camaçari",
    estado_codigo: "29",
  },
  {
    codigo: "3110400",
    municipio: "Camacho",
    estado_codigo: "31",
  },
  {
    codigo: "2503902",
    municipio: "Camalaú",
    estado_codigo: "25",
  },
  {
    codigo: "2905800",
    municipio: "Camamu",
    estado_codigo: "29",
  },
  {
    codigo: "3110509",
    municipio: "Camanducaia",
    estado_codigo: "31",
  },
  {
    codigo: "5002605",
    municipio: "Camapuã",
    estado_codigo: "50",
  },
  {
    codigo: "4303509",
    municipio: "Camaquã",
    estado_codigo: "43",
  },
  {
    codigo: "2603454",
    municipio: "Camaragibe",
    estado_codigo: "26",
  },
  {
    codigo: "4303558",
    municipio: "Camargo",
    estado_codigo: "43",
  },
  {
    codigo: "4103602",
    municipio: "Cambará",
    estado_codigo: "41",
  },
  {
    codigo: "4303608",
    municipio: "Cambará do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4103701",
    municipio: "Cambé",
    estado_codigo: "41",
  },
  {
    codigo: "4103800",
    municipio: "Cambira",
    estado_codigo: "41",
  },
  {
    codigo: "4203204",
    municipio: "Camboriú",
    estado_codigo: "42",
  },
  {
    codigo: "3300902",
    municipio: "Cambuci",
    estado_codigo: "33",
  },
  {
    codigo: "3110608",
    municipio: "Cambuí",
    estado_codigo: "31",
  },
  {
    codigo: "3110707",
    municipio: "Cambuquira",
    estado_codigo: "31",
  },
  {
    codigo: "1502103",
    municipio: "Cametá",
    estado_codigo: "15",
  },
  {
    codigo: "2302602",
    municipio: "Camocim",
    estado_codigo: "23",
  },
  {
    codigo: "2603504",
    municipio: "Camocim de São Félix",
    estado_codigo: "26",
  },
  {
    codigo: "3110806",
    municipio: "Campanário",
    estado_codigo: "31",
  },
  {
    codigo: "3110905",
    municipio: "Campanha",
    estado_codigo: "31",
  },
  {
    codigo: "2701357",
    municipio: "Campestre",
    estado_codigo: "27",
  },
  {
    codigo: "3111002",
    municipio: "Campestre",
    estado_codigo: "31",
  },
  {
    codigo: "4303673",
    municipio: "Campestre da Serra",
    estado_codigo: "43",
  },
  {
    codigo: "5204607",
    municipio: "Campestre de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "2102556",
    municipio: "Campestre do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "5204656",
    municipio: "Campinaçu",
    estado_codigo: "52",
  },
  {
    codigo: "4103909",
    municipio: "Campina da Lagoa",
    estado_codigo: "41",
  },
  {
    codigo: "4303707",
    municipio: "Campina das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "3509452",
    municipio: "Campina do Monte Alegre",
    estado_codigo: "35",
  },
  {
    codigo: "4103958",
    municipio: "Campina do Simão",
    estado_codigo: "41",
  },
  {
    codigo: "2504009",
    municipio: "Campina Grande",
    estado_codigo: "25",
  },
  {
    codigo: "4104006",
    municipio: "Campina Grande do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "5102603",
    municipio: "Campinápolis",
    estado_codigo: "51",
  },
  {
    codigo: "3509502",
    municipio: "Campinas",
    estado_codigo: "35",
  },
  {
    codigo: "2202109",
    municipio: "Campinas do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4303806",
    municipio: "Campinas do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3111101",
    municipio: "Campina Verde",
    estado_codigo: "31",
  },
  {
    codigo: "5204706",
    municipio: "Campinorte",
    estado_codigo: "52",
  },
  {
    codigo: "2701407",
    municipio: "Campo Alegre",
    estado_codigo: "27",
  },
  {
    codigo: "4203303",
    municipio: "Campo Alegre",
    estado_codigo: "42",
  },
  {
    codigo: "5204805",
    municipio: "Campo Alegre de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "2905909",
    municipio: "Campo Alegre de Lourdes",
    estado_codigo: "29",
  },
  {
    codigo: "2202117",
    municipio: "Campo Alegre do Fidalgo",
    estado_codigo: "22",
  },
  {
    codigo: "3111150",
    municipio: "Campo Azul",
    estado_codigo: "31",
  },
  {
    codigo: "3111200",
    municipio: "Campo Belo",
    estado_codigo: "31",
  },
  {
    codigo: "4203402",
    municipio: "Campo Belo do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "4303905",
    municipio: "Campo Bom",
    estado_codigo: "43",
  },
  {
    codigo: "4104055",
    municipio: "Campo Bonito",
    estado_codigo: "41",
  },
  {
    codigo: "2516409",
    municipio: "Campo de Santana",
    estado_codigo: "25",
  },
  {
    codigo: "2801009",
    municipio: "Campo do Brito",
    estado_codigo: "28",
  },
  {
    codigo: "3111309",
    municipio: "Campo do Meio",
    estado_codigo: "31",
  },
  {
    codigo: "4104105",
    municipio: "Campo do Tenente",
    estado_codigo: "41",
  },
  {
    codigo: "4203501",
    municipio: "Campo Erê",
    estado_codigo: "42",
  },
  {
    codigo: "3111408",
    municipio: "Campo Florido",
    estado_codigo: "31",
  },
  {
    codigo: "2906006",
    municipio: "Campo Formoso",
    estado_codigo: "29",
  },
  {
    codigo: "5002704",
    municipio: "Campo Grande",
    estado_codigo: "50",
  },
  {
    codigo: "2701506",
    municipio: "Campo Grande",
    estado_codigo: "27",
  },
  {
    codigo: "2202133",
    municipio: "Campo Grande do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4104204",
    municipio: "Campo Largo",
    estado_codigo: "41",
  },
  {
    codigo: "2202174",
    municipio: "Campo Largo do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "5204854",
    municipio: "Campo Limpo de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3509601",
    municipio: "Campo Limpo Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4104253",
    municipio: "Campo Magro",
    estado_codigo: "41",
  },
  {
    codigo: "2202208",
    municipio: "Campo Maior",
    estado_codigo: "22",
  },
  {
    codigo: "4104303",
    municipio: "Campo Mourão",
    estado_codigo: "41",
  },
  {
    codigo: "4304002",
    municipio: "Campo Novo",
    estado_codigo: "43",
  },
  {
    codigo: "1100700",
    municipio: "Campo Novo de Rondônia",
    estado_codigo: "11",
  },
  {
    codigo: "5102637",
    municipio: "Campo Novo do Parecis",
    estado_codigo: "51",
  },
  {
    codigo: "2402105",
    municipio: "Campo Redondo",
    estado_codigo: "24",
  },
  {
    codigo: "3111507",
    municipio: "Campos Altos",
    estado_codigo: "31",
  },
  {
    codigo: "5204904",
    municipio: "Campos Belos",
    estado_codigo: "52",
  },
  {
    codigo: "4304101",
    municipio: "Campos Borges",
    estado_codigo: "43",
  },
  {
    codigo: "5102686",
    municipio: "Campos de Júlio",
    estado_codigo: "51",
  },
  {
    codigo: "3509700",
    municipio: "Campos do Jordão",
    estado_codigo: "35",
  },
  {
    codigo: "3301009",
    municipio: "Campos dos Goytacazes",
    estado_codigo: "33",
  },
  {
    codigo: "3111606",
    municipio: "Campos Gerais",
    estado_codigo: "31",
  },
  {
    codigo: "1703842",
    municipio: "Campos Lindos",
    estado_codigo: "17",
  },
  {
    codigo: "4203600",
    municipio: "Campos Novos",
    estado_codigo: "42",
  },
  {
    codigo: "3509809",
    municipio: "Campos Novos Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "2302701",
    municipio: "Campos Sales",
    estado_codigo: "23",
  },
  {
    codigo: "5204953",
    municipio: "Campos Verdes",
    estado_codigo: "52",
  },
  {
    codigo: "5102678",
    municipio: "Campo Verde",
    estado_codigo: "51",
  },
  {
    codigo: "2603603",
    municipio: "Camutanga",
    estado_codigo: "26",
  },
  {
    codigo: "3111705",
    municipio: "Canaã",
    estado_codigo: "31",
  },
  {
    codigo: "1502152",
    municipio: "Canaã dos Carajás",
    estado_codigo: "15",
  },
  {
    codigo: "5102694",
    municipio: "Canabrava do Norte",
    estado_codigo: "51",
  },
  {
    codigo: "3509908",
    municipio: "Cananéia",
    estado_codigo: "35",
  },
  {
    codigo: "2701605",
    municipio: "Canapi",
    estado_codigo: "27",
  },
  {
    codigo: "2906105",
    municipio: "Canápolis",
    estado_codigo: "29",
  },
  {
    codigo: "3111804",
    municipio: "Canápolis",
    estado_codigo: "31",
  },
  {
    codigo: "2906204",
    municipio: "Canarana",
    estado_codigo: "29",
  },
  {
    codigo: "5102702",
    municipio: "Canarana",
    estado_codigo: "51",
  },
  {
    codigo: "3509957",
    municipio: "Canas",
    estado_codigo: "35",
  },
  {
    codigo: "3111903",
    municipio: "Cana Verde",
    estado_codigo: "31",
  },
  {
    codigo: "2202251",
    municipio: "Canavieira",
    estado_codigo: "22",
  },
  {
    codigo: "2906303",
    municipio: "Canavieiras",
    estado_codigo: "29",
  },
  {
    codigo: "2906402",
    municipio: "Candeal",
    estado_codigo: "29",
  },
  {
    codigo: "2906501",
    municipio: "Candeias",
    estado_codigo: "29",
  },
  {
    codigo: "3112000",
    municipio: "Candeias",
    estado_codigo: "31",
  },
  {
    codigo: "1100809",
    municipio: "Candeias do Jamari",
    estado_codigo: "11",
  },
  {
    codigo: "4304200",
    municipio: "Candelária",
    estado_codigo: "43",
  },
  {
    codigo: "2906600",
    municipio: "Candiba",
    estado_codigo: "29",
  },
  {
    codigo: "4104402",
    municipio: "Cândido de Abreu",
    estado_codigo: "41",
  },
  {
    codigo: "4304309",
    municipio: "Cândido Godói",
    estado_codigo: "43",
  },
  {
    codigo: "2102606",
    municipio: "Cândido Mendes",
    estado_codigo: "21",
  },
  {
    codigo: "3510005",
    municipio: "Cândido Mota",
    estado_codigo: "35",
  },
  {
    codigo: "3510104",
    municipio: "Cândido Rodrigues",
    estado_codigo: "35",
  },
  {
    codigo: "2906709",
    municipio: "Cândido Sales",
    estado_codigo: "29",
  },
  {
    codigo: "4304358",
    municipio: "Candiota",
    estado_codigo: "43",
  },
  {
    codigo: "4104428",
    municipio: "Candói",
    estado_codigo: "41",
  },
  {
    codigo: "4304408",
    municipio: "Canela",
    estado_codigo: "43",
  },
  {
    codigo: "4203709",
    municipio: "Canelinha",
    estado_codigo: "42",
  },
  {
    codigo: "2402204",
    municipio: "Canguaretama",
    estado_codigo: "24",
  },
  {
    codigo: "4304507",
    municipio: "Canguçu",
    estado_codigo: "43",
  },
  {
    codigo: "2801108",
    municipio: "Canhoba",
    estado_codigo: "28",
  },
  {
    codigo: "2603702",
    municipio: "Canhotinho",
    estado_codigo: "26",
  },
  {
    codigo: "2302800",
    municipio: "Canindé",
    estado_codigo: "23",
  },
  {
    codigo: "2801207",
    municipio: "Canindé de São Francisco",
    estado_codigo: "28",
  },
  {
    codigo: "3510153",
    municipio: "Canitar",
    estado_codigo: "35",
  },
  {
    codigo: "4304606",
    municipio: "Canoas",
    estado_codigo: "43",
  },
  {
    codigo: "4203808",
    municipio: "Canoinhas",
    estado_codigo: "42",
  },
  {
    codigo: "2906808",
    municipio: "Cansanção",
    estado_codigo: "29",
  },
  {
    codigo: "1400175",
    municipio: "Cantá",
    estado_codigo: "14",
  },
  {
    codigo: "4104451",
    municipio: "Cantagalo",
    estado_codigo: "41",
  },
  {
    codigo: "3112059",
    municipio: "Cantagalo",
    estado_codigo: "31",
  },
  {
    codigo: "3301108",
    municipio: "Cantagalo",
    estado_codigo: "33",
  },
  {
    codigo: "2102705",
    municipio: "Cantanhede",
    estado_codigo: "21",
  },
  {
    codigo: "2202307",
    municipio: "Canto do Buriti",
    estado_codigo: "22",
  },
  {
    codigo: "2906824",
    municipio: "Canudos",
    estado_codigo: "29",
  },
  {
    codigo: "4304614",
    municipio: "Canudos do Vale",
    estado_codigo: "43",
  },
  {
    codigo: "1300904",
    municipio: "Canutama",
    estado_codigo: "13",
  },
  {
    codigo: "1502202",
    municipio: "Capanema",
    estado_codigo: "15",
  },
  {
    codigo: "4104501",
    municipio: "Capanema",
    estado_codigo: "41",
  },
  {
    codigo: "4203253",
    municipio: "Capão Alto",
    estado_codigo: "42",
  },
  {
    codigo: "3510203",
    municipio: "Capão Bonito",
    estado_codigo: "35",
  },
  {
    codigo: "4304622",
    municipio: "Capão Bonito do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4304630",
    municipio: "Capão da Canoa",
    estado_codigo: "43",
  },
  {
    codigo: "4304655",
    municipio: "Capão do Cipó",
    estado_codigo: "43",
  },
  {
    codigo: "4304663",
    municipio: "Capão do Leão",
    estado_codigo: "43",
  },
  {
    codigo: "3112109",
    municipio: "Caparaó",
    estado_codigo: "31",
  },
  {
    codigo: "2801306",
    municipio: "Capela",
    estado_codigo: "28",
  },
  {
    codigo: "2701704",
    municipio: "Capela",
    estado_codigo: "27",
  },
  {
    codigo: "4304689",
    municipio: "Capela de Santana",
    estado_codigo: "43",
  },
  {
    codigo: "3510302",
    municipio: "Capela do Alto",
    estado_codigo: "35",
  },
  {
    codigo: "2906857",
    municipio: "Capela do Alto Alegre",
    estado_codigo: "29",
  },
  {
    codigo: "3112208",
    municipio: "Capela Nova",
    estado_codigo: "31",
  },
  {
    codigo: "3112307",
    municipio: "Capelinha",
    estado_codigo: "31",
  },
  {
    codigo: "3112406",
    municipio: "Capetinga",
    estado_codigo: "31",
  },
  {
    codigo: "2504033",
    municipio: "Capim",
    estado_codigo: "25",
  },
  {
    codigo: "3112505",
    municipio: "Capim Branco",
    estado_codigo: "31",
  },
  {
    codigo: "2906873",
    municipio: "Capim Grosso",
    estado_codigo: "29",
  },
  {
    codigo: "3112604",
    municipio: "Capinópolis",
    estado_codigo: "31",
  },
  {
    codigo: "4203907",
    municipio: "Capinzal",
    estado_codigo: "42",
  },
  {
    codigo: "2102754",
    municipio: "Capinzal do Norte",
    estado_codigo: "21",
  },
  {
    codigo: "2302909",
    municipio: "Capistrano",
    estado_codigo: "23",
  },
  {
    codigo: "4304697",
    municipio: "Capitão",
    estado_codigo: "43",
  },
  {
    codigo: "3112653",
    municipio: "Capitão Andrade",
    estado_codigo: "31",
  },
  {
    codigo: "2202406",
    municipio: "Capitão de Campos",
    estado_codigo: "22",
  },
  {
    codigo: "3112703",
    municipio: "Capitão Enéas",
    estado_codigo: "31",
  },
  {
    codigo: "2202455",
    municipio: "Capitão Gervásio Oliveira",
    estado_codigo: "22",
  },
  {
    codigo: "4104600",
    municipio: "Capitão Leônidas Marques",
    estado_codigo: "41",
  },
  {
    codigo: "1502301",
    municipio: "Capitão Poço",
    estado_codigo: "15",
  },
  {
    codigo: "3112802",
    municipio: "Capitólio",
    estado_codigo: "31",
  },
  {
    codigo: "3510401",
    municipio: "Capivari",
    estado_codigo: "35",
  },
  {
    codigo: "4203956",
    municipio: "Capivari de Baixo",
    estado_codigo: "42",
  },
  {
    codigo: "4304671",
    municipio: "Capivari do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "1200179",
    municipio: "Capixaba",
    estado_codigo: "12",
  },
  {
    codigo: "2603801",
    municipio: "Capoeiras",
    estado_codigo: "26",
  },
  {
    codigo: "3112901",
    municipio: "Caputira",
    estado_codigo: "31",
  },
  {
    codigo: "4304713",
    municipio: "Caraá",
    estado_codigo: "43",
  },
  {
    codigo: "1400209",
    municipio: "Caracaraí",
    estado_codigo: "14",
  },
  {
    codigo: "2202505",
    municipio: "Caracol",
    estado_codigo: "22",
  },
  {
    codigo: "5002803",
    municipio: "Caracol",
    estado_codigo: "50",
  },
  {
    codigo: "3510500",
    municipio: "Caraguatatuba",
    estado_codigo: "35",
  },
  {
    codigo: "3113008",
    municipio: "Caraí",
    estado_codigo: "31",
  },
  {
    codigo: "2906899",
    municipio: "Caraíbas",
    estado_codigo: "29",
  },
  {
    codigo: "4104659",
    municipio: "Carambeí",
    estado_codigo: "41",
  },
  {
    codigo: "3113107",
    municipio: "Caranaíba",
    estado_codigo: "31",
  },
  {
    codigo: "3113206",
    municipio: "Carandaí",
    estado_codigo: "31",
  },
  {
    codigo: "3113305",
    municipio: "Carangola",
    estado_codigo: "31",
  },
  {
    codigo: "3300936",
    municipio: "Carapebus",
    estado_codigo: "33",
  },
  {
    codigo: "3510609",
    municipio: "Carapicuíba",
    estado_codigo: "35",
  },
  {
    codigo: "3113404",
    municipio: "Caratinga",
    estado_codigo: "31",
  },
  {
    codigo: "1301001",
    municipio: "Carauari",
    estado_codigo: "13",
  },
  {
    codigo: "2402303",
    municipio: "Caraúbas",
    estado_codigo: "24",
  },
  {
    codigo: "2504074",
    municipio: "Caraúbas",
    estado_codigo: "25",
  },
  {
    codigo: "2202539",
    municipio: "Caraúbas do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2906907",
    municipio: "Caravelas",
    estado_codigo: "29",
  },
  {
    codigo: "4304705",
    municipio: "Carazinho",
    estado_codigo: "43",
  },
  {
    codigo: "3113503",
    municipio: "Carbonita",
    estado_codigo: "31",
  },
  {
    codigo: "2907004",
    municipio: "Cardeal da Silva",
    estado_codigo: "29",
  },
  {
    codigo: "3510708",
    municipio: "Cardoso",
    estado_codigo: "35",
  },
  {
    codigo: "3301157",
    municipio: "Cardoso Moreira",
    estado_codigo: "33",
  },
  {
    codigo: "3113602",
    municipio: "Careaçu",
    estado_codigo: "31",
  },
  {
    codigo: "1301100",
    municipio: "Careiro",
    estado_codigo: "13",
  },
  {
    codigo: "1301159",
    municipio: "Careiro da Várzea",
    estado_codigo: "13",
  },
  {
    codigo: "3201308",
    municipio: "Cariacica",
    estado_codigo: "32",
  },
  {
    codigo: "2303006",
    municipio: "Caridade",
    estado_codigo: "23",
  },
  {
    codigo: "2202554",
    municipio: "Caridade do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2907103",
    municipio: "Carinhanha",
    estado_codigo: "29",
  },
  {
    codigo: "2801405",
    municipio: "Carira",
    estado_codigo: "28",
  },
  {
    codigo: "2303105",
    municipio: "Cariré",
    estado_codigo: "23",
  },
  {
    codigo: "2303204",
    municipio: "Caririaçu",
    estado_codigo: "23",
  },
  {
    codigo: "1703867",
    municipio: "Cariri do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2303303",
    municipio: "Cariús",
    estado_codigo: "23",
  },
  {
    codigo: "5102793",
    municipio: "Carlinda",
    estado_codigo: "51",
  },
  {
    codigo: "4104709",
    municipio: "Carlópolis",
    estado_codigo: "41",
  },
  {
    codigo: "4304804",
    municipio: "Carlos Barbosa",
    estado_codigo: "43",
  },
  {
    codigo: "3113701",
    municipio: "Carlos Chagas",
    estado_codigo: "31",
  },
  {
    codigo: "4304853",
    municipio: "Carlos Gomes",
    estado_codigo: "43",
  },
  {
    codigo: "3113800",
    municipio: "Carmésia",
    estado_codigo: "31",
  },
  {
    codigo: "3301207",
    municipio: "Carmo",
    estado_codigo: "33",
  },
  {
    codigo: "3113909",
    municipio: "Carmo da Cachoeira",
    estado_codigo: "31",
  },
  {
    codigo: "3114006",
    municipio: "Carmo da Mata",
    estado_codigo: "31",
  },
  {
    codigo: "3114105",
    municipio: "Carmo de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "3114204",
    municipio: "Carmo do Cajuru",
    estado_codigo: "31",
  },
  {
    codigo: "3114303",
    municipio: "Carmo do Paranaíba",
    estado_codigo: "31",
  },
  {
    codigo: "3114402",
    municipio: "Carmo do Rio Claro",
    estado_codigo: "31",
  },
  {
    codigo: "5205000",
    municipio: "Carmo do Rio Verde",
    estado_codigo: "52",
  },
  {
    codigo: "1703883",
    municipio: "Carmolândia",
    estado_codigo: "17",
  },
  {
    codigo: "2801504",
    municipio: "Carmópolis",
    estado_codigo: "28",
  },
  {
    codigo: "3114501",
    municipio: "Carmópolis de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2603900",
    municipio: "Carnaíba",
    estado_codigo: "26",
  },
  {
    codigo: "2402402",
    municipio: "Carnaúba dos Dantas",
    estado_codigo: "24",
  },
  {
    codigo: "2402501",
    municipio: "Carnaubais",
    estado_codigo: "24",
  },
  {
    codigo: "2303402",
    municipio: "Carnaubal",
    estado_codigo: "23",
  },
  {
    codigo: "2603926",
    municipio: "Carnaubeira da Penha",
    estado_codigo: "26",
  },
  {
    codigo: "3114550",
    municipio: "Carneirinho",
    estado_codigo: "31",
  },
  {
    codigo: "2701803",
    municipio: "Carneiros",
    estado_codigo: "27",
  },
  {
    codigo: "1400233",
    municipio: "Caroebe",
    estado_codigo: "14",
  },
  {
    codigo: "2102804",
    municipio: "Carolina",
    estado_codigo: "21",
  },
  {
    codigo: "2604007",
    municipio: "Carpina",
    estado_codigo: "26",
  },
  {
    codigo: "3114600",
    municipio: "Carrancas",
    estado_codigo: "31",
  },
  {
    codigo: "2504108",
    municipio: "Carrapateira",
    estado_codigo: "25",
  },
  {
    codigo: "1703891",
    municipio: "Carrasco Bonito",
    estado_codigo: "17",
  },
  {
    codigo: "2604106",
    municipio: "Caruaru",
    estado_codigo: "26",
  },
  {
    codigo: "2102903",
    municipio: "Carutapera",
    estado_codigo: "21",
  },
  {
    codigo: "3114709",
    municipio: "Carvalhópolis",
    estado_codigo: "31",
  },
  {
    codigo: "3114808",
    municipio: "Carvalhos",
    estado_codigo: "31",
  },
  {
    codigo: "3510807",
    municipio: "Casa Branca",
    estado_codigo: "35",
  },
  {
    codigo: "3114907",
    municipio: "Casa Grande",
    estado_codigo: "31",
  },
  {
    codigo: "2907202",
    municipio: "Casa Nova",
    estado_codigo: "29",
  },
  {
    codigo: "4304903",
    municipio: "Casca",
    estado_codigo: "43",
  },
  {
    codigo: "3115003",
    municipio: "Cascalho Rico",
    estado_codigo: "31",
  },
  {
    codigo: "4104808",
    municipio: "Cascavel",
    estado_codigo: "41",
  },
  {
    codigo: "2303501",
    municipio: "Cascavel",
    estado_codigo: "23",
  },
  {
    codigo: "1703909",
    municipio: "Caseara",
    estado_codigo: "17",
  },
  {
    codigo: "4304952",
    municipio: "Caseiros",
    estado_codigo: "43",
  },
  {
    codigo: "3301306",
    municipio: "Casimiro de Abreu",
    estado_codigo: "33",
  },
  {
    codigo: "2604155",
    municipio: "Casinhas",
    estado_codigo: "26",
  },
  {
    codigo: "2504157",
    municipio: "Casserengue",
    estado_codigo: "25",
  },
  {
    codigo: "3115102",
    municipio: "Cássia",
    estado_codigo: "31",
  },
  {
    codigo: "3510906",
    municipio: "Cássia dos Coqueiros",
    estado_codigo: "35",
  },
  {
    codigo: "5002902",
    municipio: "Cassilândia",
    estado_codigo: "50",
  },
  {
    codigo: "1502400",
    municipio: "Castanhal",
    estado_codigo: "15",
  },
  {
    codigo: "5102850",
    municipio: "Castanheira",
    estado_codigo: "51",
  },
  {
    codigo: "1100908",
    municipio: "Castanheiras",
    estado_codigo: "11",
  },
  {
    codigo: "5205059",
    municipio: "Castelândia",
    estado_codigo: "52",
  },
  {
    codigo: "3201407",
    municipio: "Castelo",
    estado_codigo: "32",
  },
  {
    codigo: "2202604",
    municipio: "Castelo do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3511003",
    municipio: "Castilho",
    estado_codigo: "35",
  },
  {
    codigo: "4104907",
    municipio: "Castro",
    estado_codigo: "41",
  },
  {
    codigo: "2907301",
    municipio: "Castro Alves",
    estado_codigo: "29",
  },
  {
    codigo: "3115300",
    municipio: "Cataguases",
    estado_codigo: "31",
  },
  {
    codigo: "5205109",
    municipio: "Catalão",
    estado_codigo: "52",
  },
  {
    codigo: "3511102",
    municipio: "Catanduva",
    estado_codigo: "35",
  },
  {
    codigo: "4105003",
    municipio: "Catanduvas",
    estado_codigo: "41",
  },
  {
    codigo: "4204004",
    municipio: "Catanduvas",
    estado_codigo: "42",
  },
  {
    codigo: "2303600",
    municipio: "Catarina",
    estado_codigo: "23",
  },
  {
    codigo: "3115359",
    municipio: "Catas Altas",
    estado_codigo: "31",
  },
  {
    codigo: "3115409",
    municipio: "Catas Altas da Noruega",
    estado_codigo: "31",
  },
  {
    codigo: "2604205",
    municipio: "Catende",
    estado_codigo: "26",
  },
  {
    codigo: "3511201",
    municipio: "Catiguá",
    estado_codigo: "35",
  },
  {
    codigo: "2504207",
    municipio: "Catingueira",
    estado_codigo: "25",
  },
  {
    codigo: "2907400",
    municipio: "Catolândia",
    estado_codigo: "29",
  },
  {
    codigo: "2504306",
    municipio: "Catolé do Rocha",
    estado_codigo: "25",
  },
  {
    codigo: "2907509",
    municipio: "Catu",
    estado_codigo: "29",
  },
  {
    codigo: "4305009",
    municipio: "Catuípe",
    estado_codigo: "43",
  },
  {
    codigo: "3115458",
    municipio: "Catuji",
    estado_codigo: "31",
  },
  {
    codigo: "2303659",
    municipio: "Catunda",
    estado_codigo: "23",
  },
  {
    codigo: "5205208",
    municipio: "Caturaí",
    estado_codigo: "52",
  },
  {
    codigo: "2907558",
    municipio: "Caturama",
    estado_codigo: "29",
  },
  {
    codigo: "2504355",
    municipio: "Caturité",
    estado_codigo: "25",
  },
  {
    codigo: "3115474",
    municipio: "Catuti",
    estado_codigo: "31",
  },
  {
    codigo: "2303709",
    municipio: "Caucaia",
    estado_codigo: "23",
  },
  {
    codigo: "5205307",
    municipio: "Cavalcante",
    estado_codigo: "52",
  },
  {
    codigo: "3115508",
    municipio: "Caxambu",
    estado_codigo: "31",
  },
  {
    codigo: "4204103",
    municipio: "Caxambu do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "2103000",
    municipio: "Caxias",
    estado_codigo: "21",
  },
  {
    codigo: "4305108",
    municipio: "Caxias do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2202653",
    municipio: "Caxingó",
    estado_codigo: "22",
  },
  {
    codigo: "2402600",
    municipio: "Ceará-Mirim",
    estado_codigo: "24",
  },
  {
    codigo: "3511300",
    municipio: "Cedral",
    estado_codigo: "35",
  },
  {
    codigo: "2103109",
    municipio: "Cedral",
    estado_codigo: "21",
  },
  {
    codigo: "2303808",
    municipio: "Cedro",
    estado_codigo: "23",
  },
  {
    codigo: "2604304",
    municipio: "Cedro",
    estado_codigo: "26",
  },
  {
    codigo: "2801603",
    municipio: "Cedro de São João",
    estado_codigo: "28",
  },
  {
    codigo: "3115607",
    municipio: "Cedro do Abaeté",
    estado_codigo: "31",
  },
  {
    codigo: "4204152",
    municipio: "Celso Ramos",
    estado_codigo: "42",
  },
  {
    codigo: "1704105",
    municipio: "Centenário",
    estado_codigo: "17",
  },
  {
    codigo: "4305116",
    municipio: "Centenário",
    estado_codigo: "43",
  },
  {
    codigo: "4105102",
    municipio: "Centenário do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "2907608",
    municipio: "Central",
    estado_codigo: "29",
  },
  {
    codigo: "3115706",
    municipio: "Central de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2103125",
    municipio: "Central do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "3115805",
    municipio: "Centralina",
    estado_codigo: "31",
  },
  {
    codigo: "2103158",
    municipio: "Centro do Guilherme",
    estado_codigo: "21",
  },
  {
    codigo: "2103174",
    municipio: "Centro Novo do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "1100056",
    municipio: "Cerejeiras",
    estado_codigo: "11",
  },
  {
    codigo: "5205406",
    municipio: "Ceres",
    estado_codigo: "52",
  },
  {
    codigo: "3511409",
    municipio: "Cerqueira César",
    estado_codigo: "35",
  },
  {
    codigo: "3511508",
    municipio: "Cerquilho",
    estado_codigo: "35",
  },
  {
    codigo: "4305124",
    municipio: "Cerrito",
    estado_codigo: "43",
  },
  {
    codigo: "4105201",
    municipio: "Cerro Azul",
    estado_codigo: "41",
  },
  {
    codigo: "4305132",
    municipio: "Cerro Branco",
    estado_codigo: "43",
  },
  {
    codigo: "2402709",
    municipio: "Cerro Corá",
    estado_codigo: "24",
  },
  {
    codigo: "4305157",
    municipio: "Cerro Grande",
    estado_codigo: "43",
  },
  {
    codigo: "4305173",
    municipio: "Cerro Grande do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4305207",
    municipio: "Cerro Largo",
    estado_codigo: "43",
  },
  {
    codigo: "4204178",
    municipio: "Cerro Negro",
    estado_codigo: "42",
  },
  {
    codigo: "3511607",
    municipio: "Cesário Lange",
    estado_codigo: "35",
  },
  {
    codigo: "4105300",
    municipio: "Céu Azul",
    estado_codigo: "41",
  },
  {
    codigo: "5205455",
    municipio: "Cezarina",
    estado_codigo: "52",
  },
  {
    codigo: "3115904",
    municipio: "Chácara",
    estado_codigo: "31",
  },
  {
    codigo: "2604403",
    municipio: "Chã de Alegria",
    estado_codigo: "26",
  },
  {
    codigo: "2604502",
    municipio: "Chã Grande",
    estado_codigo: "26",
  },
  {
    codigo: "3116001",
    municipio: "Chalé",
    estado_codigo: "31",
  },
  {
    codigo: "4305306",
    municipio: "Chapada",
    estado_codigo: "43",
  },
  {
    codigo: "1705102",
    municipio: "Chapada da Natividade",
    estado_codigo: "17",
  },
  {
    codigo: "1704600",
    municipio: "Chapada de Areia",
    estado_codigo: "17",
  },
  {
    codigo: "3116100",
    municipio: "Chapada do Norte",
    estado_codigo: "31",
  },
  {
    codigo: "5103007",
    municipio: "Chapada dos Guimarães",
    estado_codigo: "51",
  },
  {
    codigo: "3116159",
    municipio: "Chapada Gaúcha",
    estado_codigo: "31",
  },
  {
    codigo: "5205471",
    municipio: "Chapadão do Céu",
    estado_codigo: "52",
  },
  {
    codigo: "4204194",
    municipio: "Chapadão do Lageado",
    estado_codigo: "42",
  },
  {
    codigo: "5002951",
    municipio: "Chapadão do Sul",
    estado_codigo: "50",
  },
  {
    codigo: "2103208",
    municipio: "Chapadinha",
    estado_codigo: "21",
  },
  {
    codigo: "4204202",
    municipio: "Chapecó",
    estado_codigo: "42",
  },
  {
    codigo: "2701902",
    municipio: "Chã Preta",
    estado_codigo: "27",
  },
  {
    codigo: "3511706",
    municipio: "Charqueada",
    estado_codigo: "35",
  },
  {
    codigo: "4305355",
    municipio: "Charqueadas",
    estado_codigo: "43",
  },
  {
    codigo: "4305371",
    municipio: "Charrua",
    estado_codigo: "43",
  },
  {
    codigo: "2303907",
    municipio: "Chaval",
    estado_codigo: "23",
  },
  {
    codigo: "3557204",
    municipio: "Chavantes",
    estado_codigo: "35",
  },
  {
    codigo: "1502509",
    municipio: "Chaves",
    estado_codigo: "15",
  },
  {
    codigo: "3116209",
    municipio: "Chiador",
    estado_codigo: "31",
  },
  {
    codigo: "4305405",
    municipio: "Chiapetta",
    estado_codigo: "43",
  },
  {
    codigo: "4105409",
    municipio: "Chopinzinho",
    estado_codigo: "41",
  },
  {
    codigo: "2303931",
    municipio: "Choró",
    estado_codigo: "23",
  },
  {
    codigo: "2303956",
    municipio: "Chorozinho",
    estado_codigo: "23",
  },
  {
    codigo: "2907707",
    municipio: "Chorrochó",
    estado_codigo: "29",
  },
  {
    codigo: "4305439",
    municipio: "Chuí",
    estado_codigo: "43",
  },
  {
    codigo: "1100924",
    municipio: "Chupinguaia",
    estado_codigo: "11",
  },
  {
    codigo: "4305447",
    municipio: "Chuvisca",
    estado_codigo: "43",
  },
  {
    codigo: "4105508",
    municipio: "Cianorte",
    estado_codigo: "41",
  },
  {
    codigo: "2907806",
    municipio: "Cícero Dantas",
    estado_codigo: "29",
  },
  {
    codigo: "4105607",
    municipio: "Cidade Gaúcha",
    estado_codigo: "41",
  },
  {
    codigo: "5205497",
    municipio: "Cidade Ocidental",
    estado_codigo: "52",
  },
  {
    codigo: "2103257",
    municipio: "Cidelândia",
    estado_codigo: "21",
  },
  {
    codigo: "4305454",
    municipio: "Cidreira",
    estado_codigo: "43",
  },
  {
    codigo: "2907905",
    municipio: "Cipó",
    estado_codigo: "29",
  },
  {
    codigo: "3116308",
    municipio: "Cipotânea",
    estado_codigo: "31",
  },
  {
    codigo: "4305504",
    municipio: "Ciríaco",
    estado_codigo: "43",
  },
  {
    codigo: "3116407",
    municipio: "Claraval",
    estado_codigo: "31",
  },
  {
    codigo: "3116506",
    municipio: "Claro dos Poções",
    estado_codigo: "31",
  },
  {
    codigo: "5103056",
    municipio: "Cláudia",
    estado_codigo: "51",
  },
  {
    codigo: "3116605",
    municipio: "Cláudio",
    estado_codigo: "31",
  },
  {
    codigo: "3511904",
    municipio: "Clementina",
    estado_codigo: "35",
  },
  {
    codigo: "4105706",
    municipio: "Clevelândia",
    estado_codigo: "41",
  },
  {
    codigo: "2908002",
    municipio: "Coaraci",
    estado_codigo: "29",
  },
  {
    codigo: "1301209",
    municipio: "Coari",
    estado_codigo: "13",
  },
  {
    codigo: "2202703",
    municipio: "Cocal",
    estado_codigo: "22",
  },
  {
    codigo: "2202711",
    municipio: "Cocal de Telha",
    estado_codigo: "22",
  },
  {
    codigo: "2202729",
    municipio: "Cocal dos Alves",
    estado_codigo: "22",
  },
  {
    codigo: "4204251",
    municipio: "Cocal do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "5103106",
    municipio: "Cocalinho",
    estado_codigo: "51",
  },
  {
    codigo: "5205513",
    municipio: "Cocalzinho de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "2908101",
    municipio: "Cocos",
    estado_codigo: "29",
  },
  {
    codigo: "1301308",
    municipio: "Codajás",
    estado_codigo: "13",
  },
  {
    codigo: "2103307",
    municipio: "Codó",
    estado_codigo: "21",
  },
  {
    codigo: "2103406",
    municipio: "Coelho Neto",
    estado_codigo: "21",
  },
  {
    codigo: "3116704",
    municipio: "Coimbra",
    estado_codigo: "31",
  },
  {
    codigo: "2702009",
    municipio: "Coité do Nóia",
    estado_codigo: "27",
  },
  {
    codigo: "2202737",
    municipio: "Coivaras",
    estado_codigo: "22",
  },
  {
    codigo: "1502608",
    municipio: "Colares",
    estado_codigo: "15",
  },
  {
    codigo: "3201506",
    municipio: "Colatina",
    estado_codigo: "32",
  },
  {
    codigo: "5103205",
    municipio: "Colíder",
    estado_codigo: "51",
  },
  {
    codigo: "3512001",
    municipio: "Colina",
    estado_codigo: "35",
  },
  {
    codigo: "4305587",
    municipio: "Colinas",
    estado_codigo: "43",
  },
  {
    codigo: "2103505",
    municipio: "Colinas",
    estado_codigo: "21",
  },
  {
    codigo: "5205521",
    municipio: "Colinas do Sul",
    estado_codigo: "52",
  },
  {
    codigo: "1705508",
    municipio: "Colinas do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "1716703",
    municipio: "Colméia",
    estado_codigo: "17",
  },
  {
    codigo: "5103254",
    municipio: "Colniza",
    estado_codigo: "51",
  },
  {
    codigo: "3512100",
    municipio: "Colômbia",
    estado_codigo: "35",
  },
  {
    codigo: "4105805",
    municipio: "Colombo",
    estado_codigo: "41",
  },
  {
    codigo: "2202752",
    municipio: "Colônia do Gurguéia",
    estado_codigo: "22",
  },
  {
    codigo: "2202778",
    municipio: "Colônia do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2702108",
    municipio: "Colônia Leopoldina",
    estado_codigo: "27",
  },
  {
    codigo: "4305603",
    municipio: "Colorado",
    estado_codigo: "43",
  },
  {
    codigo: "4105904",
    municipio: "Colorado",
    estado_codigo: "41",
  },
  {
    codigo: "1100064",
    municipio: "Colorado do Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "3116803",
    municipio: "Coluna",
    estado_codigo: "31",
  },
  {
    codigo: "1705557",
    municipio: "Combinado",
    estado_codigo: "17",
  },
  {
    codigo: "3116902",
    municipio: "Comendador Gomes",
    estado_codigo: "31",
  },
  {
    codigo: "3300951",
    municipio: "Comendador Levy Gasparian",
    estado_codigo: "33",
  },
  {
    codigo: "3117009",
    municipio: "Comercinho",
    estado_codigo: "31",
  },
  {
    codigo: "5103304",
    municipio: "Comodoro",
    estado_codigo: "51",
  },
  {
    codigo: "2504405",
    municipio: "Conceição",
    estado_codigo: "25",
  },
  {
    codigo: "3117108",
    municipio: "Conceição da Aparecida",
    estado_codigo: "31",
  },
  {
    codigo: "3201605",
    municipio: "Conceição da Barra",
    estado_codigo: "32",
  },
  {
    codigo: "3115201",
    municipio: "Conceição da Barra de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2908200",
    municipio: "Conceição da Feira",
    estado_codigo: "29",
  },
  {
    codigo: "3117306",
    municipio: "Conceição das Alagoas",
    estado_codigo: "31",
  },
  {
    codigo: "3117207",
    municipio: "Conceição das Pedras",
    estado_codigo: "31",
  },
  {
    codigo: "3117405",
    municipio: "Conceição de Ipanema",
    estado_codigo: "31",
  },
  {
    codigo: "3301405",
    municipio: "Conceição de Macabu",
    estado_codigo: "33",
  },
  {
    codigo: "2908309",
    municipio: "Conceição do Almeida",
    estado_codigo: "29",
  },
  {
    codigo: "1502707",
    municipio: "Conceição do Araguaia",
    estado_codigo: "15",
  },
  {
    codigo: "2202802",
    municipio: "Conceição do Canindé",
    estado_codigo: "22",
  },
  {
    codigo: "3201704",
    municipio: "Conceição do Castelo",
    estado_codigo: "32",
  },
  {
    codigo: "2908408",
    municipio: "Conceição do Coité",
    estado_codigo: "29",
  },
  {
    codigo: "2908507",
    municipio: "Conceição do Jacuípe",
    estado_codigo: "29",
  },
  {
    codigo: "2103554",
    municipio: "Conceição do Lago-Açu",
    estado_codigo: "21",
  },
  {
    codigo: "3117504",
    municipio: "Conceição do Mato Dentro",
    estado_codigo: "31",
  },
  {
    codigo: "3117603",
    municipio: "Conceição do Pará",
    estado_codigo: "31",
  },
  {
    codigo: "3117702",
    municipio: "Conceição do Rio Verde",
    estado_codigo: "31",
  },
  {
    codigo: "3117801",
    municipio: "Conceição dos Ouros",
    estado_codigo: "31",
  },
  {
    codigo: "1705607",
    municipio: "Conceição do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "3512209",
    municipio: "Conchal",
    estado_codigo: "35",
  },
  {
    codigo: "3512308",
    municipio: "Conchas",
    estado_codigo: "35",
  },
  {
    codigo: "4204301",
    municipio: "Concórdia",
    estado_codigo: "42",
  },
  {
    codigo: "1502756",
    municipio: "Concórdia do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "2604601",
    municipio: "Condado",
    estado_codigo: "26",
  },
  {
    codigo: "2504504",
    municipio: "Condado",
    estado_codigo: "25",
  },
  {
    codigo: "2908606",
    municipio: "Conde",
    estado_codigo: "29",
  },
  {
    codigo: "2504603",
    municipio: "Conde",
    estado_codigo: "25",
  },
  {
    codigo: "2908705",
    municipio: "Condeúba",
    estado_codigo: "29",
  },
  {
    codigo: "4305702",
    municipio: "Condor",
    estado_codigo: "43",
  },
  {
    codigo: "3117836",
    municipio: "Cônego Marinho",
    estado_codigo: "31",
  },
  {
    codigo: "3117876",
    municipio: "Confins",
    estado_codigo: "31",
  },
  {
    codigo: "5103353",
    municipio: "Confresa",
    estado_codigo: "51",
  },
  {
    codigo: "2504702",
    municipio: "Congo",
    estado_codigo: "25",
  },
  {
    codigo: "3117900",
    municipio: "Congonhal",
    estado_codigo: "31",
  },
  {
    codigo: "3118007",
    municipio: "Congonhas",
    estado_codigo: "31",
  },
  {
    codigo: "3118106",
    municipio: "Congonhas do Norte",
    estado_codigo: "31",
  },
  {
    codigo: "4106001",
    municipio: "Congonhinhas",
    estado_codigo: "41",
  },
  {
    codigo: "3118205",
    municipio: "Conquista",
    estado_codigo: "31",
  },
  {
    codigo: "5103361",
    municipio: "Conquista D'Oeste",
    estado_codigo: "51",
  },
  {
    codigo: "3118304",
    municipio: "Conselheiro Lafaiete",
    estado_codigo: "31",
  },
  {
    codigo: "4106100",
    municipio: "Conselheiro Mairinck",
    estado_codigo: "41",
  },
  {
    codigo: "3118403",
    municipio: "Conselheiro Pena",
    estado_codigo: "31",
  },
  {
    codigo: "3118502",
    municipio: "Consolação",
    estado_codigo: "31",
  },
  {
    codigo: "4305801",
    municipio: "Constantina",
    estado_codigo: "43",
  },
  {
    codigo: "3118601",
    municipio: "Contagem",
    estado_codigo: "31",
  },
  {
    codigo: "4106209",
    municipio: "Contenda",
    estado_codigo: "41",
  },
  {
    codigo: "2908804",
    municipio: "Contendas do Sincorá",
    estado_codigo: "29",
  },
  {
    codigo: "3118700",
    municipio: "Coqueiral",
    estado_codigo: "31",
  },
  {
    codigo: "4305835",
    municipio: "Coqueiro Baixo",
    estado_codigo: "43",
  },
  {
    codigo: "4305850",
    municipio: "Coqueiros do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2702207",
    municipio: "Coqueiro Seco",
    estado_codigo: "27",
  },
  {
    codigo: "3118809",
    municipio: "Coração de Jesus",
    estado_codigo: "31",
  },
  {
    codigo: "2908903",
    municipio: "Coração de Maria",
    estado_codigo: "29",
  },
  {
    codigo: "4106308",
    municipio: "Corbélia",
    estado_codigo: "41",
  },
  {
    codigo: "3301504",
    municipio: "Cordeiro",
    estado_codigo: "33",
  },
  {
    codigo: "3512407",
    municipio: "Cordeirópolis",
    estado_codigo: "35",
  },
  {
    codigo: "2909000",
    municipio: "Cordeiros",
    estado_codigo: "29",
  },
  {
    codigo: "4204350",
    municipio: "Cordilheira Alta",
    estado_codigo: "42",
  },
  {
    codigo: "3118908",
    municipio: "Cordisburgo",
    estado_codigo: "31",
  },
  {
    codigo: "3119005",
    municipio: "Cordislândia",
    estado_codigo: "31",
  },
  {
    codigo: "2304004",
    municipio: "Coreaú",
    estado_codigo: "23",
  },
  {
    codigo: "2504801",
    municipio: "Coremas",
    estado_codigo: "25",
  },
  {
    codigo: "5003108",
    municipio: "Corguinho",
    estado_codigo: "50",
  },
  {
    codigo: "2909109",
    municipio: "Coribe",
    estado_codigo: "29",
  },
  {
    codigo: "3119104",
    municipio: "Corinto",
    estado_codigo: "31",
  },
  {
    codigo: "4106407",
    municipio: "Cornélio Procópio",
    estado_codigo: "41",
  },
  {
    codigo: "3119203",
    municipio: "Coroaci",
    estado_codigo: "31",
  },
  {
    codigo: "3512506",
    municipio: "Coroados",
    estado_codigo: "35",
  },
  {
    codigo: "2103604",
    municipio: "Coroatá",
    estado_codigo: "21",
  },
  {
    codigo: "3119302",
    municipio: "Coromandel",
    estado_codigo: "31",
  },
  {
    codigo: "4305871",
    municipio: "Coronel Barros",
    estado_codigo: "43",
  },
  {
    codigo: "4305900",
    municipio: "Coronel Bicaco",
    estado_codigo: "43",
  },
  {
    codigo: "4106456",
    municipio: "Coronel Domingos Soares",
    estado_codigo: "41",
  },
  {
    codigo: "2402808",
    municipio: "Coronel Ezequiel",
    estado_codigo: "24",
  },
  {
    codigo: "3119401",
    municipio: "Coronel Fabriciano",
    estado_codigo: "31",
  },
  {
    codigo: "4204400",
    municipio: "Coronel Freitas",
    estado_codigo: "42",
  },
  {
    codigo: "2402907",
    municipio: "Coronel João Pessoa",
    estado_codigo: "24",
  },
  {
    codigo: "2909208",
    municipio: "Coronel João Sá",
    estado_codigo: "29",
  },
  {
    codigo: "2202851",
    municipio: "Coronel José Dias",
    estado_codigo: "22",
  },
  {
    codigo: "3512605",
    municipio: "Coronel Macedo",
    estado_codigo: "35",
  },
  {
    codigo: "4204459",
    municipio: "Coronel Martins",
    estado_codigo: "42",
  },
  {
    codigo: "3119500",
    municipio: "Coronel Murta",
    estado_codigo: "31",
  },
  {
    codigo: "3119609",
    municipio: "Coronel Pacheco",
    estado_codigo: "31",
  },
  {
    codigo: "4305934",
    municipio: "Coronel Pilar",
    estado_codigo: "43",
  },
  {
    codigo: "5003157",
    municipio: "Coronel Sapucaia",
    estado_codigo: "50",
  },
  {
    codigo: "4106506",
    municipio: "Coronel Vivida",
    estado_codigo: "41",
  },
  {
    codigo: "3119708",
    municipio: "Coronel Xavier Chaves",
    estado_codigo: "31",
  },
  {
    codigo: "3119807",
    municipio: "Córrego Danta",
    estado_codigo: "31",
  },
  {
    codigo: "3119906",
    municipio: "Córrego do Bom Jesus",
    estado_codigo: "31",
  },
  {
    codigo: "5205703",
    municipio: "Córrego do Ouro",
    estado_codigo: "52",
  },
  {
    codigo: "3119955",
    municipio: "Córrego Fundo",
    estado_codigo: "31",
  },
  {
    codigo: "3120003",
    municipio: "Córrego Novo",
    estado_codigo: "31",
  },
  {
    codigo: "4204558",
    municipio: "Correia Pinto",
    estado_codigo: "42",
  },
  {
    codigo: "2202901",
    municipio: "Corrente",
    estado_codigo: "22",
  },
  {
    codigo: "2604700",
    municipio: "Correntes",
    estado_codigo: "26",
  },
  {
    codigo: "2909307",
    municipio: "Correntina",
    estado_codigo: "29",
  },
  {
    codigo: "2604809",
    municipio: "Cortês",
    estado_codigo: "26",
  },
  {
    codigo: "5003207",
    municipio: "Corumbá",
    estado_codigo: "50",
  },
  {
    codigo: "5205802",
    municipio: "Corumbá de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "5205901",
    municipio: "Corumbaíba",
    estado_codigo: "52",
  },
  {
    codigo: "3512704",
    municipio: "Corumbataí",
    estado_codigo: "35",
  },
  {
    codigo: "4106555",
    municipio: "Corumbataí do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "1100072",
    municipio: "Corumbiara",
    estado_codigo: "11",
  },
  {
    codigo: "4204509",
    municipio: "Corupá",
    estado_codigo: "42",
  },
  {
    codigo: "2702306",
    municipio: "Coruripe",
    estado_codigo: "27",
  },
  {
    codigo: "3512803",
    municipio: "Cosmópolis",
    estado_codigo: "35",
  },
  {
    codigo: "3512902",
    municipio: "Cosmorama",
    estado_codigo: "35",
  },
  {
    codigo: "1100080",
    municipio: "Costa Marques",
    estado_codigo: "11",
  },
  {
    codigo: "5003256",
    municipio: "Costa Rica",
    estado_codigo: "50",
  },
  {
    codigo: "2909406",
    municipio: "Cotegipe",
    estado_codigo: "29",
  },
  {
    codigo: "3513009",
    municipio: "Cotia",
    estado_codigo: "35",
  },
  {
    codigo: "4305959",
    municipio: "Cotiporã",
    estado_codigo: "43",
  },
  {
    codigo: "5103379",
    municipio: "Cotriguaçu",
    estado_codigo: "51",
  },
  {
    codigo: "1706001",
    municipio: "Couto de Magalhães",
    estado_codigo: "17",
  },
  {
    codigo: "3120102",
    municipio: "Couto de Magalhães de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4305975",
    municipio: "Coxilha",
    estado_codigo: "43",
  },
  {
    codigo: "5003306",
    municipio: "Coxim",
    estado_codigo: "50",
  },
  {
    codigo: "2504850",
    municipio: "Coxixola",
    estado_codigo: "25",
  },
  {
    codigo: "2702355",
    municipio: "Craíbas",
    estado_codigo: "27",
  },
  {
    codigo: "2304103",
    municipio: "Crateús",
    estado_codigo: "23",
  },
  {
    codigo: "2304202",
    municipio: "Crato",
    estado_codigo: "23",
  },
  {
    codigo: "3513108",
    municipio: "Cravinhos",
    estado_codigo: "35",
  },
  {
    codigo: "2909505",
    municipio: "Cravolândia",
    estado_codigo: "29",
  },
  {
    codigo: "4204608",
    municipio: "Criciúma",
    estado_codigo: "42",
  },
  {
    codigo: "3120151",
    municipio: "Crisólita",
    estado_codigo: "31",
  },
  {
    codigo: "2909604",
    municipio: "Crisópolis",
    estado_codigo: "29",
  },
  {
    codigo: "4306007",
    municipio: "Crissiumal",
    estado_codigo: "43",
  },
  {
    codigo: "3120201",
    municipio: "Cristais",
    estado_codigo: "31",
  },
  {
    codigo: "3513207",
    municipio: "Cristais Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4306056",
    municipio: "Cristal",
    estado_codigo: "43",
  },
  {
    codigo: "1706100",
    municipio: "Cristalândia",
    estado_codigo: "17",
  },
  {
    codigo: "2203008",
    municipio: "Cristalândia do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4306072",
    municipio: "Cristal do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3120300",
    municipio: "Cristália",
    estado_codigo: "31",
  },
  {
    codigo: "5206206",
    municipio: "Cristalina",
    estado_codigo: "52",
  },
  {
    codigo: "3120409",
    municipio: "Cristiano Otoni",
    estado_codigo: "31",
  },
  {
    codigo: "5206305",
    municipio: "Cristianópolis",
    estado_codigo: "52",
  },
  {
    codigo: "3120508",
    municipio: "Cristina",
    estado_codigo: "31",
  },
  {
    codigo: "2801702",
    municipio: "Cristinápolis",
    estado_codigo: "28",
  },
  {
    codigo: "2203107",
    municipio: "Cristino Castro",
    estado_codigo: "22",
  },
  {
    codigo: "2909703",
    municipio: "Cristópolis",
    estado_codigo: "29",
  },
  {
    codigo: "5206404",
    municipio: "Crixás",
    estado_codigo: "52",
  },
  {
    codigo: "1706258",
    municipio: "Crixás do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2304236",
    municipio: "Croatá",
    estado_codigo: "23",
  },
  {
    codigo: "5206503",
    municipio: "Cromínia",
    estado_codigo: "52",
  },
  {
    codigo: "3120607",
    municipio: "Crucilândia",
    estado_codigo: "31",
  },
  {
    codigo: "2304251",
    municipio: "Cruz",
    estado_codigo: "23",
  },
  {
    codigo: "3513306",
    municipio: "Cruzália",
    estado_codigo: "35",
  },
  {
    codigo: "4306106",
    municipio: "Cruz Alta",
    estado_codigo: "43",
  },
  {
    codigo: "4306130",
    municipio: "Cruzaltense",
    estado_codigo: "43",
  },
  {
    codigo: "2909802",
    municipio: "Cruz das Almas",
    estado_codigo: "29",
  },
  {
    codigo: "2504900",
    municipio: "Cruz do Espírito Santo",
    estado_codigo: "25",
  },
  {
    codigo: "3513405",
    municipio: "Cruzeiro",
    estado_codigo: "35",
  },
  {
    codigo: "3120706",
    municipio: "Cruzeiro da Fortaleza",
    estado_codigo: "31",
  },
  {
    codigo: "4106571",
    municipio: "Cruzeiro do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "4106605",
    municipio: "Cruzeiro do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "4306205",
    municipio: "Cruzeiro do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4106704",
    municipio: "Cruzeiro do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "1200203",
    municipio: "Cruzeiro do Sul",
    estado_codigo: "12",
  },
  {
    codigo: "2403004",
    municipio: "Cruzeta",
    estado_codigo: "24",
  },
  {
    codigo: "3120805",
    municipio: "Cruzília",
    estado_codigo: "31",
  },
  {
    codigo: "4106803",
    municipio: "Cruz Machado",
    estado_codigo: "41",
  },
  {
    codigo: "4106852",
    municipio: "Cruzmaltina",
    estado_codigo: "41",
  },
  {
    codigo: "3513504",
    municipio: "Cubatão",
    estado_codigo: "35",
  },
  {
    codigo: "2505006",
    municipio: "Cubati",
    estado_codigo: "25",
  },
  {
    codigo: "5103403",
    municipio: "Cuiabá",
    estado_codigo: "51",
  },
  {
    codigo: "2505105",
    municipio: "Cuité",
    estado_codigo: "25",
  },
  {
    codigo: "2505238",
    municipio: "Cuité de Mamanguape",
    estado_codigo: "25",
  },
  {
    codigo: "2505204",
    municipio: "Cuitegi",
    estado_codigo: "25",
  },
  {
    codigo: "1100940",
    municipio: "Cujubim",
    estado_codigo: "11",
  },
  {
    codigo: "5206602",
    municipio: "Cumari",
    estado_codigo: "52",
  },
  {
    codigo: "2604908",
    municipio: "Cumaru",
    estado_codigo: "26",
  },
  {
    codigo: "1502764",
    municipio: "Cumaru do Norte",
    estado_codigo: "15",
  },
  {
    codigo: "2801900",
    municipio: "Cumbe",
    estado_codigo: "28",
  },
  {
    codigo: "3513603",
    municipio: "Cunha",
    estado_codigo: "35",
  },
  {
    codigo: "4204707",
    municipio: "Cunha Porã",
    estado_codigo: "42",
  },
  {
    codigo: "4204756",
    municipio: "Cunhataí",
    estado_codigo: "42",
  },
  {
    codigo: "3120839",
    municipio: "Cuparaque",
    estado_codigo: "31",
  },
  {
    codigo: "2605004",
    municipio: "Cupira",
    estado_codigo: "26",
  },
  {
    codigo: "2909901",
    municipio: "Curaçá",
    estado_codigo: "29",
  },
  {
    codigo: "2203206",
    municipio: "Curimatá",
    estado_codigo: "22",
  },
  {
    codigo: "1502772",
    municipio: "Curionópolis",
    estado_codigo: "15",
  },
  {
    codigo: "4106902",
    municipio: "Curitiba",
    estado_codigo: "41",
  },
  {
    codigo: "4204806",
    municipio: "Curitibanos",
    estado_codigo: "42",
  },
  {
    codigo: "4107009",
    municipio: "Curiúva",
    estado_codigo: "41",
  },
  {
    codigo: "2203230",
    municipio: "Currais",
    estado_codigo: "22",
  },
  {
    codigo: "2403103",
    municipio: "Currais Novos",
    estado_codigo: "24",
  },
  {
    codigo: "2505279",
    municipio: "Curral de Cima",
    estado_codigo: "25",
  },
  {
    codigo: "3120870",
    municipio: "Curral de Dentro",
    estado_codigo: "31",
  },
  {
    codigo: "1502806",
    municipio: "Curralinho",
    estado_codigo: "15",
  },
  {
    codigo: "2203255",
    municipio: "Curralinhos",
    estado_codigo: "22",
  },
  {
    codigo: "2203271",
    municipio: "Curral Novo do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2505303",
    municipio: "Curral Velho",
    estado_codigo: "25",
  },
  {
    codigo: "1502855",
    municipio: "Curuá",
    estado_codigo: "15",
  },
  {
    codigo: "1502905",
    municipio: "Curuçá",
    estado_codigo: "15",
  },
  {
    codigo: "2103703",
    municipio: "Cururupu",
    estado_codigo: "21",
  },
  {
    codigo: "5103437",
    municipio: "Curvelândia",
    estado_codigo: "51",
  },
  {
    codigo: "3120904",
    municipio: "Curvelo",
    estado_codigo: "31",
  },
  {
    codigo: "2605103",
    municipio: "Custódia",
    estado_codigo: "26",
  },
  {
    codigo: "1600212",
    municipio: "Cutias",
    estado_codigo: "16",
  },
  {
    codigo: "5206701",
    municipio: "Damianópolis",
    estado_codigo: "52",
  },
  {
    codigo: "2505352",
    municipio: "Damião",
    estado_codigo: "25",
  },
  {
    codigo: "5206800",
    municipio: "Damolândia",
    estado_codigo: "52",
  },
  {
    codigo: "1706506",
    municipio: "Darcinópolis",
    estado_codigo: "17",
  },
  {
    codigo: "2910008",
    municipio: "Dário Meira",
    estado_codigo: "29",
  },
  {
    codigo: "3121001",
    municipio: "Datas",
    estado_codigo: "31",
  },
  {
    codigo: "4306304",
    municipio: "David Canabarro",
    estado_codigo: "43",
  },
  {
    codigo: "2103752",
    municipio: "Davinópolis",
    estado_codigo: "21",
  },
  {
    codigo: "5206909",
    municipio: "Davinópolis",
    estado_codigo: "52",
  },
  {
    codigo: "3121100",
    municipio: "Delfim Moreira",
    estado_codigo: "31",
  },
  {
    codigo: "3121209",
    municipio: "Delfinópolis",
    estado_codigo: "31",
  },
  {
    codigo: "2702405",
    municipio: "Delmiro Gouveia",
    estado_codigo: "27",
  },
  {
    codigo: "3121258",
    municipio: "Delta",
    estado_codigo: "31",
  },
  {
    codigo: "2203305",
    municipio: "Demerval Lobão",
    estado_codigo: "22",
  },
  {
    codigo: "5103452",
    municipio: "Denise",
    estado_codigo: "51",
  },
  {
    codigo: "5003454",
    municipio: "Deodápolis",
    estado_codigo: "50",
  },
  {
    codigo: "2304269",
    municipio: "Deputado Irapuan Pinheiro",
    estado_codigo: "23",
  },
  {
    codigo: "4306320",
    municipio: "Derrubadas",
    estado_codigo: "43",
  },
  {
    codigo: "3513702",
    municipio: "Descalvado",
    estado_codigo: "35",
  },
  {
    codigo: "4204905",
    municipio: "Descanso",
    estado_codigo: "42",
  },
  {
    codigo: "3121308",
    municipio: "Descoberto",
    estado_codigo: "31",
  },
  {
    codigo: "2505402",
    municipio: "Desterro",
    estado_codigo: "25",
  },
  {
    codigo: "3121407",
    municipio: "Desterro de Entre Rios",
    estado_codigo: "31",
  },
  {
    codigo: "3121506",
    municipio: "Desterro do Melo",
    estado_codigo: "31",
  },
  {
    codigo: "4306353",
    municipio: "Dezesseis de Novembro",
    estado_codigo: "43",
  },
  {
    codigo: "3513801",
    municipio: "Diadema",
    estado_codigo: "35",
  },
  {
    codigo: "2505600",
    municipio: "Diamante",
    estado_codigo: "25",
  },
  {
    codigo: "4107157",
    municipio: "Diamante D'Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "4107108",
    municipio: "Diamante do Norte",
    estado_codigo: "41",
  },
  {
    codigo: "4107124",
    municipio: "Diamante do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "3121605",
    municipio: "Diamantina",
    estado_codigo: "31",
  },
  {
    codigo: "5103502",
    municipio: "Diamantino",
    estado_codigo: "51",
  },
  {
    codigo: "1707009",
    municipio: "Dianópolis",
    estado_codigo: "17",
  },
  {
    codigo: "2910057",
    municipio: "Dias d'Ávila",
    estado_codigo: "29",
  },
  {
    codigo: "4306379",
    municipio: "Dilermando de Aguiar",
    estado_codigo: "43",
  },
  {
    codigo: "3121704",
    municipio: "Diogo de Vasconcelos",
    estado_codigo: "31",
  },
  {
    codigo: "3121803",
    municipio: "Dionísio",
    estado_codigo: "31",
  },
  {
    codigo: "4205001",
    municipio: "Dionísio Cerqueira",
    estado_codigo: "42",
  },
  {
    codigo: "5207105",
    municipio: "Diorama",
    estado_codigo: "52",
  },
  {
    codigo: "3513850",
    municipio: "Dirce Reis",
    estado_codigo: "35",
  },
  {
    codigo: "2203354",
    municipio: "Dirceu Arcoverde",
    estado_codigo: "22",
  },
  {
    codigo: "2802007",
    municipio: "Divina Pastora",
    estado_codigo: "28",
  },
  {
    codigo: "3121902",
    municipio: "Divinésia",
    estado_codigo: "31",
  },
  {
    codigo: "3122009",
    municipio: "Divino",
    estado_codigo: "31",
  },
  {
    codigo: "3122108",
    municipio: "Divino das Laranjeiras",
    estado_codigo: "31",
  },
  {
    codigo: "3201803",
    municipio: "Divino de São Lourenço",
    estado_codigo: "32",
  },
  {
    codigo: "3513900",
    municipio: "Divinolândia",
    estado_codigo: "35",
  },
  {
    codigo: "3122207",
    municipio: "Divinolândia de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "3122306",
    municipio: "Divinópolis",
    estado_codigo: "31",
  },
  {
    codigo: "5208301",
    municipio: "Divinópolis de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "1707108",
    municipio: "Divinópolis do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "3122355",
    municipio: "Divisa Alegre",
    estado_codigo: "31",
  },
  {
    codigo: "3122405",
    municipio: "Divisa Nova",
    estado_codigo: "31",
  },
  {
    codigo: "3122454",
    municipio: "Divisópolis",
    estado_codigo: "31",
  },
  {
    codigo: "3514007",
    municipio: "Dobrada",
    estado_codigo: "35",
  },
  {
    codigo: "3514106",
    municipio: "Dois Córregos",
    estado_codigo: "35",
  },
  {
    codigo: "4306403",
    municipio: "Dois Irmãos",
    estado_codigo: "43",
  },
  {
    codigo: "4306429",
    municipio: "Dois Irmãos das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "5003488",
    municipio: "Dois Irmãos do Buriti",
    estado_codigo: "50",
  },
  {
    codigo: "1707207",
    municipio: "Dois Irmãos do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "4306452",
    municipio: "Dois Lajeados",
    estado_codigo: "43",
  },
  {
    codigo: "2702504",
    municipio: "Dois Riachos",
    estado_codigo: "27",
  },
  {
    codigo: "4107207",
    municipio: "Dois Vizinhos",
    estado_codigo: "41",
  },
  {
    codigo: "3514205",
    municipio: "Dolcinópolis",
    estado_codigo: "35",
  },
  {
    codigo: "5103601",
    municipio: "Dom Aquino",
    estado_codigo: "51",
  },
  {
    codigo: "2910107",
    municipio: "Dom Basílio",
    estado_codigo: "29",
  },
  {
    codigo: "3122470",
    municipio: "Dom Bosco",
    estado_codigo: "31",
  },
  {
    codigo: "3122504",
    municipio: "Dom Cavati",
    estado_codigo: "31",
  },
  {
    codigo: "1502939",
    municipio: "Dom Eliseu",
    estado_codigo: "15",
  },
  {
    codigo: "2203404",
    municipio: "Dom Expedito Lopes",
    estado_codigo: "22",
  },
  {
    codigo: "4306502",
    municipio: "Dom Feliciano",
    estado_codigo: "43",
  },
  {
    codigo: "3201902",
    municipio: "Domingos Martins",
    estado_codigo: "32",
  },
  {
    codigo: "2203420",
    municipio: "Domingos Mourão",
    estado_codigo: "22",
  },
  {
    codigo: "2203453",
    municipio: "Dom Inocêncio",
    estado_codigo: "22",
  },
  {
    codigo: "3122603",
    municipio: "Dom Joaquim",
    estado_codigo: "31",
  },
  {
    codigo: "2910206",
    municipio: "Dom Macedo Costa",
    estado_codigo: "29",
  },
  {
    codigo: "4306601",
    municipio: "Dom Pedrito",
    estado_codigo: "43",
  },
  {
    codigo: "2103802",
    municipio: "Dom Pedro",
    estado_codigo: "21",
  },
  {
    codigo: "4306551",
    municipio: "Dom Pedro de Alcântara",
    estado_codigo: "43",
  },
  {
    codigo: "3122702",
    municipio: "Dom Silvério",
    estado_codigo: "31",
  },
  {
    codigo: "3122801",
    municipio: "Dom Viçoso",
    estado_codigo: "31",
  },
  {
    codigo: "4205100",
    municipio: "Dona Emma",
    estado_codigo: "42",
  },
  {
    codigo: "3122900",
    municipio: "Dona Eusébia",
    estado_codigo: "31",
  },
  {
    codigo: "4306700",
    municipio: "Dona Francisca",
    estado_codigo: "43",
  },
  {
    codigo: "2505709",
    municipio: "Dona Inês",
    estado_codigo: "25",
  },
  {
    codigo: "3123007",
    municipio: "Dores de Campos",
    estado_codigo: "31",
  },
  {
    codigo: "3123106",
    municipio: "Dores de Guanhães",
    estado_codigo: "31",
  },
  {
    codigo: "3123205",
    municipio: "Dores do Indaiá",
    estado_codigo: "31",
  },
  {
    codigo: "3202009",
    municipio: "Dores do Rio Preto",
    estado_codigo: "32",
  },
  {
    codigo: "3123304",
    municipio: "Dores do Turvo",
    estado_codigo: "31",
  },
  {
    codigo: "3123403",
    municipio: "Doresópolis",
    estado_codigo: "31",
  },
  {
    codigo: "2605152",
    municipio: "Dormentes",
    estado_codigo: "26",
  },
  {
    codigo: "4107256",
    municipio: "Douradina",
    estado_codigo: "41",
  },
  {
    codigo: "5003504",
    municipio: "Douradina",
    estado_codigo: "50",
  },
  {
    codigo: "3514304",
    municipio: "Dourado",
    estado_codigo: "35",
  },
  {
    codigo: "3123502",
    municipio: "Douradoquara",
    estado_codigo: "31",
  },
  {
    codigo: "5003702",
    municipio: "Dourados",
    estado_codigo: "50",
  },
  {
    codigo: "4107306",
    municipio: "Doutor Camargo",
    estado_codigo: "41",
  },
  {
    codigo: "4306734",
    municipio: "Doutor Maurício Cardoso",
    estado_codigo: "43",
  },
  {
    codigo: "4205159",
    municipio: "Doutor Pedrinho",
    estado_codigo: "42",
  },
  {
    codigo: "4306759",
    municipio: "Doutor Ricardo",
    estado_codigo: "43",
  },
  {
    codigo: "2403202",
    municipio: "Doutor Severiano",
    estado_codigo: "24",
  },
  {
    codigo: "4128633",
    municipio: "Doutor Ulysses",
    estado_codigo: "41",
  },
  {
    codigo: "5207253",
    municipio: "Doverlândia",
    estado_codigo: "52",
  },
  {
    codigo: "3514403",
    municipio: "Dracena",
    estado_codigo: "35",
  },
  {
    codigo: "3514502",
    municipio: "Duartina",
    estado_codigo: "35",
  },
  {
    codigo: "3301603",
    municipio: "Duas Barras",
    estado_codigo: "33",
  },
  {
    codigo: "2505808",
    municipio: "Duas Estradas",
    estado_codigo: "25",
  },
  {
    codigo: "1707306",
    municipio: "Dueré",
    estado_codigo: "17",
  },
  {
    codigo: "3514601",
    municipio: "Dumont",
    estado_codigo: "35",
  },
  {
    codigo: "2103901",
    municipio: "Duque Bacelar",
    estado_codigo: "21",
  },
  {
    codigo: "3301702",
    municipio: "Duque de Caxias",
    estado_codigo: "33",
  },
  {
    codigo: "3123528",
    municipio: "Durandé",
    estado_codigo: "31",
  },
  {
    codigo: "3514700",
    municipio: "Echaporã",
    estado_codigo: "35",
  },
  {
    codigo: "3202108",
    municipio: "Ecoporanga",
    estado_codigo: "32",
  },
  {
    codigo: "5207352",
    municipio: "Edealina",
    estado_codigo: "52",
  },
  {
    codigo: "5207402",
    municipio: "Edéia",
    estado_codigo: "52",
  },
  {
    codigo: "1301407",
    municipio: "Eirunepé",
    estado_codigo: "13",
  },
  {
    codigo: "5003751",
    municipio: "Eldorado",
    estado_codigo: "50",
  },
  {
    codigo: "3514809",
    municipio: "Eldorado",
    estado_codigo: "35",
  },
  {
    codigo: "1502954",
    municipio: "Eldorado dos Carajás",
    estado_codigo: "15",
  },
  {
    codigo: "4306767",
    municipio: "Eldorado do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2203503",
    municipio: "Elesbão Veloso",
    estado_codigo: "22",
  },
  {
    codigo: "3514908",
    municipio: "Elias Fausto",
    estado_codigo: "35",
  },
  {
    codigo: "2203602",
    municipio: "Eliseu Martins",
    estado_codigo: "22",
  },
  {
    codigo: "3514924",
    municipio: "Elisiário",
    estado_codigo: "35",
  },
  {
    codigo: "2910305",
    municipio: "Elísio Medrado",
    estado_codigo: "29",
  },
  {
    codigo: "3123601",
    municipio: "Elói Mendes",
    estado_codigo: "31",
  },
  {
    codigo: "2505907",
    municipio: "Emas",
    estado_codigo: "25",
  },
  {
    codigo: "3514957",
    municipio: "Embaúba",
    estado_codigo: "35",
  },
  {
    codigo: "3515004",
    municipio: "Embu das Artes",
    estado_codigo: "35",
  },
  {
    codigo: "3515103",
    municipio: "Embu-Guaçu",
    estado_codigo: "35",
  },
  {
    codigo: "3515129",
    municipio: "Emilianópolis",
    estado_codigo: "35",
  },
  {
    codigo: "4306809",
    municipio: "Encantado",
    estado_codigo: "43",
  },
  {
    codigo: "2403301",
    municipio: "Encanto",
    estado_codigo: "24",
  },
  {
    codigo: "2910404",
    municipio: "Encruzilhada",
    estado_codigo: "29",
  },
  {
    codigo: "4306908",
    municipio: "Encruzilhada do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4107405",
    municipio: "Enéas Marques",
    estado_codigo: "41",
  },
  {
    codigo: "4107504",
    municipio: "Engenheiro Beltrão",
    estado_codigo: "41",
  },
  {
    codigo: "3123700",
    municipio: "Engenheiro Caldas",
    estado_codigo: "31",
  },
  {
    codigo: "3515152",
    municipio: "Engenheiro Coelho",
    estado_codigo: "35",
  },
  {
    codigo: "3123809",
    municipio: "Engenheiro Navarro",
    estado_codigo: "31",
  },
  {
    codigo: "3301801",
    municipio: "Engenheiro Paulo de Frontin",
    estado_codigo: "33",
  },
  {
    codigo: "4306924",
    municipio: "Engenho Velho",
    estado_codigo: "43",
  },
  {
    codigo: "3123858",
    municipio: "Entre Folhas",
    estado_codigo: "31",
  },
  {
    codigo: "4306932",
    municipio: "Entre-Ijuís",
    estado_codigo: "43",
  },
  {
    codigo: "2910503",
    municipio: "Entre Rios",
    estado_codigo: "29",
  },
  {
    codigo: "4205175",
    municipio: "Entre Rios",
    estado_codigo: "42",
  },
  {
    codigo: "3123908",
    municipio: "Entre Rios de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4107538",
    municipio: "Entre Rios do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "4306957",
    municipio: "Entre Rios do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "1301506",
    municipio: "Envira",
    estado_codigo: "13",
  },
  {
    codigo: "1200252",
    municipio: "Epitaciolândia",
    estado_codigo: "12",
  },
  {
    codigo: "2403400",
    municipio: "Equador",
    estado_codigo: "24",
  },
  {
    codigo: "4306973",
    municipio: "Erebango",
    estado_codigo: "43",
  },
  {
    codigo: "4307005",
    municipio: "Erechim",
    estado_codigo: "43",
  },
  {
    codigo: "2304277",
    municipio: "Ererê",
    estado_codigo: "23",
  },
  {
    codigo: "2900504",
    municipio: "Érico Cardoso",
    estado_codigo: "29",
  },
  {
    codigo: "4205191",
    municipio: "Ermo",
    estado_codigo: "42",
  },
  {
    codigo: "4307054",
    municipio: "Ernestina",
    estado_codigo: "43",
  },
  {
    codigo: "4307203",
    municipio: "Erval Grande",
    estado_codigo: "43",
  },
  {
    codigo: "3124005",
    municipio: "Ervália",
    estado_codigo: "31",
  },
  {
    codigo: "4307302",
    municipio: "Erval Seco",
    estado_codigo: "43",
  },
  {
    codigo: "4205209",
    municipio: "Erval Velho",
    estado_codigo: "42",
  },
  {
    codigo: "2605202",
    municipio: "Escada",
    estado_codigo: "26",
  },
  {
    codigo: "4307401",
    municipio: "Esmeralda",
    estado_codigo: "43",
  },
  {
    codigo: "3124104",
    municipio: "Esmeraldas",
    estado_codigo: "31",
  },
  {
    codigo: "3124203",
    municipio: "Espera Feliz",
    estado_codigo: "31",
  },
  {
    codigo: "2506004",
    municipio: "Esperança",
    estado_codigo: "25",
  },
  {
    codigo: "4307450",
    municipio: "Esperança do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4107520",
    municipio: "Esperança Nova",
    estado_codigo: "41",
  },
  {
    codigo: "1707405",
    municipio: "Esperantina",
    estado_codigo: "17",
  },
  {
    codigo: "2203701",
    municipio: "Esperantina",
    estado_codigo: "22",
  },
  {
    codigo: "2104008",
    municipio: "Esperantinópolis",
    estado_codigo: "21",
  },
  {
    codigo: "4107546",
    municipio: "Espigão Alto do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "1100098",
    municipio: "Espigão D'Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "3124302",
    municipio: "Espinosa",
    estado_codigo: "31",
  },
  {
    codigo: "2403509",
    municipio: "Espírito Santo",
    estado_codigo: "24",
  },
  {
    codigo: "3124401",
    municipio: "Espírito Santo do Dourado",
    estado_codigo: "31",
  },
  {
    codigo: "3515186",
    municipio: "Espírito Santo do Pinhal",
    estado_codigo: "35",
  },
  {
    codigo: "3515194",
    municipio: "Espírito Santo do Turvo",
    estado_codigo: "35",
  },
  {
    codigo: "2910602",
    municipio: "Esplanada",
    estado_codigo: "29",
  },
  {
    codigo: "4307500",
    municipio: "Espumoso",
    estado_codigo: "43",
  },
  {
    codigo: "4307559",
    municipio: "Estação",
    estado_codigo: "43",
  },
  {
    codigo: "2802106",
    municipio: "Estância",
    estado_codigo: "28",
  },
  {
    codigo: "4307609",
    municipio: "Estância Velha",
    estado_codigo: "43",
  },
  {
    codigo: "4307708",
    municipio: "Esteio",
    estado_codigo: "43",
  },
  {
    codigo: "3124500",
    municipio: "Estiva",
    estado_codigo: "31",
  },
  {
    codigo: "3557303",
    municipio: "Estiva Gerbi",
    estado_codigo: "35",
  },
  {
    codigo: "2104057",
    municipio: "Estreito",
    estado_codigo: "21",
  },
  {
    codigo: "4307807",
    municipio: "Estrela",
    estado_codigo: "43",
  },
  {
    codigo: "3124609",
    municipio: "Estrela Dalva",
    estado_codigo: "31",
  },
  {
    codigo: "2702553",
    municipio: "Estrela de Alagoas",
    estado_codigo: "27",
  },
  {
    codigo: "3515202",
    municipio: "Estrela d'Oeste",
    estado_codigo: "35",
  },
  {
    codigo: "3124708",
    municipio: "Estrela do Indaiá",
    estado_codigo: "31",
  },
  {
    codigo: "5207501",
    municipio: "Estrela do Norte",
    estado_codigo: "52",
  },
  {
    codigo: "3515301",
    municipio: "Estrela do Norte",
    estado_codigo: "35",
  },
  {
    codigo: "3124807",
    municipio: "Estrela do Sul",
    estado_codigo: "31",
  },
  {
    codigo: "4307815",
    municipio: "Estrela Velha",
    estado_codigo: "43",
  },
  {
    codigo: "2910701",
    municipio: "Euclides da Cunha",
    estado_codigo: "29",
  },
  {
    codigo: "3515350",
    municipio: "Euclides da Cunha Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4307831",
    municipio: "Eugênio de Castro",
    estado_codigo: "43",
  },
  {
    codigo: "3124906",
    municipio: "Eugenópolis",
    estado_codigo: "31",
  },
  {
    codigo: "2910727",
    municipio: "Eunápolis",
    estado_codigo: "29",
  },
  {
    codigo: "2304285",
    municipio: "Eusébio",
    estado_codigo: "23",
  },
  {
    codigo: "3125002",
    municipio: "Ewbank da Câmara",
    estado_codigo: "31",
  },
  {
    codigo: "9999999",
    municipio: "EXTERIOR",
    estado_codigo: "99",
  },
  {
    codigo: "3125101",
    municipio: "Extrema",
    estado_codigo: "31",
  },
  {
    codigo: "2403608",
    municipio: "Extremoz",
    estado_codigo: "24",
  },
  {
    codigo: "2605301",
    municipio: "Exu",
    estado_codigo: "26",
  },
  {
    codigo: "2506103",
    municipio: "Fagundes",
    estado_codigo: "25",
  },
  {
    codigo: "4307864",
    municipio: "Fagundes Varela",
    estado_codigo: "43",
  },
  {
    codigo: "5207535",
    municipio: "Faina",
    estado_codigo: "52",
  },
  {
    codigo: "3125200",
    municipio: "Fama",
    estado_codigo: "31",
  },
  {
    codigo: "3125309",
    municipio: "Faria Lemos",
    estado_codigo: "31",
  },
  {
    codigo: "2304301",
    municipio: "Farias Brito",
    estado_codigo: "23",
  },
  {
    codigo: "1503002",
    municipio: "Faro",
    estado_codigo: "15",
  },
  {
    codigo: "4107553",
    municipio: "Farol",
    estado_codigo: "41",
  },
  {
    codigo: "4307906",
    municipio: "Farroupilha",
    estado_codigo: "43",
  },
  {
    codigo: "3515400",
    municipio: "Fartura",
    estado_codigo: "35",
  },
  {
    codigo: "2203750",
    municipio: "Fartura do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2910750",
    municipio: "Fátima",
    estado_codigo: "29",
  },
  {
    codigo: "1707553",
    municipio: "Fátima",
    estado_codigo: "17",
  },
  {
    codigo: "5003801",
    municipio: "Fátima do Sul",
    estado_codigo: "50",
  },
  {
    codigo: "4107603",
    municipio: "Faxinal",
    estado_codigo: "41",
  },
  {
    codigo: "4205308",
    municipio: "Faxinal dos Guedes",
    estado_codigo: "42",
  },
  {
    codigo: "4308003",
    municipio: "Faxinal do Soturno",
    estado_codigo: "43",
  },
  {
    codigo: "4308052",
    municipio: "Faxinalzinho",
    estado_codigo: "43",
  },
  {
    codigo: "5207600",
    municipio: "Fazenda Nova",
    estado_codigo: "52",
  },
  {
    codigo: "4107652",
    municipio: "Fazenda Rio Grande",
    estado_codigo: "41",
  },
  {
    codigo: "4308078",
    municipio: "Fazenda Vilanova",
    estado_codigo: "43",
  },
  {
    codigo: "1200302",
    municipio: "Feijó",
    estado_codigo: "12",
  },
  {
    codigo: "2910776",
    municipio: "Feira da Mata",
    estado_codigo: "29",
  },
  {
    codigo: "2910800",
    municipio: "Feira de Santana",
    estado_codigo: "29",
  },
  {
    codigo: "2702603",
    municipio: "Feira Grande",
    estado_codigo: "27",
  },
  {
    codigo: "2605400",
    municipio: "Feira Nova",
    estado_codigo: "26",
  },
  {
    codigo: "2802205",
    municipio: "Feira Nova",
    estado_codigo: "28",
  },
  {
    codigo: "2104073",
    municipio: "Feira Nova do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "3125408",
    municipio: "Felício dos Santos",
    estado_codigo: "31",
  },
  {
    codigo: "2403707",
    municipio: "Felipe Guerra",
    estado_codigo: "24",
  },
  {
    codigo: "3125606",
    municipio: "Felisburgo",
    estado_codigo: "31",
  },
  {
    codigo: "3125705",
    municipio: "Felixlândia",
    estado_codigo: "31",
  },
  {
    codigo: "4308102",
    municipio: "Feliz",
    estado_codigo: "43",
  },
  {
    codigo: "2702702",
    municipio: "Feliz Deserto",
    estado_codigo: "27",
  },
  {
    codigo: "5103700",
    municipio: "Feliz Natal",
    estado_codigo: "51",
  },
  {
    codigo: "4107702",
    municipio: "Fênix",
    estado_codigo: "41",
  },
  {
    codigo: "4107736",
    municipio: "Fernandes Pinheiro",
    estado_codigo: "41",
  },
  {
    codigo: "3125804",
    municipio: "Fernandes Tourinho",
    estado_codigo: "31",
  },
  {
    codigo: "2605459",
    municipio: "Fernando de Noronha",
    estado_codigo: "26",
  },
  {
    codigo: "2104081",
    municipio: "Fernando Falcão",
    estado_codigo: "21",
  },
  {
    codigo: "2403756",
    municipio: "Fernando Pedroza",
    estado_codigo: "24",
  },
  {
    codigo: "3515509",
    municipio: "Fernandópolis",
    estado_codigo: "35",
  },
  {
    codigo: "3515608",
    municipio: "Fernando Prestes",
    estado_codigo: "35",
  },
  {
    codigo: "3515657",
    municipio: "Fernão",
    estado_codigo: "35",
  },
  {
    codigo: "3515707",
    municipio: "Ferraz de Vasconcelos",
    estado_codigo: "35",
  },
  {
    codigo: "1600238",
    municipio: "Ferreira Gomes",
    estado_codigo: "16",
  },
  {
    codigo: "2605509",
    municipio: "Ferreiros",
    estado_codigo: "26",
  },
  {
    codigo: "3125903",
    municipio: "Ferros",
    estado_codigo: "31",
  },
  {
    codigo: "3125952",
    municipio: "Fervedouro",
    estado_codigo: "31",
  },
  {
    codigo: "4107751",
    municipio: "Figueira",
    estado_codigo: "41",
  },
  {
    codigo: "5003900",
    municipio: "Figueirão",
    estado_codigo: "50",
  },
  {
    codigo: "1707652",
    municipio: "Figueirópolis",
    estado_codigo: "17",
  },
  {
    codigo: "5103809",
    municipio: "Figueirópolis D'Oeste",
    estado_codigo: "51",
  },
  {
    codigo: "1707702",
    municipio: "Filadélfia",
    estado_codigo: "17",
  },
  {
    codigo: "2910859",
    municipio: "Filadélfia",
    estado_codigo: "29",
  },
  {
    codigo: "2910909",
    municipio: "Firmino Alves",
    estado_codigo: "29",
  },
  {
    codigo: "5207808",
    municipio: "Firminópolis",
    estado_codigo: "52",
  },
  {
    codigo: "2702801",
    municipio: "Flexeiras",
    estado_codigo: "27",
  },
  {
    codigo: "4107801",
    municipio: "Floraí",
    estado_codigo: "41",
  },
  {
    codigo: "2403806",
    municipio: "Florânia",
    estado_codigo: "24",
  },
  {
    codigo: "3515806",
    municipio: "Flora Rica",
    estado_codigo: "35",
  },
  {
    codigo: "4107850",
    municipio: "Flor da Serra do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "4205357",
    municipio: "Flor do Sertão",
    estado_codigo: "42",
  },
  {
    codigo: "3515905",
    municipio: "Floreal",
    estado_codigo: "35",
  },
  {
    codigo: "2605608",
    municipio: "Flores",
    estado_codigo: "26",
  },
  {
    codigo: "4308201",
    municipio: "Flores da Cunha",
    estado_codigo: "43",
  },
  {
    codigo: "5207907",
    municipio: "Flores de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "2203800",
    municipio: "Flores do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4107900",
    municipio: "Floresta",
    estado_codigo: "41",
  },
  {
    codigo: "2605707",
    municipio: "Floresta",
    estado_codigo: "26",
  },
  {
    codigo: "2911006",
    municipio: "Floresta Azul",
    estado_codigo: "29",
  },
  {
    codigo: "1503044",
    municipio: "Floresta do Araguaia",
    estado_codigo: "15",
  },
  {
    codigo: "2203859",
    municipio: "Floresta do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3126000",
    municipio: "Florestal",
    estado_codigo: "31",
  },
  {
    codigo: "4108007",
    municipio: "Florestópolis",
    estado_codigo: "41",
  },
  {
    codigo: "2203909",
    municipio: "Floriano",
    estado_codigo: "22",
  },
  {
    codigo: "4308250",
    municipio: "Floriano Peixoto",
    estado_codigo: "43",
  },
  {
    codigo: "4205407",
    municipio: "Florianópolis",
    estado_codigo: "42",
  },
  {
    codigo: "4108106",
    municipio: "Flórida",
    estado_codigo: "41",
  },
  {
    codigo: "3516002",
    municipio: "Flórida Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "3516101",
    municipio: "Florínia",
    estado_codigo: "35",
  },
  {
    codigo: "1301605",
    municipio: "Fonte Boa",
    estado_codigo: "13",
  },
  {
    codigo: "4308300",
    municipio: "Fontoura Xavier",
    estado_codigo: "43",
  },
  {
    codigo: "3126109",
    municipio: "Formiga",
    estado_codigo: "31",
  },
  {
    codigo: "4308409",
    municipio: "Formigueiro",
    estado_codigo: "43",
  },
  {
    codigo: "5208004",
    municipio: "Formosa",
    estado_codigo: "52",
  },
  {
    codigo: "2104099",
    municipio: "Formosa da Serra Negra",
    estado_codigo: "21",
  },
  {
    codigo: "4108205",
    municipio: "Formosa do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "2911105",
    municipio: "Formosa do Rio Preto",
    estado_codigo: "29",
  },
  {
    codigo: "4205431",
    municipio: "Formosa do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "5208103",
    municipio: "Formoso",
    estado_codigo: "52",
  },
  {
    codigo: "3126208",
    municipio: "Formoso",
    estado_codigo: "31",
  },
  {
    codigo: "1708205",
    municipio: "Formoso do Araguaia",
    estado_codigo: "17",
  },
  {
    codigo: "4308433",
    municipio: "Forquetinha",
    estado_codigo: "43",
  },
  {
    codigo: "2304350",
    municipio: "Forquilha",
    estado_codigo: "23",
  },
  {
    codigo: "4205456",
    municipio: "Forquilhinha",
    estado_codigo: "42",
  },
  {
    codigo: "2304400",
    municipio: "Fortaleza",
    estado_codigo: "23",
  },
  {
    codigo: "3126307",
    municipio: "Fortaleza de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2104107",
    municipio: "Fortaleza dos Nogueiras",
    estado_codigo: "21",
  },
  {
    codigo: "4308458",
    municipio: "Fortaleza dos Valos",
    estado_codigo: "43",
  },
  {
    codigo: "1708254",
    municipio: "Fortaleza do Tabocão",
    estado_codigo: "17",
  },
  {
    codigo: "2304459",
    municipio: "Fortim",
    estado_codigo: "23",
  },
  {
    codigo: "2104206",
    municipio: "Fortuna",
    estado_codigo: "21",
  },
  {
    codigo: "3126406",
    municipio: "Fortuna de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4108304",
    municipio: "Foz do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "4108452",
    municipio: "Foz do Jordão",
    estado_codigo: "41",
  },
  {
    codigo: "4205506",
    municipio: "Fraiburgo",
    estado_codigo: "42",
  },
  {
    codigo: "3516200",
    municipio: "Franca",
    estado_codigo: "35",
  },
  {
    codigo: "2204006",
    municipio: "Francinópolis",
    estado_codigo: "22",
  },
  {
    codigo: "4108320",
    municipio: "Francisco Alves",
    estado_codigo: "41",
  },
  {
    codigo: "2204105",
    municipio: "Francisco Ayres",
    estado_codigo: "22",
  },
  {
    codigo: "3126505",
    municipio: "Francisco Badaró",
    estado_codigo: "31",
  },
  {
    codigo: "4108403",
    municipio: "Francisco Beltrão",
    estado_codigo: "41",
  },
  {
    codigo: "2403905",
    municipio: "Francisco Dantas",
    estado_codigo: "24",
  },
  {
    codigo: "3126604",
    municipio: "Francisco Dumont",
    estado_codigo: "31",
  },
  {
    codigo: "2204154",
    municipio: "Francisco Macedo",
    estado_codigo: "22",
  },
  {
    codigo: "3516309",
    municipio: "Francisco Morato",
    estado_codigo: "35",
  },
  {
    codigo: "3126752",
    municipio: "Franciscópolis",
    estado_codigo: "31",
  },
  {
    codigo: "3126703",
    municipio: "Francisco Sá",
    estado_codigo: "31",
  },
  {
    codigo: "2204204",
    municipio: "Francisco Santos",
    estado_codigo: "22",
  },
  {
    codigo: "3516408",
    municipio: "Franco da Rocha",
    estado_codigo: "35",
  },
  {
    codigo: "2304509",
    municipio: "Frecheirinha",
    estado_codigo: "23",
  },
  {
    codigo: "4308508",
    municipio: "Frederico Westphalen",
    estado_codigo: "43",
  },
  {
    codigo: "3126802",
    municipio: "Frei Gaspar",
    estado_codigo: "31",
  },
  {
    codigo: "3126901",
    municipio: "Frei Inocêncio",
    estado_codigo: "31",
  },
  {
    codigo: "3126950",
    municipio: "Frei Lagonegro",
    estado_codigo: "31",
  },
  {
    codigo: "2506202",
    municipio: "Frei Martinho",
    estado_codigo: "25",
  },
  {
    codigo: "2605806",
    municipio: "Frei Miguelinho",
    estado_codigo: "26",
  },
  {
    codigo: "2802304",
    municipio: "Frei Paulo",
    estado_codigo: "28",
  },
  {
    codigo: "4205555",
    municipio: "Frei Rogério",
    estado_codigo: "42",
  },
  {
    codigo: "3127008",
    municipio: "Fronteira",
    estado_codigo: "31",
  },
  {
    codigo: "3127057",
    municipio: "Fronteira dos Vales",
    estado_codigo: "31",
  },
  {
    codigo: "2204303",
    municipio: "Fronteiras",
    estado_codigo: "22",
  },
  {
    codigo: "3127073",
    municipio: "Fruta de Leite",
    estado_codigo: "31",
  },
  {
    codigo: "3127107",
    municipio: "Frutal",
    estado_codigo: "31",
  },
  {
    codigo: "2404002",
    municipio: "Frutuoso Gomes",
    estado_codigo: "24",
  },
  {
    codigo: "3202207",
    municipio: "Fundão",
    estado_codigo: "32",
  },
  {
    codigo: "3127206",
    municipio: "Funilândia",
    estado_codigo: "31",
  },
  {
    codigo: "3516507",
    municipio: "Gabriel Monteiro",
    estado_codigo: "35",
  },
  {
    codigo: "2506251",
    municipio: "Gado Bravo",
    estado_codigo: "25",
  },
  {
    codigo: "3516606",
    municipio: "Gália",
    estado_codigo: "35",
  },
  {
    codigo: "3127305",
    municipio: "Galiléia",
    estado_codigo: "31",
  },
  {
    codigo: "2404101",
    municipio: "Galinhos",
    estado_codigo: "24",
  },
  {
    codigo: "4205605",
    municipio: "Galvão",
    estado_codigo: "42",
  },
  {
    codigo: "2605905",
    municipio: "Gameleira",
    estado_codigo: "26",
  },
  {
    codigo: "5208152",
    municipio: "Gameleira de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3127339",
    municipio: "Gameleiras",
    estado_codigo: "31",
  },
  {
    codigo: "2911204",
    municipio: "Gandu",
    estado_codigo: "29",
  },
  {
    codigo: "2606002",
    municipio: "Garanhuns",
    estado_codigo: "26",
  },
  {
    codigo: "2802403",
    municipio: "Gararu",
    estado_codigo: "28",
  },
  {
    codigo: "3516705",
    municipio: "Garça",
    estado_codigo: "35",
  },
  {
    codigo: "4308607",
    municipio: "Garibaldi",
    estado_codigo: "43",
  },
  {
    codigo: "4205704",
    municipio: "Garopaba",
    estado_codigo: "42",
  },
  {
    codigo: "1503077",
    municipio: "Garrafão do Norte",
    estado_codigo: "15",
  },
  {
    codigo: "4308656",
    municipio: "Garruchos",
    estado_codigo: "43",
  },
  {
    codigo: "4205803",
    municipio: "Garuva",
    estado_codigo: "42",
  },
  {
    codigo: "4205902",
    municipio: "Gaspar",
    estado_codigo: "42",
  },
  {
    codigo: "3516804",
    municipio: "Gastão Vidigal",
    estado_codigo: "35",
  },
  {
    codigo: "5103858",
    municipio: "Gaúcha do Norte",
    estado_codigo: "51",
  },
  {
    codigo: "4308706",
    municipio: "Gaurama",
    estado_codigo: "43",
  },
  {
    codigo: "2911253",
    municipio: "Gavião",
    estado_codigo: "29",
  },
  {
    codigo: "3516853",
    municipio: "Gavião Peixoto",
    estado_codigo: "35",
  },
  {
    codigo: "2204352",
    municipio: "Geminiano",
    estado_codigo: "22",
  },
  {
    codigo: "4308805",
    municipio: "General Câmara",
    estado_codigo: "43",
  },
  {
    codigo: "5103908",
    municipio: "General Carneiro",
    estado_codigo: "51",
  },
  {
    codigo: "4108502",
    municipio: "General Carneiro",
    estado_codigo: "41",
  },
  {
    codigo: "2802502",
    municipio: "General Maynard",
    estado_codigo: "28",
  },
  {
    codigo: "3516903",
    municipio: "General Salgado",
    estado_codigo: "35",
  },
  {
    codigo: "2304608",
    municipio: "General Sampaio",
    estado_codigo: "23",
  },
  {
    codigo: "4308854",
    municipio: "Gentil",
    estado_codigo: "43",
  },
  {
    codigo: "2911303",
    municipio: "Gentio do Ouro",
    estado_codigo: "29",
  },
  {
    codigo: "3517000",
    municipio: "Getulina",
    estado_codigo: "35",
  },
  {
    codigo: "4308904",
    municipio: "Getúlio Vargas",
    estado_codigo: "43",
  },
  {
    codigo: "2204402",
    municipio: "Gilbués",
    estado_codigo: "22",
  },
  {
    codigo: "2702900",
    municipio: "Girau do Ponciano",
    estado_codigo: "27",
  },
  {
    codigo: "4309001",
    municipio: "Giruá",
    estado_codigo: "43",
  },
  {
    codigo: "3127354",
    municipio: "Glaucilândia",
    estado_codigo: "31",
  },
  {
    codigo: "3517109",
    municipio: "Glicério",
    estado_codigo: "35",
  },
  {
    codigo: "2911402",
    municipio: "Glória",
    estado_codigo: "29",
  },
  {
    codigo: "5004007",
    municipio: "Glória de Dourados",
    estado_codigo: "50",
  },
  {
    codigo: "5103957",
    municipio: "Glória D'Oeste",
    estado_codigo: "51",
  },
  {
    codigo: "2606101",
    municipio: "Glória do Goitá",
    estado_codigo: "26",
  },
  {
    codigo: "4309050",
    municipio: "Glorinha",
    estado_codigo: "43",
  },
  {
    codigo: "2104305",
    municipio: "Godofredo Viana",
    estado_codigo: "21",
  },
  {
    codigo: "4108551",
    municipio: "Godoy Moreira",
    estado_codigo: "41",
  },
  {
    codigo: "3127370",
    municipio: "Goiabeira",
    estado_codigo: "31",
  },
  {
    codigo: "2606200",
    municipio: "Goiana",
    estado_codigo: "26",
  },
  {
    codigo: "3127388",
    municipio: "Goianá",
    estado_codigo: "31",
  },
  {
    codigo: "5208400",
    municipio: "Goianápolis",
    estado_codigo: "52",
  },
  {
    codigo: "5208509",
    municipio: "Goiandira",
    estado_codigo: "52",
  },
  {
    codigo: "5208608",
    municipio: "Goianésia",
    estado_codigo: "52",
  },
  {
    codigo: "1503093",
    municipio: "Goianésia do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "5208707",
    municipio: "Goiânia",
    estado_codigo: "52",
  },
  {
    codigo: "2404200",
    municipio: "Goianinha",
    estado_codigo: "24",
  },
  {
    codigo: "5208806",
    municipio: "Goianira",
    estado_codigo: "52",
  },
  {
    codigo: "1708304",
    municipio: "Goianorte",
    estado_codigo: "17",
  },
  {
    codigo: "5208905",
    municipio: "Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "1709005",
    municipio: "Goiatins",
    estado_codigo: "17",
  },
  {
    codigo: "5209101",
    municipio: "Goiatuba",
    estado_codigo: "52",
  },
  {
    codigo: "4108601",
    municipio: "Goioerê",
    estado_codigo: "41",
  },
  {
    codigo: "4108650",
    municipio: "Goioxim",
    estado_codigo: "41",
  },
  {
    codigo: "3127404",
    municipio: "Gonçalves",
    estado_codigo: "31",
  },
  {
    codigo: "2104404",
    municipio: "Gonçalves Dias",
    estado_codigo: "21",
  },
  {
    codigo: "2911501",
    municipio: "Gongogi",
    estado_codigo: "29",
  },
  {
    codigo: "3127503",
    municipio: "Gonzaga",
    estado_codigo: "31",
  },
  {
    codigo: "3127602",
    municipio: "Gouveia",
    estado_codigo: "31",
  },
  {
    codigo: "5209150",
    municipio: "Gouvelândia",
    estado_codigo: "52",
  },
  {
    codigo: "2104503",
    municipio: "Governador Archer",
    estado_codigo: "21",
  },
  {
    codigo: "4206009",
    municipio: "Governador Celso Ramos",
    estado_codigo: "42",
  },
  {
    codigo: "2404309",
    municipio: "Governador Dix-Sept Rosado",
    estado_codigo: "24",
  },
  {
    codigo: "2104552",
    municipio: "Governador Edison Lobão",
    estado_codigo: "21",
  },
  {
    codigo: "2104602",
    municipio: "Governador Eugênio Barros",
    estado_codigo: "21",
  },
  {
    codigo: "1101005",
    municipio: "Governador Jorge Teixeira",
    estado_codigo: "11",
  },
  {
    codigo: "3202256",
    municipio: "Governador Lindenberg",
    estado_codigo: "32",
  },
  {
    codigo: "2104628",
    municipio: "Governador Luiz Rocha",
    estado_codigo: "21",
  },
  {
    codigo: "2911600",
    municipio: "Governador Mangabeira",
    estado_codigo: "29",
  },
  {
    codigo: "2104651",
    municipio: "Governador Newton Bello",
    estado_codigo: "21",
  },
  {
    codigo: "2104677",
    municipio: "Governador Nunes Freire",
    estado_codigo: "21",
  },
  {
    codigo: "3127701",
    municipio: "Governador Valadares",
    estado_codigo: "31",
  },
  {
    codigo: "2304657",
    municipio: "Graça",
    estado_codigo: "23",
  },
  {
    codigo: "2104701",
    municipio: "Graça Aranha",
    estado_codigo: "21",
  },
  {
    codigo: "2802601",
    municipio: "Gracho Cardoso",
    estado_codigo: "28",
  },
  {
    codigo: "2104800",
    municipio: "Grajaú",
    estado_codigo: "21",
  },
  {
    codigo: "4309100",
    municipio: "Gramado",
    estado_codigo: "43",
  },
  {
    codigo: "4309126",
    municipio: "Gramado dos Loureiros",
    estado_codigo: "43",
  },
  {
    codigo: "4309159",
    municipio: "Gramado Xavier",
    estado_codigo: "43",
  },
  {
    codigo: "4108700",
    municipio: "Grandes Rios",
    estado_codigo: "41",
  },
  {
    codigo: "2606309",
    municipio: "Granito",
    estado_codigo: "26",
  },
  {
    codigo: "2304707",
    municipio: "Granja",
    estado_codigo: "23",
  },
  {
    codigo: "2304806",
    municipio: "Granjeiro",
    estado_codigo: "23",
  },
  {
    codigo: "3127800",
    municipio: "Grão Mogol",
    estado_codigo: "31",
  },
  {
    codigo: "4206108",
    municipio: "Grão Pará",
    estado_codigo: "42",
  },
  {
    codigo: "2606408",
    municipio: "Gravatá",
    estado_codigo: "26",
  },
  {
    codigo: "4309209",
    municipio: "Gravataí",
    estado_codigo: "43",
  },
  {
    codigo: "4206207",
    municipio: "Gravatal",
    estado_codigo: "42",
  },
  {
    codigo: "2304905",
    municipio: "Groaíras",
    estado_codigo: "23",
  },
  {
    codigo: "2404408",
    municipio: "Grossos",
    estado_codigo: "24",
  },
  {
    codigo: "3127909",
    municipio: "Grupiara",
    estado_codigo: "31",
  },
  {
    codigo: "4309258",
    municipio: "Guabiju",
    estado_codigo: "43",
  },
  {
    codigo: "4206306",
    municipio: "Guabiruba",
    estado_codigo: "42",
  },
  {
    codigo: "3202306",
    municipio: "Guaçuí",
    estado_codigo: "32",
  },
  {
    codigo: "2204501",
    municipio: "Guadalupe",
    estado_codigo: "22",
  },
  {
    codigo: "4309308",
    municipio: "Guaíba",
    estado_codigo: "43",
  },
  {
    codigo: "3517208",
    municipio: "Guaiçara",
    estado_codigo: "35",
  },
  {
    codigo: "3517307",
    municipio: "Guaimbê",
    estado_codigo: "35",
  },
  {
    codigo: "4108809",
    municipio: "Guaíra",
    estado_codigo: "41",
  },
  {
    codigo: "3517406",
    municipio: "Guaíra",
    estado_codigo: "35",
  },
  {
    codigo: "4108908",
    municipio: "Guairaçá",
    estado_codigo: "41",
  },
  {
    codigo: "2304954",
    municipio: "Guaiúba",
    estado_codigo: "23",
  },
  {
    codigo: "1301654",
    municipio: "Guajará",
    estado_codigo: "13",
  },
  {
    codigo: "1100106",
    municipio: "Guajará-Mirim",
    estado_codigo: "11",
  },
  {
    codigo: "2911659",
    municipio: "Guajeru",
    estado_codigo: "29",
  },
  {
    codigo: "2404507",
    municipio: "Guamaré",
    estado_codigo: "24",
  },
  {
    codigo: "4108957",
    municipio: "Guamiranga",
    estado_codigo: "41",
  },
  {
    codigo: "2911709",
    municipio: "Guanambi",
    estado_codigo: "29",
  },
  {
    codigo: "3128006",
    municipio: "Guanhães",
    estado_codigo: "31",
  },
  {
    codigo: "3128105",
    municipio: "Guapé",
    estado_codigo: "31",
  },
  {
    codigo: "3517505",
    municipio: "Guapiaçu",
    estado_codigo: "35",
  },
  {
    codigo: "3517604",
    municipio: "Guapiara",
    estado_codigo: "35",
  },
  {
    codigo: "3301850",
    municipio: "Guapimirim",
    estado_codigo: "33",
  },
  {
    codigo: "4109005",
    municipio: "Guapirama",
    estado_codigo: "41",
  },
  {
    codigo: "5209200",
    municipio: "Guapó",
    estado_codigo: "52",
  },
  {
    codigo: "4309407",
    municipio: "Guaporé",
    estado_codigo: "43",
  },
  {
    codigo: "4109104",
    municipio: "Guaporema",
    estado_codigo: "41",
  },
  {
    codigo: "3517703",
    municipio: "Guará",
    estado_codigo: "35",
  },
  {
    codigo: "2506301",
    municipio: "Guarabira",
    estado_codigo: "25",
  },
  {
    codigo: "3517802",
    municipio: "Guaraçaí",
    estado_codigo: "35",
  },
  {
    codigo: "3517901",
    municipio: "Guaraci",
    estado_codigo: "35",
  },
  {
    codigo: "4109203",
    municipio: "Guaraci",
    estado_codigo: "41",
  },
  {
    codigo: "3128204",
    municipio: "Guaraciaba",
    estado_codigo: "31",
  },
  {
    codigo: "4206405",
    municipio: "Guaraciaba",
    estado_codigo: "42",
  },
  {
    codigo: "2305001",
    municipio: "Guaraciaba do Norte",
    estado_codigo: "23",
  },
  {
    codigo: "3128253",
    municipio: "Guaraciama",
    estado_codigo: "31",
  },
  {
    codigo: "1709302",
    municipio: "Guaraí",
    estado_codigo: "17",
  },
  {
    codigo: "5209291",
    municipio: "Guaraíta",
    estado_codigo: "52",
  },
  {
    codigo: "2305100",
    municipio: "Guaramiranga",
    estado_codigo: "23",
  },
  {
    codigo: "4206504",
    municipio: "Guaramirim",
    estado_codigo: "42",
  },
  {
    codigo: "3128303",
    municipio: "Guaranésia",
    estado_codigo: "31",
  },
  {
    codigo: "3128402",
    municipio: "Guarani",
    estado_codigo: "31",
  },
  {
    codigo: "4109302",
    municipio: "Guaraniaçu",
    estado_codigo: "41",
  },
  {
    codigo: "4309506",
    municipio: "Guarani das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "5209408",
    municipio: "Guarani de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3518008",
    municipio: "Guarani d'Oeste",
    estado_codigo: "35",
  },
  {
    codigo: "3518107",
    municipio: "Guarantã",
    estado_codigo: "35",
  },
  {
    codigo: "5104104",
    municipio: "Guarantã do Norte",
    estado_codigo: "51",
  },
  {
    codigo: "3202405",
    municipio: "Guarapari",
    estado_codigo: "32",
  },
  {
    codigo: "4109401",
    municipio: "Guarapuava",
    estado_codigo: "41",
  },
  {
    codigo: "4109500",
    municipio: "Guaraqueçaba",
    estado_codigo: "41",
  },
  {
    codigo: "3128501",
    municipio: "Guarará",
    estado_codigo: "31",
  },
  {
    codigo: "3518206",
    municipio: "Guararapes",
    estado_codigo: "35",
  },
  {
    codigo: "3518305",
    municipio: "Guararema",
    estado_codigo: "35",
  },
  {
    codigo: "2911808",
    municipio: "Guaratinga",
    estado_codigo: "29",
  },
  {
    codigo: "3518404",
    municipio: "Guaratinguetá",
    estado_codigo: "35",
  },
  {
    codigo: "4109609",
    municipio: "Guaratuba",
    estado_codigo: "41",
  },
  {
    codigo: "3128600",
    municipio: "Guarda-Mor",
    estado_codigo: "31",
  },
  {
    codigo: "3518503",
    municipio: "Guareí",
    estado_codigo: "35",
  },
  {
    codigo: "3518602",
    municipio: "Guariba",
    estado_codigo: "35",
  },
  {
    codigo: "2204550",
    municipio: "Guaribas",
    estado_codigo: "22",
  },
  {
    codigo: "5209457",
    municipio: "Guarinos",
    estado_codigo: "52",
  },
  {
    codigo: "3518701",
    municipio: "Guarujá",
    estado_codigo: "35",
  },
  {
    codigo: "4206603",
    municipio: "Guarujá do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "3518800",
    municipio: "Guarulhos",
    estado_codigo: "35",
  },
  {
    codigo: "4206652",
    municipio: "Guatambú",
    estado_codigo: "42",
  },
  {
    codigo: "3518859",
    municipio: "Guatapará",
    estado_codigo: "35",
  },
  {
    codigo: "3128709",
    municipio: "Guaxupé",
    estado_codigo: "31",
  },
  {
    codigo: "5004106",
    municipio: "Guia Lopes da Laguna",
    estado_codigo: "50",
  },
  {
    codigo: "3128808",
    municipio: "Guidoval",
    estado_codigo: "31",
  },
  {
    codigo: "2104909",
    municipio: "Guimarães",
    estado_codigo: "21",
  },
  {
    codigo: "3128907",
    municipio: "Guimarânia",
    estado_codigo: "31",
  },
  {
    codigo: "5104203",
    municipio: "Guiratinga",
    estado_codigo: "51",
  },
  {
    codigo: "3129004",
    municipio: "Guiricema",
    estado_codigo: "31",
  },
  {
    codigo: "3129103",
    municipio: "Gurinhatã",
    estado_codigo: "31",
  },
  {
    codigo: "2506400",
    municipio: "Gurinhém",
    estado_codigo: "25",
  },
  {
    codigo: "2506509",
    municipio: "Gurjão",
    estado_codigo: "25",
  },
  {
    codigo: "1503101",
    municipio: "Gurupá",
    estado_codigo: "15",
  },
  {
    codigo: "1709500",
    municipio: "Gurupi",
    estado_codigo: "17",
  },
  {
    codigo: "3518909",
    municipio: "Guzolândia",
    estado_codigo: "35",
  },
  {
    codigo: "4309555",
    municipio: "Harmonia",
    estado_codigo: "43",
  },
  {
    codigo: "5209606",
    municipio: "Heitoraí",
    estado_codigo: "52",
  },
  {
    codigo: "3129202",
    municipio: "Heliodora",
    estado_codigo: "31",
  },
  {
    codigo: "2911857",
    municipio: "Heliópolis",
    estado_codigo: "29",
  },
  {
    codigo: "3519006",
    municipio: "Herculândia",
    estado_codigo: "35",
  },
  {
    codigo: "4307104",
    municipio: "Herval",
    estado_codigo: "43",
  },
  {
    codigo: "4206702",
    municipio: "Herval d'Oeste",
    estado_codigo: "42",
  },
  {
    codigo: "4309571",
    municipio: "Herveiras",
    estado_codigo: "43",
  },
  {
    codigo: "5209705",
    municipio: "Hidrolândia",
    estado_codigo: "52",
  },
  {
    codigo: "2305209",
    municipio: "Hidrolândia",
    estado_codigo: "23",
  },
  {
    codigo: "5209804",
    municipio: "Hidrolina",
    estado_codigo: "52",
  },
  {
    codigo: "3519055",
    municipio: "Holambra",
    estado_codigo: "35",
  },
  {
    codigo: "4109658",
    municipio: "Honório Serpa",
    estado_codigo: "41",
  },
  {
    codigo: "2305233",
    municipio: "Horizonte",
    estado_codigo: "23",
  },
  {
    codigo: "4309605",
    municipio: "Horizontina",
    estado_codigo: "43",
  },
  {
    codigo: "3519071",
    municipio: "Hortolândia",
    estado_codigo: "35",
  },
  {
    codigo: "2204600",
    municipio: "Hugo Napoleão",
    estado_codigo: "22",
  },
  {
    codigo: "4309654",
    municipio: "Hulha Negra",
    estado_codigo: "43",
  },
  {
    codigo: "1301704",
    municipio: "Humaitá",
    estado_codigo: "13",
  },
  {
    codigo: "4309704",
    municipio: "Humaitá",
    estado_codigo: "43",
  },
  {
    codigo: "2105005",
    municipio: "Humberto de Campos",
    estado_codigo: "21",
  },
  {
    codigo: "3519105",
    municipio: "Iacanga",
    estado_codigo: "35",
  },
  {
    codigo: "5209903",
    municipio: "Iaciara",
    estado_codigo: "52",
  },
  {
    codigo: "3519204",
    municipio: "Iacri",
    estado_codigo: "35",
  },
  {
    codigo: "2911907",
    municipio: "Iaçu",
    estado_codigo: "29",
  },
  {
    codigo: "3129301",
    municipio: "Iapu",
    estado_codigo: "31",
  },
  {
    codigo: "3519253",
    municipio: "Iaras",
    estado_codigo: "35",
  },
  {
    codigo: "2606507",
    municipio: "Iati",
    estado_codigo: "26",
  },
  {
    codigo: "4109708",
    municipio: "Ibaiti",
    estado_codigo: "41",
  },
  {
    codigo: "4309753",
    municipio: "Ibarama",
    estado_codigo: "43",
  },
  {
    codigo: "2305266",
    municipio: "Ibaretama",
    estado_codigo: "23",
  },
  {
    codigo: "3519303",
    municipio: "Ibaté",
    estado_codigo: "35",
  },
  {
    codigo: "2703007",
    municipio: "Ibateguara",
    estado_codigo: "27",
  },
  {
    codigo: "3202454",
    municipio: "Ibatiba",
    estado_codigo: "32",
  },
  {
    codigo: "4109757",
    municipio: "Ibema",
    estado_codigo: "41",
  },
  {
    codigo: "3129400",
    municipio: "Ibertioga",
    estado_codigo: "31",
  },
  {
    codigo: "3129509",
    municipio: "Ibiá",
    estado_codigo: "31",
  },
  {
    codigo: "4309803",
    municipio: "Ibiaçá",
    estado_codigo: "43",
  },
  {
    codigo: "3129608",
    municipio: "Ibiaí",
    estado_codigo: "31",
  },
  {
    codigo: "4206751",
    municipio: "Ibiam",
    estado_codigo: "42",
  },
  {
    codigo: "2305308",
    municipio: "Ibiapina",
    estado_codigo: "23",
  },
  {
    codigo: "2506608",
    municipio: "Ibiara",
    estado_codigo: "25",
  },
  {
    codigo: "2912004",
    municipio: "Ibiassucê",
    estado_codigo: "29",
  },
  {
    codigo: "2912103",
    municipio: "Ibicaraí",
    estado_codigo: "29",
  },
  {
    codigo: "4206801",
    municipio: "Ibicaré",
    estado_codigo: "42",
  },
  {
    codigo: "2912202",
    municipio: "Ibicoara",
    estado_codigo: "29",
  },
  {
    codigo: "2912301",
    municipio: "Ibicuí",
    estado_codigo: "29",
  },
  {
    codigo: "2305332",
    municipio: "Ibicuitinga",
    estado_codigo: "23",
  },
  {
    codigo: "2606606",
    municipio: "Ibimirim",
    estado_codigo: "26",
  },
  {
    codigo: "2912400",
    municipio: "Ibipeba",
    estado_codigo: "29",
  },
  {
    codigo: "2912509",
    municipio: "Ibipitanga",
    estado_codigo: "29",
  },
  {
    codigo: "4109807",
    municipio: "Ibiporã",
    estado_codigo: "41",
  },
  {
    codigo: "2912608",
    municipio: "Ibiquera",
    estado_codigo: "29",
  },
  {
    codigo: "3519402",
    municipio: "Ibirá",
    estado_codigo: "35",
  },
  {
    codigo: "3129657",
    municipio: "Ibiracatu",
    estado_codigo: "31",
  },
  {
    codigo: "3129707",
    municipio: "Ibiraci",
    estado_codigo: "31",
  },
  {
    codigo: "3202504",
    municipio: "Ibiraçu",
    estado_codigo: "32",
  },
  {
    codigo: "4309902",
    municipio: "Ibiraiaras",
    estado_codigo: "43",
  },
  {
    codigo: "2606705",
    municipio: "Ibirajuba",
    estado_codigo: "26",
  },
  {
    codigo: "4206900",
    municipio: "Ibirama",
    estado_codigo: "42",
  },
  {
    codigo: "2912707",
    municipio: "Ibirapitanga",
    estado_codigo: "29",
  },
  {
    codigo: "2912806",
    municipio: "Ibirapuã",
    estado_codigo: "29",
  },
  {
    codigo: "4309951",
    municipio: "Ibirapuitã",
    estado_codigo: "43",
  },
  {
    codigo: "3519501",
    municipio: "Ibirarema",
    estado_codigo: "35",
  },
  {
    codigo: "2912905",
    municipio: "Ibirataia",
    estado_codigo: "29",
  },
  {
    codigo: "3129806",
    municipio: "Ibirité",
    estado_codigo: "31",
  },
  {
    codigo: "4310009",
    municipio: "Ibirubá",
    estado_codigo: "43",
  },
  {
    codigo: "2913002",
    municipio: "Ibitiara",
    estado_codigo: "29",
  },
  {
    codigo: "3519600",
    municipio: "Ibitinga",
    estado_codigo: "35",
  },
  {
    codigo: "3202553",
    municipio: "Ibitirama",
    estado_codigo: "32",
  },
  {
    codigo: "2913101",
    municipio: "Ibititá",
    estado_codigo: "29",
  },
  {
    codigo: "3129905",
    municipio: "Ibitiúra de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "3130002",
    municipio: "Ibituruna",
    estado_codigo: "31",
  },
  {
    codigo: "3519709",
    municipio: "Ibiúna",
    estado_codigo: "35",
  },
  {
    codigo: "2913200",
    municipio: "Ibotirama",
    estado_codigo: "29",
  },
  {
    codigo: "2305357",
    municipio: "Icapuí",
    estado_codigo: "23",
  },
  {
    codigo: "4207007",
    municipio: "Içara",
    estado_codigo: "42",
  },
  {
    codigo: "3130051",
    municipio: "Icaraí de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4109906",
    municipio: "Icaraíma",
    estado_codigo: "41",
  },
  {
    codigo: "2105104",
    municipio: "Icatu",
    estado_codigo: "21",
  },
  {
    codigo: "3519808",
    municipio: "Icém",
    estado_codigo: "35",
  },
  {
    codigo: "2913309",
    municipio: "Ichu",
    estado_codigo: "29",
  },
  {
    codigo: "2305407",
    municipio: "Icó",
    estado_codigo: "23",
  },
  {
    codigo: "3202603",
    municipio: "Iconha",
    estado_codigo: "32",
  },
  {
    codigo: "2404606",
    municipio: "Ielmo Marinho",
    estado_codigo: "24",
  },
  {
    codigo: "3519907",
    municipio: "Iepê",
    estado_codigo: "35",
  },
  {
    codigo: "2703106",
    municipio: "Igaci",
    estado_codigo: "27",
  },
  {
    codigo: "2913408",
    municipio: "Igaporã",
    estado_codigo: "29",
  },
  {
    codigo: "3520004",
    municipio: "Igaraçu do Tietê",
    estado_codigo: "35",
  },
  {
    codigo: "2502607",
    municipio: "Igaracy",
    estado_codigo: "25",
  },
  {
    codigo: "3520103",
    municipio: "Igarapava",
    estado_codigo: "35",
  },
  {
    codigo: "3130101",
    municipio: "Igarapé",
    estado_codigo: "31",
  },
  {
    codigo: "1503200",
    municipio: "Igarapé-Açu",
    estado_codigo: "15",
  },
  {
    codigo: "2105153",
    municipio: "Igarapé do Meio",
    estado_codigo: "21",
  },
  {
    codigo: "2105203",
    municipio: "Igarapé Grande",
    estado_codigo: "21",
  },
  {
    codigo: "1503309",
    municipio: "Igarapé-Miri",
    estado_codigo: "15",
  },
  {
    codigo: "2606804",
    municipio: "Igarassu",
    estado_codigo: "26",
  },
  {
    codigo: "3520202",
    municipio: "Igaratá",
    estado_codigo: "35",
  },
  {
    codigo: "3130200",
    municipio: "Igaratinga",
    estado_codigo: "31",
  },
  {
    codigo: "2913457",
    municipio: "Igrapiúna",
    estado_codigo: "29",
  },
  {
    codigo: "2703205",
    municipio: "Igreja Nova",
    estado_codigo: "27",
  },
  {
    codigo: "4310108",
    municipio: "Igrejinha",
    estado_codigo: "43",
  },
  {
    codigo: "3301876",
    municipio: "Iguaba Grande",
    estado_codigo: "33",
  },
  {
    codigo: "2913507",
    municipio: "Iguaí",
    estado_codigo: "29",
  },
  {
    codigo: "3520301",
    municipio: "Iguape",
    estado_codigo: "35",
  },
  {
    codigo: "2606903",
    municipio: "Iguaraci",
    estado_codigo: "26",
  },
  {
    codigo: "4110003",
    municipio: "Iguaraçu",
    estado_codigo: "41",
  },
  {
    codigo: "3130309",
    municipio: "Iguatama",
    estado_codigo: "31",
  },
  {
    codigo: "5004304",
    municipio: "Iguatemi",
    estado_codigo: "50",
  },
  {
    codigo: "4110052",
    municipio: "Iguatu",
    estado_codigo: "41",
  },
  {
    codigo: "2305506",
    municipio: "Iguatu",
    estado_codigo: "23",
  },
  {
    codigo: "3130408",
    municipio: "Ijaci",
    estado_codigo: "31",
  },
  {
    codigo: "4310207",
    municipio: "Ijuí",
    estado_codigo: "43",
  },
  {
    codigo: "3520400",
    municipio: "Ilhabela",
    estado_codigo: "35",
  },
  {
    codigo: "3520426",
    municipio: "Ilha Comprida",
    estado_codigo: "35",
  },
  {
    codigo: "2802700",
    municipio: "Ilha das Flores",
    estado_codigo: "28",
  },
  {
    codigo: "2607604",
    municipio: "Ilha de Itamaracá",
    estado_codigo: "26",
  },
  {
    codigo: "2204659",
    municipio: "Ilha Grande",
    estado_codigo: "22",
  },
  {
    codigo: "3520442",
    municipio: "Ilha Solteira",
    estado_codigo: "35",
  },
  {
    codigo: "2913606",
    municipio: "Ilhéus",
    estado_codigo: "29",
  },
  {
    codigo: "4207106",
    municipio: "Ilhota",
    estado_codigo: "42",
  },
  {
    codigo: "3130507",
    municipio: "Ilicínea",
    estado_codigo: "31",
  },
  {
    codigo: "4310306",
    municipio: "Ilópolis",
    estado_codigo: "43",
  },
  {
    codigo: "2506707",
    municipio: "Imaculada",
    estado_codigo: "25",
  },
  {
    codigo: "4207205",
    municipio: "Imaruí",
    estado_codigo: "42",
  },
  {
    codigo: "4110078",
    municipio: "Imbaú",
    estado_codigo: "41",
  },
  {
    codigo: "4310330",
    municipio: "Imbé",
    estado_codigo: "43",
  },
  {
    codigo: "3130556",
    municipio: "Imbé de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4207304",
    municipio: "Imbituba",
    estado_codigo: "42",
  },
  {
    codigo: "4110102",
    municipio: "Imbituva",
    estado_codigo: "41",
  },
  {
    codigo: "4207403",
    municipio: "Imbuia",
    estado_codigo: "42",
  },
  {
    codigo: "4310363",
    municipio: "Imigrante",
    estado_codigo: "43",
  },
  {
    codigo: "2105302",
    municipio: "Imperatriz",
    estado_codigo: "21",
  },
  {
    codigo: "5209937",
    municipio: "Inaciolândia",
    estado_codigo: "52",
  },
  {
    codigo: "4110201",
    municipio: "Inácio Martins",
    estado_codigo: "41",
  },
  {
    codigo: "2607000",
    municipio: "Inajá",
    estado_codigo: "26",
  },
  {
    codigo: "4110300",
    municipio: "Inajá",
    estado_codigo: "41",
  },
  {
    codigo: "3130606",
    municipio: "Inconfidentes",
    estado_codigo: "31",
  },
  {
    codigo: "3130655",
    municipio: "Indaiabira",
    estado_codigo: "31",
  },
  {
    codigo: "4207502",
    municipio: "Indaial",
    estado_codigo: "42",
  },
  {
    codigo: "3520509",
    municipio: "Indaiatuba",
    estado_codigo: "35",
  },
  {
    codigo: "2305605",
    municipio: "Independência",
    estado_codigo: "23",
  },
  {
    codigo: "4310405",
    municipio: "Independência",
    estado_codigo: "43",
  },
  {
    codigo: "3520608",
    municipio: "Indiana",
    estado_codigo: "35",
  },
  {
    codigo: "4110409",
    municipio: "Indianópolis",
    estado_codigo: "41",
  },
  {
    codigo: "3130705",
    municipio: "Indianópolis",
    estado_codigo: "31",
  },
  {
    codigo: "3520707",
    municipio: "Indiaporã",
    estado_codigo: "35",
  },
  {
    codigo: "5209952",
    municipio: "Indiara",
    estado_codigo: "52",
  },
  {
    codigo: "2802809",
    municipio: "Indiaroba",
    estado_codigo: "28",
  },
  {
    codigo: "5104500",
    municipio: "Indiavaí",
    estado_codigo: "51",
  },
  {
    codigo: "2506806",
    municipio: "Ingá",
    estado_codigo: "25",
  },
  {
    codigo: "3130804",
    municipio: "Ingaí",
    estado_codigo: "31",
  },
  {
    codigo: "2607109",
    municipio: "Ingazeira",
    estado_codigo: "26",
  },
  {
    codigo: "4310413",
    municipio: "Inhacorá",
    estado_codigo: "43",
  },
  {
    codigo: "2913705",
    municipio: "Inhambupe",
    estado_codigo: "29",
  },
  {
    codigo: "1503408",
    municipio: "Inhangapi",
    estado_codigo: "15",
  },
  {
    codigo: "2703304",
    municipio: "Inhapi",
    estado_codigo: "27",
  },
  {
    codigo: "3130903",
    municipio: "Inhapim",
    estado_codigo: "31",
  },
  {
    codigo: "3131000",
    municipio: "Inhaúma",
    estado_codigo: "31",
  },
  {
    codigo: "2204709",
    municipio: "Inhuma",
    estado_codigo: "22",
  },
  {
    codigo: "5210000",
    municipio: "Inhumas",
    estado_codigo: "52",
  },
  {
    codigo: "3131109",
    municipio: "Inimutaba",
    estado_codigo: "31",
  },
  {
    codigo: "5004403",
    municipio: "Inocência",
    estado_codigo: "50",
  },
  {
    codigo: "3520806",
    municipio: "Inúbia Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4207577",
    municipio: "Iomerê",
    estado_codigo: "42",
  },
  {
    codigo: "3131158",
    municipio: "Ipaba",
    estado_codigo: "31",
  },
  {
    codigo: "5210109",
    municipio: "Ipameri",
    estado_codigo: "52",
  },
  {
    codigo: "3131208",
    municipio: "Ipanema",
    estado_codigo: "31",
  },
  {
    codigo: "2404705",
    municipio: "Ipanguaçu",
    estado_codigo: "24",
  },
  {
    codigo: "2305654",
    municipio: "Ipaporanga",
    estado_codigo: "23",
  },
  {
    codigo: "3131307",
    municipio: "Ipatinga",
    estado_codigo: "31",
  },
  {
    codigo: "2305704",
    municipio: "Ipaumirim",
    estado_codigo: "23",
  },
  {
    codigo: "3520905",
    municipio: "Ipaussu",
    estado_codigo: "35",
  },
  {
    codigo: "4310439",
    municipio: "Ipê",
    estado_codigo: "43",
  },
  {
    codigo: "2913804",
    municipio: "Ipecaetá",
    estado_codigo: "29",
  },
  {
    codigo: "3521002",
    municipio: "Iperó",
    estado_codigo: "35",
  },
  {
    codigo: "3521101",
    municipio: "Ipeúna",
    estado_codigo: "35",
  },
  {
    codigo: "3131406",
    municipio: "Ipiaçu",
    estado_codigo: "31",
  },
  {
    codigo: "2913903",
    municipio: "Ipiaú",
    estado_codigo: "29",
  },
  {
    codigo: "3521150",
    municipio: "Ipiguá",
    estado_codigo: "35",
  },
  {
    codigo: "4207601",
    municipio: "Ipira",
    estado_codigo: "42",
  },
  {
    codigo: "2914000",
    municipio: "Ipirá",
    estado_codigo: "29",
  },
  {
    codigo: "4110508",
    municipio: "Ipiranga",
    estado_codigo: "41",
  },
  {
    codigo: "5210158",
    municipio: "Ipiranga de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "5104526",
    municipio: "Ipiranga do Norte",
    estado_codigo: "51",
  },
  {
    codigo: "2204808",
    municipio: "Ipiranga do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4310462",
    municipio: "Ipiranga do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "1301803",
    municipio: "Ipixuna",
    estado_codigo: "13",
  },
  {
    codigo: "1503457",
    municipio: "Ipixuna do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "2607208",
    municipio: "Ipojuca",
    estado_codigo: "26",
  },
  {
    codigo: "5210208",
    municipio: "Iporá",
    estado_codigo: "52",
  },
  {
    codigo: "4110607",
    municipio: "Iporã",
    estado_codigo: "41",
  },
  {
    codigo: "4207650",
    municipio: "Iporã do Oeste",
    estado_codigo: "42",
  },
  {
    codigo: "3521200",
    municipio: "Iporanga",
    estado_codigo: "35",
  },
  {
    codigo: "2305803",
    municipio: "Ipu",
    estado_codigo: "23",
  },
  {
    codigo: "3521309",
    municipio: "Ipuã",
    estado_codigo: "35",
  },
  {
    codigo: "4207684",
    municipio: "Ipuaçu",
    estado_codigo: "42",
  },
  {
    codigo: "2607307",
    municipio: "Ipubi",
    estado_codigo: "26",
  },
  {
    codigo: "2404804",
    municipio: "Ipueira",
    estado_codigo: "24",
  },
  {
    codigo: "2305902",
    municipio: "Ipueiras",
    estado_codigo: "23",
  },
  {
    codigo: "1709807",
    municipio: "Ipueiras",
    estado_codigo: "17",
  },
  {
    codigo: "3131505",
    municipio: "Ipuiúna",
    estado_codigo: "31",
  },
  {
    codigo: "4207700",
    municipio: "Ipumirim",
    estado_codigo: "42",
  },
  {
    codigo: "2914109",
    municipio: "Ipupiara",
    estado_codigo: "29",
  },
  {
    codigo: "2306009",
    municipio: "Iracema",
    estado_codigo: "23",
  },
  {
    codigo: "1400282",
    municipio: "Iracema",
    estado_codigo: "14",
  },
  {
    codigo: "4110656",
    municipio: "Iracema do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "3521408",
    municipio: "Iracemápolis",
    estado_codigo: "35",
  },
  {
    codigo: "4207759",
    municipio: "Iraceminha",
    estado_codigo: "42",
  },
  {
    codigo: "4310504",
    municipio: "Iraí",
    estado_codigo: "43",
  },
  {
    codigo: "3131604",
    municipio: "Iraí de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2914208",
    municipio: "Irajuba",
    estado_codigo: "29",
  },
  {
    codigo: "2914307",
    municipio: "Iramaia",
    estado_codigo: "29",
  },
  {
    codigo: "1301852",
    municipio: "Iranduba",
    estado_codigo: "13",
  },
  {
    codigo: "4207809",
    municipio: "Irani",
    estado_codigo: "42",
  },
  {
    codigo: "3521507",
    municipio: "Irapuã",
    estado_codigo: "35",
  },
  {
    codigo: "3521606",
    municipio: "Irapuru",
    estado_codigo: "35",
  },
  {
    codigo: "2914406",
    municipio: "Iraquara",
    estado_codigo: "29",
  },
  {
    codigo: "2914505",
    municipio: "Irará",
    estado_codigo: "29",
  },
  {
    codigo: "4207858",
    municipio: "Irati",
    estado_codigo: "42",
  },
  {
    codigo: "4110706",
    municipio: "Irati",
    estado_codigo: "41",
  },
  {
    codigo: "2306108",
    municipio: "Irauçuba",
    estado_codigo: "23",
  },
  {
    codigo: "2914604",
    municipio: "Irecê",
    estado_codigo: "29",
  },
  {
    codigo: "4110805",
    municipio: "Iretama",
    estado_codigo: "41",
  },
  {
    codigo: "4207908",
    municipio: "Irineópolis",
    estado_codigo: "42",
  },
  {
    codigo: "1503507",
    municipio: "Irituia",
    estado_codigo: "15",
  },
  {
    codigo: "3202652",
    municipio: "Irupi",
    estado_codigo: "32",
  },
  {
    codigo: "2204907",
    municipio: "Isaías Coelho",
    estado_codigo: "22",
  },
  {
    codigo: "5210307",
    municipio: "Israelândia",
    estado_codigo: "52",
  },
  {
    codigo: "4208005",
    municipio: "Itá",
    estado_codigo: "42",
  },
  {
    codigo: "4310538",
    municipio: "Itaara",
    estado_codigo: "43",
  },
  {
    codigo: "2802908",
    municipio: "Itabaiana",
    estado_codigo: "28",
  },
  {
    codigo: "2506905",
    municipio: "Itabaiana",
    estado_codigo: "25",
  },
  {
    codigo: "2803005",
    municipio: "Itabaianinha",
    estado_codigo: "28",
  },
  {
    codigo: "2914653",
    municipio: "Itabela",
    estado_codigo: "29",
  },
  {
    codigo: "3521705",
    municipio: "Itaberá",
    estado_codigo: "35",
  },
  {
    codigo: "2914703",
    municipio: "Itaberaba",
    estado_codigo: "29",
  },
  {
    codigo: "5210406",
    municipio: "Itaberaí",
    estado_codigo: "52",
  },
  {
    codigo: "2803104",
    municipio: "Itabi",
    estado_codigo: "28",
  },
  {
    codigo: "3131703",
    municipio: "Itabira",
    estado_codigo: "31",
  },
  {
    codigo: "3131802",
    municipio: "Itabirinha",
    estado_codigo: "31",
  },
  {
    codigo: "3131901",
    municipio: "Itabirito",
    estado_codigo: "31",
  },
  {
    codigo: "3301900",
    municipio: "Itaboraí",
    estado_codigo: "33",
  },
  {
    codigo: "2914802",
    municipio: "Itabuna",
    estado_codigo: "29",
  },
  {
    codigo: "1710508",
    municipio: "Itacajá",
    estado_codigo: "17",
  },
  {
    codigo: "3132008",
    municipio: "Itacambira",
    estado_codigo: "31",
  },
  {
    codigo: "3132107",
    municipio: "Itacarambi",
    estado_codigo: "31",
  },
  {
    codigo: "2914901",
    municipio: "Itacaré",
    estado_codigo: "29",
  },
  {
    codigo: "1301902",
    municipio: "Itacoatiara",
    estado_codigo: "13",
  },
  {
    codigo: "2607406",
    municipio: "Itacuruba",
    estado_codigo: "26",
  },
  {
    codigo: "4310553",
    municipio: "Itacurubi",
    estado_codigo: "43",
  },
  {
    codigo: "2915007",
    municipio: "Itaeté",
    estado_codigo: "29",
  },
  {
    codigo: "2915106",
    municipio: "Itagi",
    estado_codigo: "29",
  },
  {
    codigo: "2915205",
    municipio: "Itagibá",
    estado_codigo: "29",
  },
  {
    codigo: "2915304",
    municipio: "Itagimirim",
    estado_codigo: "29",
  },
  {
    codigo: "3202702",
    municipio: "Itaguaçu",
    estado_codigo: "32",
  },
  {
    codigo: "2915353",
    municipio: "Itaguaçu da Bahia",
    estado_codigo: "29",
  },
  {
    codigo: "3302007",
    municipio: "Itaguaí",
    estado_codigo: "33",
  },
  {
    codigo: "4110904",
    municipio: "Itaguajé",
    estado_codigo: "41",
  },
  {
    codigo: "3132206",
    municipio: "Itaguara",
    estado_codigo: "31",
  },
  {
    codigo: "5210562",
    municipio: "Itaguari",
    estado_codigo: "52",
  },
  {
    codigo: "5210604",
    municipio: "Itaguaru",
    estado_codigo: "52",
  },
  {
    codigo: "1710706",
    municipio: "Itaguatins",
    estado_codigo: "17",
  },
  {
    codigo: "3521804",
    municipio: "Itaí",
    estado_codigo: "35",
  },
  {
    codigo: "2607505",
    municipio: "Itaíba",
    estado_codigo: "26",
  },
  {
    codigo: "2306207",
    municipio: "Itaiçaba",
    estado_codigo: "23",
  },
  {
    codigo: "2205003",
    municipio: "Itainópolis",
    estado_codigo: "22",
  },
  {
    codigo: "4208104",
    municipio: "Itaiópolis",
    estado_codigo: "42",
  },
  {
    codigo: "2105351",
    municipio: "Itaipava do Grajaú",
    estado_codigo: "21",
  },
  {
    codigo: "3132305",
    municipio: "Itaipé",
    estado_codigo: "31",
  },
  {
    codigo: "4110953",
    municipio: "Itaipulândia",
    estado_codigo: "41",
  },
  {
    codigo: "2306256",
    municipio: "Itaitinga",
    estado_codigo: "23",
  },
  {
    codigo: "1503606",
    municipio: "Itaituba",
    estado_codigo: "15",
  },
  {
    codigo: "5210802",
    municipio: "Itajá",
    estado_codigo: "52",
  },
  {
    codigo: "2404853",
    municipio: "Itajá",
    estado_codigo: "24",
  },
  {
    codigo: "4208203",
    municipio: "Itajaí",
    estado_codigo: "42",
  },
  {
    codigo: "3521903",
    municipio: "Itajobi",
    estado_codigo: "35",
  },
  {
    codigo: "3522000",
    municipio: "Itaju",
    estado_codigo: "35",
  },
  {
    codigo: "3132404",
    municipio: "Itajubá",
    estado_codigo: "31",
  },
  {
    codigo: "2915403",
    municipio: "Itaju do Colônia",
    estado_codigo: "29",
  },
  {
    codigo: "2915502",
    municipio: "Itajuípe",
    estado_codigo: "29",
  },
  {
    codigo: "3302056",
    municipio: "Italva",
    estado_codigo: "33",
  },
  {
    codigo: "2915601",
    municipio: "Itamaraju",
    estado_codigo: "29",
  },
  {
    codigo: "3132503",
    municipio: "Itamarandiba",
    estado_codigo: "31",
  },
  {
    codigo: "1301951",
    municipio: "Itamarati",
    estado_codigo: "13",
  },
  {
    codigo: "3132602",
    municipio: "Itamarati de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2915700",
    municipio: "Itamari",
    estado_codigo: "29",
  },
  {
    codigo: "3132701",
    municipio: "Itambacuri",
    estado_codigo: "31",
  },
  {
    codigo: "4111001",
    municipio: "Itambaracá",
    estado_codigo: "41",
  },
  {
    codigo: "2607653",
    municipio: "Itambé",
    estado_codigo: "26",
  },
  {
    codigo: "2915809",
    municipio: "Itambé",
    estado_codigo: "29",
  },
  {
    codigo: "4111100",
    municipio: "Itambé",
    estado_codigo: "41",
  },
  {
    codigo: "3132800",
    municipio: "Itambé do Mato Dentro",
    estado_codigo: "31",
  },
  {
    codigo: "3132909",
    municipio: "Itamogi",
    estado_codigo: "31",
  },
  {
    codigo: "3133006",
    municipio: "Itamonte",
    estado_codigo: "31",
  },
  {
    codigo: "2915908",
    municipio: "Itanagra",
    estado_codigo: "29",
  },
  {
    codigo: "3522109",
    municipio: "Itanhaém",
    estado_codigo: "35",
  },
  {
    codigo: "3133105",
    municipio: "Itanhandu",
    estado_codigo: "31",
  },
  {
    codigo: "5104542",
    municipio: "Itanhangá",
    estado_codigo: "51",
  },
  {
    codigo: "2916005",
    municipio: "Itanhém",
    estado_codigo: "29",
  },
  {
    codigo: "3133204",
    municipio: "Itanhomi",
    estado_codigo: "31",
  },
  {
    codigo: "3133303",
    municipio: "Itaobim",
    estado_codigo: "31",
  },
  {
    codigo: "3522158",
    municipio: "Itaóca",
    estado_codigo: "35",
  },
  {
    codigo: "3302106",
    municipio: "Itaocara",
    estado_codigo: "33",
  },
  {
    codigo: "5210901",
    municipio: "Itapaci",
    estado_codigo: "52",
  },
  {
    codigo: "2306306",
    municipio: "Itapagé",
    estado_codigo: "23",
  },
  {
    codigo: "3133402",
    municipio: "Itapagipe",
    estado_codigo: "31",
  },
  {
    codigo: "2916104",
    municipio: "Itaparica",
    estado_codigo: "29",
  },
  {
    codigo: "2916203",
    municipio: "Itapé",
    estado_codigo: "29",
  },
  {
    codigo: "2916302",
    municipio: "Itapebi",
    estado_codigo: "29",
  },
  {
    codigo: "3133501",
    municipio: "Itapecerica",
    estado_codigo: "31",
  },
  {
    codigo: "3522208",
    municipio: "Itapecerica da Serra",
    estado_codigo: "35",
  },
  {
    codigo: "2105401",
    municipio: "Itapecuru Mirim",
    estado_codigo: "21",
  },
  {
    codigo: "4111209",
    municipio: "Itapejara d'Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "4208302",
    municipio: "Itapema",
    estado_codigo: "42",
  },
  {
    codigo: "3202801",
    municipio: "Itapemirim",
    estado_codigo: "32",
  },
  {
    codigo: "4111258",
    municipio: "Itaperuçu",
    estado_codigo: "41",
  },
  {
    codigo: "3302205",
    municipio: "Itaperuna",
    estado_codigo: "33",
  },
  {
    codigo: "2607703",
    municipio: "Itapetim",
    estado_codigo: "26",
  },
  {
    codigo: "2916401",
    municipio: "Itapetinga",
    estado_codigo: "29",
  },
  {
    codigo: "3522307",
    municipio: "Itapetininga",
    estado_codigo: "35",
  },
  {
    codigo: "3133600",
    municipio: "Itapeva",
    estado_codigo: "31",
  },
  {
    codigo: "3522406",
    municipio: "Itapeva",
    estado_codigo: "35",
  },
  {
    codigo: "3522505",
    municipio: "Itapevi",
    estado_codigo: "35",
  },
  {
    codigo: "2916500",
    municipio: "Itapicuru",
    estado_codigo: "29",
  },
  {
    codigo: "2306405",
    municipio: "Itapipoca",
    estado_codigo: "23",
  },
  {
    codigo: "3522604",
    municipio: "Itapira",
    estado_codigo: "35",
  },
  {
    codigo: "4208401",
    municipio: "Itapiranga",
    estado_codigo: "42",
  },
  {
    codigo: "1302009",
    municipio: "Itapiranga",
    estado_codigo: "13",
  },
  {
    codigo: "5211008",
    municipio: "Itapirapuã",
    estado_codigo: "52",
  },
  {
    codigo: "3522653",
    municipio: "Itapirapuã Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "1710904",
    municipio: "Itapiratins",
    estado_codigo: "17",
  },
  {
    codigo: "2607752",
    municipio: "Itapissuma",
    estado_codigo: "26",
  },
  {
    codigo: "2916609",
    municipio: "Itapitanga",
    estado_codigo: "29",
  },
  {
    codigo: "2306504",
    municipio: "Itapiúna",
    estado_codigo: "23",
  },
  {
    codigo: "4208450",
    municipio: "Itapoá",
    estado_codigo: "42",
  },
  {
    codigo: "3522703",
    municipio: "Itápolis",
    estado_codigo: "35",
  },
  {
    codigo: "5004502",
    municipio: "Itaporã",
    estado_codigo: "50",
  },
  {
    codigo: "1711100",
    municipio: "Itaporã do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2507002",
    municipio: "Itaporanga",
    estado_codigo: "25",
  },
  {
    codigo: "3522802",
    municipio: "Itaporanga",
    estado_codigo: "35",
  },
  {
    codigo: "2803203",
    municipio: "Itaporanga d'Ajuda",
    estado_codigo: "28",
  },
  {
    codigo: "2507101",
    municipio: "Itapororoca",
    estado_codigo: "25",
  },
  {
    codigo: "1101104",
    municipio: "Itapuã do Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "4310579",
    municipio: "Itapuca",
    estado_codigo: "43",
  },
  {
    codigo: "3522901",
    municipio: "Itapuí",
    estado_codigo: "35",
  },
  {
    codigo: "3523008",
    municipio: "Itapura",
    estado_codigo: "35",
  },
  {
    codigo: "5211206",
    municipio: "Itapuranga",
    estado_codigo: "52",
  },
  {
    codigo: "3523107",
    municipio: "Itaquaquecetuba",
    estado_codigo: "35",
  },
  {
    codigo: "2916708",
    municipio: "Itaquara",
    estado_codigo: "29",
  },
  {
    codigo: "4310603",
    municipio: "Itaqui",
    estado_codigo: "43",
  },
  {
    codigo: "5004601",
    municipio: "Itaquiraí",
    estado_codigo: "50",
  },
  {
    codigo: "2607802",
    municipio: "Itaquitinga",
    estado_codigo: "26",
  },
  {
    codigo: "3202900",
    municipio: "Itarana",
    estado_codigo: "32",
  },
  {
    codigo: "2916807",
    municipio: "Itarantim",
    estado_codigo: "29",
  },
  {
    codigo: "3523206",
    municipio: "Itararé",
    estado_codigo: "35",
  },
  {
    codigo: "2306553",
    municipio: "Itarema",
    estado_codigo: "23",
  },
  {
    codigo: "3523305",
    municipio: "Itariri",
    estado_codigo: "35",
  },
  {
    codigo: "5211305",
    municipio: "Itarumã",
    estado_codigo: "52",
  },
  {
    codigo: "4310652",
    municipio: "Itati",
    estado_codigo: "43",
  },
  {
    codigo: "3302254",
    municipio: "Itatiaia",
    estado_codigo: "33",
  },
  {
    codigo: "3133709",
    municipio: "Itatiaiuçu",
    estado_codigo: "31",
  },
  {
    codigo: "3523404",
    municipio: "Itatiba",
    estado_codigo: "35",
  },
  {
    codigo: "4310702",
    municipio: "Itatiba do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2916856",
    municipio: "Itatim",
    estado_codigo: "29",
  },
  {
    codigo: "3523503",
    municipio: "Itatinga",
    estado_codigo: "35",
  },
  {
    codigo: "2306603",
    municipio: "Itatira",
    estado_codigo: "23",
  },
  {
    codigo: "2507200",
    municipio: "Itatuba",
    estado_codigo: "25",
  },
  {
    codigo: "2404903",
    municipio: "Itaú",
    estado_codigo: "24",
  },
  {
    codigo: "5104559",
    municipio: "Itaúba",
    estado_codigo: "51",
  },
  {
    codigo: "1600253",
    municipio: "Itaubal",
    estado_codigo: "16",
  },
  {
    codigo: "5211404",
    municipio: "Itauçu",
    estado_codigo: "52",
  },
  {
    codigo: "3133758",
    municipio: "Itaú de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2205102",
    municipio: "Itaueira",
    estado_codigo: "22",
  },
  {
    codigo: "3133808",
    municipio: "Itaúna",
    estado_codigo: "31",
  },
  {
    codigo: "4111308",
    municipio: "Itaúna do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "3133907",
    municipio: "Itaverava",
    estado_codigo: "31",
  },
  {
    codigo: "3134004",
    municipio: "Itinga",
    estado_codigo: "31",
  },
  {
    codigo: "2105427",
    municipio: "Itinga do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "5104609",
    municipio: "Itiquira",
    estado_codigo: "51",
  },
  {
    codigo: "3523602",
    municipio: "Itirapina",
    estado_codigo: "35",
  },
  {
    codigo: "3523701",
    municipio: "Itirapuã",
    estado_codigo: "35",
  },
  {
    codigo: "2916906",
    municipio: "Itiruçu",
    estado_codigo: "29",
  },
  {
    codigo: "2917003",
    municipio: "Itiúba",
    estado_codigo: "29",
  },
  {
    codigo: "3523800",
    municipio: "Itobi",
    estado_codigo: "35",
  },
  {
    codigo: "2917102",
    municipio: "Itororó",
    estado_codigo: "29",
  },
  {
    codigo: "3523909",
    municipio: "Itu",
    estado_codigo: "35",
  },
  {
    codigo: "2917201",
    municipio: "Ituaçu",
    estado_codigo: "29",
  },
  {
    codigo: "2917300",
    municipio: "Ituberá",
    estado_codigo: "29",
  },
  {
    codigo: "3134103",
    municipio: "Itueta",
    estado_codigo: "31",
  },
  {
    codigo: "3134202",
    municipio: "Ituiutaba",
    estado_codigo: "31",
  },
  {
    codigo: "5211503",
    municipio: "Itumbiara",
    estado_codigo: "52",
  },
  {
    codigo: "3134301",
    municipio: "Itumirim",
    estado_codigo: "31",
  },
  {
    codigo: "3524006",
    municipio: "Itupeva",
    estado_codigo: "35",
  },
  {
    codigo: "1503705",
    municipio: "Itupiranga",
    estado_codigo: "15",
  },
  {
    codigo: "4208500",
    municipio: "Ituporanga",
    estado_codigo: "42",
  },
  {
    codigo: "3134400",
    municipio: "Iturama",
    estado_codigo: "31",
  },
  {
    codigo: "3134509",
    municipio: "Itutinga",
    estado_codigo: "31",
  },
  {
    codigo: "3524105",
    municipio: "Ituverava",
    estado_codigo: "35",
  },
  {
    codigo: "2917334",
    municipio: "Iuiú",
    estado_codigo: "29",
  },
  {
    codigo: "3203007",
    municipio: "Iúna",
    estado_codigo: "32",
  },
  {
    codigo: "4111407",
    municipio: "Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "4111506",
    municipio: "Ivaiporã",
    estado_codigo: "41",
  },
  {
    codigo: "4111555",
    municipio: "Ivaté",
    estado_codigo: "41",
  },
  {
    codigo: "4111605",
    municipio: "Ivatuba",
    estado_codigo: "41",
  },
  {
    codigo: "5004700",
    municipio: "Ivinhema",
    estado_codigo: "50",
  },
  {
    codigo: "5211602",
    municipio: "Ivolândia",
    estado_codigo: "52",
  },
  {
    codigo: "4310751",
    municipio: "Ivorá",
    estado_codigo: "43",
  },
  {
    codigo: "4310801",
    municipio: "Ivoti",
    estado_codigo: "43",
  },
  {
    codigo: "2607901",
    municipio: "Jaboatão dos Guararapes",
    estado_codigo: "26",
  },
  {
    codigo: "4208609",
    municipio: "Jaborá",
    estado_codigo: "42",
  },
  {
    codigo: "2917359",
    municipio: "Jaborandi",
    estado_codigo: "29",
  },
  {
    codigo: "3524204",
    municipio: "Jaborandi",
    estado_codigo: "35",
  },
  {
    codigo: "4111704",
    municipio: "Jaboti",
    estado_codigo: "41",
  },
  {
    codigo: "4310850",
    municipio: "Jaboticaba",
    estado_codigo: "43",
  },
  {
    codigo: "3524303",
    municipio: "Jaboticabal",
    estado_codigo: "35",
  },
  {
    codigo: "3134608",
    municipio: "Jaboticatubas",
    estado_codigo: "31",
  },
  {
    codigo: "2405009",
    municipio: "Jaçanã",
    estado_codigo: "24",
  },
  {
    codigo: "2917409",
    municipio: "Jacaraci",
    estado_codigo: "29",
  },
  {
    codigo: "2507309",
    municipio: "Jacaraú",
    estado_codigo: "25",
  },
  {
    codigo: "1503754",
    municipio: "Jacareacanga",
    estado_codigo: "15",
  },
  {
    codigo: "2703403",
    municipio: "Jacaré dos Homens",
    estado_codigo: "27",
  },
  {
    codigo: "3524402",
    municipio: "Jacareí",
    estado_codigo: "35",
  },
  {
    codigo: "4111803",
    municipio: "Jacarezinho",
    estado_codigo: "41",
  },
  {
    codigo: "3524501",
    municipio: "Jaci",
    estado_codigo: "35",
  },
  {
    codigo: "5104807",
    municipio: "Jaciara",
    estado_codigo: "51",
  },
  {
    codigo: "3134707",
    municipio: "Jacinto",
    estado_codigo: "31",
  },
  {
    codigo: "4208708",
    municipio: "Jacinto Machado",
    estado_codigo: "42",
  },
  {
    codigo: "2917508",
    municipio: "Jacobina",
    estado_codigo: "29",
  },
  {
    codigo: "2205151",
    municipio: "Jacobina do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3134806",
    municipio: "Jacuí",
    estado_codigo: "31",
  },
  {
    codigo: "2703502",
    municipio: "Jacuípe",
    estado_codigo: "27",
  },
  {
    codigo: "4310876",
    municipio: "Jacuizinho",
    estado_codigo: "43",
  },
  {
    codigo: "1503804",
    municipio: "Jacundá",
    estado_codigo: "15",
  },
  {
    codigo: "3524600",
    municipio: "Jacupiranga",
    estado_codigo: "35",
  },
  {
    codigo: "3134905",
    municipio: "Jacutinga",
    estado_codigo: "31",
  },
  {
    codigo: "4310900",
    municipio: "Jacutinga",
    estado_codigo: "43",
  },
  {
    codigo: "4111902",
    municipio: "Jaguapitã",
    estado_codigo: "41",
  },
  {
    codigo: "2917607",
    municipio: "Jaguaquara",
    estado_codigo: "29",
  },
  {
    codigo: "3135001",
    municipio: "Jaguaraçu",
    estado_codigo: "31",
  },
  {
    codigo: "4311007",
    municipio: "Jaguarão",
    estado_codigo: "43",
  },
  {
    codigo: "2917706",
    municipio: "Jaguarari",
    estado_codigo: "29",
  },
  {
    codigo: "3203056",
    municipio: "Jaguaré",
    estado_codigo: "32",
  },
  {
    codigo: "2306702",
    municipio: "Jaguaretama",
    estado_codigo: "23",
  },
  {
    codigo: "4311106",
    municipio: "Jaguari",
    estado_codigo: "43",
  },
  {
    codigo: "4112009",
    municipio: "Jaguariaíva",
    estado_codigo: "41",
  },
  {
    codigo: "2306801",
    municipio: "Jaguaribara",
    estado_codigo: "23",
  },
  {
    codigo: "2306900",
    municipio: "Jaguaribe",
    estado_codigo: "23",
  },
  {
    codigo: "2917805",
    municipio: "Jaguaripe",
    estado_codigo: "29",
  },
  {
    codigo: "3524709",
    municipio: "Jaguariúna",
    estado_codigo: "35",
  },
  {
    codigo: "2307007",
    municipio: "Jaguaruana",
    estado_codigo: "23",
  },
  {
    codigo: "4208807",
    municipio: "Jaguaruna",
    estado_codigo: "42",
  },
  {
    codigo: "3135050",
    municipio: "Jaíba",
    estado_codigo: "31",
  },
  {
    codigo: "2205201",
    municipio: "Jaicós",
    estado_codigo: "22",
  },
  {
    codigo: "3524808",
    municipio: "Jales",
    estado_codigo: "35",
  },
  {
    codigo: "3524907",
    municipio: "Jambeiro",
    estado_codigo: "35",
  },
  {
    codigo: "3135076",
    municipio: "Jampruca",
    estado_codigo: "31",
  },
  {
    codigo: "3135100",
    municipio: "Janaúba",
    estado_codigo: "31",
  },
  {
    codigo: "5211701",
    municipio: "Jandaia",
    estado_codigo: "52",
  },
  {
    codigo: "4112108",
    municipio: "Jandaia do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "2405108",
    municipio: "Jandaíra",
    estado_codigo: "24",
  },
  {
    codigo: "2917904",
    municipio: "Jandaíra",
    estado_codigo: "29",
  },
  {
    codigo: "3525003",
    municipio: "Jandira",
    estado_codigo: "35",
  },
  {
    codigo: "2405207",
    municipio: "Janduís",
    estado_codigo: "24",
  },
  {
    codigo: "5104906",
    municipio: "Jangada",
    estado_codigo: "51",
  },
  {
    codigo: "4112207",
    municipio: "Janiópolis",
    estado_codigo: "41",
  },
  {
    codigo: "3135209",
    municipio: "Januária",
    estado_codigo: "31",
  },
  {
    codigo: "2405306",
    municipio: "Januário Cicco",
    estado_codigo: "24",
  },
  {
    codigo: "3135308",
    municipio: "Japaraíba",
    estado_codigo: "31",
  },
  {
    codigo: "2703601",
    municipio: "Japaratinga",
    estado_codigo: "27",
  },
  {
    codigo: "2803302",
    municipio: "Japaratuba",
    estado_codigo: "28",
  },
  {
    codigo: "3302270",
    municipio: "Japeri",
    estado_codigo: "33",
  },
  {
    codigo: "2405405",
    municipio: "Japi",
    estado_codigo: "24",
  },
  {
    codigo: "4112306",
    municipio: "Japira",
    estado_codigo: "41",
  },
  {
    codigo: "2803401",
    municipio: "Japoatã",
    estado_codigo: "28",
  },
  {
    codigo: "3135357",
    municipio: "Japonvar",
    estado_codigo: "31",
  },
  {
    codigo: "5004809",
    municipio: "Japorã",
    estado_codigo: "50",
  },
  {
    codigo: "1302108",
    municipio: "Japurá",
    estado_codigo: "13",
  },
  {
    codigo: "4112405",
    municipio: "Japurá",
    estado_codigo: "41",
  },
  {
    codigo: "2607950",
    municipio: "Jaqueira",
    estado_codigo: "26",
  },
  {
    codigo: "4311122",
    municipio: "Jaquirana",
    estado_codigo: "43",
  },
  {
    codigo: "5211800",
    municipio: "Jaraguá",
    estado_codigo: "52",
  },
  {
    codigo: "4208906",
    municipio: "Jaraguá do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "5004908",
    municipio: "Jaraguari",
    estado_codigo: "50",
  },
  {
    codigo: "2703700",
    municipio: "Jaramataia",
    estado_codigo: "27",
  },
  {
    codigo: "5005004",
    municipio: "Jardim",
    estado_codigo: "50",
  },
  {
    codigo: "2307106",
    municipio: "Jardim",
    estado_codigo: "23",
  },
  {
    codigo: "4112504",
    municipio: "Jardim Alegre",
    estado_codigo: "41",
  },
  {
    codigo: "2405504",
    municipio: "Jardim de Angicos",
    estado_codigo: "24",
  },
  {
    codigo: "2405603",
    municipio: "Jardim de Piranhas",
    estado_codigo: "24",
  },
  {
    codigo: "2205250",
    municipio: "Jardim do Mulato",
    estado_codigo: "22",
  },
  {
    codigo: "2405702",
    municipio: "Jardim do Seridó",
    estado_codigo: "24",
  },
  {
    codigo: "4112603",
    municipio: "Jardim Olinda",
    estado_codigo: "41",
  },
  {
    codigo: "3525102",
    municipio: "Jardinópolis",
    estado_codigo: "35",
  },
  {
    codigo: "4208955",
    municipio: "Jardinópolis",
    estado_codigo: "42",
  },
  {
    codigo: "4311130",
    municipio: "Jari",
    estado_codigo: "43",
  },
  {
    codigo: "3525201",
    municipio: "Jarinu",
    estado_codigo: "35",
  },
  {
    codigo: "1100114",
    municipio: "Jaru",
    estado_codigo: "11",
  },
  {
    codigo: "5211909",
    municipio: "Jataí",
    estado_codigo: "52",
  },
  {
    codigo: "4112702",
    municipio: "Jataizinho",
    estado_codigo: "41",
  },
  {
    codigo: "2608008",
    municipio: "Jataúba",
    estado_codigo: "26",
  },
  {
    codigo: "5005103",
    municipio: "Jateí",
    estado_codigo: "50",
  },
  {
    codigo: "2307205",
    municipio: "Jati",
    estado_codigo: "23",
  },
  {
    codigo: "2105450",
    municipio: "Jatobá",
    estado_codigo: "21",
  },
  {
    codigo: "2608057",
    municipio: "Jatobá",
    estado_codigo: "26",
  },
  {
    codigo: "2205276",
    municipio: "Jatobá do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3525300",
    municipio: "Jaú",
    estado_codigo: "35",
  },
  {
    codigo: "1711506",
    municipio: "Jaú do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "5212006",
    municipio: "Jaupaci",
    estado_codigo: "52",
  },
  {
    codigo: "5105002",
    municipio: "Jauru",
    estado_codigo: "51",
  },
  {
    codigo: "3135407",
    municipio: "Jeceaba",
    estado_codigo: "31",
  },
  {
    codigo: "3135456",
    municipio: "Jenipapo de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2105476",
    municipio: "Jenipapo dos Vieiras",
    estado_codigo: "21",
  },
  {
    codigo: "3135506",
    municipio: "Jequeri",
    estado_codigo: "31",
  },
  {
    codigo: "2703759",
    municipio: "Jequiá da Praia",
    estado_codigo: "27",
  },
  {
    codigo: "2918001",
    municipio: "Jequié",
    estado_codigo: "29",
  },
  {
    codigo: "3135605",
    municipio: "Jequitaí",
    estado_codigo: "31",
  },
  {
    codigo: "3135704",
    municipio: "Jequitibá",
    estado_codigo: "31",
  },
  {
    codigo: "3135803",
    municipio: "Jequitinhonha",
    estado_codigo: "31",
  },
  {
    codigo: "2918100",
    municipio: "Jeremoabo",
    estado_codigo: "29",
  },
  {
    codigo: "2507408",
    municipio: "Jericó",
    estado_codigo: "25",
  },
  {
    codigo: "3525409",
    municipio: "Jeriquara",
    estado_codigo: "35",
  },
  {
    codigo: "3203106",
    municipio: "Jerônimo Monteiro",
    estado_codigo: "32",
  },
  {
    codigo: "2205300",
    municipio: "Jerumenha",
    estado_codigo: "22",
  },
  {
    codigo: "3135902",
    municipio: "Jesuânia",
    estado_codigo: "31",
  },
  {
    codigo: "4112751",
    municipio: "Jesuítas",
    estado_codigo: "41",
  },
  {
    codigo: "5212055",
    municipio: "Jesúpolis",
    estado_codigo: "52",
  },
  {
    codigo: "2307254",
    municipio: "Jijoca de Jericoacoara",
    estado_codigo: "23",
  },
  {
    codigo: "1100122",
    municipio: "Ji-Paraná",
    estado_codigo: "11",
  },
  {
    codigo: "2918209",
    municipio: "Jiquiriçá",
    estado_codigo: "29",
  },
  {
    codigo: "2918308",
    municipio: "Jitaúna",
    estado_codigo: "29",
  },
  {
    codigo: "4209003",
    municipio: "Joaçaba",
    estado_codigo: "42",
  },
  {
    codigo: "3136009",
    municipio: "Joaíma",
    estado_codigo: "31",
  },
  {
    codigo: "3136108",
    municipio: "Joanésia",
    estado_codigo: "31",
  },
  {
    codigo: "3525508",
    municipio: "Joanópolis",
    estado_codigo: "35",
  },
  {
    codigo: "2608107",
    municipio: "João Alfredo",
    estado_codigo: "26",
  },
  {
    codigo: "2405801",
    municipio: "João Câmara",
    estado_codigo: "24",
  },
  {
    codigo: "2205359",
    municipio: "João Costa",
    estado_codigo: "22",
  },
  {
    codigo: "2405900",
    municipio: "João Dias",
    estado_codigo: "24",
  },
  {
    codigo: "2918357",
    municipio: "João Dourado",
    estado_codigo: "29",
  },
  {
    codigo: "2105500",
    municipio: "João Lisboa",
    estado_codigo: "21",
  },
  {
    codigo: "3136207",
    municipio: "João Monlevade",
    estado_codigo: "31",
  },
  {
    codigo: "3203130",
    municipio: "João Neiva",
    estado_codigo: "32",
  },
  {
    codigo: "2507507",
    municipio: "João Pessoa",
    estado_codigo: "25",
  },
  {
    codigo: "3136306",
    municipio: "João Pinheiro",
    estado_codigo: "31",
  },
  {
    codigo: "3525607",
    municipio: "João Ramalho",
    estado_codigo: "35",
  },
  {
    codigo: "3136405",
    municipio: "Joaquim Felício",
    estado_codigo: "31",
  },
  {
    codigo: "2703809",
    municipio: "Joaquim Gomes",
    estado_codigo: "27",
  },
  {
    codigo: "2608206",
    municipio: "Joaquim Nabuco",
    estado_codigo: "26",
  },
  {
    codigo: "2205409",
    municipio: "Joaquim Pires",
    estado_codigo: "22",
  },
  {
    codigo: "4112801",
    municipio: "Joaquim Távora",
    estado_codigo: "41",
  },
  {
    codigo: "2205458",
    municipio: "Joca Marques",
    estado_codigo: "22",
  },
  {
    codigo: "4311155",
    municipio: "Jóia",
    estado_codigo: "43",
  },
  {
    codigo: "4209102",
    municipio: "Joinville",
    estado_codigo: "42",
  },
  {
    codigo: "3136504",
    municipio: "Jordânia",
    estado_codigo: "31",
  },
  {
    codigo: "1200328",
    municipio: "Jordão",
    estado_codigo: "12",
  },
  {
    codigo: "4209151",
    municipio: "José Boiteux",
    estado_codigo: "42",
  },
  {
    codigo: "3525706",
    municipio: "José Bonifácio",
    estado_codigo: "35",
  },
  {
    codigo: "2406007",
    municipio: "José da Penha",
    estado_codigo: "24",
  },
  {
    codigo: "2205508",
    municipio: "José de Freitas",
    estado_codigo: "22",
  },
  {
    codigo: "3136520",
    municipio: "José Gonçalves de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2105609",
    municipio: "Joselândia",
    estado_codigo: "21",
  },
  {
    codigo: "3136579",
    municipio: "Josenópolis",
    estado_codigo: "31",
  },
  {
    codigo: "3136553",
    municipio: "José Raydan",
    estado_codigo: "31",
  },
  {
    codigo: "5212105",
    municipio: "Joviânia",
    estado_codigo: "52",
  },
  {
    codigo: "5105101",
    municipio: "Juara",
    estado_codigo: "51",
  },
  {
    codigo: "2507606",
    municipio: "Juarez Távora",
    estado_codigo: "25",
  },
  {
    codigo: "1711803",
    municipio: "Juarina",
    estado_codigo: "17",
  },
  {
    codigo: "3136652",
    municipio: "Juatuba",
    estado_codigo: "31",
  },
  {
    codigo: "2507705",
    municipio: "Juazeirinho",
    estado_codigo: "25",
  },
  {
    codigo: "2918407",
    municipio: "Juazeiro",
    estado_codigo: "29",
  },
  {
    codigo: "2307304",
    municipio: "Juazeiro do Norte",
    estado_codigo: "23",
  },
  {
    codigo: "2205516",
    municipio: "Juazeiro do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2307403",
    municipio: "Jucás",
    estado_codigo: "23",
  },
  {
    codigo: "2608255",
    municipio: "Jucati",
    estado_codigo: "26",
  },
  {
    codigo: "2918456",
    municipio: "Jucuruçu",
    estado_codigo: "29",
  },
  {
    codigo: "2406106",
    municipio: "Jucurutu",
    estado_codigo: "24",
  },
  {
    codigo: "5105150",
    municipio: "Juína",
    estado_codigo: "51",
  },
  {
    codigo: "3136702",
    municipio: "Juiz de Fora",
    estado_codigo: "31",
  },
  {
    codigo: "2205524",
    municipio: "Júlio Borges",
    estado_codigo: "22",
  },
  {
    codigo: "4311205",
    municipio: "Júlio de Castilhos",
    estado_codigo: "43",
  },
  {
    codigo: "3525805",
    municipio: "Júlio Mesquita",
    estado_codigo: "35",
  },
  {
    codigo: "3525854",
    municipio: "Jumirim",
    estado_codigo: "35",
  },
  {
    codigo: "2105658",
    municipio: "Junco do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "2507804",
    municipio: "Junco do Seridó",
    estado_codigo: "25",
  },
  {
    codigo: "2406155",
    municipio: "Jundiá",
    estado_codigo: "24",
  },
  {
    codigo: "2703908",
    municipio: "Jundiá",
    estado_codigo: "27",
  },
  {
    codigo: "3525904",
    municipio: "Jundiaí",
    estado_codigo: "35",
  },
  {
    codigo: "4112900",
    municipio: "Jundiaí do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "2704005",
    municipio: "Junqueiro",
    estado_codigo: "27",
  },
  {
    codigo: "3526001",
    municipio: "Junqueirópolis",
    estado_codigo: "35",
  },
  {
    codigo: "2608305",
    municipio: "Jupi",
    estado_codigo: "26",
  },
  {
    codigo: "4209177",
    municipio: "Jupiá",
    estado_codigo: "42",
  },
  {
    codigo: "3526100",
    municipio: "Juquiá",
    estado_codigo: "35",
  },
  {
    codigo: "3526209",
    municipio: "Juquitiba",
    estado_codigo: "35",
  },
  {
    codigo: "3136801",
    municipio: "Juramento",
    estado_codigo: "31",
  },
  {
    codigo: "4112959",
    municipio: "Juranda",
    estado_codigo: "41",
  },
  {
    codigo: "2205532",
    municipio: "Jurema",
    estado_codigo: "22",
  },
  {
    codigo: "2608404",
    municipio: "Jurema",
    estado_codigo: "26",
  },
  {
    codigo: "2507903",
    municipio: "Juripiranga",
    estado_codigo: "25",
  },
  {
    codigo: "2508000",
    municipio: "Juru",
    estado_codigo: "25",
  },
  {
    codigo: "1302207",
    municipio: "Juruá",
    estado_codigo: "13",
  },
  {
    codigo: "3136900",
    municipio: "Juruaia",
    estado_codigo: "31",
  },
  {
    codigo: "5105176",
    municipio: "Juruena",
    estado_codigo: "51",
  },
  {
    codigo: "1503903",
    municipio: "Juruti",
    estado_codigo: "15",
  },
  {
    codigo: "5105200",
    municipio: "Juscimeira",
    estado_codigo: "51",
  },
  {
    codigo: "4113007",
    municipio: "Jussara",
    estado_codigo: "41",
  },
  {
    codigo: "5212204",
    municipio: "Jussara",
    estado_codigo: "52",
  },
  {
    codigo: "2918506",
    municipio: "Jussara",
    estado_codigo: "29",
  },
  {
    codigo: "2918555",
    municipio: "Jussari",
    estado_codigo: "29",
  },
  {
    codigo: "2918605",
    municipio: "Jussiape",
    estado_codigo: "29",
  },
  {
    codigo: "1302306",
    municipio: "Jutaí",
    estado_codigo: "13",
  },
  {
    codigo: "5005152",
    municipio: "Juti",
    estado_codigo: "50",
  },
  {
    codigo: "3136959",
    municipio: "Juvenília",
    estado_codigo: "31",
  },
  {
    codigo: "4113106",
    municipio: "Kaloré",
    estado_codigo: "41",
  },
  {
    codigo: "1302405",
    municipio: "Lábrea",
    estado_codigo: "13",
  },
  {
    codigo: "4209201",
    municipio: "Lacerdópolis",
    estado_codigo: "42",
  },
  {
    codigo: "3137007",
    municipio: "Ladainha",
    estado_codigo: "31",
  },
  {
    codigo: "5005202",
    municipio: "Ladário",
    estado_codigo: "50",
  },
  {
    codigo: "2918704",
    municipio: "Lafaiete Coutinho",
    estado_codigo: "29",
  },
  {
    codigo: "3137106",
    municipio: "Lagamar",
    estado_codigo: "31",
  },
  {
    codigo: "2803500",
    municipio: "Lagarto",
    estado_codigo: "28",
  },
  {
    codigo: "4209300",
    municipio: "Lages",
    estado_codigo: "42",
  },
  {
    codigo: "2508109",
    municipio: "Lagoa",
    estado_codigo: "25",
  },
  {
    codigo: "2205557",
    municipio: "Lagoa Alegre",
    estado_codigo: "22",
  },
  {
    codigo: "4311239",
    municipio: "Lagoa Bonita do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2704104",
    municipio: "Lagoa da Canoa",
    estado_codigo: "27",
  },
  {
    codigo: "1711902",
    municipio: "Lagoa da Confusão",
    estado_codigo: "17",
  },
  {
    codigo: "2406205",
    municipio: "Lagoa d'Anta",
    estado_codigo: "24",
  },
  {
    codigo: "3137205",
    municipio: "Lagoa da Prata",
    estado_codigo: "31",
  },
  {
    codigo: "2508208",
    municipio: "Lagoa de Dentro",
    estado_codigo: "25",
  },
  {
    codigo: "2406304",
    municipio: "Lagoa de Pedras",
    estado_codigo: "24",
  },
  {
    codigo: "2205573",
    municipio: "Lagoa de São Francisco",
    estado_codigo: "22",
  },
  {
    codigo: "2406403",
    municipio: "Lagoa de Velhos",
    estado_codigo: "24",
  },
  {
    codigo: "2205565",
    municipio: "Lagoa do Barro do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2608453",
    municipio: "Lagoa do Carro",
    estado_codigo: "26",
  },
  {
    codigo: "2608503",
    municipio: "Lagoa do Itaenga",
    estado_codigo: "26",
  },
  {
    codigo: "2105922",
    municipio: "Lagoa do Mato",
    estado_codigo: "21",
  },
  {
    codigo: "2608602",
    municipio: "Lagoa do Ouro",
    estado_codigo: "26",
  },
  {
    codigo: "2205581",
    municipio: "Lagoa do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2608701",
    municipio: "Lagoa dos Gatos",
    estado_codigo: "26",
  },
  {
    codigo: "2205599",
    municipio: "Lagoa do Sítio",
    estado_codigo: "22",
  },
  {
    codigo: "3137304",
    municipio: "Lagoa dos Patos",
    estado_codigo: "31",
  },
  {
    codigo: "4311270",
    municipio: "Lagoa dos Três Cantos",
    estado_codigo: "43",
  },
  {
    codigo: "1711951",
    municipio: "Lagoa do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "3137403",
    municipio: "Lagoa Dourada",
    estado_codigo: "31",
  },
  {
    codigo: "3137502",
    municipio: "Lagoa Formosa",
    estado_codigo: "31",
  },
  {
    codigo: "2608750",
    municipio: "Lagoa Grande",
    estado_codigo: "26",
  },
  {
    codigo: "3137536",
    municipio: "Lagoa Grande",
    estado_codigo: "31",
  },
  {
    codigo: "2105963",
    municipio: "Lagoa Grande do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "2406502",
    municipio: "Lagoa Nova",
    estado_codigo: "24",
  },
  {
    codigo: "4311254",
    municipio: "Lagoão",
    estado_codigo: "43",
  },
  {
    codigo: "2918753",
    municipio: "Lagoa Real",
    estado_codigo: "29",
  },
  {
    codigo: "2406601",
    municipio: "Lagoa Salgada",
    estado_codigo: "24",
  },
  {
    codigo: "3137601",
    municipio: "Lagoa Santa",
    estado_codigo: "31",
  },
  {
    codigo: "5212253",
    municipio: "Lagoa Santa",
    estado_codigo: "52",
  },
  {
    codigo: "2508307",
    municipio: "Lagoa Seca",
    estado_codigo: "25",
  },
  {
    codigo: "4311304",
    municipio: "Lagoa Vermelha",
    estado_codigo: "43",
  },
  {
    codigo: "2105708",
    municipio: "Lago da Pedra",
    estado_codigo: "21",
  },
  {
    codigo: "2105807",
    municipio: "Lago do Junco",
    estado_codigo: "21",
  },
  {
    codigo: "2105948",
    municipio: "Lago dos Rodrigues",
    estado_codigo: "21",
  },
  {
    codigo: "3526308",
    municipio: "Lagoinha",
    estado_codigo: "35",
  },
  {
    codigo: "2205540",
    municipio: "Lagoinha do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2105906",
    municipio: "Lago Verde",
    estado_codigo: "21",
  },
  {
    codigo: "4209409",
    municipio: "Laguna",
    estado_codigo: "42",
  },
  {
    codigo: "5005251",
    municipio: "Laguna Carapã",
    estado_codigo: "50",
  },
  {
    codigo: "2918803",
    municipio: "Laje",
    estado_codigo: "29",
  },
  {
    codigo: "4311403",
    municipio: "Lajeado",
    estado_codigo: "43",
  },
  {
    codigo: "1712009",
    municipio: "Lajeado",
    estado_codigo: "17",
  },
  {
    codigo: "4311429",
    municipio: "Lajeado do Bugre",
    estado_codigo: "43",
  },
  {
    codigo: "4209458",
    municipio: "Lajeado Grande",
    estado_codigo: "42",
  },
  {
    codigo: "2105989",
    municipio: "Lajeado Novo",
    estado_codigo: "21",
  },
  {
    codigo: "2918902",
    municipio: "Lajedão",
    estado_codigo: "29",
  },
  {
    codigo: "2919009",
    municipio: "Lajedinho",
    estado_codigo: "29",
  },
  {
    codigo: "2608800",
    municipio: "Lajedo",
    estado_codigo: "26",
  },
  {
    codigo: "2919058",
    municipio: "Lajedo do Tabocal",
    estado_codigo: "29",
  },
  {
    codigo: "3302304",
    municipio: "Laje do Muriaé",
    estado_codigo: "33",
  },
  {
    codigo: "2406700",
    municipio: "Lajes",
    estado_codigo: "24",
  },
  {
    codigo: "2406809",
    municipio: "Lajes Pintadas",
    estado_codigo: "24",
  },
  {
    codigo: "3137700",
    municipio: "Lajinha",
    estado_codigo: "31",
  },
  {
    codigo: "2919108",
    municipio: "Lamarão",
    estado_codigo: "29",
  },
  {
    codigo: "3137809",
    municipio: "Lambari",
    estado_codigo: "31",
  },
  {
    codigo: "5105234",
    municipio: "Lambari D'Oeste",
    estado_codigo: "51",
  },
  {
    codigo: "3137908",
    municipio: "Lamim",
    estado_codigo: "31",
  },
  {
    codigo: "2205607",
    municipio: "Landri Sales",
    estado_codigo: "22",
  },
  {
    codigo: "4113205",
    municipio: "Lapa",
    estado_codigo: "41",
  },
  {
    codigo: "2919157",
    municipio: "Lapão",
    estado_codigo: "29",
  },
  {
    codigo: "3203163",
    municipio: "Laranja da Terra",
    estado_codigo: "32",
  },
  {
    codigo: "3138005",
    municipio: "Laranjal",
    estado_codigo: "31",
  },
  {
    codigo: "4113254",
    municipio: "Laranjal",
    estado_codigo: "41",
  },
  {
    codigo: "1600279",
    municipio: "Laranjal do Jari",
    estado_codigo: "16",
  },
  {
    codigo: "3526407",
    municipio: "Laranjal Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "2803609",
    municipio: "Laranjeiras",
    estado_codigo: "28",
  },
  {
    codigo: "4113304",
    municipio: "Laranjeiras do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "3138104",
    municipio: "Lassance",
    estado_codigo: "31",
  },
  {
    codigo: "2508406",
    municipio: "Lastro",
    estado_codigo: "25",
  },
  {
    codigo: "4209508",
    municipio: "Laurentino",
    estado_codigo: "42",
  },
  {
    codigo: "2919207",
    municipio: "Lauro de Freitas",
    estado_codigo: "29",
  },
  {
    codigo: "4209607",
    municipio: "Lauro Muller",
    estado_codigo: "42",
  },
  {
    codigo: "1712157",
    municipio: "Lavandeira",
    estado_codigo: "17",
  },
  {
    codigo: "3526506",
    municipio: "Lavínia",
    estado_codigo: "35",
  },
  {
    codigo: "3138203",
    municipio: "Lavras",
    estado_codigo: "31",
  },
  {
    codigo: "2307502",
    municipio: "Lavras da Mangabeira",
    estado_codigo: "23",
  },
  {
    codigo: "4311502",
    municipio: "Lavras do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3526605",
    municipio: "Lavrinhas",
    estado_codigo: "35",
  },
  {
    codigo: "3138302",
    municipio: "Leandro Ferreira",
    estado_codigo: "31",
  },
  {
    codigo: "4209706",
    municipio: "Lebon Régis",
    estado_codigo: "42",
  },
  {
    codigo: "3526704",
    municipio: "Leme",
    estado_codigo: "35",
  },
  {
    codigo: "3138351",
    municipio: "Leme do Prado",
    estado_codigo: "31",
  },
  {
    codigo: "2919306",
    municipio: "Lençóis",
    estado_codigo: "29",
  },
  {
    codigo: "3526803",
    municipio: "Lençóis Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4209805",
    municipio: "Leoberto Leal",
    estado_codigo: "42",
  },
  {
    codigo: "3138401",
    municipio: "Leopoldina",
    estado_codigo: "31",
  },
  {
    codigo: "5212303",
    municipio: "Leopoldo de Bulhões",
    estado_codigo: "52",
  },
  {
    codigo: "4113403",
    municipio: "Leópolis",
    estado_codigo: "41",
  },
  {
    codigo: "4311601",
    municipio: "Liberato Salzano",
    estado_codigo: "43",
  },
  {
    codigo: "3138500",
    municipio: "Liberdade",
    estado_codigo: "31",
  },
  {
    codigo: "2919405",
    municipio: "Licínio de Almeida",
    estado_codigo: "29",
  },
  {
    codigo: "4113429",
    municipio: "Lidianópolis",
    estado_codigo: "41",
  },
  {
    codigo: "2106003",
    municipio: "Lima Campos",
    estado_codigo: "21",
  },
  {
    codigo: "3138609",
    municipio: "Lima Duarte",
    estado_codigo: "31",
  },
  {
    codigo: "3526902",
    municipio: "Limeira",
    estado_codigo: "35",
  },
  {
    codigo: "3138625",
    municipio: "Limeira do Oeste",
    estado_codigo: "31",
  },
  {
    codigo: "2608909",
    municipio: "Limoeiro",
    estado_codigo: "26",
  },
  {
    codigo: "2704203",
    municipio: "Limoeiro de Anadia",
    estado_codigo: "27",
  },
  {
    codigo: "1504000",
    municipio: "Limoeiro do Ajuru",
    estado_codigo: "15",
  },
  {
    codigo: "2307601",
    municipio: "Limoeiro do Norte",
    estado_codigo: "23",
  },
  {
    codigo: "4113452",
    municipio: "Lindoeste",
    estado_codigo: "41",
  },
  {
    codigo: "3527009",
    municipio: "Lindóia",
    estado_codigo: "35",
  },
  {
    codigo: "4209854",
    municipio: "Lindóia do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "4311627",
    municipio: "Lindolfo Collor",
    estado_codigo: "43",
  },
  {
    codigo: "4311643",
    municipio: "Linha Nova",
    estado_codigo: "43",
  },
  {
    codigo: "3203205",
    municipio: "Linhares",
    estado_codigo: "32",
  },
  {
    codigo: "3527108",
    municipio: "Lins",
    estado_codigo: "35",
  },
  {
    codigo: "2508505",
    municipio: "Livramento",
    estado_codigo: "25",
  },
  {
    codigo: "2919504",
    municipio: "Livramento de Nossa Senhora",
    estado_codigo: "29",
  },
  {
    codigo: "1712405",
    municipio: "Lizarda",
    estado_codigo: "17",
  },
  {
    codigo: "4113502",
    municipio: "Loanda",
    estado_codigo: "41",
  },
  {
    codigo: "4113601",
    municipio: "Lobato",
    estado_codigo: "41",
  },
  {
    codigo: "2508554",
    municipio: "Logradouro",
    estado_codigo: "25",
  },
  {
    codigo: "4113700",
    municipio: "Londrina",
    estado_codigo: "41",
  },
  {
    codigo: "3138658",
    municipio: "Lontra",
    estado_codigo: "31",
  },
  {
    codigo: "4209904",
    municipio: "Lontras",
    estado_codigo: "42",
  },
  {
    codigo: "3527207",
    municipio: "Lorena",
    estado_codigo: "35",
  },
  {
    codigo: "2106102",
    municipio: "Loreto",
    estado_codigo: "21",
  },
  {
    codigo: "3527256",
    municipio: "Lourdes",
    estado_codigo: "35",
  },
  {
    codigo: "3527306",
    municipio: "Louveira",
    estado_codigo: "35",
  },
  {
    codigo: "5105259",
    municipio: "Lucas do Rio Verde",
    estado_codigo: "51",
  },
  {
    codigo: "3527405",
    municipio: "Lucélia",
    estado_codigo: "35",
  },
  {
    codigo: "2508604",
    municipio: "Lucena",
    estado_codigo: "25",
  },
  {
    codigo: "3527504",
    municipio: "Lucianópolis",
    estado_codigo: "35",
  },
  {
    codigo: "5105309",
    municipio: "Luciára",
    estado_codigo: "51",
  },
  {
    codigo: "2406908",
    municipio: "Lucrécia",
    estado_codigo: "24",
  },
  {
    codigo: "3527603",
    municipio: "Luís Antônio",
    estado_codigo: "35",
  },
  {
    codigo: "3138674",
    municipio: "Luisburgo",
    estado_codigo: "31",
  },
  {
    codigo: "2205706",
    municipio: "Luís Correia",
    estado_codigo: "22",
  },
  {
    codigo: "2106201",
    municipio: "Luís Domingues",
    estado_codigo: "21",
  },
  {
    codigo: "2919553",
    municipio: "Luís Eduardo Magalhães",
    estado_codigo: "29",
  },
  {
    codigo: "2407005",
    municipio: "Luís Gomes",
    estado_codigo: "24",
  },
  {
    codigo: "3138682",
    municipio: "Luislândia",
    estado_codigo: "31",
  },
  {
    codigo: "4210001",
    municipio: "Luiz Alves",
    estado_codigo: "42",
  },
  {
    codigo: "4113734",
    municipio: "Luiziana",
    estado_codigo: "41",
  },
  {
    codigo: "3527702",
    municipio: "Luiziânia",
    estado_codigo: "35",
  },
  {
    codigo: "3138708",
    municipio: "Luminárias",
    estado_codigo: "31",
  },
  {
    codigo: "4113759",
    municipio: "Lunardelli",
    estado_codigo: "41",
  },
  {
    codigo: "3527801",
    municipio: "Lupércio",
    estado_codigo: "35",
  },
  {
    codigo: "4113809",
    municipio: "Lupionópolis",
    estado_codigo: "41",
  },
  {
    codigo: "3527900",
    municipio: "Lutécia",
    estado_codigo: "35",
  },
  {
    codigo: "3138807",
    municipio: "Luz",
    estado_codigo: "31",
  },
  {
    codigo: "4210035",
    municipio: "Luzerna",
    estado_codigo: "42",
  },
  {
    codigo: "5212501",
    municipio: "Luziânia",
    estado_codigo: "52",
  },
  {
    codigo: "2205805",
    municipio: "Luzilândia",
    estado_codigo: "22",
  },
  {
    codigo: "1712454",
    municipio: "Luzinópolis",
    estado_codigo: "17",
  },
  {
    codigo: "3302403",
    municipio: "Macaé",
    estado_codigo: "33",
  },
  {
    codigo: "2407104",
    municipio: "Macaíba",
    estado_codigo: "24",
  },
  {
    codigo: "2919603",
    municipio: "Macajuba",
    estado_codigo: "29",
  },
  {
    codigo: "4311718",
    municipio: "Maçambara",
    estado_codigo: "43",
  },
  {
    codigo: "2803708",
    municipio: "Macambira",
    estado_codigo: "28",
  },
  {
    codigo: "1600303",
    municipio: "Macapá",
    estado_codigo: "16",
  },
  {
    codigo: "2609006",
    municipio: "Macaparana",
    estado_codigo: "26",
  },
  {
    codigo: "2919702",
    municipio: "Macarani",
    estado_codigo: "29",
  },
  {
    codigo: "3528007",
    municipio: "Macatuba",
    estado_codigo: "35",
  },
  {
    codigo: "2407203",
    municipio: "Macau",
    estado_codigo: "24",
  },
  {
    codigo: "3528106",
    municipio: "Macaubal",
    estado_codigo: "35",
  },
  {
    codigo: "2919801",
    municipio: "Macaúbas",
    estado_codigo: "29",
  },
  {
    codigo: "3528205",
    municipio: "Macedônia",
    estado_codigo: "35",
  },
  {
    codigo: "2704302",
    municipio: "Maceió",
    estado_codigo: "27",
  },
  {
    codigo: "3138906",
    municipio: "Machacalis",
    estado_codigo: "31",
  },
  {
    codigo: "4311700",
    municipio: "Machadinho",
    estado_codigo: "43",
  },
  {
    codigo: "1100130",
    municipio: "Machadinho D'Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "3139003",
    municipio: "Machado",
    estado_codigo: "31",
  },
  {
    codigo: "2609105",
    municipio: "Machados",
    estado_codigo: "26",
  },
  {
    codigo: "4210050",
    municipio: "Macieira",
    estado_codigo: "42",
  },
  {
    codigo: "3302452",
    municipio: "Macuco",
    estado_codigo: "33",
  },
  {
    codigo: "2919900",
    municipio: "Macururé",
    estado_codigo: "29",
  },
  {
    codigo: "2307635",
    municipio: "Madalena",
    estado_codigo: "23",
  },
  {
    codigo: "2205854",
    municipio: "Madeiro",
    estado_codigo: "22",
  },
  {
    codigo: "2919926",
    municipio: "Madre de Deus",
    estado_codigo: "29",
  },
  {
    codigo: "3139102",
    municipio: "Madre de Deus de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2508703",
    municipio: "Mãe d'Água",
    estado_codigo: "25",
  },
  {
    codigo: "1504059",
    municipio: "Mãe do Rio",
    estado_codigo: "15",
  },
  {
    codigo: "2919959",
    municipio: "Maetinga",
    estado_codigo: "29",
  },
  {
    codigo: "4210100",
    municipio: "Mafra",
    estado_codigo: "42",
  },
  {
    codigo: "1504109",
    municipio: "Magalhães Barata",
    estado_codigo: "15",
  },
  {
    codigo: "2106300",
    municipio: "Magalhães de Almeida",
    estado_codigo: "21",
  },
  {
    codigo: "3528304",
    municipio: "Magda",
    estado_codigo: "35",
  },
  {
    codigo: "3302502",
    municipio: "Magé",
    estado_codigo: "33",
  },
  {
    codigo: "2920007",
    municipio: "Maiquinique",
    estado_codigo: "29",
  },
  {
    codigo: "2920106",
    municipio: "Mairi",
    estado_codigo: "29",
  },
  {
    codigo: "3528403",
    municipio: "Mairinque",
    estado_codigo: "35",
  },
  {
    codigo: "3528502",
    municipio: "Mairiporã",
    estado_codigo: "35",
  },
  {
    codigo: "5212600",
    municipio: "Mairipotaba",
    estado_codigo: "52",
  },
  {
    codigo: "4210209",
    municipio: "Major Gercino",
    estado_codigo: "42",
  },
  {
    codigo: "2704401",
    municipio: "Major Isidoro",
    estado_codigo: "27",
  },
  {
    codigo: "2407252",
    municipio: "Major Sales",
    estado_codigo: "24",
  },
  {
    codigo: "4210308",
    municipio: "Major Vieira",
    estado_codigo: "42",
  },
  {
    codigo: "3139201",
    municipio: "Malacacheta",
    estado_codigo: "31",
  },
  {
    codigo: "2920205",
    municipio: "Malhada",
    estado_codigo: "29",
  },
  {
    codigo: "2920304",
    municipio: "Malhada de Pedras",
    estado_codigo: "29",
  },
  {
    codigo: "2803807",
    municipio: "Malhada dos Bois",
    estado_codigo: "28",
  },
  {
    codigo: "2803906",
    municipio: "Malhador",
    estado_codigo: "28",
  },
  {
    codigo: "4113908",
    municipio: "Mallet",
    estado_codigo: "41",
  },
  {
    codigo: "2508802",
    municipio: "Malta",
    estado_codigo: "25",
  },
  {
    codigo: "2508901",
    municipio: "Mamanguape",
    estado_codigo: "25",
  },
  {
    codigo: "5212709",
    municipio: "Mambaí",
    estado_codigo: "52",
  },
  {
    codigo: "4114005",
    municipio: "Mamborê",
    estado_codigo: "41",
  },
  {
    codigo: "3139250",
    municipio: "Mamonas",
    estado_codigo: "31",
  },
  {
    codigo: "4311734",
    municipio: "Mampituba",
    estado_codigo: "43",
  },
  {
    codigo: "1302504",
    municipio: "Manacapuru",
    estado_codigo: "13",
  },
  {
    codigo: "2509008",
    municipio: "Manaíra",
    estado_codigo: "25",
  },
  {
    codigo: "1302553",
    municipio: "Manaquiri",
    estado_codigo: "13",
  },
  {
    codigo: "2609154",
    municipio: "Manari",
    estado_codigo: "26",
  },
  {
    codigo: "1302603",
    municipio: "Manaus",
    estado_codigo: "13",
  },
  {
    codigo: "1200336",
    municipio: "Mâncio Lima",
    estado_codigo: "12",
  },
  {
    codigo: "4114104",
    municipio: "Mandaguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "4114203",
    municipio: "Mandaguari",
    estado_codigo: "41",
  },
  {
    codigo: "4114302",
    municipio: "Mandirituba",
    estado_codigo: "41",
  },
  {
    codigo: "3528601",
    municipio: "Manduri",
    estado_codigo: "35",
  },
  {
    codigo: "4114351",
    municipio: "Manfrinópolis",
    estado_codigo: "41",
  },
  {
    codigo: "3139300",
    municipio: "Manga",
    estado_codigo: "31",
  },
  {
    codigo: "3302601",
    municipio: "Mangaratiba",
    estado_codigo: "33",
  },
  {
    codigo: "4114401",
    municipio: "Mangueirinha",
    estado_codigo: "41",
  },
  {
    codigo: "3139409",
    municipio: "Manhuaçu",
    estado_codigo: "31",
  },
  {
    codigo: "3139508",
    municipio: "Manhumirim",
    estado_codigo: "31",
  },
  {
    codigo: "1302702",
    municipio: "Manicoré",
    estado_codigo: "13",
  },
  {
    codigo: "2205904",
    municipio: "Manoel Emídio",
    estado_codigo: "22",
  },
  {
    codigo: "4114500",
    municipio: "Manoel Ribas",
    estado_codigo: "41",
  },
  {
    codigo: "1200344",
    municipio: "Manoel Urbano",
    estado_codigo: "12",
  },
  {
    codigo: "4311759",
    municipio: "Manoel Viana",
    estado_codigo: "43",
  },
  {
    codigo: "2920403",
    municipio: "Manoel Vitorino",
    estado_codigo: "29",
  },
  {
    codigo: "2920452",
    municipio: "Mansidão",
    estado_codigo: "29",
  },
  {
    codigo: "3139607",
    municipio: "Mantena",
    estado_codigo: "31",
  },
  {
    codigo: "3203304",
    municipio: "Mantenópolis",
    estado_codigo: "32",
  },
  {
    codigo: "4311775",
    municipio: "Maquiné",
    estado_codigo: "43",
  },
  {
    codigo: "1302801",
    municipio: "Maraã",
    estado_codigo: "13",
  },
  {
    codigo: "1504208",
    municipio: "Marabá",
    estado_codigo: "15",
  },
  {
    codigo: "3528700",
    municipio: "Marabá Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "2106326",
    municipio: "Maracaçumé",
    estado_codigo: "21",
  },
  {
    codigo: "3528809",
    municipio: "Maracaí",
    estado_codigo: "35",
  },
  {
    codigo: "4210407",
    municipio: "Maracajá",
    estado_codigo: "42",
  },
  {
    codigo: "5005400",
    municipio: "Maracaju",
    estado_codigo: "50",
  },
  {
    codigo: "1504307",
    municipio: "Maracanã",
    estado_codigo: "15",
  },
  {
    codigo: "2307650",
    municipio: "Maracanaú",
    estado_codigo: "23",
  },
  {
    codigo: "2920502",
    municipio: "Maracás",
    estado_codigo: "29",
  },
  {
    codigo: "2704500",
    municipio: "Maragogi",
    estado_codigo: "27",
  },
  {
    codigo: "2920601",
    municipio: "Maragogipe",
    estado_codigo: "29",
  },
  {
    codigo: "2609204",
    municipio: "Maraial",
    estado_codigo: "26",
  },
  {
    codigo: "2106359",
    municipio: "Marajá do Sena",
    estado_codigo: "21",
  },
  {
    codigo: "2307700",
    municipio: "Maranguape",
    estado_codigo: "23",
  },
  {
    codigo: "2106375",
    municipio: "Maranhãozinho",
    estado_codigo: "21",
  },
  {
    codigo: "1504406",
    municipio: "Marapanim",
    estado_codigo: "15",
  },
  {
    codigo: "3528858",
    municipio: "Marapoama",
    estado_codigo: "35",
  },
  {
    codigo: "5212808",
    municipio: "Mara Rosa",
    estado_codigo: "52",
  },
  {
    codigo: "4311791",
    municipio: "Maratá",
    estado_codigo: "43",
  },
  {
    codigo: "3203320",
    municipio: "Marataízes",
    estado_codigo: "32",
  },
  {
    codigo: "4311809",
    municipio: "Marau",
    estado_codigo: "43",
  },
  {
    codigo: "2920700",
    municipio: "Maraú",
    estado_codigo: "29",
  },
  {
    codigo: "2704609",
    municipio: "Maravilha",
    estado_codigo: "27",
  },
  {
    codigo: "4210506",
    municipio: "Maravilha",
    estado_codigo: "42",
  },
  {
    codigo: "3139706",
    municipio: "Maravilhas",
    estado_codigo: "31",
  },
  {
    codigo: "2509057",
    municipio: "Marcação",
    estado_codigo: "25",
  },
  {
    codigo: "5105580",
    municipio: "Marcelândia",
    estado_codigo: "51",
  },
  {
    codigo: "4311908",
    municipio: "Marcelino Ramos",
    estado_codigo: "43",
  },
  {
    codigo: "2407302",
    municipio: "Marcelino Vieira",
    estado_codigo: "24",
  },
  {
    codigo: "2920809",
    municipio: "Marcionílio Souza",
    estado_codigo: "29",
  },
  {
    codigo: "2307809",
    municipio: "Marco",
    estado_codigo: "23",
  },
  {
    codigo: "2205953",
    municipio: "Marcolândia",
    estado_codigo: "22",
  },
  {
    codigo: "2206001",
    municipio: "Marcos Parente",
    estado_codigo: "22",
  },
  {
    codigo: "3139805",
    municipio: "Mar de Espanha",
    estado_codigo: "31",
  },
  {
    codigo: "4114609",
    municipio: "Marechal Cândido Rondon",
    estado_codigo: "41",
  },
  {
    codigo: "2704708",
    municipio: "Marechal Deodoro",
    estado_codigo: "27",
  },
  {
    codigo: "3203346",
    municipio: "Marechal Floriano",
    estado_codigo: "32",
  },
  {
    codigo: "1200351",
    municipio: "Marechal Thaumaturgo",
    estado_codigo: "12",
  },
  {
    codigo: "4210555",
    municipio: "Marema",
    estado_codigo: "42",
  },
  {
    codigo: "2509107",
    municipio: "Mari",
    estado_codigo: "25",
  },
  {
    codigo: "3139904",
    municipio: "Maria da Fé",
    estado_codigo: "31",
  },
  {
    codigo: "4114708",
    municipio: "Maria Helena",
    estado_codigo: "41",
  },
  {
    codigo: "4114807",
    municipio: "Marialva",
    estado_codigo: "41",
  },
  {
    codigo: "3140001",
    municipio: "Mariana",
    estado_codigo: "31",
  },
  {
    codigo: "4311981",
    municipio: "Mariana Pimentel",
    estado_codigo: "43",
  },
  {
    codigo: "4312005",
    municipio: "Mariano Moro",
    estado_codigo: "43",
  },
  {
    codigo: "1712504",
    municipio: "Marianópolis do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "3528908",
    municipio: "Mariápolis",
    estado_codigo: "35",
  },
  {
    codigo: "2704807",
    municipio: "Maribondo",
    estado_codigo: "27",
  },
  {
    codigo: "3302700",
    municipio: "Maricá",
    estado_codigo: "33",
  },
  {
    codigo: "3140100",
    municipio: "Marilac",
    estado_codigo: "31",
  },
  {
    codigo: "3203353",
    municipio: "Marilândia",
    estado_codigo: "32",
  },
  {
    codigo: "4114906",
    municipio: "Marilândia do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "4115002",
    municipio: "Marilena",
    estado_codigo: "41",
  },
  {
    codigo: "3529005",
    municipio: "Marília",
    estado_codigo: "35",
  },
  {
    codigo: "4115101",
    municipio: "Mariluz",
    estado_codigo: "41",
  },
  {
    codigo: "4115200",
    municipio: "Maringá",
    estado_codigo: "41",
  },
  {
    codigo: "3529104",
    municipio: "Marinópolis",
    estado_codigo: "35",
  },
  {
    codigo: "3140159",
    municipio: "Mário Campos",
    estado_codigo: "31",
  },
  {
    codigo: "4115309",
    municipio: "Mariópolis",
    estado_codigo: "41",
  },
  {
    codigo: "4115358",
    municipio: "Maripá",
    estado_codigo: "41",
  },
  {
    codigo: "3140209",
    municipio: "Maripá de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "1504422",
    municipio: "Marituba",
    estado_codigo: "15",
  },
  {
    codigo: "2509156",
    municipio: "Marizópolis",
    estado_codigo: "25",
  },
  {
    codigo: "3140308",
    municipio: "Marliéria",
    estado_codigo: "31",
  },
  {
    codigo: "4115408",
    municipio: "Marmeleiro",
    estado_codigo: "41",
  },
  {
    codigo: "3140407",
    municipio: "Marmelópolis",
    estado_codigo: "31",
  },
  {
    codigo: "4312054",
    municipio: "Marques de Souza",
    estado_codigo: "43",
  },
  {
    codigo: "4115457",
    municipio: "Marquinho",
    estado_codigo: "41",
  },
  {
    codigo: "3140506",
    municipio: "Martinho Campos",
    estado_codigo: "31",
  },
  {
    codigo: "2307908",
    municipio: "Martinópole",
    estado_codigo: "23",
  },
  {
    codigo: "3529203",
    municipio: "Martinópolis",
    estado_codigo: "35",
  },
  {
    codigo: "2407401",
    municipio: "Martins",
    estado_codigo: "24",
  },
  {
    codigo: "3140530",
    municipio: "Martins Soares",
    estado_codigo: "31",
  },
  {
    codigo: "2804003",
    municipio: "Maruim",
    estado_codigo: "28",
  },
  {
    codigo: "4115507",
    municipio: "Marumbi",
    estado_codigo: "41",
  },
  {
    codigo: "2704906",
    municipio: "Mar Vermelho",
    estado_codigo: "27",
  },
  {
    codigo: "5212907",
    municipio: "Marzagão",
    estado_codigo: "52",
  },
  {
    codigo: "2920908",
    municipio: "Mascote",
    estado_codigo: "29",
  },
  {
    codigo: "2308005",
    municipio: "Massapê",
    estado_codigo: "23",
  },
  {
    codigo: "2206050",
    municipio: "Massapê do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4210605",
    municipio: "Massaranduba",
    estado_codigo: "42",
  },
  {
    codigo: "2509206",
    municipio: "Massaranduba",
    estado_codigo: "25",
  },
  {
    codigo: "4312104",
    municipio: "Mata",
    estado_codigo: "43",
  },
  {
    codigo: "2921005",
    municipio: "Mata de São João",
    estado_codigo: "29",
  },
  {
    codigo: "2705002",
    municipio: "Mata Grande",
    estado_codigo: "27",
  },
  {
    codigo: "3529302",
    municipio: "Matão",
    estado_codigo: "35",
  },
  {
    codigo: "2509305",
    municipio: "Mataraca",
    estado_codigo: "25",
  },
  {
    codigo: "2106409",
    municipio: "Mata Roma",
    estado_codigo: "21",
  },
  {
    codigo: "3140555",
    municipio: "Mata Verde",
    estado_codigo: "31",
  },
  {
    codigo: "1712702",
    municipio: "Mateiros",
    estado_codigo: "17",
  },
  {
    codigo: "4115606",
    municipio: "Matelândia",
    estado_codigo: "41",
  },
  {
    codigo: "3140605",
    municipio: "Materlândia",
    estado_codigo: "31",
  },
  {
    codigo: "3140704",
    municipio: "Mateus Leme",
    estado_codigo: "31",
  },
  {
    codigo: "3171501",
    municipio: "Mathias Lobato",
    estado_codigo: "31",
  },
  {
    codigo: "3140803",
    municipio: "Matias Barbosa",
    estado_codigo: "31",
  },
  {
    codigo: "3140852",
    municipio: "Matias Cardoso",
    estado_codigo: "31",
  },
  {
    codigo: "2206100",
    municipio: "Matias Olímpio",
    estado_codigo: "22",
  },
  {
    codigo: "2921054",
    municipio: "Matina",
    estado_codigo: "29",
  },
  {
    codigo: "2106508",
    municipio: "Matinha",
    estado_codigo: "21",
  },
  {
    codigo: "2509339",
    municipio: "Matinhas",
    estado_codigo: "25",
  },
  {
    codigo: "4115705",
    municipio: "Matinhos",
    estado_codigo: "41",
  },
  {
    codigo: "3140902",
    municipio: "Matipó",
    estado_codigo: "31",
  },
  {
    codigo: "4312138",
    municipio: "Mato Castelhano",
    estado_codigo: "43",
  },
  {
    codigo: "2106607",
    municipio: "Matões",
    estado_codigo: "21",
  },
  {
    codigo: "2106631",
    municipio: "Matões do Norte",
    estado_codigo: "21",
  },
  {
    codigo: "2509370",
    municipio: "Mato Grosso",
    estado_codigo: "25",
  },
  {
    codigo: "4312153",
    municipio: "Mato Leitão",
    estado_codigo: "43",
  },
  {
    codigo: "4312179",
    municipio: "Mato Queimado",
    estado_codigo: "43",
  },
  {
    codigo: "4115739",
    municipio: "Mato Rico",
    estado_codigo: "41",
  },
  {
    codigo: "4210704",
    municipio: "Matos Costa",
    estado_codigo: "42",
  },
  {
    codigo: "3141009",
    municipio: "Mato Verde",
    estado_codigo: "31",
  },
  {
    codigo: "3141108",
    municipio: "Matozinhos",
    estado_codigo: "31",
  },
  {
    codigo: "5212956",
    municipio: "Matrinchã",
    estado_codigo: "52",
  },
  {
    codigo: "2705101",
    municipio: "Matriz de Camaragibe",
    estado_codigo: "27",
  },
  {
    codigo: "5105606",
    municipio: "Matupá",
    estado_codigo: "51",
  },
  {
    codigo: "2509396",
    municipio: "Maturéia",
    estado_codigo: "25",
  },
  {
    codigo: "3141207",
    municipio: "Matutina",
    estado_codigo: "31",
  },
  {
    codigo: "3529401",
    municipio: "Mauá",
    estado_codigo: "35",
  },
  {
    codigo: "4115754",
    municipio: "Mauá da Serra",
    estado_codigo: "41",
  },
  {
    codigo: "1302900",
    municipio: "Maués",
    estado_codigo: "13",
  },
  {
    codigo: "5213004",
    municipio: "Maurilândia",
    estado_codigo: "52",
  },
  {
    codigo: "1712801",
    municipio: "Maurilândia do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2308104",
    municipio: "Mauriti",
    estado_codigo: "23",
  },
  {
    codigo: "2407500",
    municipio: "Maxaranguape",
    estado_codigo: "24",
  },
  {
    codigo: "4312203",
    municipio: "Maximiliano de Almeida",
    estado_codigo: "43",
  },
  {
    codigo: "1600402",
    municipio: "Mazagão",
    estado_codigo: "16",
  },
  {
    codigo: "3141306",
    municipio: "Medeiros",
    estado_codigo: "31",
  },
  {
    codigo: "2921104",
    municipio: "Medeiros Neto",
    estado_codigo: "29",
  },
  {
    codigo: "4115804",
    municipio: "Medianeira",
    estado_codigo: "41",
  },
  {
    codigo: "1504455",
    municipio: "Medicilândia",
    estado_codigo: "15",
  },
  {
    codigo: "3141405",
    municipio: "Medina",
    estado_codigo: "31",
  },
  {
    codigo: "4210803",
    municipio: "Meleiro",
    estado_codigo: "42",
  },
  {
    codigo: "1504505",
    municipio: "Melgaço",
    estado_codigo: "15",
  },
  {
    codigo: "3302809",
    municipio: "Mendes",
    estado_codigo: "33",
  },
  {
    codigo: "3141504",
    municipio: "Mendes Pimentel",
    estado_codigo: "31",
  },
  {
    codigo: "3529500",
    municipio: "Mendonça",
    estado_codigo: "35",
  },
  {
    codigo: "4115853",
    municipio: "Mercedes",
    estado_codigo: "41",
  },
  {
    codigo: "3141603",
    municipio: "Mercês",
    estado_codigo: "31",
  },
  {
    codigo: "3529609",
    municipio: "Meridiano",
    estado_codigo: "35",
  },
  {
    codigo: "2308203",
    municipio: "Meruoca",
    estado_codigo: "23",
  },
  {
    codigo: "3529658",
    municipio: "Mesópolis",
    estado_codigo: "35",
  },
  {
    codigo: "3141702",
    municipio: "Mesquita",
    estado_codigo: "31",
  },
  {
    codigo: "3302858",
    municipio: "Mesquita",
    estado_codigo: "33",
  },
  {
    codigo: "2705200",
    municipio: "Messias",
    estado_codigo: "27",
  },
  {
    codigo: "2407609",
    municipio: "Messias Targino",
    estado_codigo: "24",
  },
  {
    codigo: "2206209",
    municipio: "Miguel Alves",
    estado_codigo: "22",
  },
  {
    codigo: "2921203",
    municipio: "Miguel Calmon",
    estado_codigo: "29",
  },
  {
    codigo: "2206308",
    municipio: "Miguel Leão",
    estado_codigo: "22",
  },
  {
    codigo: "3529708",
    municipio: "Miguelópolis",
    estado_codigo: "35",
  },
  {
    codigo: "3302908",
    municipio: "Miguel Pereira",
    estado_codigo: "33",
  },
  {
    codigo: "2921302",
    municipio: "Milagres",
    estado_codigo: "29",
  },
  {
    codigo: "2308302",
    municipio: "Milagres",
    estado_codigo: "23",
  },
  {
    codigo: "2106672",
    municipio: "Milagres do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "2308351",
    municipio: "Milhã",
    estado_codigo: "23",
  },
  {
    codigo: "2206357",
    municipio: "Milton Brandão",
    estado_codigo: "22",
  },
  {
    codigo: "5213053",
    municipio: "Mimoso de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3203403",
    municipio: "Mimoso do Sul",
    estado_codigo: "32",
  },
  {
    codigo: "5213087",
    municipio: "Minaçu",
    estado_codigo: "52",
  },
  {
    codigo: "2705309",
    municipio: "Minador do Negrão",
    estado_codigo: "27",
  },
  {
    codigo: "4312252",
    municipio: "Minas do Leão",
    estado_codigo: "43",
  },
  {
    codigo: "3141801",
    municipio: "Minas Novas",
    estado_codigo: "31",
  },
  {
    codigo: "3141900",
    municipio: "Minduri",
    estado_codigo: "31",
  },
  {
    codigo: "5213103",
    municipio: "Mineiros",
    estado_codigo: "52",
  },
  {
    codigo: "3529807",
    municipio: "Mineiros do Tietê",
    estado_codigo: "35",
  },
  {
    codigo: "1101203",
    municipio: "Ministro Andreazza",
    estado_codigo: "11",
  },
  {
    codigo: "3142007",
    municipio: "Mirabela",
    estado_codigo: "31",
  },
  {
    codigo: "3529906",
    municipio: "Miracatu",
    estado_codigo: "35",
  },
  {
    codigo: "3303005",
    municipio: "Miracema",
    estado_codigo: "33",
  },
  {
    codigo: "1713205",
    municipio: "Miracema do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "4115903",
    municipio: "Mirador",
    estado_codigo: "41",
  },
  {
    codigo: "2106706",
    municipio: "Mirador",
    estado_codigo: "21",
  },
  {
    codigo: "3142106",
    municipio: "Miradouro",
    estado_codigo: "31",
  },
  {
    codigo: "3530003",
    municipio: "Mira Estrela",
    estado_codigo: "35",
  },
  {
    codigo: "4312302",
    municipio: "Miraguaí",
    estado_codigo: "43",
  },
  {
    codigo: "3142205",
    municipio: "Miraí",
    estado_codigo: "31",
  },
  {
    codigo: "2308377",
    municipio: "Miraíma",
    estado_codigo: "23",
  },
  {
    codigo: "5005608",
    municipio: "Miranda",
    estado_codigo: "50",
  },
  {
    codigo: "2106755",
    municipio: "Miranda do Norte",
    estado_codigo: "21",
  },
  {
    codigo: "2609303",
    municipio: "Mirandiba",
    estado_codigo: "26",
  },
  {
    codigo: "3530102",
    municipio: "Mirandópolis",
    estado_codigo: "35",
  },
  {
    codigo: "2921401",
    municipio: "Mirangaba",
    estado_codigo: "29",
  },
  {
    codigo: "1713304",
    municipio: "Miranorte",
    estado_codigo: "17",
  },
  {
    codigo: "2921450",
    municipio: "Mirante",
    estado_codigo: "29",
  },
  {
    codigo: "1101302",
    municipio: "Mirante da Serra",
    estado_codigo: "11",
  },
  {
    codigo: "3530201",
    municipio: "Mirante do Paranapanema",
    estado_codigo: "35",
  },
  {
    codigo: "4116000",
    municipio: "Miraselva",
    estado_codigo: "41",
  },
  {
    codigo: "3530300",
    municipio: "Mirassol",
    estado_codigo: "35",
  },
  {
    codigo: "3530409",
    municipio: "Mirassolândia",
    estado_codigo: "35",
  },
  {
    codigo: "5105622",
    municipio: "Mirassol d'Oeste",
    estado_codigo: "51",
  },
  {
    codigo: "3142254",
    municipio: "Miravânia",
    estado_codigo: "31",
  },
  {
    codigo: "4210852",
    municipio: "Mirim Doce",
    estado_codigo: "42",
  },
  {
    codigo: "2106805",
    municipio: "Mirinzal",
    estado_codigo: "21",
  },
  {
    codigo: "4116059",
    municipio: "Missal",
    estado_codigo: "41",
  },
  {
    codigo: "2308401",
    municipio: "Missão Velha",
    estado_codigo: "23",
  },
  {
    codigo: "1504604",
    municipio: "Mocajuba",
    estado_codigo: "15",
  },
  {
    codigo: "3530508",
    municipio: "Mococa",
    estado_codigo: "35",
  },
  {
    codigo: "4210902",
    municipio: "Modelo",
    estado_codigo: "42",
  },
  {
    codigo: "3142304",
    municipio: "Moeda",
    estado_codigo: "31",
  },
  {
    codigo: "3142403",
    municipio: "Moema",
    estado_codigo: "31",
  },
  {
    codigo: "2509404",
    municipio: "Mogeiro",
    estado_codigo: "25",
  },
  {
    codigo: "3530607",
    municipio: "Mogi das Cruzes",
    estado_codigo: "35",
  },
  {
    codigo: "3530706",
    municipio: "Mogi Guaçu",
    estado_codigo: "35",
  },
  {
    codigo: "5213400",
    municipio: "Moiporá",
    estado_codigo: "52",
  },
  {
    codigo: "2804102",
    municipio: "Moita Bonita",
    estado_codigo: "28",
  },
  {
    codigo: "3530805",
    municipio: "Mogi Mirim",
    estado_codigo: "35",
  },
  {
    codigo: "1504703",
    municipio: "Moju",
    estado_codigo: "15",
  },
  {
    codigo: "1504752",
    municipio: "Mojuí dos Campos",
    estado_codigo: "15",
  },
  {
    codigo: "2308500",
    municipio: "Mombaça",
    estado_codigo: "23",
  },
  {
    codigo: "3530904",
    municipio: "Mombuca",
    estado_codigo: "35",
  },
  {
    codigo: "2106904",
    municipio: "Monção",
    estado_codigo: "21",
  },
  {
    codigo: "3531001",
    municipio: "Monções",
    estado_codigo: "35",
  },
  {
    codigo: "4211009",
    municipio: "Mondaí",
    estado_codigo: "42",
  },
  {
    codigo: "3531100",
    municipio: "Mongaguá",
    estado_codigo: "35",
  },
  {
    codigo: "3142502",
    municipio: "Monjolos",
    estado_codigo: "31",
  },
  {
    codigo: "2206407",
    municipio: "Monsenhor Gil",
    estado_codigo: "22",
  },
  {
    codigo: "2206506",
    municipio: "Monsenhor Hipólito",
    estado_codigo: "22",
  },
  {
    codigo: "3142601",
    municipio: "Monsenhor Paulo",
    estado_codigo: "31",
  },
  {
    codigo: "2308609",
    municipio: "Monsenhor Tabosa",
    estado_codigo: "23",
  },
  {
    codigo: "2509503",
    municipio: "Montadas",
    estado_codigo: "25",
  },
  {
    codigo: "3142700",
    municipio: "Montalvânia",
    estado_codigo: "31",
  },
  {
    codigo: "3203502",
    municipio: "Montanha",
    estado_codigo: "32",
  },
  {
    codigo: "2407708",
    municipio: "Montanhas",
    estado_codigo: "24",
  },
  {
    codigo: "4312351",
    municipio: "Montauri",
    estado_codigo: "43",
  },
  {
    codigo: "2407807",
    municipio: "Monte Alegre",
    estado_codigo: "24",
  },
  {
    codigo: "1504802",
    municipio: "Monte Alegre",
    estado_codigo: "15",
  },
  {
    codigo: "5213509",
    municipio: "Monte Alegre de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3142809",
    municipio: "Monte Alegre de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2804201",
    municipio: "Monte Alegre de Sergipe",
    estado_codigo: "28",
  },
  {
    codigo: "2206605",
    municipio: "Monte Alegre do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4312377",
    municipio: "Monte Alegre dos Campos",
    estado_codigo: "43",
  },
  {
    codigo: "3531209",
    municipio: "Monte Alegre do Sul",
    estado_codigo: "35",
  },
  {
    codigo: "3531308",
    municipio: "Monte Alto",
    estado_codigo: "35",
  },
  {
    codigo: "3531407",
    municipio: "Monte Aprazível",
    estado_codigo: "35",
  },
  {
    codigo: "3142908",
    municipio: "Monte Azul",
    estado_codigo: "31",
  },
  {
    codigo: "3531506",
    municipio: "Monte Azul Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "3143005",
    municipio: "Monte Belo",
    estado_codigo: "31",
  },
  {
    codigo: "4312385",
    municipio: "Monte Belo do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4211058",
    municipio: "Monte Carlo",
    estado_codigo: "42",
  },
  {
    codigo: "3143104",
    municipio: "Monte Carmelo",
    estado_codigo: "31",
  },
  {
    codigo: "3531605",
    municipio: "Monte Castelo",
    estado_codigo: "35",
  },
  {
    codigo: "4211108",
    municipio: "Monte Castelo",
    estado_codigo: "42",
  },
  {
    codigo: "2407906",
    municipio: "Monte das Gameleiras",
    estado_codigo: "24",
  },
  {
    codigo: "1713601",
    municipio: "Monte do Carmo",
    estado_codigo: "17",
  },
  {
    codigo: "3143153",
    municipio: "Monte Formoso",
    estado_codigo: "31",
  },
  {
    codigo: "2509602",
    municipio: "Monte Horebe",
    estado_codigo: "25",
  },
  {
    codigo: "2509701",
    municipio: "Monteiro",
    estado_codigo: "25",
  },
  {
    codigo: "3531704",
    municipio: "Monteiro Lobato",
    estado_codigo: "35",
  },
  {
    codigo: "2705408",
    municipio: "Monteirópolis",
    estado_codigo: "27",
  },
  {
    codigo: "3531803",
    municipio: "Monte Mor",
    estado_codigo: "35",
  },
  {
    codigo: "4312401",
    municipio: "Montenegro",
    estado_codigo: "43",
  },
  {
    codigo: "1101401",
    municipio: "Monte Negro",
    estado_codigo: "11",
  },
  {
    codigo: "2107001",
    municipio: "Montes Altos",
    estado_codigo: "21",
  },
  {
    codigo: "2921500",
    municipio: "Monte Santo",
    estado_codigo: "29",
  },
  {
    codigo: "3143203",
    municipio: "Monte Santo de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "1713700",
    municipio: "Monte Santo do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "3143302",
    municipio: "Montes Claros",
    estado_codigo: "31",
  },
  {
    codigo: "5213707",
    municipio: "Montes Claros de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3143401",
    municipio: "Monte Sião",
    estado_codigo: "31",
  },
  {
    codigo: "3143450",
    municipio: "Montezuma",
    estado_codigo: "31",
  },
  {
    codigo: "5213756",
    municipio: "Montividiu",
    estado_codigo: "52",
  },
  {
    codigo: "5213772",
    municipio: "Montividiu do Norte",
    estado_codigo: "52",
  },
  {
    codigo: "2308708",
    municipio: "Morada Nova",
    estado_codigo: "23",
  },
  {
    codigo: "3143500",
    municipio: "Morada Nova de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2308807",
    municipio: "Moraújo",
    estado_codigo: "23",
  },
  {
    codigo: "2614303",
    municipio: "Moreilândia",
    estado_codigo: "26",
  },
  {
    codigo: "4116109",
    municipio: "Moreira Sales",
    estado_codigo: "41",
  },
  {
    codigo: "2609402",
    municipio: "Moreno",
    estado_codigo: "26",
  },
  {
    codigo: "4312427",
    municipio: "Mormaço",
    estado_codigo: "43",
  },
  {
    codigo: "2921609",
    municipio: "Morpará",
    estado_codigo: "29",
  },
  {
    codigo: "4116208",
    municipio: "Morretes",
    estado_codigo: "41",
  },
  {
    codigo: "2308906",
    municipio: "Morrinhos",
    estado_codigo: "23",
  },
  {
    codigo: "5213806",
    municipio: "Morrinhos",
    estado_codigo: "52",
  },
  {
    codigo: "4312443",
    municipio: "Morrinhos do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3531902",
    municipio: "Morro Agudo",
    estado_codigo: "35",
  },
  {
    codigo: "5213855",
    municipio: "Morro Agudo de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "2206654",
    municipio: "Morro Cabeça no Tempo",
    estado_codigo: "22",
  },
  {
    codigo: "4211207",
    municipio: "Morro da Fumaça",
    estado_codigo: "42",
  },
  {
    codigo: "3143609",
    municipio: "Morro da Garça",
    estado_codigo: "31",
  },
  {
    codigo: "2921708",
    municipio: "Morro do Chapéu",
    estado_codigo: "29",
  },
  {
    codigo: "2206670",
    municipio: "Morro do Chapéu do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3143708",
    municipio: "Morro do Pilar",
    estado_codigo: "31",
  },
  {
    codigo: "4211256",
    municipio: "Morro Grande",
    estado_codigo: "42",
  },
  {
    codigo: "4312450",
    municipio: "Morro Redondo",
    estado_codigo: "43",
  },
  {
    codigo: "4312476",
    municipio: "Morro Reuter",
    estado_codigo: "43",
  },
  {
    codigo: "2107100",
    municipio: "Morros",
    estado_codigo: "21",
  },
  {
    codigo: "2921807",
    municipio: "Mortugaba",
    estado_codigo: "29",
  },
  {
    codigo: "3532009",
    municipio: "Morungaba",
    estado_codigo: "35",
  },
  {
    codigo: "5213905",
    municipio: "Mossâmedes",
    estado_codigo: "52",
  },
  {
    codigo: "2408003",
    municipio: "Mossoró",
    estado_codigo: "24",
  },
  {
    codigo: "4312500",
    municipio: "Mostardas",
    estado_codigo: "43",
  },
  {
    codigo: "3532058",
    municipio: "Motuca",
    estado_codigo: "35",
  },
  {
    codigo: "5214002",
    municipio: "Mozarlândia",
    estado_codigo: "52",
  },
  {
    codigo: "1504901",
    municipio: "Muaná",
    estado_codigo: "15",
  },
  {
    codigo: "1400308",
    municipio: "Mucajaí",
    estado_codigo: "14",
  },
  {
    codigo: "2309003",
    municipio: "Mucambo",
    estado_codigo: "23",
  },
  {
    codigo: "2921906",
    municipio: "Mucugê",
    estado_codigo: "29",
  },
  {
    codigo: "4312609",
    municipio: "Muçum",
    estado_codigo: "43",
  },
  {
    codigo: "2922003",
    municipio: "Mucuri",
    estado_codigo: "29",
  },
  {
    codigo: "3203601",
    municipio: "Mucurici",
    estado_codigo: "32",
  },
  {
    codigo: "4312617",
    municipio: "Muitos Capões",
    estado_codigo: "43",
  },
  {
    codigo: "4312625",
    municipio: "Muliterno",
    estado_codigo: "43",
  },
  {
    codigo: "2509800",
    municipio: "Mulungu",
    estado_codigo: "25",
  },
  {
    codigo: "2309102",
    municipio: "Mulungu",
    estado_codigo: "23",
  },
  {
    codigo: "2922052",
    municipio: "Mulungu do Morro",
    estado_codigo: "29",
  },
  {
    codigo: "5005681",
    municipio: "Mundo Novo",
    estado_codigo: "50",
  },
  {
    codigo: "2922102",
    municipio: "Mundo Novo",
    estado_codigo: "29",
  },
  {
    codigo: "5214051",
    municipio: "Mundo Novo",
    estado_codigo: "52",
  },
  {
    codigo: "3143807",
    municipio: "Munhoz",
    estado_codigo: "31",
  },
  {
    codigo: "4116307",
    municipio: "Munhoz de Melo",
    estado_codigo: "41",
  },
  {
    codigo: "2922201",
    municipio: "Muniz Ferreira",
    estado_codigo: "29",
  },
  {
    codigo: "3203700",
    municipio: "Muniz Freire",
    estado_codigo: "32",
  },
  {
    codigo: "2922250",
    municipio: "Muquém de São Francisco",
    estado_codigo: "29",
  },
  {
    codigo: "3203809",
    municipio: "Muqui",
    estado_codigo: "32",
  },
  {
    codigo: "3143906",
    municipio: "Muriaé",
    estado_codigo: "31",
  },
  {
    codigo: "2804300",
    municipio: "Muribeca",
    estado_codigo: "28",
  },
  {
    codigo: "2705507",
    municipio: "Murici",
    estado_codigo: "27",
  },
  {
    codigo: "2206696",
    municipio: "Murici dos Portelas",
    estado_codigo: "22",
  },
  {
    codigo: "1713957",
    municipio: "Muricilândia",
    estado_codigo: "17",
  },
  {
    codigo: "2922300",
    municipio: "Muritiba",
    estado_codigo: "29",
  },
  {
    codigo: "3532108",
    municipio: "Murutinga do Sul",
    estado_codigo: "35",
  },
  {
    codigo: "2922409",
    municipio: "Mutuípe",
    estado_codigo: "29",
  },
  {
    codigo: "3144003",
    municipio: "Mutum",
    estado_codigo: "31",
  },
  {
    codigo: "5214101",
    municipio: "Mutunópolis",
    estado_codigo: "52",
  },
  {
    codigo: "3144102",
    municipio: "Muzambinho",
    estado_codigo: "31",
  },
  {
    codigo: "3144201",
    municipio: "Nacip Raydan",
    estado_codigo: "31",
  },
  {
    codigo: "3532157",
    municipio: "Nantes",
    estado_codigo: "35",
  },
  {
    codigo: "3144300",
    municipio: "Nanuque",
    estado_codigo: "31",
  },
  {
    codigo: "4312658",
    municipio: "Não-Me-Toque",
    estado_codigo: "43",
  },
  {
    codigo: "3144359",
    municipio: "Naque",
    estado_codigo: "31",
  },
  {
    codigo: "3532207",
    municipio: "Narandiba",
    estado_codigo: "35",
  },
  {
    codigo: "2408102",
    municipio: "Natal",
    estado_codigo: "24",
  },
  {
    codigo: "3144375",
    municipio: "Natalândia",
    estado_codigo: "31",
  },
  {
    codigo: "3144409",
    municipio: "Natércia",
    estado_codigo: "31",
  },
  {
    codigo: "1714203",
    municipio: "Natividade",
    estado_codigo: "17",
  },
  {
    codigo: "3303104",
    municipio: "Natividade",
    estado_codigo: "33",
  },
  {
    codigo: "3532306",
    municipio: "Natividade da Serra",
    estado_codigo: "35",
  },
  {
    codigo: "2509909",
    municipio: "Natuba",
    estado_codigo: "25",
  },
  {
    codigo: "4211306",
    municipio: "Navegantes",
    estado_codigo: "42",
  },
  {
    codigo: "5005707",
    municipio: "Naviraí",
    estado_codigo: "50",
  },
  {
    codigo: "2922508",
    municipio: "Nazaré",
    estado_codigo: "29",
  },
  {
    codigo: "1714302",
    municipio: "Nazaré",
    estado_codigo: "17",
  },
  {
    codigo: "2609501",
    municipio: "Nazaré da Mata",
    estado_codigo: "26",
  },
  {
    codigo: "2206704",
    municipio: "Nazaré do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3144508",
    municipio: "Nazareno",
    estado_codigo: "31",
  },
  {
    codigo: "3532405",
    municipio: "Nazaré Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "2510006",
    municipio: "Nazarezinho",
    estado_codigo: "25",
  },
  {
    codigo: "2206720",
    municipio: "Nazária",
    estado_codigo: "22",
  },
  {
    codigo: "5214408",
    municipio: "Nazário",
    estado_codigo: "52",
  },
  {
    codigo: "2804409",
    municipio: "Neópolis",
    estado_codigo: "28",
  },
  {
    codigo: "3144607",
    municipio: "Nepomuceno",
    estado_codigo: "31",
  },
  {
    codigo: "5214507",
    municipio: "Nerópolis",
    estado_codigo: "52",
  },
  {
    codigo: "3532504",
    municipio: "Neves Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "1303007",
    municipio: "Nhamundá",
    estado_codigo: "13",
  },
  {
    codigo: "3532603",
    municipio: "Nhandeara",
    estado_codigo: "35",
  },
  {
    codigo: "4312674",
    municipio: "Nicolau Vergueiro",
    estado_codigo: "43",
  },
  {
    codigo: "2922607",
    municipio: "Nilo Peçanha",
    estado_codigo: "29",
  },
  {
    codigo: "3303203",
    municipio: "Nilópolis",
    estado_codigo: "33",
  },
  {
    codigo: "2107209",
    municipio: "Nina Rodrigues",
    estado_codigo: "21",
  },
  {
    codigo: "3144656",
    municipio: "Ninheira",
    estado_codigo: "31",
  },
  {
    codigo: "5005806",
    municipio: "Nioaque",
    estado_codigo: "50",
  },
  {
    codigo: "3532702",
    municipio: "Nipoã",
    estado_codigo: "35",
  },
  {
    codigo: "5214606",
    municipio: "Niquelândia",
    estado_codigo: "52",
  },
  {
    codigo: "2408201",
    municipio: "Nísia Floresta",
    estado_codigo: "24",
  },
  {
    codigo: "3303302",
    municipio: "Niterói",
    estado_codigo: "33",
  },
  {
    codigo: "5105903",
    municipio: "Nobres",
    estado_codigo: "51",
  },
  {
    codigo: "4312708",
    municipio: "Nonoai",
    estado_codigo: "43",
  },
  {
    codigo: "2922656",
    municipio: "Nordestina",
    estado_codigo: "29",
  },
  {
    codigo: "1400407",
    municipio: "Normandia",
    estado_codigo: "14",
  },
  {
    codigo: "5106000",
    municipio: "Nortelândia",
    estado_codigo: "51",
  },
  {
    codigo: "2804458",
    municipio: "Nossa Senhora Aparecida",
    estado_codigo: "28",
  },
  {
    codigo: "2804508",
    municipio: "Nossa Senhora da Glória",
    estado_codigo: "28",
  },
  {
    codigo: "2804607",
    municipio: "Nossa Senhora das Dores",
    estado_codigo: "28",
  },
  {
    codigo: "4116406",
    municipio: "Nossa Senhora das Graças",
    estado_codigo: "41",
  },
  {
    codigo: "2804706",
    municipio: "Nossa Senhora de Lourdes",
    estado_codigo: "28",
  },
  {
    codigo: "2206753",
    municipio: "Nossa Senhora de Nazaré",
    estado_codigo: "22",
  },
  {
    codigo: "5106109",
    municipio: "Nossa Senhora do Livramento",
    estado_codigo: "51",
  },
  {
    codigo: "2804805",
    municipio: "Nossa Senhora do Socorro",
    estado_codigo: "28",
  },
  {
    codigo: "2206803",
    municipio: "Nossa Senhora dos Remédios",
    estado_codigo: "22",
  },
  {
    codigo: "3532801",
    municipio: "Nova Aliança",
    estado_codigo: "35",
  },
  {
    codigo: "4116505",
    municipio: "Nova Aliança do Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "4312757",
    municipio: "Nova Alvorada",
    estado_codigo: "43",
  },
  {
    codigo: "5006002",
    municipio: "Nova Alvorada do Sul",
    estado_codigo: "50",
  },
  {
    codigo: "5214705",
    municipio: "Nova América",
    estado_codigo: "52",
  },
  {
    codigo: "4116604",
    municipio: "Nova América da Colina",
    estado_codigo: "41",
  },
  {
    codigo: "5006200",
    municipio: "Nova Andradina",
    estado_codigo: "50",
  },
  {
    codigo: "4312807",
    municipio: "Nova Araçá",
    estado_codigo: "43",
  },
  {
    codigo: "4116703",
    municipio: "Nova Aurora",
    estado_codigo: "41",
  },
  {
    codigo: "5214804",
    municipio: "Nova Aurora",
    estado_codigo: "52",
  },
  {
    codigo: "5106158",
    municipio: "Nova Bandeirantes",
    estado_codigo: "51",
  },
  {
    codigo: "4312906",
    municipio: "Nova Bassano",
    estado_codigo: "43",
  },
  {
    codigo: "3144672",
    municipio: "Nova Belém",
    estado_codigo: "31",
  },
  {
    codigo: "4312955",
    municipio: "Nova Boa Vista",
    estado_codigo: "43",
  },
  {
    codigo: "5106208",
    municipio: "Nova Brasilândia",
    estado_codigo: "51",
  },
  {
    codigo: "1100148",
    municipio: "Nova Brasilândia D'Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "4313003",
    municipio: "Nova Bréscia",
    estado_codigo: "43",
  },
  {
    codigo: "3532827",
    municipio: "Nova Campina",
    estado_codigo: "35",
  },
  {
    codigo: "2922706",
    municipio: "Nova Canaã",
    estado_codigo: "29",
  },
  {
    codigo: "5106216",
    municipio: "Nova Canaã do Norte",
    estado_codigo: "51",
  },
  {
    codigo: "3532843",
    municipio: "Nova Canaã Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4313011",
    municipio: "Nova Candelária",
    estado_codigo: "43",
  },
  {
    codigo: "4116802",
    municipio: "Nova Cantu",
    estado_codigo: "41",
  },
  {
    codigo: "3532868",
    municipio: "Nova Castilho",
    estado_codigo: "35",
  },
  {
    codigo: "2107258",
    municipio: "Nova Colinas",
    estado_codigo: "21",
  },
  {
    codigo: "5214838",
    municipio: "Nova Crixás",
    estado_codigo: "52",
  },
  {
    codigo: "2408300",
    municipio: "Nova Cruz",
    estado_codigo: "24",
  },
  {
    codigo: "3144706",
    municipio: "Nova Era",
    estado_codigo: "31",
  },
  {
    codigo: "4211405",
    municipio: "Nova Erechim",
    estado_codigo: "42",
  },
  {
    codigo: "4116901",
    municipio: "Nova Esperança",
    estado_codigo: "41",
  },
  {
    codigo: "1504950",
    municipio: "Nova Esperança do Piriá",
    estado_codigo: "15",
  },
  {
    codigo: "4116950",
    municipio: "Nova Esperança do Sudoeste",
    estado_codigo: "41",
  },
  {
    codigo: "4313037",
    municipio: "Nova Esperança do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3532900",
    municipio: "Nova Europa",
    estado_codigo: "35",
  },
  {
    codigo: "4117008",
    municipio: "Nova Fátima",
    estado_codigo: "41",
  },
  {
    codigo: "2922730",
    municipio: "Nova Fátima",
    estado_codigo: "29",
  },
  {
    codigo: "2510105",
    municipio: "Nova Floresta",
    estado_codigo: "25",
  },
  {
    codigo: "3303401",
    municipio: "Nova Friburgo",
    estado_codigo: "33",
  },
  {
    codigo: "5214861",
    municipio: "Nova Glória",
    estado_codigo: "52",
  },
  {
    codigo: "3533007",
    municipio: "Nova Granada",
    estado_codigo: "35",
  },
  {
    codigo: "5108808",
    municipio: "Nova Guarita",
    estado_codigo: "51",
  },
  {
    codigo: "3533106",
    municipio: "Nova Guataporanga",
    estado_codigo: "35",
  },
  {
    codigo: "4313060",
    municipio: "Nova Hartz",
    estado_codigo: "43",
  },
  {
    codigo: "2922755",
    municipio: "Nova Ibiá",
    estado_codigo: "29",
  },
  {
    codigo: "3303500",
    municipio: "Nova Iguaçu",
    estado_codigo: "33",
  },
  {
    codigo: "5214879",
    municipio: "Nova Iguaçu de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3533205",
    municipio: "Nova Independência",
    estado_codigo: "35",
  },
  {
    codigo: "2107308",
    municipio: "Nova Iorque",
    estado_codigo: "21",
  },
  {
    codigo: "1504976",
    municipio: "Nova Ipixuna",
    estado_codigo: "15",
  },
  {
    codigo: "3533254",
    municipio: "Novais",
    estado_codigo: "35",
  },
  {
    codigo: "4211454",
    municipio: "Nova Itaberaba",
    estado_codigo: "42",
  },
  {
    codigo: "2922805",
    municipio: "Nova Itarana",
    estado_codigo: "29",
  },
  {
    codigo: "5106182",
    municipio: "Nova Lacerda",
    estado_codigo: "51",
  },
  {
    codigo: "4117057",
    municipio: "Nova Laranjeiras",
    estado_codigo: "41",
  },
  {
    codigo: "3144805",
    municipio: "Nova Lima",
    estado_codigo: "31",
  },
  {
    codigo: "4117107",
    municipio: "Nova Londrina",
    estado_codigo: "41",
  },
  {
    codigo: "3533304",
    municipio: "Nova Luzitânia",
    estado_codigo: "35",
  },
  {
    codigo: "1100338",
    municipio: "Nova Mamoré",
    estado_codigo: "11",
  },
  {
    codigo: "5108857",
    municipio: "Nova Marilândia",
    estado_codigo: "51",
  },
  {
    codigo: "5108907",
    municipio: "Nova Maringá",
    estado_codigo: "51",
  },
  {
    codigo: "3144904",
    municipio: "Nova Módica",
    estado_codigo: "31",
  },
  {
    codigo: "5108956",
    municipio: "Nova Monte Verde",
    estado_codigo: "51",
  },
  {
    codigo: "5106224",
    municipio: "Nova Mutum",
    estado_codigo: "51",
  },
  {
    codigo: "5106174",
    municipio: "Nova Nazaré",
    estado_codigo: "51",
  },
  {
    codigo: "3533403",
    municipio: "Nova Odessa",
    estado_codigo: "35",
  },
  {
    codigo: "4117206",
    municipio: "Nova Olímpia",
    estado_codigo: "41",
  },
  {
    codigo: "5106232",
    municipio: "Nova Olímpia",
    estado_codigo: "51",
  },
  {
    codigo: "2309201",
    municipio: "Nova Olinda",
    estado_codigo: "23",
  },
  {
    codigo: "2510204",
    municipio: "Nova Olinda",
    estado_codigo: "25",
  },
  {
    codigo: "1714880",
    municipio: "Nova Olinda",
    estado_codigo: "17",
  },
  {
    codigo: "2107357",
    municipio: "Nova Olinda do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "1303106",
    municipio: "Nova Olinda do Norte",
    estado_codigo: "13",
  },
  {
    codigo: "4313086",
    municipio: "Nova Pádua",
    estado_codigo: "43",
  },
  {
    codigo: "4313102",
    municipio: "Nova Palma",
    estado_codigo: "43",
  },
  {
    codigo: "2510303",
    municipio: "Nova Palmeira",
    estado_codigo: "25",
  },
  {
    codigo: "4313201",
    municipio: "Nova Petrópolis",
    estado_codigo: "43",
  },
  {
    codigo: "3145000",
    municipio: "Nova Ponte",
    estado_codigo: "31",
  },
  {
    codigo: "3145059",
    municipio: "Nova Porteirinha",
    estado_codigo: "31",
  },
  {
    codigo: "4313300",
    municipio: "Nova Prata",
    estado_codigo: "43",
  },
  {
    codigo: "4117255",
    municipio: "Nova Prata do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "4313334",
    municipio: "Nova Ramada",
    estado_codigo: "43",
  },
  {
    codigo: "2922854",
    municipio: "Nova Redenção",
    estado_codigo: "29",
  },
  {
    codigo: "3145109",
    municipio: "Nova Resende",
    estado_codigo: "31",
  },
  {
    codigo: "5214903",
    municipio: "Nova Roma",
    estado_codigo: "52",
  },
  {
    codigo: "4313359",
    municipio: "Nova Roma do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "1715002",
    municipio: "Nova Rosalândia",
    estado_codigo: "17",
  },
  {
    codigo: "2309300",
    municipio: "Nova Russas",
    estado_codigo: "23",
  },
  {
    codigo: "4117214",
    municipio: "Nova Santa Bárbara",
    estado_codigo: "41",
  },
  {
    codigo: "5106190",
    municipio: "Nova Santa Helena",
    estado_codigo: "51",
  },
  {
    codigo: "2207959",
    municipio: "Nova Santa Rita",
    estado_codigo: "22",
  },
  {
    codigo: "4313375",
    municipio: "Nova Santa Rita",
    estado_codigo: "43",
  },
  {
    codigo: "4117222",
    municipio: "Nova Santa Rosa",
    estado_codigo: "41",
  },
  {
    codigo: "3145208",
    municipio: "Nova Serrana",
    estado_codigo: "31",
  },
  {
    codigo: "2922904",
    municipio: "Nova Soure",
    estado_codigo: "29",
  },
  {
    codigo: "4117271",
    municipio: "Nova Tebas",
    estado_codigo: "41",
  },
  {
    codigo: "1505007",
    municipio: "Nova Timboteua",
    estado_codigo: "15",
  },
  {
    codigo: "4211504",
    municipio: "Nova Trento",
    estado_codigo: "42",
  },
  {
    codigo: "5106240",
    municipio: "Nova Ubiratã",
    estado_codigo: "51",
  },
  {
    codigo: "1101435",
    municipio: "Nova União",
    estado_codigo: "11",
  },
  {
    codigo: "3136603",
    municipio: "Nova União",
    estado_codigo: "31",
  },
  {
    codigo: "3203908",
    municipio: "Nova Venécia",
    estado_codigo: "32",
  },
  {
    codigo: "5215009",
    municipio: "Nova Veneza",
    estado_codigo: "52",
  },
  {
    codigo: "4211603",
    municipio: "Nova Veneza",
    estado_codigo: "42",
  },
  {
    codigo: "2923001",
    municipio: "Nova Viçosa",
    estado_codigo: "29",
  },
  {
    codigo: "5106257",
    municipio: "Nova Xavantina",
    estado_codigo: "51",
  },
  {
    codigo: "1715101",
    municipio: "Novo Acordo",
    estado_codigo: "17",
  },
  {
    codigo: "1303205",
    municipio: "Novo Airão",
    estado_codigo: "13",
  },
  {
    codigo: "1715150",
    municipio: "Novo Alegre",
    estado_codigo: "17",
  },
  {
    codigo: "1303304",
    municipio: "Novo Aripuanã",
    estado_codigo: "13",
  },
  {
    codigo: "4313490",
    municipio: "Novo Barreiro",
    estado_codigo: "43",
  },
  {
    codigo: "5215207",
    municipio: "Novo Brasil",
    estado_codigo: "52",
  },
  {
    codigo: "4313391",
    municipio: "Novo Cabrais",
    estado_codigo: "43",
  },
  {
    codigo: "3145307",
    municipio: "Novo Cruzeiro",
    estado_codigo: "31",
  },
  {
    codigo: "5215231",
    municipio: "Novo Gama",
    estado_codigo: "52",
  },
  {
    codigo: "4313409",
    municipio: "Novo Hamburgo",
    estado_codigo: "43",
  },
  {
    codigo: "3533502",
    municipio: "Novo Horizonte",
    estado_codigo: "35",
  },
  {
    codigo: "4211652",
    municipio: "Novo Horizonte",
    estado_codigo: "42",
  },
  {
    codigo: "2923035",
    municipio: "Novo Horizonte",
    estado_codigo: "29",
  },
  {
    codigo: "5106273",
    municipio: "Novo Horizonte do Norte",
    estado_codigo: "51",
  },
  {
    codigo: "1100502",
    municipio: "Novo Horizonte do Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "5006259",
    municipio: "Novo Horizonte do Sul",
    estado_codigo: "50",
  },
  {
    codigo: "4117297",
    municipio: "Novo Itacolomi",
    estado_codigo: "41",
  },
  {
    codigo: "1715259",
    municipio: "Novo Jardim",
    estado_codigo: "17",
  },
  {
    codigo: "2705606",
    municipio: "Novo Lino",
    estado_codigo: "27",
  },
  {
    codigo: "4313425",
    municipio: "Novo Machado",
    estado_codigo: "43",
  },
  {
    codigo: "5106265",
    municipio: "Novo Mundo",
    estado_codigo: "51",
  },
  {
    codigo: "2309409",
    municipio: "Novo Oriente",
    estado_codigo: "23",
  },
  {
    codigo: "3145356",
    municipio: "Novo Oriente de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2206902",
    municipio: "Novo Oriente do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "5215256",
    municipio: "Novo Planalto",
    estado_codigo: "52",
  },
  {
    codigo: "1505031",
    municipio: "Novo Progresso",
    estado_codigo: "15",
  },
  {
    codigo: "1505064",
    municipio: "Novo Repartimento",
    estado_codigo: "15",
  },
  {
    codigo: "3145372",
    municipio: "Novorizonte",
    estado_codigo: "31",
  },
  {
    codigo: "5106315",
    municipio: "Novo Santo Antônio",
    estado_codigo: "51",
  },
  {
    codigo: "2206951",
    municipio: "Novo Santo Antônio",
    estado_codigo: "22",
  },
  {
    codigo: "5106281",
    municipio: "Novo São Joaquim",
    estado_codigo: "51",
  },
  {
    codigo: "4313441",
    municipio: "Novo Tiradentes",
    estado_codigo: "43",
  },
  {
    codigo: "2923050",
    municipio: "Novo Triunfo",
    estado_codigo: "29",
  },
  {
    codigo: "4313466",
    municipio: "Novo Xingu",
    estado_codigo: "43",
  },
  {
    codigo: "3533601",
    municipio: "Nuporanga",
    estado_codigo: "35",
  },
  {
    codigo: "1505106",
    municipio: "Óbidos",
    estado_codigo: "15",
  },
  {
    codigo: "2309458",
    municipio: "Ocara",
    estado_codigo: "23",
  },
  {
    codigo: "3533700",
    municipio: "Ocauçu",
    estado_codigo: "35",
  },
  {
    codigo: "2207009",
    municipio: "Oeiras",
    estado_codigo: "22",
  },
  {
    codigo: "1505205",
    municipio: "Oeiras do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "1600501",
    municipio: "Oiapoque",
    estado_codigo: "16",
  },
  {
    codigo: "3145406",
    municipio: "Olaria",
    estado_codigo: "31",
  },
  {
    codigo: "3533809",
    municipio: "Óleo",
    estado_codigo: "35",
  },
  {
    codigo: "2510402",
    municipio: "Olho d'Água",
    estado_codigo: "25",
  },
  {
    codigo: "2107407",
    municipio: "Olho d'Água das Cunhãs",
    estado_codigo: "21",
  },
  {
    codigo: "2705705",
    municipio: "Olho d'Água das Flores",
    estado_codigo: "27",
  },
  {
    codigo: "2408409",
    municipio: "Olho-d'Água do Borges",
    estado_codigo: "24",
  },
  {
    codigo: "2705804",
    municipio: "Olho d'Água do Casado",
    estado_codigo: "27",
  },
  {
    codigo: "2207108",
    municipio: "Olho D'Água do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2705903",
    municipio: "Olho d'Água Grande",
    estado_codigo: "27",
  },
  {
    codigo: "3145455",
    municipio: "Olhos-d'Água",
    estado_codigo: "31",
  },
  {
    codigo: "3533908",
    municipio: "Olímpia",
    estado_codigo: "35",
  },
  {
    codigo: "3145505",
    municipio: "Olímpio Noronha",
    estado_codigo: "31",
  },
  {
    codigo: "2609600",
    municipio: "Olinda",
    estado_codigo: "26",
  },
  {
    codigo: "2107456",
    municipio: "Olinda Nova do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "2923100",
    municipio: "Olindina",
    estado_codigo: "29",
  },
  {
    codigo: "2510501",
    municipio: "Olivedos",
    estado_codigo: "25",
  },
  {
    codigo: "3145604",
    municipio: "Oliveira",
    estado_codigo: "31",
  },
  {
    codigo: "1715507",
    municipio: "Oliveira de Fátima",
    estado_codigo: "17",
  },
  {
    codigo: "2923209",
    municipio: "Oliveira dos Brejinhos",
    estado_codigo: "29",
  },
  {
    codigo: "3145703",
    municipio: "Oliveira Fortes",
    estado_codigo: "31",
  },
  {
    codigo: "2706000",
    municipio: "Olivença",
    estado_codigo: "27",
  },
  {
    codigo: "3145802",
    municipio: "Onça de Pitangui",
    estado_codigo: "31",
  },
  {
    codigo: "3534005",
    municipio: "Onda Verde",
    estado_codigo: "35",
  },
  {
    codigo: "3145851",
    municipio: "Oratórios",
    estado_codigo: "31",
  },
  {
    codigo: "3534104",
    municipio: "Oriente",
    estado_codigo: "35",
  },
  {
    codigo: "3534203",
    municipio: "Orindiúva",
    estado_codigo: "35",
  },
  {
    codigo: "1505304",
    municipio: "Oriximiná",
    estado_codigo: "15",
  },
  {
    codigo: "3145877",
    municipio: "Orizânia",
    estado_codigo: "31",
  },
  {
    codigo: "5215306",
    municipio: "Orizona",
    estado_codigo: "52",
  },
  {
    codigo: "3534302",
    municipio: "Orlândia",
    estado_codigo: "35",
  },
  {
    codigo: "4211702",
    municipio: "Orleans",
    estado_codigo: "42",
  },
  {
    codigo: "2609709",
    municipio: "Orobó",
    estado_codigo: "26",
  },
  {
    codigo: "2609808",
    municipio: "Orocó",
    estado_codigo: "26",
  },
  {
    codigo: "2309508",
    municipio: "Orós",
    estado_codigo: "23",
  },
  {
    codigo: "4117305",
    municipio: "Ortigueira",
    estado_codigo: "41",
  },
  {
    codigo: "3534401",
    municipio: "Osasco",
    estado_codigo: "35",
  },
  {
    codigo: "3534500",
    municipio: "Oscar Bressane",
    estado_codigo: "35",
  },
  {
    codigo: "4313508",
    municipio: "Osório",
    estado_codigo: "43",
  },
  {
    codigo: "3534609",
    municipio: "Osvaldo Cruz",
    estado_codigo: "35",
  },
  {
    codigo: "4211751",
    municipio: "Otacílio Costa",
    estado_codigo: "42",
  },
  {
    codigo: "1505403",
    municipio: "Ourém",
    estado_codigo: "15",
  },
  {
    codigo: "2923308",
    municipio: "Ouriçangas",
    estado_codigo: "29",
  },
  {
    codigo: "2609907",
    municipio: "Ouricuri",
    estado_codigo: "26",
  },
  {
    codigo: "1505437",
    municipio: "Ourilândia do Norte",
    estado_codigo: "15",
  },
  {
    codigo: "3534708",
    municipio: "Ourinhos",
    estado_codigo: "35",
  },
  {
    codigo: "4117404",
    municipio: "Ourizona",
    estado_codigo: "41",
  },
  {
    codigo: "4211801",
    municipio: "Ouro",
    estado_codigo: "42",
  },
  {
    codigo: "2706109",
    municipio: "Ouro Branco",
    estado_codigo: "27",
  },
  {
    codigo: "3145901",
    municipio: "Ouro Branco",
    estado_codigo: "31",
  },
  {
    codigo: "2408508",
    municipio: "Ouro Branco",
    estado_codigo: "24",
  },
  {
    codigo: "3534757",
    municipio: "Ouroeste",
    estado_codigo: "35",
  },
  {
    codigo: "3146008",
    municipio: "Ouro Fino",
    estado_codigo: "31",
  },
  {
    codigo: "2923357",
    municipio: "Ourolândia",
    estado_codigo: "29",
  },
  {
    codigo: "3146107",
    municipio: "Ouro Preto",
    estado_codigo: "31",
  },
  {
    codigo: "1100155",
    municipio: "Ouro Preto do Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "2510600",
    municipio: "Ouro Velho",
    estado_codigo: "25",
  },
  {
    codigo: "3534807",
    municipio: "Ouro Verde",
    estado_codigo: "35",
  },
  {
    codigo: "4211850",
    municipio: "Ouro Verde",
    estado_codigo: "42",
  },
  {
    codigo: "5215405",
    municipio: "Ouro Verde de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3146206",
    municipio: "Ouro Verde de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4117453",
    municipio: "Ouro Verde do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "5215504",
    municipio: "Ouvidor",
    estado_codigo: "52",
  },
  {
    codigo: "3534906",
    municipio: "Pacaembu",
    estado_codigo: "35",
  },
  {
    codigo: "1505486",
    municipio: "Pacajá",
    estado_codigo: "15",
  },
  {
    codigo: "2309607",
    municipio: "Pacajus",
    estado_codigo: "23",
  },
  {
    codigo: "1400456",
    municipio: "Pacaraima",
    estado_codigo: "14",
  },
  {
    codigo: "2309706",
    municipio: "Pacatuba",
    estado_codigo: "23",
  },
  {
    codigo: "2804904",
    municipio: "Pacatuba",
    estado_codigo: "28",
  },
  {
    codigo: "2107506",
    municipio: "Paço do Lumiar",
    estado_codigo: "21",
  },
  {
    codigo: "2309805",
    municipio: "Pacoti",
    estado_codigo: "23",
  },
  {
    codigo: "2309904",
    municipio: "Pacujá",
    estado_codigo: "23",
  },
  {
    codigo: "5215603",
    municipio: "Padre Bernardo",
    estado_codigo: "52",
  },
  {
    codigo: "3146255",
    municipio: "Padre Carvalho",
    estado_codigo: "31",
  },
  {
    codigo: "2207207",
    municipio: "Padre Marcos",
    estado_codigo: "22",
  },
  {
    codigo: "3146305",
    municipio: "Padre Paraíso",
    estado_codigo: "31",
  },
  {
    codigo: "2207306",
    municipio: "Paes Landim",
    estado_codigo: "22",
  },
  {
    codigo: "4211876",
    municipio: "Paial",
    estado_codigo: "42",
  },
  {
    codigo: "4117503",
    municipio: "Paiçandu",
    estado_codigo: "41",
  },
  {
    codigo: "4313607",
    municipio: "Paim Filho",
    estado_codigo: "43",
  },
  {
    codigo: "3146404",
    municipio: "Paineiras",
    estado_codigo: "31",
  },
  {
    codigo: "4211892",
    municipio: "Painel",
    estado_codigo: "42",
  },
  {
    codigo: "3146503",
    municipio: "Pains",
    estado_codigo: "31",
  },
  {
    codigo: "3146552",
    municipio: "Pai Pedro",
    estado_codigo: "31",
  },
  {
    codigo: "3146602",
    municipio: "Paiva",
    estado_codigo: "31",
  },
  {
    codigo: "2207355",
    municipio: "Pajeú do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3535002",
    municipio: "Palestina",
    estado_codigo: "35",
  },
  {
    codigo: "2706208",
    municipio: "Palestina",
    estado_codigo: "27",
  },
  {
    codigo: "5215652",
    municipio: "Palestina de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "1505494",
    municipio: "Palestina do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "2310001",
    municipio: "Palhano",
    estado_codigo: "23",
  },
  {
    codigo: "4211900",
    municipio: "Palhoça",
    estado_codigo: "42",
  },
  {
    codigo: "3146701",
    municipio: "Palma",
    estado_codigo: "31",
  },
  {
    codigo: "2310100",
    municipio: "Palmácia",
    estado_codigo: "23",
  },
  {
    codigo: "2610004",
    municipio: "Palmares",
    estado_codigo: "26",
  },
  {
    codigo: "4313656",
    municipio: "Palmares do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3535101",
    municipio: "Palmares Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4117602",
    municipio: "Palmas",
    estado_codigo: "41",
  },
  {
    codigo: "1721000",
    municipio: "Palmas",
    estado_codigo: "17",
  },
  {
    codigo: "2923407",
    municipio: "Palmas de Monte Alto",
    estado_codigo: "29",
  },
  {
    codigo: "4212007",
    municipio: "Palma Sola",
    estado_codigo: "42",
  },
  {
    codigo: "4117701",
    municipio: "Palmeira",
    estado_codigo: "41",
  },
  {
    codigo: "4212056",
    municipio: "Palmeira",
    estado_codigo: "42",
  },
  {
    codigo: "4313706",
    municipio: "Palmeira das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "3535200",
    municipio: "Palmeira d'Oeste",
    estado_codigo: "35",
  },
  {
    codigo: "2207405",
    municipio: "Palmeira do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2706307",
    municipio: "Palmeira dos Índios",
    estado_codigo: "27",
  },
  {
    codigo: "2207504",
    municipio: "Palmeirais",
    estado_codigo: "22",
  },
  {
    codigo: "2107605",
    municipio: "Palmeirândia",
    estado_codigo: "21",
  },
  {
    codigo: "1715705",
    municipio: "Palmeirante",
    estado_codigo: "17",
  },
  {
    codigo: "2923506",
    municipio: "Palmeiras",
    estado_codigo: "29",
  },
  {
    codigo: "5215702",
    municipio: "Palmeiras de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "1713809",
    municipio: "Palmeiras do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2610103",
    municipio: "Palmeirina",
    estado_codigo: "26",
  },
  {
    codigo: "1715754",
    municipio: "Palmeirópolis",
    estado_codigo: "17",
  },
  {
    codigo: "5215801",
    municipio: "Palmelo",
    estado_codigo: "52",
  },
  {
    codigo: "5215900",
    municipio: "Palminópolis",
    estado_codigo: "52",
  },
  {
    codigo: "3535309",
    municipio: "Palmital",
    estado_codigo: "35",
  },
  {
    codigo: "4117800",
    municipio: "Palmital",
    estado_codigo: "41",
  },
  {
    codigo: "4313805",
    municipio: "Palmitinho",
    estado_codigo: "43",
  },
  {
    codigo: "4212106",
    municipio: "Palmitos",
    estado_codigo: "42",
  },
  {
    codigo: "3146750",
    municipio: "Palmópolis",
    estado_codigo: "31",
  },
  {
    codigo: "4117909",
    municipio: "Palotina",
    estado_codigo: "41",
  },
  {
    codigo: "5216007",
    municipio: "Panamá",
    estado_codigo: "52",
  },
  {
    codigo: "4313904",
    municipio: "Panambi",
    estado_codigo: "43",
  },
  {
    codigo: "3204005",
    municipio: "Pancas",
    estado_codigo: "32",
  },
  {
    codigo: "2610202",
    municipio: "Panelas",
    estado_codigo: "26",
  },
  {
    codigo: "3535408",
    municipio: "Panorama",
    estado_codigo: "35",
  },
  {
    codigo: "4313953",
    municipio: "Pantano Grande",
    estado_codigo: "43",
  },
  {
    codigo: "2706406",
    municipio: "Pão de Açúcar",
    estado_codigo: "27",
  },
  {
    codigo: "3146909",
    municipio: "Papagaios",
    estado_codigo: "31",
  },
  {
    codigo: "4212205",
    municipio: "Papanduva",
    estado_codigo: "42",
  },
  {
    codigo: "2207553",
    municipio: "Paquetá",
    estado_codigo: "22",
  },
  {
    codigo: "3303609",
    municipio: "Paracambi",
    estado_codigo: "33",
  },
  {
    codigo: "3147006",
    municipio: "Paracatu",
    estado_codigo: "31",
  },
  {
    codigo: "2310209",
    municipio: "Paracuru",
    estado_codigo: "23",
  },
  {
    codigo: "3147105",
    municipio: "Pará de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "1505502",
    municipio: "Paragominas",
    estado_codigo: "15",
  },
  {
    codigo: "3147204",
    municipio: "Paraguaçu",
    estado_codigo: "31",
  },
  {
    codigo: "3535507",
    municipio: "Paraguaçu Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4314001",
    municipio: "Paraí",
    estado_codigo: "43",
  },
  {
    codigo: "3303708",
    municipio: "Paraíba do Sul",
    estado_codigo: "33",
  },
  {
    codigo: "2107704",
    municipio: "Paraibano",
    estado_codigo: "21",
  },
  {
    codigo: "3535606",
    municipio: "Paraibuna",
    estado_codigo: "35",
  },
  {
    codigo: "2310258",
    municipio: "Paraipaba",
    estado_codigo: "23",
  },
  {
    codigo: "3535705",
    municipio: "Paraíso",
    estado_codigo: "35",
  },
  {
    codigo: "4212239",
    municipio: "Paraíso",
    estado_codigo: "42",
  },
  {
    codigo: "5006275",
    municipio: "Paraíso das Águas",
    estado_codigo: "50",
  },
  {
    codigo: "4118006",
    municipio: "Paraíso do Norte",
    estado_codigo: "41",
  },
  {
    codigo: "4314027",
    municipio: "Paraíso do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "1716109",
    municipio: "Paraíso do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "3147303",
    municipio: "Paraisópolis",
    estado_codigo: "31",
  },
  {
    codigo: "2310308",
    municipio: "Parambu",
    estado_codigo: "23",
  },
  {
    codigo: "2923605",
    municipio: "Paramirim",
    estado_codigo: "29",
  },
  {
    codigo: "2310407",
    municipio: "Paramoti",
    estado_codigo: "23",
  },
  {
    codigo: "2408607",
    municipio: "Paraná",
    estado_codigo: "24",
  },
  {
    codigo: "1716208",
    municipio: "Paranã",
    estado_codigo: "17",
  },
  {
    codigo: "4118105",
    municipio: "Paranacity",
    estado_codigo: "41",
  },
  {
    codigo: "4118204",
    municipio: "Paranaguá",
    estado_codigo: "41",
  },
  {
    codigo: "5006309",
    municipio: "Paranaíba",
    estado_codigo: "50",
  },
  {
    codigo: "5216304",
    municipio: "Paranaiguara",
    estado_codigo: "52",
  },
  {
    codigo: "5106299",
    municipio: "Paranaíta",
    estado_codigo: "51",
  },
  {
    codigo: "3535804",
    municipio: "Paranapanema",
    estado_codigo: "35",
  },
  {
    codigo: "4118303",
    municipio: "Paranapoema",
    estado_codigo: "41",
  },
  {
    codigo: "3535903",
    municipio: "Paranapuã",
    estado_codigo: "35",
  },
  {
    codigo: "2610301",
    municipio: "Paranatama",
    estado_codigo: "26",
  },
  {
    codigo: "5106307",
    municipio: "Paranatinga",
    estado_codigo: "51",
  },
  {
    codigo: "4118402",
    municipio: "Paranavaí",
    estado_codigo: "41",
  },
  {
    codigo: "5006358",
    municipio: "Paranhos",
    estado_codigo: "50",
  },
  {
    codigo: "3147402",
    municipio: "Paraopeba",
    estado_codigo: "31",
  },
  {
    codigo: "3536000",
    municipio: "Parapuã",
    estado_codigo: "35",
  },
  {
    codigo: "2510659",
    municipio: "Parari",
    estado_codigo: "25",
  },
  {
    codigo: "3303807",
    municipio: "Parati",
    estado_codigo: "33",
  },
  {
    codigo: "2923704",
    municipio: "Paratinga",
    estado_codigo: "29",
  },
  {
    codigo: "2408706",
    municipio: "Paraú",
    estado_codigo: "24",
  },
  {
    codigo: "1505536",
    municipio: "Parauapebas",
    estado_codigo: "15",
  },
  {
    codigo: "5216403",
    municipio: "Paraúna",
    estado_codigo: "52",
  },
  {
    codigo: "2408805",
    municipio: "Parazinho",
    estado_codigo: "24",
  },
  {
    codigo: "3536109",
    municipio: "Pardinho",
    estado_codigo: "35",
  },
  {
    codigo: "4314035",
    municipio: "Pareci Novo",
    estado_codigo: "43",
  },
  {
    codigo: "1101450",
    municipio: "Parecis",
    estado_codigo: "11",
  },
  {
    codigo: "2408904",
    municipio: "Parelhas",
    estado_codigo: "24",
  },
  {
    codigo: "2706422",
    municipio: "Pariconha",
    estado_codigo: "27",
  },
  {
    codigo: "1303403",
    municipio: "Parintins",
    estado_codigo: "13",
  },
  {
    codigo: "2923803",
    municipio: "Paripiranga",
    estado_codigo: "29",
  },
  {
    codigo: "2706448",
    municipio: "Paripueira",
    estado_codigo: "27",
  },
  {
    codigo: "3536208",
    municipio: "Pariquera-Açu",
    estado_codigo: "35",
  },
  {
    codigo: "3536257",
    municipio: "Parisi",
    estado_codigo: "35",
  },
  {
    codigo: "2207603",
    municipio: "Parnaguá",
    estado_codigo: "22",
  },
  {
    codigo: "2207702",
    municipio: "Parnaíba",
    estado_codigo: "22",
  },
  {
    codigo: "2610400",
    municipio: "Parnamirim",
    estado_codigo: "26",
  },
  {
    codigo: "2403251",
    municipio: "Parnamirim",
    estado_codigo: "24",
  },
  {
    codigo: "2107803",
    municipio: "Parnarama",
    estado_codigo: "21",
  },
  {
    codigo: "4314050",
    municipio: "Parobé",
    estado_codigo: "43",
  },
  {
    codigo: "3147501",
    municipio: "Passabém",
    estado_codigo: "31",
  },
  {
    codigo: "2409100",
    municipio: "Passa e Fica",
    estado_codigo: "24",
  },
  {
    codigo: "2510709",
    municipio: "Passagem",
    estado_codigo: "25",
  },
  {
    codigo: "2409209",
    municipio: "Passagem",
    estado_codigo: "24",
  },
  {
    codigo: "2107902",
    municipio: "Passagem Franca",
    estado_codigo: "21",
  },
  {
    codigo: "2207751",
    municipio: "Passagem Franca do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3147600",
    municipio: "Passa Quatro",
    estado_codigo: "31",
  },
  {
    codigo: "4314068",
    municipio: "Passa Sete",
    estado_codigo: "43",
  },
  {
    codigo: "3147709",
    municipio: "Passa Tempo",
    estado_codigo: "31",
  },
  {
    codigo: "3147808",
    municipio: "Passa-Vinte",
    estado_codigo: "31",
  },
  {
    codigo: "2610509",
    municipio: "Passira",
    estado_codigo: "26",
  },
  {
    codigo: "2706505",
    municipio: "Passo de Camaragibe",
    estado_codigo: "27",
  },
  {
    codigo: "4212254",
    municipio: "Passo de Torres",
    estado_codigo: "42",
  },
  {
    codigo: "4314076",
    municipio: "Passo do Sobrado",
    estado_codigo: "43",
  },
  {
    codigo: "4314100",
    municipio: "Passo Fundo",
    estado_codigo: "43",
  },
  {
    codigo: "3147907",
    municipio: "Passos",
    estado_codigo: "31",
  },
  {
    codigo: "4212270",
    municipio: "Passos Maia",
    estado_codigo: "42",
  },
  {
    codigo: "2108009",
    municipio: "Pastos Bons",
    estado_codigo: "21",
  },
  {
    codigo: "3147956",
    municipio: "Patis",
    estado_codigo: "31",
  },
  {
    codigo: "4118451",
    municipio: "Pato Bragado",
    estado_codigo: "41",
  },
  {
    codigo: "4118501",
    municipio: "Pato Branco",
    estado_codigo: "41",
  },
  {
    codigo: "2510808",
    municipio: "Patos",
    estado_codigo: "25",
  },
  {
    codigo: "3148004",
    municipio: "Patos de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2207777",
    municipio: "Patos do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3148103",
    municipio: "Patrocínio",
    estado_codigo: "31",
  },
  {
    codigo: "3148202",
    municipio: "Patrocínio do Muriaé",
    estado_codigo: "31",
  },
  {
    codigo: "3536307",
    municipio: "Patrocínio Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "2409308",
    municipio: "Patu",
    estado_codigo: "24",
  },
  {
    codigo: "3303856",
    municipio: "Paty do Alferes",
    estado_codigo: "33",
  },
  {
    codigo: "2923902",
    municipio: "Pau Brasil",
    estado_codigo: "29",
  },
  {
    codigo: "2610608",
    municipio: "Paudalho",
    estado_codigo: "26",
  },
  {
    codigo: "1716307",
    municipio: "Pau D'Arco",
    estado_codigo: "17",
  },
  {
    codigo: "1505551",
    municipio: "Pau D'Arco",
    estado_codigo: "15",
  },
  {
    codigo: "2207793",
    municipio: "Pau D'Arco do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2409407",
    municipio: "Pau dos Ferros",
    estado_codigo: "24",
  },
  {
    codigo: "1303502",
    municipio: "Pauini",
    estado_codigo: "13",
  },
  {
    codigo: "3148301",
    municipio: "Paula Cândido",
    estado_codigo: "31",
  },
  {
    codigo: "4118600",
    municipio: "Paula Freitas",
    estado_codigo: "41",
  },
  {
    codigo: "3536406",
    municipio: "Paulicéia",
    estado_codigo: "35",
  },
  {
    codigo: "3536505",
    municipio: "Paulínia",
    estado_codigo: "35",
  },
  {
    codigo: "2108058",
    municipio: "Paulino Neves",
    estado_codigo: "21",
  },
  {
    codigo: "2510907",
    municipio: "Paulista",
    estado_codigo: "25",
  },
  {
    codigo: "2610707",
    municipio: "Paulista",
    estado_codigo: "26",
  },
  {
    codigo: "2207801",
    municipio: "Paulistana",
    estado_codigo: "22",
  },
  {
    codigo: "3536570",
    municipio: "Paulistânia",
    estado_codigo: "35",
  },
  {
    codigo: "3148400",
    municipio: "Paulistas",
    estado_codigo: "31",
  },
  {
    codigo: "2924009",
    municipio: "Paulo Afonso",
    estado_codigo: "29",
  },
  {
    codigo: "4314134",
    municipio: "Paulo Bento",
    estado_codigo: "43",
  },
  {
    codigo: "3536604",
    municipio: "Paulo de Faria",
    estado_codigo: "35",
  },
  {
    codigo: "4118709",
    municipio: "Paulo Frontin",
    estado_codigo: "41",
  },
  {
    codigo: "2706604",
    municipio: "Paulo Jacinto",
    estado_codigo: "27",
  },
  {
    codigo: "4212304",
    municipio: "Paulo Lopes",
    estado_codigo: "42",
  },
  {
    codigo: "2108108",
    municipio: "Paulo Ramos",
    estado_codigo: "21",
  },
  {
    codigo: "3148509",
    municipio: "Pavão",
    estado_codigo: "31",
  },
  {
    codigo: "4314159",
    municipio: "Paverama",
    estado_codigo: "43",
  },
  {
    codigo: "2207850",
    municipio: "Pavussu",
    estado_codigo: "22",
  },
  {
    codigo: "4118808",
    municipio: "Peabiru",
    estado_codigo: "41",
  },
  {
    codigo: "3148608",
    municipio: "Peçanha",
    estado_codigo: "31",
  },
  {
    codigo: "3536703",
    municipio: "Pederneiras",
    estado_codigo: "35",
  },
  {
    codigo: "2924058",
    municipio: "Pé de Serra",
    estado_codigo: "29",
  },
  {
    codigo: "2610806",
    municipio: "Pedra",
    estado_codigo: "26",
  },
  {
    codigo: "3148707",
    municipio: "Pedra Azul",
    estado_codigo: "31",
  },
  {
    codigo: "3536802",
    municipio: "Pedra Bela",
    estado_codigo: "35",
  },
  {
    codigo: "3148756",
    municipio: "Pedra Bonita",
    estado_codigo: "31",
  },
  {
    codigo: "2511004",
    municipio: "Pedra Branca",
    estado_codigo: "25",
  },
  {
    codigo: "2310506",
    municipio: "Pedra Branca",
    estado_codigo: "23",
  },
  {
    codigo: "1600154",
    municipio: "Pedra Branca do Amapari",
    estado_codigo: "16",
  },
  {
    codigo: "3148806",
    municipio: "Pedra do Anta",
    estado_codigo: "31",
  },
  {
    codigo: "3148905",
    municipio: "Pedra do Indaiá",
    estado_codigo: "31",
  },
  {
    codigo: "3149002",
    municipio: "Pedra Dourada",
    estado_codigo: "31",
  },
  {
    codigo: "2409506",
    municipio: "Pedra Grande",
    estado_codigo: "24",
  },
  {
    codigo: "2511103",
    municipio: "Pedra Lavrada",
    estado_codigo: "25",
  },
  {
    codigo: "3149101",
    municipio: "Pedralva",
    estado_codigo: "31",
  },
  {
    codigo: "2805000",
    municipio: "Pedra Mole",
    estado_codigo: "28",
  },
  {
    codigo: "3536901",
    municipio: "Pedranópolis",
    estado_codigo: "35",
  },
  {
    codigo: "2924108",
    municipio: "Pedrão",
    estado_codigo: "29",
  },
  {
    codigo: "2409605",
    municipio: "Pedra Preta",
    estado_codigo: "24",
  },
  {
    codigo: "5106372",
    municipio: "Pedra Preta",
    estado_codigo: "51",
  },
  {
    codigo: "4314175",
    municipio: "Pedras Altas",
    estado_codigo: "43",
  },
  {
    codigo: "2511202",
    municipio: "Pedras de Fogo",
    estado_codigo: "25",
  },
  {
    codigo: "3149150",
    municipio: "Pedras de Maria da Cruz",
    estado_codigo: "31",
  },
  {
    codigo: "4212403",
    municipio: "Pedras Grandes",
    estado_codigo: "42",
  },
  {
    codigo: "3537008",
    municipio: "Pedregulho",
    estado_codigo: "35",
  },
  {
    codigo: "3537107",
    municipio: "Pedreira",
    estado_codigo: "35",
  },
  {
    codigo: "2108207",
    municipio: "Pedreiras",
    estado_codigo: "21",
  },
  {
    codigo: "2805109",
    municipio: "Pedrinhas",
    estado_codigo: "28",
  },
  {
    codigo: "3537156",
    municipio: "Pedrinhas Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "3149200",
    municipio: "Pedrinópolis",
    estado_codigo: "31",
  },
  {
    codigo: "1716505",
    municipio: "Pedro Afonso",
    estado_codigo: "17",
  },
  {
    codigo: "2924207",
    municipio: "Pedro Alexandre",
    estado_codigo: "29",
  },
  {
    codigo: "2409704",
    municipio: "Pedro Avelino",
    estado_codigo: "24",
  },
  {
    codigo: "3204054",
    municipio: "Pedro Canário",
    estado_codigo: "32",
  },
  {
    codigo: "3537206",
    municipio: "Pedro de Toledo",
    estado_codigo: "35",
  },
  {
    codigo: "2108256",
    municipio: "Pedro do Rosário",
    estado_codigo: "21",
  },
  {
    codigo: "5006408",
    municipio: "Pedro Gomes",
    estado_codigo: "50",
  },
  {
    codigo: "2207900",
    municipio: "Pedro II",
    estado_codigo: "22",
  },
  {
    codigo: "2207934",
    municipio: "Pedro Laurentino",
    estado_codigo: "22",
  },
  {
    codigo: "3149309",
    municipio: "Pedro Leopoldo",
    estado_codigo: "31",
  },
  {
    codigo: "4314209",
    municipio: "Pedro Osório",
    estado_codigo: "43",
  },
  {
    codigo: "2512721",
    municipio: "Pedro Régis",
    estado_codigo: "25",
  },
  {
    codigo: "3149408",
    municipio: "Pedro Teixeira",
    estado_codigo: "31",
  },
  {
    codigo: "2409803",
    municipio: "Pedro Velho",
    estado_codigo: "24",
  },
  {
    codigo: "1716604",
    municipio: "Peixe",
    estado_codigo: "17",
  },
  {
    codigo: "1505601",
    municipio: "Peixe-Boi",
    estado_codigo: "15",
  },
  {
    codigo: "5106422",
    municipio: "Peixoto de Azevedo",
    estado_codigo: "51",
  },
  {
    codigo: "4314308",
    municipio: "Pejuçara",
    estado_codigo: "43",
  },
  {
    codigo: "4314407",
    municipio: "Pelotas",
    estado_codigo: "43",
  },
  {
    codigo: "2310605",
    municipio: "Penaforte",
    estado_codigo: "23",
  },
  {
    codigo: "2108306",
    municipio: "Penalva",
    estado_codigo: "21",
  },
  {
    codigo: "3537305",
    municipio: "Penápolis",
    estado_codigo: "35",
  },
  {
    codigo: "2409902",
    municipio: "Pendências",
    estado_codigo: "24",
  },
  {
    codigo: "2706703",
    municipio: "Penedo",
    estado_codigo: "27",
  },
  {
    codigo: "4212502",
    municipio: "Penha",
    estado_codigo: "42",
  },
  {
    codigo: "2310704",
    municipio: "Pentecoste",
    estado_codigo: "23",
  },
  {
    codigo: "3149507",
    municipio: "Pequeri",
    estado_codigo: "31",
  },
  {
    codigo: "3149606",
    municipio: "Pequi",
    estado_codigo: "31",
  },
  {
    codigo: "1716653",
    municipio: "Pequizeiro",
    estado_codigo: "17",
  },
  {
    codigo: "3149705",
    municipio: "Perdigão",
    estado_codigo: "31",
  },
  {
    codigo: "3149804",
    municipio: "Perdizes",
    estado_codigo: "31",
  },
  {
    codigo: "3149903",
    municipio: "Perdões",
    estado_codigo: "31",
  },
  {
    codigo: "3537404",
    municipio: "Pereira Barreto",
    estado_codigo: "35",
  },
  {
    codigo: "3537503",
    municipio: "Pereiras",
    estado_codigo: "35",
  },
  {
    codigo: "2310803",
    municipio: "Pereiro",
    estado_codigo: "23",
  },
  {
    codigo: "2108405",
    municipio: "Peri Mirim",
    estado_codigo: "21",
  },
  {
    codigo: "3149952",
    municipio: "Periquito",
    estado_codigo: "31",
  },
  {
    codigo: "4212601",
    municipio: "Peritiba",
    estado_codigo: "42",
  },
  {
    codigo: "2108454",
    municipio: "Peritoró",
    estado_codigo: "21",
  },
  {
    codigo: "4118857",
    municipio: "Perobal",
    estado_codigo: "41",
  },
  {
    codigo: "4118907",
    municipio: "Pérola",
    estado_codigo: "41",
  },
  {
    codigo: "4119004",
    municipio: "Pérola d'Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "5216452",
    municipio: "Perolândia",
    estado_codigo: "52",
  },
  {
    codigo: "3537602",
    municipio: "Peruíbe",
    estado_codigo: "35",
  },
  {
    codigo: "3150000",
    municipio: "Pescador",
    estado_codigo: "31",
  },
  {
    codigo: "4212650",
    municipio: "Pescaria Brava",
    estado_codigo: "42",
  },
  {
    codigo: "2610905",
    municipio: "Pesqueira",
    estado_codigo: "26",
  },
  {
    codigo: "4212700",
    municipio: "Petrolândia",
    estado_codigo: "42",
  },
  {
    codigo: "2611002",
    municipio: "Petrolândia",
    estado_codigo: "26",
  },
  {
    codigo: "2611101",
    municipio: "Petrolina",
    estado_codigo: "26",
  },
  {
    codigo: "5216809",
    municipio: "Petrolina de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3303906",
    municipio: "Petrópolis",
    estado_codigo: "33",
  },
  {
    codigo: "2706802",
    municipio: "Piaçabuçu",
    estado_codigo: "27",
  },
  {
    codigo: "3537701",
    municipio: "Piacatu",
    estado_codigo: "35",
  },
  {
    codigo: "2511301",
    municipio: "Piancó",
    estado_codigo: "25",
  },
  {
    codigo: "2924306",
    municipio: "Piatã",
    estado_codigo: "29",
  },
  {
    codigo: "3150109",
    municipio: "Piau",
    estado_codigo: "31",
  },
  {
    codigo: "4314423",
    municipio: "Picada Café",
    estado_codigo: "43",
  },
  {
    codigo: "1505635",
    municipio: "Piçarra",
    estado_codigo: "15",
  },
  {
    codigo: "2208007",
    municipio: "Picos",
    estado_codigo: "22",
  },
  {
    codigo: "2511400",
    municipio: "Picuí",
    estado_codigo: "25",
  },
  {
    codigo: "3537800",
    municipio: "Piedade",
    estado_codigo: "35",
  },
  {
    codigo: "3150158",
    municipio: "Piedade de Caratinga",
    estado_codigo: "31",
  },
  {
    codigo: "3150208",
    municipio: "Piedade de Ponte Nova",
    estado_codigo: "31",
  },
  {
    codigo: "3150307",
    municipio: "Piedade do Rio Grande",
    estado_codigo: "31",
  },
  {
    codigo: "3150406",
    municipio: "Piedade dos Gerais",
    estado_codigo: "31",
  },
  {
    codigo: "4119103",
    municipio: "Piên",
    estado_codigo: "41",
  },
  {
    codigo: "2924405",
    municipio: "Pilão Arcado",
    estado_codigo: "29",
  },
  {
    codigo: "2511509",
    municipio: "Pilar",
    estado_codigo: "25",
  },
  {
    codigo: "2706901",
    municipio: "Pilar",
    estado_codigo: "27",
  },
  {
    codigo: "5216908",
    municipio: "Pilar de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3537909",
    municipio: "Pilar do Sul",
    estado_codigo: "35",
  },
  {
    codigo: "2410009",
    municipio: "Pilões",
    estado_codigo: "24",
  },
  {
    codigo: "2511608",
    municipio: "Pilões",
    estado_codigo: "25",
  },
  {
    codigo: "2511707",
    municipio: "Pilõezinhos",
    estado_codigo: "25",
  },
  {
    codigo: "3150505",
    municipio: "Pimenta",
    estado_codigo: "31",
  },
  {
    codigo: "1100189",
    municipio: "Pimenta Bueno",
    estado_codigo: "11",
  },
  {
    codigo: "2208106",
    municipio: "Pimenteiras",
    estado_codigo: "22",
  },
  {
    codigo: "1101468",
    municipio: "Pimenteiras do Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "2924504",
    municipio: "Pindaí",
    estado_codigo: "29",
  },
  {
    codigo: "3538006",
    municipio: "Pindamonhangaba",
    estado_codigo: "35",
  },
  {
    codigo: "2108504",
    municipio: "Pindaré-Mirim",
    estado_codigo: "21",
  },
  {
    codigo: "2707008",
    municipio: "Pindoba",
    estado_codigo: "27",
  },
  {
    codigo: "2924603",
    municipio: "Pindobaçu",
    estado_codigo: "29",
  },
  {
    codigo: "3538105",
    municipio: "Pindorama",
    estado_codigo: "35",
  },
  {
    codigo: "1717008",
    municipio: "Pindorama do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2310852",
    municipio: "Pindoretama",
    estado_codigo: "23",
  },
  {
    codigo: "3150539",
    municipio: "Pingo-d'Água",
    estado_codigo: "31",
  },
  {
    codigo: "4119152",
    municipio: "Pinhais",
    estado_codigo: "41",
  },
  {
    codigo: "4314456",
    municipio: "Pinhal",
    estado_codigo: "43",
  },
  {
    codigo: "4119202",
    municipio: "Pinhalão",
    estado_codigo: "41",
  },
  {
    codigo: "4314464",
    municipio: "Pinhal da Serra",
    estado_codigo: "43",
  },
  {
    codigo: "4119251",
    municipio: "Pinhal de São Bento",
    estado_codigo: "41",
  },
  {
    codigo: "4314472",
    municipio: "Pinhal Grande",
    estado_codigo: "43",
  },
  {
    codigo: "4212908",
    municipio: "Pinhalzinho",
    estado_codigo: "42",
  },
  {
    codigo: "3538204",
    municipio: "Pinhalzinho",
    estado_codigo: "35",
  },
  {
    codigo: "2805208",
    municipio: "Pinhão",
    estado_codigo: "28",
  },
  {
    codigo: "4119301",
    municipio: "Pinhão",
    estado_codigo: "41",
  },
  {
    codigo: "3303955",
    municipio: "Pinheiral",
    estado_codigo: "33",
  },
  {
    codigo: "4314498",
    municipio: "Pinheirinho do Vale",
    estado_codigo: "43",
  },
  {
    codigo: "2108603",
    municipio: "Pinheiro",
    estado_codigo: "21",
  },
  {
    codigo: "4314506",
    municipio: "Pinheiro Machado",
    estado_codigo: "43",
  },
  {
    codigo: "4213005",
    municipio: "Pinheiro Preto",
    estado_codigo: "42",
  },
  {
    codigo: "3204104",
    municipio: "Pinheiros",
    estado_codigo: "32",
  },
  {
    codigo: "2924652",
    municipio: "Pintadas",
    estado_codigo: "29",
  },
  {
    codigo: "4314548",
    municipio: "Pinto Bandeira",
    estado_codigo: "43",
  },
  {
    codigo: "3150570",
    municipio: "Pintópolis",
    estado_codigo: "31",
  },
  {
    codigo: "2208205",
    municipio: "Pio IX",
    estado_codigo: "22",
  },
  {
    codigo: "2108702",
    municipio: "Pio XII",
    estado_codigo: "21",
  },
  {
    codigo: "3538303",
    municipio: "Piquerobi",
    estado_codigo: "35",
  },
  {
    codigo: "2310902",
    municipio: "Piquet Carneiro",
    estado_codigo: "23",
  },
  {
    codigo: "3538501",
    municipio: "Piquete",
    estado_codigo: "35",
  },
  {
    codigo: "3538600",
    municipio: "Piracaia",
    estado_codigo: "35",
  },
  {
    codigo: "5217104",
    municipio: "Piracanjuba",
    estado_codigo: "52",
  },
  {
    codigo: "3150604",
    municipio: "Piracema",
    estado_codigo: "31",
  },
  {
    codigo: "3538709",
    municipio: "Piracicaba",
    estado_codigo: "35",
  },
  {
    codigo: "2208304",
    municipio: "Piracuruca",
    estado_codigo: "22",
  },
  {
    codigo: "3304003",
    municipio: "Piraí",
    estado_codigo: "33",
  },
  {
    codigo: "2924678",
    municipio: "Piraí do Norte",
    estado_codigo: "29",
  },
  {
    codigo: "4119400",
    municipio: "Piraí do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "3538808",
    municipio: "Piraju",
    estado_codigo: "35",
  },
  {
    codigo: "3150703",
    municipio: "Pirajuba",
    estado_codigo: "31",
  },
  {
    codigo: "3538907",
    municipio: "Pirajuí",
    estado_codigo: "35",
  },
  {
    codigo: "2805307",
    municipio: "Pirambu",
    estado_codigo: "28",
  },
  {
    codigo: "3150802",
    municipio: "Piranga",
    estado_codigo: "31",
  },
  {
    codigo: "3539004",
    municipio: "Pirangi",
    estado_codigo: "35",
  },
  {
    codigo: "3150901",
    municipio: "Piranguçu",
    estado_codigo: "31",
  },
  {
    codigo: "3151008",
    municipio: "Piranguinho",
    estado_codigo: "31",
  },
  {
    codigo: "2707107",
    municipio: "Piranhas",
    estado_codigo: "27",
  },
  {
    codigo: "5217203",
    municipio: "Piranhas",
    estado_codigo: "52",
  },
  {
    codigo: "2108801",
    municipio: "Pirapemas",
    estado_codigo: "21",
  },
  {
    codigo: "3151107",
    municipio: "Pirapetinga",
    estado_codigo: "31",
  },
  {
    codigo: "4314555",
    municipio: "Pirapó",
    estado_codigo: "43",
  },
  {
    codigo: "3151206",
    municipio: "Pirapora",
    estado_codigo: "31",
  },
  {
    codigo: "3539103",
    municipio: "Pirapora do Bom Jesus",
    estado_codigo: "35",
  },
  {
    codigo: "3539202",
    municipio: "Pirapozinho",
    estado_codigo: "35",
  },
  {
    codigo: "4119509",
    municipio: "Piraquara",
    estado_codigo: "41",
  },
  {
    codigo: "1717206",
    municipio: "Piraquê",
    estado_codigo: "17",
  },
  {
    codigo: "3539301",
    municipio: "Pirassununga",
    estado_codigo: "35",
  },
  {
    codigo: "4314605",
    municipio: "Piratini",
    estado_codigo: "43",
  },
  {
    codigo: "3539400",
    municipio: "Piratininga",
    estado_codigo: "35",
  },
  {
    codigo: "4213104",
    municipio: "Piratuba",
    estado_codigo: "42",
  },
  {
    codigo: "3151305",
    municipio: "Piraúba",
    estado_codigo: "31",
  },
  {
    codigo: "5217302",
    municipio: "Pirenópolis",
    estado_codigo: "52",
  },
  {
    codigo: "5217401",
    municipio: "Pires do Rio",
    estado_codigo: "52",
  },
  {
    codigo: "2310951",
    municipio: "Pires Ferreira",
    estado_codigo: "23",
  },
  {
    codigo: "2924702",
    municipio: "Piripá",
    estado_codigo: "29",
  },
  {
    codigo: "2208403",
    municipio: "Piripiri",
    estado_codigo: "22",
  },
  {
    codigo: "2924801",
    municipio: "Piritiba",
    estado_codigo: "29",
  },
  {
    codigo: "2511806",
    municipio: "Pirpirituba",
    estado_codigo: "25",
  },
  {
    codigo: "4119608",
    municipio: "Pitanga",
    estado_codigo: "41",
  },
  {
    codigo: "3539509",
    municipio: "Pitangueiras",
    estado_codigo: "35",
  },
  {
    codigo: "4119657",
    municipio: "Pitangueiras",
    estado_codigo: "41",
  },
  {
    codigo: "3151404",
    municipio: "Pitangui",
    estado_codigo: "31",
  },
  {
    codigo: "2511905",
    municipio: "Pitimbu",
    estado_codigo: "25",
  },
  {
    codigo: "1717503",
    municipio: "Pium",
    estado_codigo: "17",
  },
  {
    codigo: "3204203",
    municipio: "Piúma",
    estado_codigo: "32",
  },
  {
    codigo: "3151503",
    municipio: "Piumhi",
    estado_codigo: "31",
  },
  {
    codigo: "1505650",
    municipio: "Placas",
    estado_codigo: "15",
  },
  {
    codigo: "1200385",
    municipio: "Plácido de Castro",
    estado_codigo: "12",
  },
  {
    codigo: "5217609",
    municipio: "Planaltina",
    estado_codigo: "52",
  },
  {
    codigo: "4119707",
    municipio: "Planaltina do Paraná",
    estado_codigo: "41",
  },
  {
    codigo: "2924900",
    municipio: "Planaltino",
    estado_codigo: "29",
  },
  {
    codigo: "3539608",
    municipio: "Planalto",
    estado_codigo: "35",
  },
  {
    codigo: "4314704",
    municipio: "Planalto",
    estado_codigo: "43",
  },
  {
    codigo: "4119806",
    municipio: "Planalto",
    estado_codigo: "41",
  },
  {
    codigo: "2925006",
    municipio: "Planalto",
    estado_codigo: "29",
  },
  {
    codigo: "4213153",
    municipio: "Planalto Alegre",
    estado_codigo: "42",
  },
  {
    codigo: "5106455",
    municipio: "Planalto da Serra",
    estado_codigo: "51",
  },
  {
    codigo: "3151602",
    municipio: "Planura",
    estado_codigo: "31",
  },
  {
    codigo: "3539707",
    municipio: "Platina",
    estado_codigo: "35",
  },
  {
    codigo: "3539806",
    municipio: "Poá",
    estado_codigo: "35",
  },
  {
    codigo: "2611200",
    municipio: "Poção",
    estado_codigo: "26",
  },
  {
    codigo: "2108900",
    municipio: "Poção de Pedras",
    estado_codigo: "21",
  },
  {
    codigo: "2512002",
    municipio: "Pocinhos",
    estado_codigo: "25",
  },
  {
    codigo: "2410108",
    municipio: "Poço Branco",
    estado_codigo: "24",
  },
  {
    codigo: "2512036",
    municipio: "Poço Dantas",
    estado_codigo: "25",
  },
  {
    codigo: "4314753",
    municipio: "Poço das Antas",
    estado_codigo: "43",
  },
  {
    codigo: "2707206",
    municipio: "Poço das Trincheiras",
    estado_codigo: "27",
  },
  {
    codigo: "2512077",
    municipio: "Poço de José de Moura",
    estado_codigo: "25",
  },
  {
    codigo: "2925105",
    municipio: "Poções",
    estado_codigo: "29",
  },
  {
    codigo: "3151701",
    municipio: "Poço Fundo",
    estado_codigo: "31",
  },
  {
    codigo: "5106505",
    municipio: "Poconé",
    estado_codigo: "51",
  },
  {
    codigo: "2805406",
    municipio: "Poço Redondo",
    estado_codigo: "28",
  },
  {
    codigo: "3151800",
    municipio: "Poços de Caldas",
    estado_codigo: "31",
  },
  {
    codigo: "2805505",
    municipio: "Poço Verde",
    estado_codigo: "28",
  },
  {
    codigo: "3151909",
    municipio: "Pocrane",
    estado_codigo: "31",
  },
  {
    codigo: "2925204",
    municipio: "Pojuca",
    estado_codigo: "29",
  },
  {
    codigo: "3539905",
    municipio: "Poloni",
    estado_codigo: "35",
  },
  {
    codigo: "2512101",
    municipio: "Pombal",
    estado_codigo: "25",
  },
  {
    codigo: "2611309",
    municipio: "Pombos",
    estado_codigo: "26",
  },
  {
    codigo: "4213203",
    municipio: "Pomerode",
    estado_codigo: "42",
  },
  {
    codigo: "3540002",
    municipio: "Pompéia",
    estado_codigo: "35",
  },
  {
    codigo: "3152006",
    municipio: "Pompéu",
    estado_codigo: "31",
  },
  {
    codigo: "3540101",
    municipio: "Pongaí",
    estado_codigo: "35",
  },
  {
    codigo: "1505700",
    municipio: "Ponta de Pedras",
    estado_codigo: "15",
  },
  {
    codigo: "4119905",
    municipio: "Ponta Grossa",
    estado_codigo: "41",
  },
  {
    codigo: "3540200",
    municipio: "Pontal",
    estado_codigo: "35",
  },
  {
    codigo: "5106653",
    municipio: "Pontal do Araguaia",
    estado_codigo: "51",
  },
  {
    codigo: "4119954",
    municipio: "Pontal do Paraná",
    estado_codigo: "41",
  },
  {
    codigo: "5217708",
    municipio: "Pontalina",
    estado_codigo: "52",
  },
  {
    codigo: "3540259",
    municipio: "Pontalinda",
    estado_codigo: "35",
  },
  {
    codigo: "4314779",
    municipio: "Pontão",
    estado_codigo: "43",
  },
  {
    codigo: "5006606",
    municipio: "Ponta Porã",
    estado_codigo: "50",
  },
  {
    codigo: "4213302",
    municipio: "Ponte Alta",
    estado_codigo: "42",
  },
  {
    codigo: "1717800",
    municipio: "Ponte Alta do Bom Jesus",
    estado_codigo: "17",
  },
  {
    codigo: "4213351",
    municipio: "Ponte Alta do Norte",
    estado_codigo: "42",
  },
  {
    codigo: "1717909",
    municipio: "Ponte Alta do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "5106703",
    municipio: "Ponte Branca",
    estado_codigo: "51",
  },
  {
    codigo: "3152105",
    municipio: "Ponte Nova",
    estado_codigo: "31",
  },
  {
    codigo: "4314787",
    municipio: "Ponte Preta",
    estado_codigo: "43",
  },
  {
    codigo: "5106752",
    municipio: "Pontes e Lacerda",
    estado_codigo: "51",
  },
  {
    codigo: "4213401",
    municipio: "Ponte Serrada",
    estado_codigo: "42",
  },
  {
    codigo: "3540309",
    municipio: "Pontes Gestal",
    estado_codigo: "35",
  },
  {
    codigo: "3204252",
    municipio: "Ponto Belo",
    estado_codigo: "32",
  },
  {
    codigo: "3152131",
    municipio: "Ponto Chique",
    estado_codigo: "31",
  },
  {
    codigo: "3152170",
    municipio: "Ponto dos Volantes",
    estado_codigo: "31",
  },
  {
    codigo: "2925253",
    municipio: "Ponto Novo",
    estado_codigo: "29",
  },
  {
    codigo: "3540408",
    municipio: "Populina",
    estado_codigo: "35",
  },
  {
    codigo: "2311009",
    municipio: "Poranga",
    estado_codigo: "23",
  },
  {
    codigo: "3540507",
    municipio: "Porangaba",
    estado_codigo: "35",
  },
  {
    codigo: "5218003",
    municipio: "Porangatu",
    estado_codigo: "52",
  },
  {
    codigo: "3304102",
    municipio: "Porciúncula",
    estado_codigo: "33",
  },
  {
    codigo: "4120002",
    municipio: "Porecatu",
    estado_codigo: "41",
  },
  {
    codigo: "2410207",
    municipio: "Portalegre",
    estado_codigo: "24",
  },
  {
    codigo: "4314803",
    municipio: "Portão",
    estado_codigo: "43",
  },
  {
    codigo: "5218052",
    municipio: "Porteirão",
    estado_codigo: "52",
  },
  {
    codigo: "2311108",
    municipio: "Porteiras",
    estado_codigo: "23",
  },
  {
    codigo: "3152204",
    municipio: "Porteirinha",
    estado_codigo: "31",
  },
  {
    codigo: "1505809",
    municipio: "Portel",
    estado_codigo: "15",
  },
  {
    codigo: "5218102",
    municipio: "Portelândia",
    estado_codigo: "52",
  },
  {
    codigo: "2208502",
    municipio: "Porto",
    estado_codigo: "22",
  },
  {
    codigo: "1200807",
    municipio: "Porto Acre",
    estado_codigo: "12",
  },
  {
    codigo: "4314902",
    municipio: "Porto Alegre",
    estado_codigo: "43",
  },
  {
    codigo: "5106778",
    municipio: "Porto Alegre do Norte",
    estado_codigo: "51",
  },
  {
    codigo: "2208551",
    municipio: "Porto Alegre do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "1718006",
    municipio: "Porto Alegre do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "4120101",
    municipio: "Porto Amazonas",
    estado_codigo: "41",
  },
  {
    codigo: "4120150",
    municipio: "Porto Barreiro",
    estado_codigo: "41",
  },
  {
    codigo: "4213500",
    municipio: "Porto Belo",
    estado_codigo: "42",
  },
  {
    codigo: "2707305",
    municipio: "Porto Calvo",
    estado_codigo: "27",
  },
  {
    codigo: "2805604",
    municipio: "Porto da Folha",
    estado_codigo: "28",
  },
  {
    codigo: "1505908",
    municipio: "Porto de Moz",
    estado_codigo: "15",
  },
  {
    codigo: "2707404",
    municipio: "Porto de Pedras",
    estado_codigo: "27",
  },
  {
    codigo: "2410256",
    municipio: "Porto do Mangue",
    estado_codigo: "24",
  },
  {
    codigo: "5106802",
    municipio: "Porto dos Gaúchos",
    estado_codigo: "51",
  },
  {
    codigo: "5106828",
    municipio: "Porto Esperidião",
    estado_codigo: "51",
  },
  {
    codigo: "5106851",
    municipio: "Porto Estrela",
    estado_codigo: "51",
  },
  {
    codigo: "3540606",
    municipio: "Porto Feliz",
    estado_codigo: "35",
  },
  {
    codigo: "3540705",
    municipio: "Porto Ferreira",
    estado_codigo: "35",
  },
  {
    codigo: "3152303",
    municipio: "Porto Firme",
    estado_codigo: "31",
  },
  {
    codigo: "2109007",
    municipio: "Porto Franco",
    estado_codigo: "21",
  },
  {
    codigo: "1600535",
    municipio: "Porto Grande",
    estado_codigo: "16",
  },
  {
    codigo: "4315008",
    municipio: "Porto Lucena",
    estado_codigo: "43",
  },
  {
    codigo: "4315057",
    municipio: "Porto Mauá",
    estado_codigo: "43",
  },
  {
    codigo: "5006903",
    municipio: "Porto Murtinho",
    estado_codigo: "50",
  },
  {
    codigo: "1718204",
    municipio: "Porto Nacional",
    estado_codigo: "17",
  },
  {
    codigo: "3304110",
    municipio: "Porto Real",
    estado_codigo: "33",
  },
  {
    codigo: "2707503",
    municipio: "Porto Real do Colégio",
    estado_codigo: "27",
  },
  {
    codigo: "4120200",
    municipio: "Porto Rico",
    estado_codigo: "41",
  },
  {
    codigo: "2109056",
    municipio: "Porto Rico do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "2925303",
    municipio: "Porto Seguro",
    estado_codigo: "29",
  },
  {
    codigo: "4213609",
    municipio: "Porto União",
    estado_codigo: "42",
  },
  {
    codigo: "1100205",
    municipio: "Porto Velho",
    estado_codigo: "11",
  },
  {
    codigo: "4315073",
    municipio: "Porto Vera Cruz",
    estado_codigo: "43",
  },
  {
    codigo: "4120309",
    municipio: "Porto Vitória",
    estado_codigo: "41",
  },
  {
    codigo: "1200393",
    municipio: "Porto Walter",
    estado_codigo: "12",
  },
  {
    codigo: "4315107",
    municipio: "Porto Xavier",
    estado_codigo: "43",
  },
  {
    codigo: "5218300",
    municipio: "Posse",
    estado_codigo: "52",
  },
  {
    codigo: "3152402",
    municipio: "Poté",
    estado_codigo: "31",
  },
  {
    codigo: "2311207",
    municipio: "Potengi",
    estado_codigo: "23",
  },
  {
    codigo: "3540754",
    municipio: "Potim",
    estado_codigo: "35",
  },
  {
    codigo: "2925402",
    municipio: "Potiraguá",
    estado_codigo: "29",
  },
  {
    codigo: "3540804",
    municipio: "Potirendaba",
    estado_codigo: "35",
  },
  {
    codigo: "2311231",
    municipio: "Potiretama",
    estado_codigo: "23",
  },
  {
    codigo: "3152501",
    municipio: "Pouso Alegre",
    estado_codigo: "31",
  },
  {
    codigo: "3152600",
    municipio: "Pouso Alto",
    estado_codigo: "31",
  },
  {
    codigo: "4315131",
    municipio: "Pouso Novo",
    estado_codigo: "43",
  },
  {
    codigo: "4213708",
    municipio: "Pouso Redondo",
    estado_codigo: "42",
  },
  {
    codigo: "5107008",
    municipio: "Poxoréo",
    estado_codigo: "51",
  },
  {
    codigo: "3540853",
    municipio: "Pracinha",
    estado_codigo: "35",
  },
  {
    codigo: "1600550",
    municipio: "Pracuúba",
    estado_codigo: "16",
  },
  {
    codigo: "2925501",
    municipio: "Prado",
    estado_codigo: "29",
  },
  {
    codigo: "4120333",
    municipio: "Prado Ferreira",
    estado_codigo: "41",
  },
  {
    codigo: "3540903",
    municipio: "Pradópolis",
    estado_codigo: "35",
  },
  {
    codigo: "3152709",
    municipio: "Prados",
    estado_codigo: "31",
  },
  {
    codigo: "3541000",
    municipio: "Praia Grande",
    estado_codigo: "35",
  },
  {
    codigo: "4213807",
    municipio: "Praia Grande",
    estado_codigo: "42",
  },
  {
    codigo: "1718303",
    municipio: "Praia Norte",
    estado_codigo: "17",
  },
  {
    codigo: "1506005",
    municipio: "Prainha",
    estado_codigo: "15",
  },
  {
    codigo: "4120358",
    municipio: "Pranchita",
    estado_codigo: "41",
  },
  {
    codigo: "3152808",
    municipio: "Prata",
    estado_codigo: "31",
  },
  {
    codigo: "2512200",
    municipio: "Prata",
    estado_codigo: "25",
  },
  {
    codigo: "2208601",
    municipio: "Prata do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3541059",
    municipio: "Pratânia",
    estado_codigo: "35",
  },
  {
    codigo: "3152907",
    municipio: "Pratápolis",
    estado_codigo: "31",
  },
  {
    codigo: "3153004",
    municipio: "Pratinha",
    estado_codigo: "31",
  },
  {
    codigo: "3541109",
    municipio: "Presidente Alves",
    estado_codigo: "35",
  },
  {
    codigo: "3541208",
    municipio: "Presidente Bernardes",
    estado_codigo: "35",
  },
  {
    codigo: "3153103",
    municipio: "Presidente Bernardes",
    estado_codigo: "31",
  },
  {
    codigo: "4213906",
    municipio: "Presidente Castello Branco",
    estado_codigo: "42",
  },
  {
    codigo: "4120408",
    municipio: "Presidente Castelo Branco",
    estado_codigo: "41",
  },
  {
    codigo: "2109106",
    municipio: "Presidente Dutra",
    estado_codigo: "21",
  },
  {
    codigo: "2925600",
    municipio: "Presidente Dutra",
    estado_codigo: "29",
  },
  {
    codigo: "3541307",
    municipio: "Presidente Epitácio",
    estado_codigo: "35",
  },
  {
    codigo: "1303536",
    municipio: "Presidente Figueiredo",
    estado_codigo: "13",
  },
  {
    codigo: "4214003",
    municipio: "Presidente Getúlio",
    estado_codigo: "42",
  },
  {
    codigo: "2925709",
    municipio: "Presidente Jânio Quadros",
    estado_codigo: "29",
  },
  {
    codigo: "2109205",
    municipio: "Presidente Juscelino",
    estado_codigo: "21",
  },
  {
    codigo: "2410306",
    municipio: "Presidente Juscelino",
    estado_codigo: "24",
  },
  {
    codigo: "3153202",
    municipio: "Presidente Juscelino",
    estado_codigo: "31",
  },
  {
    codigo: "3204302",
    municipio: "Presidente Kennedy",
    estado_codigo: "32",
  },
  {
    codigo: "1718402",
    municipio: "Presidente Kennedy",
    estado_codigo: "17",
  },
  {
    codigo: "3153301",
    municipio: "Presidente Kubitschek",
    estado_codigo: "31",
  },
  {
    codigo: "4315149",
    municipio: "Presidente Lucena",
    estado_codigo: "43",
  },
  {
    codigo: "1100254",
    municipio: "Presidente Médici",
    estado_codigo: "11",
  },
  {
    codigo: "2109239",
    municipio: "Presidente Médici",
    estado_codigo: "21",
  },
  {
    codigo: "4214102",
    municipio: "Presidente Nereu",
    estado_codigo: "42",
  },
  {
    codigo: "3153400",
    municipio: "Presidente Olegário",
    estado_codigo: "31",
  },
  {
    codigo: "3541406",
    municipio: "Presidente Prudente",
    estado_codigo: "35",
  },
  {
    codigo: "2109270",
    municipio: "Presidente Sarney",
    estado_codigo: "21",
  },
  {
    codigo: "2925758",
    municipio: "Presidente Tancredo Neves",
    estado_codigo: "29",
  },
  {
    codigo: "2109304",
    municipio: "Presidente Vargas",
    estado_codigo: "21",
  },
  {
    codigo: "3541505",
    municipio: "Presidente Venceslau",
    estado_codigo: "35",
  },
  {
    codigo: "1506104",
    municipio: "Primavera",
    estado_codigo: "15",
  },
  {
    codigo: "2611408",
    municipio: "Primavera",
    estado_codigo: "26",
  },
  {
    codigo: "1101476",
    municipio: "Primavera de Rondônia",
    estado_codigo: "11",
  },
  {
    codigo: "5107040",
    municipio: "Primavera do Leste",
    estado_codigo: "51",
  },
  {
    codigo: "2109403",
    municipio: "Primeira Cruz",
    estado_codigo: "21",
  },
  {
    codigo: "4120507",
    municipio: "Primeiro de Maio",
    estado_codigo: "41",
  },
  {
    codigo: "4214151",
    municipio: "Princesa",
    estado_codigo: "42",
  },
  {
    codigo: "2512309",
    municipio: "Princesa Isabel",
    estado_codigo: "25",
  },
  {
    codigo: "5218391",
    municipio: "Professor Jamil",
    estado_codigo: "52",
  },
  {
    codigo: "4315156",
    municipio: "Progresso",
    estado_codigo: "43",
  },
  {
    codigo: "3541604",
    municipio: "Promissão",
    estado_codigo: "35",
  },
  {
    codigo: "2805703",
    municipio: "Propriá",
    estado_codigo: "28",
  },
  {
    codigo: "4315172",
    municipio: "Protásio Alves",
    estado_codigo: "43",
  },
  {
    codigo: "3153608",
    municipio: "Prudente de Morais",
    estado_codigo: "31",
  },
  {
    codigo: "4120606",
    municipio: "Prudentópolis",
    estado_codigo: "41",
  },
  {
    codigo: "1718451",
    municipio: "Pugmil",
    estado_codigo: "17",
  },
  {
    codigo: "2410405",
    municipio: "Pureza",
    estado_codigo: "24",
  },
  {
    codigo: "4315206",
    municipio: "Putinga",
    estado_codigo: "43",
  },
  {
    codigo: "2512408",
    municipio: "Puxinanã",
    estado_codigo: "25",
  },
  {
    codigo: "3541653",
    municipio: "Quadra",
    estado_codigo: "35",
  },
  {
    codigo: "4315305",
    municipio: "Quaraí",
    estado_codigo: "43",
  },
  {
    codigo: "3153707",
    municipio: "Quartel Geral",
    estado_codigo: "31",
  },
  {
    codigo: "4120655",
    municipio: "Quarto Centenário",
    estado_codigo: "41",
  },
  {
    codigo: "3541703",
    municipio: "Quatá",
    estado_codigo: "35",
  },
  {
    codigo: "4120705",
    municipio: "Quatiguá",
    estado_codigo: "41",
  },
  {
    codigo: "1506112",
    municipio: "Quatipuru",
    estado_codigo: "15",
  },
  {
    codigo: "3304128",
    municipio: "Quatis",
    estado_codigo: "33",
  },
  {
    codigo: "4120804",
    municipio: "Quatro Barras",
    estado_codigo: "41",
  },
  {
    codigo: "4315313",
    municipio: "Quatro Irmãos",
    estado_codigo: "43",
  },
  {
    codigo: "4120853",
    municipio: "Quatro Pontes",
    estado_codigo: "41",
  },
  {
    codigo: "2707602",
    municipio: "Quebrangulo",
    estado_codigo: "27",
  },
  {
    codigo: "4120903",
    municipio: "Quedas do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "2208650",
    municipio: "Queimada Nova",
    estado_codigo: "22",
  },
  {
    codigo: "2512507",
    municipio: "Queimadas",
    estado_codigo: "25",
  },
  {
    codigo: "2925808",
    municipio: "Queimadas",
    estado_codigo: "29",
  },
  {
    codigo: "3304144",
    municipio: "Queimados",
    estado_codigo: "33",
  },
  {
    codigo: "3541802",
    municipio: "Queiroz",
    estado_codigo: "35",
  },
  {
    codigo: "3541901",
    municipio: "Queluz",
    estado_codigo: "35",
  },
  {
    codigo: "3153806",
    municipio: "Queluzito",
    estado_codigo: "31",
  },
  {
    codigo: "5107065",
    municipio: "Querência",
    estado_codigo: "51",
  },
  {
    codigo: "4121000",
    municipio: "Querência do Norte",
    estado_codigo: "41",
  },
  {
    codigo: "4315321",
    municipio: "Quevedos",
    estado_codigo: "43",
  },
  {
    codigo: "2925907",
    municipio: "Quijingue",
    estado_codigo: "29",
  },
  {
    codigo: "4214201",
    municipio: "Quilombo",
    estado_codigo: "42",
  },
  {
    codigo: "4121109",
    municipio: "Quinta do Sol",
    estado_codigo: "41",
  },
  {
    codigo: "3542008",
    municipio: "Quintana",
    estado_codigo: "35",
  },
  {
    codigo: "4315354",
    municipio: "Quinze de Novembro",
    estado_codigo: "43",
  },
  {
    codigo: "2611507",
    municipio: "Quipapá",
    estado_codigo: "26",
  },
  {
    codigo: "5218508",
    municipio: "Quirinópolis",
    estado_codigo: "52",
  },
  {
    codigo: "3304151",
    municipio: "Quissamã",
    estado_codigo: "33",
  },
  {
    codigo: "4121208",
    municipio: "Quitandinha",
    estado_codigo: "41",
  },
  {
    codigo: "2311264",
    municipio: "Quiterianópolis",
    estado_codigo: "23",
  },
  {
    codigo: "2611533",
    municipio: "Quixaba",
    estado_codigo: "26",
  },
  {
    codigo: "2512606",
    municipio: "Quixabá",
    estado_codigo: "25",
  },
  {
    codigo: "2925931",
    municipio: "Quixabeira",
    estado_codigo: "29",
  },
  {
    codigo: "2311306",
    municipio: "Quixadá",
    estado_codigo: "23",
  },
  {
    codigo: "2311355",
    municipio: "Quixelô",
    estado_codigo: "23",
  },
  {
    codigo: "2311405",
    municipio: "Quixeramobim",
    estado_codigo: "23",
  },
  {
    codigo: "2311504",
    municipio: "Quixeré",
    estado_codigo: "23",
  },
  {
    codigo: "2410504",
    municipio: "Rafael Fernandes",
    estado_codigo: "24",
  },
  {
    codigo: "2410603",
    municipio: "Rafael Godeiro",
    estado_codigo: "24",
  },
  {
    codigo: "2925956",
    municipio: "Rafael Jambeiro",
    estado_codigo: "29",
  },
  {
    codigo: "3542107",
    municipio: "Rafard",
    estado_codigo: "35",
  },
  {
    codigo: "4121257",
    municipio: "Ramilândia",
    estado_codigo: "41",
  },
  {
    codigo: "3542206",
    municipio: "Rancharia",
    estado_codigo: "35",
  },
  {
    codigo: "4121307",
    municipio: "Rancho Alegre",
    estado_codigo: "41",
  },
  {
    codigo: "4121356",
    municipio: "Rancho Alegre D'Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "4214300",
    municipio: "Rancho Queimado",
    estado_codigo: "42",
  },
  {
    codigo: "2109452",
    municipio: "Raposa",
    estado_codigo: "21",
  },
  {
    codigo: "3153905",
    municipio: "Raposos",
    estado_codigo: "31",
  },
  {
    codigo: "3154002",
    municipio: "Raul Soares",
    estado_codigo: "31",
  },
  {
    codigo: "4121406",
    municipio: "Realeza",
    estado_codigo: "41",
  },
  {
    codigo: "4121505",
    municipio: "Rebouças",
    estado_codigo: "41",
  },
  {
    codigo: "2611606",
    municipio: "Recife",
    estado_codigo: "26",
  },
  {
    codigo: "3154101",
    municipio: "Recreio",
    estado_codigo: "31",
  },
  {
    codigo: "1718501",
    municipio: "Recursolândia",
    estado_codigo: "17",
  },
  {
    codigo: "1506138",
    municipio: "Redenção",
    estado_codigo: "15",
  },
  {
    codigo: "2311603",
    municipio: "Redenção",
    estado_codigo: "23",
  },
  {
    codigo: "3542305",
    municipio: "Redenção da Serra",
    estado_codigo: "35",
  },
  {
    codigo: "2208700",
    municipio: "Redenção do Gurguéia",
    estado_codigo: "22",
  },
  {
    codigo: "4315404",
    municipio: "Redentora",
    estado_codigo: "43",
  },
  {
    codigo: "3154150",
    municipio: "Reduto",
    estado_codigo: "31",
  },
  {
    codigo: "2208809",
    municipio: "Regeneração",
    estado_codigo: "22",
  },
  {
    codigo: "3542404",
    municipio: "Regente Feijó",
    estado_codigo: "35",
  },
  {
    codigo: "3542503",
    municipio: "Reginópolis",
    estado_codigo: "35",
  },
  {
    codigo: "3542602",
    municipio: "Registro",
    estado_codigo: "35",
  },
  {
    codigo: "4315453",
    municipio: "Relvado",
    estado_codigo: "43",
  },
  {
    codigo: "2926004",
    municipio: "Remanso",
    estado_codigo: "29",
  },
  {
    codigo: "2512705",
    municipio: "Remígio",
    estado_codigo: "25",
  },
  {
    codigo: "4121604",
    municipio: "Renascença",
    estado_codigo: "41",
  },
  {
    codigo: "2311702",
    municipio: "Reriutaba",
    estado_codigo: "23",
  },
  {
    codigo: "3304201",
    municipio: "Resende",
    estado_codigo: "33",
  },
  {
    codigo: "3154200",
    municipio: "Resende Costa",
    estado_codigo: "31",
  },
  {
    codigo: "4121703",
    municipio: "Reserva",
    estado_codigo: "41",
  },
  {
    codigo: "5107156",
    municipio: "Reserva do Cabaçal",
    estado_codigo: "51",
  },
  {
    codigo: "4121752",
    municipio: "Reserva do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "3154309",
    municipio: "Resplendor",
    estado_codigo: "31",
  },
  {
    codigo: "3154408",
    municipio: "Ressaquinha",
    estado_codigo: "31",
  },
  {
    codigo: "3542701",
    municipio: "Restinga",
    estado_codigo: "35",
  },
  {
    codigo: "4315503",
    municipio: "Restinga Seca",
    estado_codigo: "43",
  },
  {
    codigo: "2926103",
    municipio: "Retirolândia",
    estado_codigo: "29",
  },
  {
    codigo: "2109502",
    municipio: "Riachão",
    estado_codigo: "21",
  },
  {
    codigo: "2512747",
    municipio: "Riachão",
    estado_codigo: "25",
  },
  {
    codigo: "2926202",
    municipio: "Riachão das Neves",
    estado_codigo: "29",
  },
  {
    codigo: "2512754",
    municipio: "Riachão do Bacamarte",
    estado_codigo: "25",
  },
  {
    codigo: "2805802",
    municipio: "Riachão do Dantas",
    estado_codigo: "28",
  },
  {
    codigo: "2926301",
    municipio: "Riachão do Jacuípe",
    estado_codigo: "29",
  },
  {
    codigo: "2512762",
    municipio: "Riachão do Poço",
    estado_codigo: "25",
  },
  {
    codigo: "1718550",
    municipio: "Riachinho",
    estado_codigo: "17",
  },
  {
    codigo: "3154457",
    municipio: "Riachinho",
    estado_codigo: "31",
  },
  {
    codigo: "2410702",
    municipio: "Riacho da Cruz",
    estado_codigo: "24",
  },
  {
    codigo: "2611705",
    municipio: "Riacho das Almas",
    estado_codigo: "26",
  },
  {
    codigo: "2926400",
    municipio: "Riacho de Santana",
    estado_codigo: "29",
  },
  {
    codigo: "2410801",
    municipio: "Riacho de Santana",
    estado_codigo: "24",
  },
  {
    codigo: "2512788",
    municipio: "Riacho de Santo Antônio",
    estado_codigo: "25",
  },
  {
    codigo: "2512804",
    municipio: "Riacho dos Cavalos",
    estado_codigo: "25",
  },
  {
    codigo: "3154507",
    municipio: "Riacho dos Machados",
    estado_codigo: "31",
  },
  {
    codigo: "2208858",
    municipio: "Riacho Frio",
    estado_codigo: "22",
  },
  {
    codigo: "2410900",
    municipio: "Riachuelo",
    estado_codigo: "24",
  },
  {
    codigo: "2805901",
    municipio: "Riachuelo",
    estado_codigo: "28",
  },
  {
    codigo: "5218607",
    municipio: "Rialma",
    estado_codigo: "52",
  },
  {
    codigo: "5218706",
    municipio: "Rianápolis",
    estado_codigo: "52",
  },
  {
    codigo: "2109551",
    municipio: "Ribamar Fiquene",
    estado_codigo: "21",
  },
  {
    codigo: "5007109",
    municipio: "Ribas do Rio Pardo",
    estado_codigo: "50",
  },
  {
    codigo: "3542800",
    municipio: "Ribeira",
    estado_codigo: "35",
  },
  {
    codigo: "2926509",
    municipio: "Ribeira do Amparo",
    estado_codigo: "29",
  },
  {
    codigo: "2208874",
    municipio: "Ribeira do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2926608",
    municipio: "Ribeira do Pombal",
    estado_codigo: "29",
  },
  {
    codigo: "2611804",
    municipio: "Ribeirão",
    estado_codigo: "26",
  },
  {
    codigo: "3542909",
    municipio: "Ribeirão Bonito",
    estado_codigo: "35",
  },
  {
    codigo: "3543006",
    municipio: "Ribeirão Branco",
    estado_codigo: "35",
  },
  {
    codigo: "5107180",
    municipio: "Ribeirão Cascalheira",
    estado_codigo: "51",
  },
  {
    codigo: "4121802",
    municipio: "Ribeirão Claro",
    estado_codigo: "41",
  },
  {
    codigo: "3543105",
    municipio: "Ribeirão Corrente",
    estado_codigo: "35",
  },
  {
    codigo: "3154606",
    municipio: "Ribeirão das Neves",
    estado_codigo: "31",
  },
  {
    codigo: "2926657",
    municipio: "Ribeirão do Largo",
    estado_codigo: "29",
  },
  {
    codigo: "4121901",
    municipio: "Ribeirão do Pinhal",
    estado_codigo: "41",
  },
  {
    codigo: "3543238",
    municipio: "Ribeirão dos Índios",
    estado_codigo: "35",
  },
  {
    codigo: "3543204",
    municipio: "Ribeirão do Sul",
    estado_codigo: "35",
  },
  {
    codigo: "3543253",
    municipio: "Ribeirão Grande",
    estado_codigo: "35",
  },
  {
    codigo: "3543303",
    municipio: "Ribeirão Pires",
    estado_codigo: "35",
  },
  {
    codigo: "3543402",
    municipio: "Ribeirão Preto",
    estado_codigo: "35",
  },
  {
    codigo: "3154705",
    municipio: "Ribeirão Vermelho",
    estado_codigo: "31",
  },
  {
    codigo: "5107198",
    municipio: "Ribeirãozinho",
    estado_codigo: "51",
  },
  {
    codigo: "2208908",
    municipio: "Ribeiro Gonçalves",
    estado_codigo: "22",
  },
  {
    codigo: "2806008",
    municipio: "Ribeirópolis",
    estado_codigo: "28",
  },
  {
    codigo: "3543600",
    municipio: "Rifaina",
    estado_codigo: "35",
  },
  {
    codigo: "3543709",
    municipio: "Rincão",
    estado_codigo: "35",
  },
  {
    codigo: "3543808",
    municipio: "Rinópolis",
    estado_codigo: "35",
  },
  {
    codigo: "3154804",
    municipio: "Rio Acima",
    estado_codigo: "31",
  },
  {
    codigo: "4122008",
    municipio: "Rio Azul",
    estado_codigo: "41",
  },
  {
    codigo: "3204351",
    municipio: "Rio Bananal",
    estado_codigo: "32",
  },
  {
    codigo: "4122107",
    municipio: "Rio Bom",
    estado_codigo: "41",
  },
  {
    codigo: "3304300",
    municipio: "Rio Bonito",
    estado_codigo: "33",
  },
  {
    codigo: "4122156",
    municipio: "Rio Bonito do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "5107206",
    municipio: "Rio Branco",
    estado_codigo: "51",
  },
  {
    codigo: "1200401",
    municipio: "Rio Branco",
    estado_codigo: "12",
  },
  {
    codigo: "4122172",
    municipio: "Rio Branco do Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "4122206",
    municipio: "Rio Branco do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "5007208",
    municipio: "Rio Brilhante",
    estado_codigo: "50",
  },
  {
    codigo: "3154903",
    municipio: "Rio Casca",
    estado_codigo: "31",
  },
  {
    codigo: "3304409",
    municipio: "Rio Claro",
    estado_codigo: "33",
  },
  {
    codigo: "3543907",
    municipio: "Rio Claro",
    estado_codigo: "35",
  },
  {
    codigo: "1100262",
    municipio: "Rio Crespo",
    estado_codigo: "11",
  },
  {
    codigo: "1718659",
    municipio: "Rio da Conceição",
    estado_codigo: "17",
  },
  {
    codigo: "4214409",
    municipio: "Rio das Antas",
    estado_codigo: "42",
  },
  {
    codigo: "3304508",
    municipio: "Rio das Flores",
    estado_codigo: "33",
  },
  {
    codigo: "3304524",
    municipio: "Rio das Ostras",
    estado_codigo: "33",
  },
  {
    codigo: "3544004",
    municipio: "Rio das Pedras",
    estado_codigo: "35",
  },
  {
    codigo: "2926707",
    municipio: "Rio de Contas",
    estado_codigo: "29",
  },
  {
    codigo: "3304557",
    municipio: "Rio de Janeiro",
    estado_codigo: "33",
  },
  {
    codigo: "2926806",
    municipio: "Rio do Antônio",
    estado_codigo: "29",
  },
  {
    codigo: "4214508",
    municipio: "Rio do Campo",
    estado_codigo: "42",
  },
  {
    codigo: "3155009",
    municipio: "Rio Doce",
    estado_codigo: "31",
  },
  {
    codigo: "2408953",
    municipio: "Rio do Fogo",
    estado_codigo: "24",
  },
  {
    codigo: "4214607",
    municipio: "Rio do Oeste",
    estado_codigo: "42",
  },
  {
    codigo: "2926905",
    municipio: "Rio do Pires",
    estado_codigo: "29",
  },
  {
    codigo: "3155108",
    municipio: "Rio do Prado",
    estado_codigo: "31",
  },
  {
    codigo: "1718709",
    municipio: "Rio dos Bois",
    estado_codigo: "17",
  },
  {
    codigo: "4214706",
    municipio: "Rio dos Cedros",
    estado_codigo: "42",
  },
  {
    codigo: "4315552",
    municipio: "Rio dos Índios",
    estado_codigo: "43",
  },
  {
    codigo: "4214805",
    municipio: "Rio do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "3155207",
    municipio: "Rio Espera",
    estado_codigo: "31",
  },
  {
    codigo: "2611903",
    municipio: "Rio Formoso",
    estado_codigo: "26",
  },
  {
    codigo: "4214904",
    municipio: "Rio Fortuna",
    estado_codigo: "42",
  },
  {
    codigo: "4315602",
    municipio: "Rio Grande",
    estado_codigo: "43",
  },
  {
    codigo: "3544103",
    municipio: "Rio Grande da Serra",
    estado_codigo: "35",
  },
  {
    codigo: "2209005",
    municipio: "Rio Grande do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3544202",
    municipio: "Riolândia",
    estado_codigo: "35",
  },
  {
    codigo: "2707701",
    municipio: "Rio Largo",
    estado_codigo: "27",
  },
  {
    codigo: "3155306",
    municipio: "Rio Manso",
    estado_codigo: "31",
  },
  {
    codigo: "1506161",
    municipio: "Rio Maria",
    estado_codigo: "15",
  },
  {
    codigo: "4215000",
    municipio: "Rio Negrinho",
    estado_codigo: "42",
  },
  {
    codigo: "4122305",
    municipio: "Rio Negro",
    estado_codigo: "41",
  },
  {
    codigo: "5007307",
    municipio: "Rio Negro",
    estado_codigo: "50",
  },
  {
    codigo: "3155405",
    municipio: "Rio Novo",
    estado_codigo: "31",
  },
  {
    codigo: "3204401",
    municipio: "Rio Novo do Sul",
    estado_codigo: "32",
  },
  {
    codigo: "3155504",
    municipio: "Rio Paranaíba",
    estado_codigo: "31",
  },
  {
    codigo: "4315701",
    municipio: "Rio Pardo",
    estado_codigo: "43",
  },
  {
    codigo: "3155603",
    municipio: "Rio Pardo de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "3155702",
    municipio: "Rio Piracicaba",
    estado_codigo: "31",
  },
  {
    codigo: "3155801",
    municipio: "Rio Pomba",
    estado_codigo: "31",
  },
  {
    codigo: "3155900",
    municipio: "Rio Preto",
    estado_codigo: "31",
  },
  {
    codigo: "1303569",
    municipio: "Rio Preto da Eva",
    estado_codigo: "13",
  },
  {
    codigo: "5218789",
    municipio: "Rio Quente",
    estado_codigo: "52",
  },
  {
    codigo: "2927002",
    municipio: "Rio Real",
    estado_codigo: "29",
  },
  {
    codigo: "4215059",
    municipio: "Rio Rufino",
    estado_codigo: "42",
  },
  {
    codigo: "1718758",
    municipio: "Rio Sono",
    estado_codigo: "17",
  },
  {
    codigo: "2512903",
    municipio: "Rio Tinto",
    estado_codigo: "25",
  },
  {
    codigo: "5218805",
    municipio: "Rio Verde",
    estado_codigo: "52",
  },
  {
    codigo: "5007406",
    municipio: "Rio Verde de Mato Grosso",
    estado_codigo: "50",
  },
  {
    codigo: "3156007",
    municipio: "Rio Vermelho",
    estado_codigo: "31",
  },
  {
    codigo: "4315750",
    municipio: "Riozinho",
    estado_codigo: "43",
  },
  {
    codigo: "4215075",
    municipio: "Riqueza",
    estado_codigo: "42",
  },
  {
    codigo: "3156106",
    municipio: "Ritápolis",
    estado_codigo: "31",
  },
  {
    codigo: "3543501",
    municipio: "Riversul",
    estado_codigo: "35",
  },
  {
    codigo: "4315800",
    municipio: "Roca Sales",
    estado_codigo: "43",
  },
  {
    codigo: "5007505",
    municipio: "Rochedo",
    estado_codigo: "50",
  },
  {
    codigo: "3156205",
    municipio: "Rochedo de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4215109",
    municipio: "Rodeio",
    estado_codigo: "42",
  },
  {
    codigo: "4315909",
    municipio: "Rodeio Bonito",
    estado_codigo: "43",
  },
  {
    codigo: "3156304",
    municipio: "Rodeiro",
    estado_codigo: "31",
  },
  {
    codigo: "2927101",
    municipio: "Rodelas",
    estado_codigo: "29",
  },
  {
    codigo: "2411007",
    municipio: "Rodolfo Fernandes",
    estado_codigo: "24",
  },
  {
    codigo: "1200427",
    municipio: "Rodrigues Alves",
    estado_codigo: "12",
  },
  {
    codigo: "4315958",
    municipio: "Rolador",
    estado_codigo: "43",
  },
  {
    codigo: "4122404",
    municipio: "Rolândia",
    estado_codigo: "41",
  },
  {
    codigo: "4316006",
    municipio: "Rolante",
    estado_codigo: "43",
  },
  {
    codigo: "1100288",
    municipio: "Rolim de Moura",
    estado_codigo: "11",
  },
  {
    codigo: "3156403",
    municipio: "Romaria",
    estado_codigo: "31",
  },
  {
    codigo: "4215208",
    municipio: "Romelândia",
    estado_codigo: "42",
  },
  {
    codigo: "4122503",
    municipio: "Roncador",
    estado_codigo: "41",
  },
  {
    codigo: "4316105",
    municipio: "Ronda Alta",
    estado_codigo: "43",
  },
  {
    codigo: "4316204",
    municipio: "Rondinha",
    estado_codigo: "43",
  },
  {
    codigo: "5107578",
    municipio: "Rondolândia",
    estado_codigo: "51",
  },
  {
    codigo: "4122602",
    municipio: "Rondon",
    estado_codigo: "41",
  },
  {
    codigo: "1506187",
    municipio: "Rondon do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "5107602",
    municipio: "Rondonópolis",
    estado_codigo: "51",
  },
  {
    codigo: "4316303",
    municipio: "Roque Gonzales",
    estado_codigo: "43",
  },
  {
    codigo: "1400472",
    municipio: "Rorainópolis",
    estado_codigo: "14",
  },
  {
    codigo: "3544251",
    municipio: "Rosana",
    estado_codigo: "35",
  },
  {
    codigo: "2109601",
    municipio: "Rosário",
    estado_codigo: "21",
  },
  {
    codigo: "3156452",
    municipio: "Rosário da Limeira",
    estado_codigo: "31",
  },
  {
    codigo: "2806107",
    municipio: "Rosário do Catete",
    estado_codigo: "28",
  },
  {
    codigo: "4122651",
    municipio: "Rosário do Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "4316402",
    municipio: "Rosário do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "5107701",
    municipio: "Rosário Oeste",
    estado_codigo: "51",
  },
  {
    codigo: "3544301",
    municipio: "Roseira",
    estado_codigo: "35",
  },
  {
    codigo: "2707800",
    municipio: "Roteiro",
    estado_codigo: "27",
  },
  {
    codigo: "3156502",
    municipio: "Rubelita",
    estado_codigo: "31",
  },
  {
    codigo: "3544400",
    municipio: "Rubiácea",
    estado_codigo: "35",
  },
  {
    codigo: "5218904",
    municipio: "Rubiataba",
    estado_codigo: "52",
  },
  {
    codigo: "3156601",
    municipio: "Rubim",
    estado_codigo: "31",
  },
  {
    codigo: "3544509",
    municipio: "Rubinéia",
    estado_codigo: "35",
  },
  {
    codigo: "1506195",
    municipio: "Rurópolis",
    estado_codigo: "15",
  },
  {
    codigo: "2311801",
    municipio: "Russas",
    estado_codigo: "23",
  },
  {
    codigo: "2411106",
    municipio: "Ruy Barbosa",
    estado_codigo: "24",
  },
  {
    codigo: "2927200",
    municipio: "Ruy Barbosa",
    estado_codigo: "29",
  },
  {
    codigo: "3156700",
    municipio: "Sabará",
    estado_codigo: "31",
  },
  {
    codigo: "4122701",
    municipio: "Sabáudia",
    estado_codigo: "41",
  },
  {
    codigo: "3544608",
    municipio: "Sabino",
    estado_codigo: "35",
  },
  {
    codigo: "3156809",
    municipio: "Sabinópolis",
    estado_codigo: "31",
  },
  {
    codigo: "2311900",
    municipio: "Saboeiro",
    estado_codigo: "23",
  },
  {
    codigo: "3156908",
    municipio: "Sacramento",
    estado_codigo: "31",
  },
  {
    codigo: "4316428",
    municipio: "Sagrada Família",
    estado_codigo: "43",
  },
  {
    codigo: "3544707",
    municipio: "Sagres",
    estado_codigo: "35",
  },
  {
    codigo: "2612000",
    municipio: "Sairé",
    estado_codigo: "26",
  },
  {
    codigo: "4316436",
    municipio: "Saldanha Marinho",
    estado_codigo: "43",
  },
  {
    codigo: "3544806",
    municipio: "Sales",
    estado_codigo: "35",
  },
  {
    codigo: "3544905",
    municipio: "Sales Oliveira",
    estado_codigo: "35",
  },
  {
    codigo: "3545001",
    municipio: "Salesópolis",
    estado_codigo: "35",
  },
  {
    codigo: "4215307",
    municipio: "Salete",
    estado_codigo: "42",
  },
  {
    codigo: "2513000",
    municipio: "Salgadinho",
    estado_codigo: "25",
  },
  {
    codigo: "2612109",
    municipio: "Salgadinho",
    estado_codigo: "26",
  },
  {
    codigo: "2806206",
    municipio: "Salgado",
    estado_codigo: "28",
  },
  {
    codigo: "2513109",
    municipio: "Salgado de São Félix",
    estado_codigo: "25",
  },
  {
    codigo: "4122800",
    municipio: "Salgado Filho",
    estado_codigo: "41",
  },
  {
    codigo: "2612208",
    municipio: "Salgueiro",
    estado_codigo: "26",
  },
  {
    codigo: "3157005",
    municipio: "Salinas",
    estado_codigo: "31",
  },
  {
    codigo: "2927309",
    municipio: "Salinas da Margarida",
    estado_codigo: "29",
  },
  {
    codigo: "1506203",
    municipio: "Salinópolis",
    estado_codigo: "15",
  },
  {
    codigo: "2311959",
    municipio: "Salitre",
    estado_codigo: "23",
  },
  {
    codigo: "3545100",
    municipio: "Salmourão",
    estado_codigo: "35",
  },
  {
    codigo: "2612307",
    municipio: "Saloá",
    estado_codigo: "26",
  },
  {
    codigo: "3545159",
    municipio: "Saltinho",
    estado_codigo: "35",
  },
  {
    codigo: "4215356",
    municipio: "Saltinho",
    estado_codigo: "42",
  },
  {
    codigo: "3545209",
    municipio: "Salto",
    estado_codigo: "35",
  },
  {
    codigo: "3157104",
    municipio: "Salto da Divisa",
    estado_codigo: "31",
  },
  {
    codigo: "3545308",
    municipio: "Salto de Pirapora",
    estado_codigo: "35",
  },
  {
    codigo: "5107750",
    municipio: "Salto do Céu",
    estado_codigo: "51",
  },
  {
    codigo: "4122909",
    municipio: "Salto do Itararé",
    estado_codigo: "41",
  },
  {
    codigo: "4316451",
    municipio: "Salto do Jacuí",
    estado_codigo: "43",
  },
  {
    codigo: "4123006",
    municipio: "Salto do Lontra",
    estado_codigo: "41",
  },
  {
    codigo: "3545407",
    municipio: "Salto Grande",
    estado_codigo: "35",
  },
  {
    codigo: "4215406",
    municipio: "Salto Veloso",
    estado_codigo: "42",
  },
  {
    codigo: "2927408",
    municipio: "Salvador",
    estado_codigo: "29",
  },
  {
    codigo: "4316477",
    municipio: "Salvador das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "4316501",
    municipio: "Salvador do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "1506302",
    municipio: "Salvaterra",
    estado_codigo: "15",
  },
  {
    codigo: "2109700",
    municipio: "Sambaíba",
    estado_codigo: "21",
  },
  {
    codigo: "1718808",
    municipio: "Sampaio",
    estado_codigo: "17",
  },
  {
    codigo: "4316600",
    municipio: "Sananduva",
    estado_codigo: "43",
  },
  {
    codigo: "5219001",
    municipio: "Sanclerlândia",
    estado_codigo: "52",
  },
  {
    codigo: "1718840",
    municipio: "Sandolândia",
    estado_codigo: "17",
  },
  {
    codigo: "3545506",
    municipio: "Sandovalina",
    estado_codigo: "35",
  },
  {
    codigo: "4215455",
    municipio: "Sangão",
    estado_codigo: "42",
  },
  {
    codigo: "2612406",
    municipio: "Sanharó",
    estado_codigo: "26",
  },
  {
    codigo: "3545605",
    municipio: "Santa Adélia",
    estado_codigo: "35",
  },
  {
    codigo: "3545704",
    municipio: "Santa Albertina",
    estado_codigo: "35",
  },
  {
    codigo: "4123105",
    municipio: "Santa Amélia",
    estado_codigo: "41",
  },
  {
    codigo: "3157203",
    municipio: "Santa Bárbara",
    estado_codigo: "31",
  },
  {
    codigo: "2927507",
    municipio: "Santa Bárbara",
    estado_codigo: "29",
  },
  {
    codigo: "5219100",
    municipio: "Santa Bárbara de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3545803",
    municipio: "Santa Bárbara d'Oeste",
    estado_codigo: "35",
  },
  {
    codigo: "3157252",
    municipio: "Santa Bárbara do Leste",
    estado_codigo: "31",
  },
  {
    codigo: "3157278",
    municipio: "Santa Bárbara do Monte Verde",
    estado_codigo: "31",
  },
  {
    codigo: "1506351",
    municipio: "Santa Bárbara do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "4316709",
    municipio: "Santa Bárbara do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3157302",
    municipio: "Santa Bárbara do Tugúrio",
    estado_codigo: "31",
  },
  {
    codigo: "3546009",
    municipio: "Santa Branca",
    estado_codigo: "35",
  },
  {
    codigo: "2927606",
    municipio: "Santa Brígida",
    estado_codigo: "29",
  },
  {
    codigo: "5107248",
    municipio: "Santa Carmem",
    estado_codigo: "51",
  },
  {
    codigo: "2513158",
    municipio: "Santa Cecília",
    estado_codigo: "25",
  },
  {
    codigo: "4215505",
    municipio: "Santa Cecília",
    estado_codigo: "42",
  },
  {
    codigo: "4123204",
    municipio: "Santa Cecília do Pavão",
    estado_codigo: "41",
  },
  {
    codigo: "4316733",
    municipio: "Santa Cecília do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3546108",
    municipio: "Santa Clara d'Oeste",
    estado_codigo: "35",
  },
  {
    codigo: "4316758",
    municipio: "Santa Clara do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2411205",
    municipio: "Santa Cruz",
    estado_codigo: "24",
  },
  {
    codigo: "2513208",
    municipio: "Santa Cruz",
    estado_codigo: "25",
  },
  {
    codigo: "2612455",
    municipio: "Santa Cruz",
    estado_codigo: "26",
  },
  {
    codigo: "2927705",
    municipio: "Santa Cruz Cabrália",
    estado_codigo: "29",
  },
  {
    codigo: "2612471",
    municipio: "Santa Cruz da Baixa Verde",
    estado_codigo: "26",
  },
  {
    codigo: "3546207",
    municipio: "Santa Cruz da Conceição",
    estado_codigo: "35",
  },
  {
    codigo: "3546256",
    municipio: "Santa Cruz da Esperança",
    estado_codigo: "35",
  },
  {
    codigo: "3546306",
    municipio: "Santa Cruz das Palmeiras",
    estado_codigo: "35",
  },
  {
    codigo: "2927804",
    municipio: "Santa Cruz da Vitória",
    estado_codigo: "29",
  },
  {
    codigo: "5219209",
    municipio: "Santa Cruz de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3157336",
    municipio: "Santa Cruz de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4123303",
    municipio: "Santa Cruz de Monte Castelo",
    estado_codigo: "41",
  },
  {
    codigo: "3157377",
    municipio: "Santa Cruz de Salinas",
    estado_codigo: "31",
  },
  {
    codigo: "1506401",
    municipio: "Santa Cruz do Arari",
    estado_codigo: "15",
  },
  {
    codigo: "2612505",
    municipio: "Santa Cruz do Capibaribe",
    estado_codigo: "26",
  },
  {
    codigo: "3157401",
    municipio: "Santa Cruz do Escalvado",
    estado_codigo: "31",
  },
  {
    codigo: "2209104",
    municipio: "Santa Cruz do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3546405",
    municipio: "Santa Cruz do Rio Pardo",
    estado_codigo: "35",
  },
  {
    codigo: "2209153",
    municipio: "Santa Cruz dos Milagres",
    estado_codigo: "22",
  },
  {
    codigo: "4316808",
    municipio: "Santa Cruz do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "5107743",
    municipio: "Santa Cruz do Xingu",
    estado_codigo: "51",
  },
  {
    codigo: "3157500",
    municipio: "Santa Efigênia de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "3546504",
    municipio: "Santa Ernestina",
    estado_codigo: "35",
  },
  {
    codigo: "4123402",
    municipio: "Santa Fé",
    estado_codigo: "41",
  },
  {
    codigo: "5219258",
    municipio: "Santa Fé de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3157609",
    municipio: "Santa Fé de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "1718865",
    municipio: "Santa Fé do Araguaia",
    estado_codigo: "17",
  },
  {
    codigo: "3546603",
    municipio: "Santa Fé do Sul",
    estado_codigo: "35",
  },
  {
    codigo: "2209203",
    municipio: "Santa Filomena",
    estado_codigo: "22",
  },
  {
    codigo: "2612554",
    municipio: "Santa Filomena",
    estado_codigo: "26",
  },
  {
    codigo: "2109759",
    municipio: "Santa Filomena do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "3546702",
    municipio: "Santa Gertrudes",
    estado_codigo: "35",
  },
  {
    codigo: "4123501",
    municipio: "Santa Helena",
    estado_codigo: "41",
  },
  {
    codigo: "4215554",
    municipio: "Santa Helena",
    estado_codigo: "42",
  },
  {
    codigo: "2513307",
    municipio: "Santa Helena",
    estado_codigo: "25",
  },
  {
    codigo: "2109809",
    municipio: "Santa Helena",
    estado_codigo: "21",
  },
  {
    codigo: "5219308",
    municipio: "Santa Helena de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3157658",
    municipio: "Santa Helena de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2513356",
    municipio: "Santa Inês",
    estado_codigo: "25",
  },
  {
    codigo: "2109908",
    municipio: "Santa Inês",
    estado_codigo: "21",
  },
  {
    codigo: "4123600",
    municipio: "Santa Inês",
    estado_codigo: "41",
  },
  {
    codigo: "2927903",
    municipio: "Santa Inês",
    estado_codigo: "29",
  },
  {
    codigo: "3546801",
    municipio: "Santa Isabel",
    estado_codigo: "35",
  },
  {
    codigo: "5219357",
    municipio: "Santa Isabel",
    estado_codigo: "52",
  },
  {
    codigo: "4123709",
    municipio: "Santa Isabel do Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "1506500",
    municipio: "Santa Isabel do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "1303601",
    municipio: "Santa Isabel do Rio Negro",
    estado_codigo: "13",
  },
  {
    codigo: "4123808",
    municipio: "Santa Izabel do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "3157708",
    municipio: "Santa Juliana",
    estado_codigo: "31",
  },
  {
    codigo: "3204500",
    municipio: "Santa Leopoldina",
    estado_codigo: "32",
  },
  {
    codigo: "4123824",
    municipio: "Santa Lúcia",
    estado_codigo: "41",
  },
  {
    codigo: "3546900",
    municipio: "Santa Lúcia",
    estado_codigo: "35",
  },
  {
    codigo: "2928000",
    municipio: "Santaluz",
    estado_codigo: "29",
  },
  {
    codigo: "2209302",
    municipio: "Santa Luz",
    estado_codigo: "22",
  },
  {
    codigo: "2110005",
    municipio: "Santa Luzia",
    estado_codigo: "21",
  },
  {
    codigo: "2928059",
    municipio: "Santa Luzia",
    estado_codigo: "29",
  },
  {
    codigo: "2513406",
    municipio: "Santa Luzia",
    estado_codigo: "25",
  },
  {
    codigo: "3157807",
    municipio: "Santa Luzia",
    estado_codigo: "31",
  },
  {
    codigo: "1100296",
    municipio: "Santa Luzia D'Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "2806305",
    municipio: "Santa Luzia do Itanhy",
    estado_codigo: "28",
  },
  {
    codigo: "2707909",
    municipio: "Santa Luzia do Norte",
    estado_codigo: "27",
  },
  {
    codigo: "1506559",
    municipio: "Santa Luzia do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "2110039",
    municipio: "Santa Luzia do Paruá",
    estado_codigo: "21",
  },
  {
    codigo: "3157906",
    municipio: "Santa Margarida",
    estado_codigo: "31",
  },
  {
    codigo: "4316972",
    municipio: "Santa Margarida do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4316907",
    municipio: "Santa Maria",
    estado_codigo: "43",
  },
  {
    codigo: "2409332",
    municipio: "Santa Maria",
    estado_codigo: "24",
  },
  {
    codigo: "2612604",
    municipio: "Santa Maria da Boa Vista",
    estado_codigo: "26",
  },
  {
    codigo: "1506583",
    municipio: "Santa Maria das Barreiras",
    estado_codigo: "15",
  },
  {
    codigo: "3547007",
    municipio: "Santa Maria da Serra",
    estado_codigo: "35",
  },
  {
    codigo: "2928109",
    municipio: "Santa Maria da Vitória",
    estado_codigo: "29",
  },
  {
    codigo: "3158003",
    municipio: "Santa Maria de Itabira",
    estado_codigo: "31",
  },
  {
    codigo: "3204559",
    municipio: "Santa Maria de Jetibá",
    estado_codigo: "32",
  },
  {
    codigo: "2612703",
    municipio: "Santa Maria do Cambucá",
    estado_codigo: "26",
  },
  {
    codigo: "4316956",
    municipio: "Santa Maria do Herval",
    estado_codigo: "43",
  },
  {
    codigo: "4123857",
    municipio: "Santa Maria do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "1506609",
    municipio: "Santa Maria do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "3158102",
    municipio: "Santa Maria do Salto",
    estado_codigo: "31",
  },
  {
    codigo: "3158201",
    municipio: "Santa Maria do Suaçuí",
    estado_codigo: "31",
  },
  {
    codigo: "1718881",
    municipio: "Santa Maria do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "3304607",
    municipio: "Santa Maria Madalena",
    estado_codigo: "33",
  },
  {
    codigo: "4123907",
    municipio: "Santa Mariana",
    estado_codigo: "41",
  },
  {
    codigo: "3547106",
    municipio: "Santa Mercedes",
    estado_codigo: "35",
  },
  {
    codigo: "4123956",
    municipio: "Santa Mônica",
    estado_codigo: "41",
  },
  {
    codigo: "2928208",
    municipio: "Santana",
    estado_codigo: "29",
  },
  {
    codigo: "1600600",
    municipio: "Santana",
    estado_codigo: "16",
  },
  {
    codigo: "4317004",
    municipio: "Santana da Boa Vista",
    estado_codigo: "43",
  },
  {
    codigo: "3547205",
    municipio: "Santana da Ponte Pensa",
    estado_codigo: "35",
  },
  {
    codigo: "3158300",
    municipio: "Santana da Vargem",
    estado_codigo: "31",
  },
  {
    codigo: "3158409",
    municipio: "Santana de Cataguases",
    estado_codigo: "31",
  },
  {
    codigo: "2513505",
    municipio: "Santana de Mangueira",
    estado_codigo: "25",
  },
  {
    codigo: "3547304",
    municipio: "Santana de Parnaíba",
    estado_codigo: "35",
  },
  {
    codigo: "3158508",
    municipio: "Santana de Pirapama",
    estado_codigo: "31",
  },
  {
    codigo: "2312007",
    municipio: "Santana do Acaraú",
    estado_codigo: "23",
  },
  {
    codigo: "1506708",
    municipio: "Santana do Araguaia",
    estado_codigo: "15",
  },
  {
    codigo: "2312106",
    municipio: "Santana do Cariri",
    estado_codigo: "23",
  },
  {
    codigo: "3158607",
    municipio: "Santana do Deserto",
    estado_codigo: "31",
  },
  {
    codigo: "3158706",
    municipio: "Santana do Garambéu",
    estado_codigo: "31",
  },
  {
    codigo: "2708006",
    municipio: "Santana do Ipanema",
    estado_codigo: "27",
  },
  {
    codigo: "4124004",
    municipio: "Santana do Itararé",
    estado_codigo: "41",
  },
  {
    codigo: "3158805",
    municipio: "Santana do Jacaré",
    estado_codigo: "31",
  },
  {
    codigo: "4317103",
    municipio: "Santana do Livramento",
    estado_codigo: "43",
  },
  {
    codigo: "3158904",
    municipio: "Santana do Manhuaçu",
    estado_codigo: "31",
  },
  {
    codigo: "2110237",
    municipio: "Santana do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "2411403",
    municipio: "Santana do Matos",
    estado_codigo: "24",
  },
  {
    codigo: "2708105",
    municipio: "Santana do Mundaú",
    estado_codigo: "27",
  },
  {
    codigo: "3158953",
    municipio: "Santana do Paraíso",
    estado_codigo: "31",
  },
  {
    codigo: "2209351",
    municipio: "Santana do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3159001",
    municipio: "Santana do Riacho",
    estado_codigo: "31",
  },
  {
    codigo: "2806404",
    municipio: "Santana do São Francisco",
    estado_codigo: "28",
  },
  {
    codigo: "2411429",
    municipio: "Santana do Seridó",
    estado_codigo: "24",
  },
  {
    codigo: "2513604",
    municipio: "Santana dos Garrotes",
    estado_codigo: "25",
  },
  {
    codigo: "3159100",
    municipio: "Santana dos Montes",
    estado_codigo: "31",
  },
  {
    codigo: "2928307",
    municipio: "Santanópolis",
    estado_codigo: "29",
  },
  {
    codigo: "2312205",
    municipio: "Santa Quitéria",
    estado_codigo: "23",
  },
  {
    codigo: "2110104",
    municipio: "Santa Quitéria do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "1506807",
    municipio: "Santarém",
    estado_codigo: "15",
  },
  {
    codigo: "2513653",
    municipio: "Santarém",
    estado_codigo: "25",
  },
  {
    codigo: "1506906",
    municipio: "Santarém Novo",
    estado_codigo: "15",
  },
  {
    codigo: "2513703",
    municipio: "Santa Rita",
    estado_codigo: "25",
  },
  {
    codigo: "2110203",
    municipio: "Santa Rita",
    estado_codigo: "21",
  },
  {
    codigo: "3159209",
    municipio: "Santa Rita de Caldas",
    estado_codigo: "31",
  },
  {
    codigo: "2928406",
    municipio: "Santa Rita de Cássia",
    estado_codigo: "29",
  },
  {
    codigo: "3159407",
    municipio: "Santa Rita de Ibitipoca",
    estado_codigo: "31",
  },
  {
    codigo: "3159308",
    municipio: "Santa Rita de Jacutinga",
    estado_codigo: "31",
  },
  {
    codigo: "3159357",
    municipio: "Santa Rita de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "5219407",
    municipio: "Santa Rita do Araguaia",
    estado_codigo: "52",
  },
  {
    codigo: "3547403",
    municipio: "Santa Rita d'Oeste",
    estado_codigo: "35",
  },
  {
    codigo: "3159506",
    municipio: "Santa Rita do Itueto",
    estado_codigo: "31",
  },
  {
    codigo: "5219456",
    municipio: "Santa Rita do Novo Destino",
    estado_codigo: "52",
  },
  {
    codigo: "5007554",
    municipio: "Santa Rita do Pardo",
    estado_codigo: "50",
  },
  {
    codigo: "3547502",
    municipio: "Santa Rita do Passa Quatro",
    estado_codigo: "35",
  },
  {
    codigo: "3159605",
    municipio: "Santa Rita do Sapucaí",
    estado_codigo: "31",
  },
  {
    codigo: "1718899",
    municipio: "Santa Rita do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "5107768",
    municipio: "Santa Rita do Trivelato",
    estado_codigo: "51",
  },
  {
    codigo: "4317202",
    municipio: "Santa Rosa",
    estado_codigo: "43",
  },
  {
    codigo: "3159704",
    municipio: "Santa Rosa da Serra",
    estado_codigo: "31",
  },
  {
    codigo: "5219506",
    municipio: "Santa Rosa de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "2806503",
    municipio: "Santa Rosa de Lima",
    estado_codigo: "28",
  },
  {
    codigo: "4215604",
    municipio: "Santa Rosa de Lima",
    estado_codigo: "42",
  },
  {
    codigo: "3547601",
    municipio: "Santa Rosa de Viterbo",
    estado_codigo: "35",
  },
  {
    codigo: "2209377",
    municipio: "Santa Rosa do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "1200435",
    municipio: "Santa Rosa do Purus",
    estado_codigo: "12",
  },
  {
    codigo: "4215653",
    municipio: "Santa Rosa do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "1718907",
    municipio: "Santa Rosa do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "3547650",
    municipio: "Santa Salete",
    estado_codigo: "35",
  },
  {
    codigo: "3204609",
    municipio: "Santa Teresa",
    estado_codigo: "32",
  },
  {
    codigo: "2928505",
    municipio: "Santa Teresinha",
    estado_codigo: "29",
  },
  {
    codigo: "2513802",
    municipio: "Santa Teresinha",
    estado_codigo: "25",
  },
  {
    codigo: "4317251",
    municipio: "Santa Tereza",
    estado_codigo: "43",
  },
  {
    codigo: "5219605",
    municipio: "Santa Tereza de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "4124020",
    municipio: "Santa Tereza do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "1719004",
    municipio: "Santa Tereza do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2612802",
    municipio: "Santa Terezinha",
    estado_codigo: "26",
  },
  {
    codigo: "5107776",
    municipio: "Santa Terezinha",
    estado_codigo: "51",
  },
  {
    codigo: "4215679",
    municipio: "Santa Terezinha",
    estado_codigo: "42",
  },
  {
    codigo: "5219704",
    municipio: "Santa Terezinha de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "4124053",
    municipio: "Santa Terezinha de Itaipu",
    estado_codigo: "41",
  },
  {
    codigo: "4215687",
    municipio: "Santa Terezinha do Progresso",
    estado_codigo: "42",
  },
  {
    codigo: "1720002",
    municipio: "Santa Terezinha do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "3159803",
    municipio: "Santa Vitória",
    estado_codigo: "31",
  },
  {
    codigo: "4317301",
    municipio: "Santa Vitória do Palmar",
    estado_codigo: "43",
  },
  {
    codigo: "4317400",
    municipio: "Santiago",
    estado_codigo: "43",
  },
  {
    codigo: "4215695",
    municipio: "Santiago do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "5107263",
    municipio: "Santo Afonso",
    estado_codigo: "51",
  },
  {
    codigo: "2928604",
    municipio: "Santo Amaro",
    estado_codigo: "29",
  },
  {
    codigo: "4215703",
    municipio: "Santo Amaro da Imperatriz",
    estado_codigo: "42",
  },
  {
    codigo: "2806602",
    municipio: "Santo Amaro das Brotas",
    estado_codigo: "28",
  },
  {
    codigo: "2110278",
    municipio: "Santo Amaro do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "3547700",
    municipio: "Santo Anastácio",
    estado_codigo: "35",
  },
  {
    codigo: "2513851",
    municipio: "Santo André",
    estado_codigo: "25",
  },
  {
    codigo: "3547809",
    municipio: "Santo André",
    estado_codigo: "35",
  },
  {
    codigo: "4317509",
    municipio: "Santo Ângelo",
    estado_codigo: "43",
  },
  {
    codigo: "2411502",
    municipio: "Santo Antônio",
    estado_codigo: "24",
  },
  {
    codigo: "3547908",
    municipio: "Santo Antônio da Alegria",
    estado_codigo: "35",
  },
  {
    codigo: "5219712",
    municipio: "Santo Antônio da Barra",
    estado_codigo: "52",
  },
  {
    codigo: "4317608",
    municipio: "Santo Antônio da Patrulha",
    estado_codigo: "43",
  },
  {
    codigo: "4124103",
    municipio: "Santo Antônio da Platina",
    estado_codigo: "41",
  },
  {
    codigo: "4317707",
    municipio: "Santo Antônio das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "5219738",
    municipio: "Santo Antônio de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "2928703",
    municipio: "Santo Antônio de Jesus",
    estado_codigo: "29",
  },
  {
    codigo: "2209401",
    municipio: "Santo Antônio de Lisboa",
    estado_codigo: "22",
  },
  {
    codigo: "3304706",
    municipio: "Santo Antônio de Pádua",
    estado_codigo: "33",
  },
  {
    codigo: "3548005",
    municipio: "Santo Antônio de Posse",
    estado_codigo: "35",
  },
  {
    codigo: "3159902",
    municipio: "Santo Antônio do Amparo",
    estado_codigo: "31",
  },
  {
    codigo: "3548054",
    municipio: "Santo Antônio do Aracanguá",
    estado_codigo: "35",
  },
  {
    codigo: "3160009",
    municipio: "Santo Antônio do Aventureiro",
    estado_codigo: "31",
  },
  {
    codigo: "4124202",
    municipio: "Santo Antônio do Caiuá",
    estado_codigo: "41",
  },
  {
    codigo: "5219753",
    municipio: "Santo Antônio do Descoberto",
    estado_codigo: "52",
  },
  {
    codigo: "3160108",
    municipio: "Santo Antônio do Grama",
    estado_codigo: "31",
  },
  {
    codigo: "1303700",
    municipio: "Santo Antônio do Içá",
    estado_codigo: "13",
  },
  {
    codigo: "3160207",
    municipio: "Santo Antônio do Itambé",
    estado_codigo: "31",
  },
  {
    codigo: "3160306",
    municipio: "Santo Antônio do Jacinto",
    estado_codigo: "31",
  },
  {
    codigo: "3548104",
    municipio: "Santo Antônio do Jardim",
    estado_codigo: "35",
  },
  {
    codigo: "5107792",
    municipio: "Santo Antônio do Leste",
    estado_codigo: "51",
  },
  {
    codigo: "5107800",
    municipio: "Santo Antônio do Leverger",
    estado_codigo: "51",
  },
  {
    codigo: "3160405",
    municipio: "Santo Antônio do Monte",
    estado_codigo: "31",
  },
  {
    codigo: "4317558",
    municipio: "Santo Antônio do Palma",
    estado_codigo: "43",
  },
  {
    codigo: "4124301",
    municipio: "Santo Antônio do Paraíso",
    estado_codigo: "41",
  },
  {
    codigo: "3548203",
    municipio: "Santo Antônio do Pinhal",
    estado_codigo: "35",
  },
  {
    codigo: "4317756",
    municipio: "Santo Antônio do Planalto",
    estado_codigo: "43",
  },
  {
    codigo: "3160454",
    municipio: "Santo Antônio do Retiro",
    estado_codigo: "31",
  },
  {
    codigo: "3160504",
    municipio: "Santo Antônio do Rio Abaixo",
    estado_codigo: "31",
  },
  {
    codigo: "2110302",
    municipio: "Santo Antônio dos Lopes",
    estado_codigo: "21",
  },
  {
    codigo: "2209450",
    municipio: "Santo Antônio dos Milagres",
    estado_codigo: "22",
  },
  {
    codigo: "4124400",
    municipio: "Santo Antônio do Sudoeste",
    estado_codigo: "41",
  },
  {
    codigo: "1507003",
    municipio: "Santo Antônio do Tauá",
    estado_codigo: "15",
  },
  {
    codigo: "4317806",
    municipio: "Santo Augusto",
    estado_codigo: "43",
  },
  {
    codigo: "4317905",
    municipio: "Santo Cristo",
    estado_codigo: "43",
  },
  {
    codigo: "2928802",
    municipio: "Santo Estêvão",
    estado_codigo: "29",
  },
  {
    codigo: "3548302",
    municipio: "Santo Expedito",
    estado_codigo: "35",
  },
  {
    codigo: "4317954",
    municipio: "Santo Expedito do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3160603",
    municipio: "Santo Hipólito",
    estado_codigo: "31",
  },
  {
    codigo: "4124509",
    municipio: "Santo Inácio",
    estado_codigo: "41",
  },
  {
    codigo: "2209500",
    municipio: "Santo Inácio do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3548401",
    municipio: "Santópolis do Aguapeí",
    estado_codigo: "35",
  },
  {
    codigo: "3548500",
    municipio: "Santos",
    estado_codigo: "35",
  },
  {
    codigo: "3160702",
    municipio: "Santos Dumont",
    estado_codigo: "31",
  },
  {
    codigo: "2312304",
    municipio: "São Benedito",
    estado_codigo: "23",
  },
  {
    codigo: "2110401",
    municipio: "São Benedito do Rio Preto",
    estado_codigo: "21",
  },
  {
    codigo: "2612901",
    municipio: "São Benedito do Sul",
    estado_codigo: "26",
  },
  {
    codigo: "2513927",
    municipio: "São Bentinho",
    estado_codigo: "25",
  },
  {
    codigo: "2513901",
    municipio: "São Bento",
    estado_codigo: "25",
  },
  {
    codigo: "2110500",
    municipio: "São Bento",
    estado_codigo: "21",
  },
  {
    codigo: "3160801",
    municipio: "São Bento Abade",
    estado_codigo: "31",
  },
  {
    codigo: "2411601",
    municipio: "São Bento do Norte",
    estado_codigo: "24",
  },
  {
    codigo: "3548609",
    municipio: "São Bento do Sapucaí",
    estado_codigo: "35",
  },
  {
    codigo: "4215802",
    municipio: "São Bento do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "1720101",
    municipio: "São Bento do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2411700",
    municipio: "São Bento do Trairí",
    estado_codigo: "24",
  },
  {
    codigo: "2613008",
    municipio: "São Bento do Una",
    estado_codigo: "26",
  },
  {
    codigo: "4215752",
    municipio: "São Bernardino",
    estado_codigo: "42",
  },
  {
    codigo: "2110609",
    municipio: "São Bernardo",
    estado_codigo: "21",
  },
  {
    codigo: "3548708",
    municipio: "São Bernardo do Campo",
    estado_codigo: "35",
  },
  {
    codigo: "4215901",
    municipio: "São Bonifácio",
    estado_codigo: "42",
  },
  {
    codigo: "4318002",
    municipio: "São Borja",
    estado_codigo: "43",
  },
  {
    codigo: "2708204",
    municipio: "São Brás",
    estado_codigo: "27",
  },
  {
    codigo: "3160900",
    municipio: "São Brás do Suaçuí",
    estado_codigo: "31",
  },
  {
    codigo: "2209559",
    municipio: "São Braz do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "1507102",
    municipio: "São Caetano de Odivelas",
    estado_codigo: "15",
  },
  {
    codigo: "3548807",
    municipio: "São Caetano do Sul",
    estado_codigo: "35",
  },
  {
    codigo: "2613107",
    municipio: "São Caitano",
    estado_codigo: "26",
  },
  {
    codigo: "4216008",
    municipio: "São Carlos",
    estado_codigo: "42",
  },
  {
    codigo: "3548906",
    municipio: "São Carlos",
    estado_codigo: "35",
  },
  {
    codigo: "4124608",
    municipio: "São Carlos do Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "2806701",
    municipio: "São Cristóvão",
    estado_codigo: "28",
  },
  {
    codigo: "4216057",
    municipio: "São Cristovão do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "2928901",
    municipio: "São Desidério",
    estado_codigo: "29",
  },
  {
    codigo: "2928950",
    municipio: "São Domingos",
    estado_codigo: "29",
  },
  {
    codigo: "4216107",
    municipio: "São Domingos",
    estado_codigo: "42",
  },
  {
    codigo: "5219803",
    municipio: "São Domingos",
    estado_codigo: "52",
  },
  {
    codigo: "2806800",
    municipio: "São Domingos",
    estado_codigo: "28",
  },
  {
    codigo: "3160959",
    municipio: "São Domingos das Dores",
    estado_codigo: "31",
  },
  {
    codigo: "2513968",
    municipio: "São Domingos de Pombal",
    estado_codigo: "25",
  },
  {
    codigo: "1507151",
    municipio: "São Domingos do Araguaia",
    estado_codigo: "15",
  },
  {
    codigo: "2110658",
    municipio: "São Domingos do Azeitão",
    estado_codigo: "21",
  },
  {
    codigo: "1507201",
    municipio: "São Domingos do Capim",
    estado_codigo: "15",
  },
  {
    codigo: "2513943",
    municipio: "São Domingos do Cariri",
    estado_codigo: "25",
  },
  {
    codigo: "2110708",
    municipio: "São Domingos do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "3204658",
    municipio: "São Domingos do Norte",
    estado_codigo: "32",
  },
  {
    codigo: "3161007",
    municipio: "São Domingos do Prata",
    estado_codigo: "31",
  },
  {
    codigo: "4318051",
    municipio: "São Domingos do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2929107",
    municipio: "São Felipe",
    estado_codigo: "29",
  },
  {
    codigo: "1101484",
    municipio: "São Felipe D'Oeste",
    estado_codigo: "11",
  },
  {
    codigo: "2929008",
    municipio: "São Félix",
    estado_codigo: "29",
  },
  {
    codigo: "2110807",
    municipio: "São Félix de Balsas",
    estado_codigo: "21",
  },
  {
    codigo: "3161056",
    municipio: "São Félix de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "5107859",
    municipio: "São Félix do Araguaia",
    estado_codigo: "51",
  },
  {
    codigo: "2929057",
    municipio: "São Félix do Coribe",
    estado_codigo: "29",
  },
  {
    codigo: "2209609",
    municipio: "São Félix do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "1720150",
    municipio: "São Félix do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "1507300",
    municipio: "São Félix do Xingu",
    estado_codigo: "15",
  },
  {
    codigo: "2411809",
    municipio: "São Fernando",
    estado_codigo: "24",
  },
  {
    codigo: "3304805",
    municipio: "São Fidélis",
    estado_codigo: "33",
  },
  {
    codigo: "3161106",
    municipio: "São Francisco",
    estado_codigo: "31",
  },
  {
    codigo: "3549003",
    municipio: "São Francisco",
    estado_codigo: "35",
  },
  {
    codigo: "2513984",
    municipio: "São Francisco",
    estado_codigo: "25",
  },
  {
    codigo: "2806909",
    municipio: "São Francisco",
    estado_codigo: "28",
  },
  {
    codigo: "4318101",
    municipio: "São Francisco de Assis",
    estado_codigo: "43",
  },
  {
    codigo: "2209658",
    municipio: "São Francisco de Assis do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "5219902",
    municipio: "São Francisco de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3304755",
    municipio: "São Francisco de Itabapoana",
    estado_codigo: "33",
  },
  {
    codigo: "4318200",
    municipio: "São Francisco de Paula",
    estado_codigo: "43",
  },
  {
    codigo: "3161205",
    municipio: "São Francisco de Paula",
    estado_codigo: "31",
  },
  {
    codigo: "3161304",
    municipio: "São Francisco de Sales",
    estado_codigo: "31",
  },
  {
    codigo: "2110856",
    municipio: "São Francisco do Brejão",
    estado_codigo: "21",
  },
  {
    codigo: "2929206",
    municipio: "São Francisco do Conde",
    estado_codigo: "29",
  },
  {
    codigo: "3161403",
    municipio: "São Francisco do Glória",
    estado_codigo: "31",
  },
  {
    codigo: "1101492",
    municipio: "São Francisco do Guaporé",
    estado_codigo: "11",
  },
  {
    codigo: "2110906",
    municipio: "São Francisco do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "2411908",
    municipio: "São Francisco do Oeste",
    estado_codigo: "24",
  },
  {
    codigo: "1507409",
    municipio: "São Francisco do Pará",
    estado_codigo: "15",
  },
  {
    codigo: "2209708",
    municipio: "São Francisco do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4216206",
    municipio: "São Francisco do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "2929255",
    municipio: "São Gabriel",
    estado_codigo: "29",
  },
  {
    codigo: "4318309",
    municipio: "São Gabriel",
    estado_codigo: "43",
  },
  {
    codigo: "1303809",
    municipio: "São Gabriel da Cachoeira",
    estado_codigo: "13",
  },
  {
    codigo: "3204708",
    municipio: "São Gabriel da Palha",
    estado_codigo: "32",
  },
  {
    codigo: "5007695",
    municipio: "São Gabriel do Oeste",
    estado_codigo: "50",
  },
  {
    codigo: "3161502",
    municipio: "São Geraldo",
    estado_codigo: "31",
  },
  {
    codigo: "3161601",
    municipio: "São Geraldo da Piedade",
    estado_codigo: "31",
  },
  {
    codigo: "1507458",
    municipio: "São Geraldo do Araguaia",
    estado_codigo: "15",
  },
  {
    codigo: "3161650",
    municipio: "São Geraldo do Baixio",
    estado_codigo: "31",
  },
  {
    codigo: "3304904",
    municipio: "São Gonçalo",
    estado_codigo: "33",
  },
  {
    codigo: "3161700",
    municipio: "São Gonçalo do Abaeté",
    estado_codigo: "31",
  },
  {
    codigo: "2412005",
    municipio: "São Gonçalo do Amarante",
    estado_codigo: "24",
  },
  {
    codigo: "2312403",
    municipio: "São Gonçalo do Amarante",
    estado_codigo: "23",
  },
  {
    codigo: "2209757",
    municipio: "São Gonçalo do Gurguéia",
    estado_codigo: "22",
  },
  {
    codigo: "3161809",
    municipio: "São Gonçalo do Pará",
    estado_codigo: "31",
  },
  {
    codigo: "2209807",
    municipio: "São Gonçalo do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3161908",
    municipio: "São Gonçalo do Rio Abaixo",
    estado_codigo: "31",
  },
  {
    codigo: "3125507",
    municipio: "São Gonçalo do Rio Preto",
    estado_codigo: "31",
  },
  {
    codigo: "3162005",
    municipio: "São Gonçalo do Sapucaí",
    estado_codigo: "31",
  },
  {
    codigo: "2929305",
    municipio: "São Gonçalo dos Campos",
    estado_codigo: "29",
  },
  {
    codigo: "3162104",
    municipio: "São Gotardo",
    estado_codigo: "31",
  },
  {
    codigo: "4318408",
    municipio: "São Jerônimo",
    estado_codigo: "43",
  },
  {
    codigo: "4124707",
    municipio: "São Jerônimo da Serra",
    estado_codigo: "41",
  },
  {
    codigo: "2613206",
    municipio: "São João",
    estado_codigo: "26",
  },
  {
    codigo: "4124806",
    municipio: "São João",
    estado_codigo: "41",
  },
  {
    codigo: "4216305",
    municipio: "São João Batista",
    estado_codigo: "42",
  },
  {
    codigo: "2111003",
    municipio: "São João Batista",
    estado_codigo: "21",
  },
  {
    codigo: "3162203",
    municipio: "São João Batista do Glória",
    estado_codigo: "31",
  },
  {
    codigo: "1400506",
    municipio: "São João da Baliza",
    estado_codigo: "14",
  },
  {
    codigo: "3305000",
    municipio: "São João da Barra",
    estado_codigo: "33",
  },
  {
    codigo: "3549102",
    municipio: "São João da Boa Vista",
    estado_codigo: "35",
  },
  {
    codigo: "2209856",
    municipio: "São João da Canabrava",
    estado_codigo: "22",
  },
  {
    codigo: "2209872",
    municipio: "São João da Fronteira",
    estado_codigo: "22",
  },
  {
    codigo: "3162252",
    municipio: "São João da Lagoa",
    estado_codigo: "31",
  },
  {
    codigo: "5220009",
    municipio: "São João d'Aliança",
    estado_codigo: "52",
  },
  {
    codigo: "3162302",
    municipio: "São João da Mata",
    estado_codigo: "31",
  },
  {
    codigo: "5220058",
    municipio: "São João da Paraúna",
    estado_codigo: "52",
  },
  {
    codigo: "1507466",
    municipio: "São João da Ponta",
    estado_codigo: "15",
  },
  {
    codigo: "3162401",
    municipio: "São João da Ponte",
    estado_codigo: "31",
  },
  {
    codigo: "3549201",
    municipio: "São João das Duas Pontes",
    estado_codigo: "35",
  },
  {
    codigo: "2209906",
    municipio: "São João da Serra",
    estado_codigo: "22",
  },
  {
    codigo: "3162450",
    municipio: "São João das Missões",
    estado_codigo: "31",
  },
  {
    codigo: "4318424",
    municipio: "São João da Urtiga",
    estado_codigo: "43",
  },
  {
    codigo: "2209955",
    municipio: "São João da Varjota",
    estado_codigo: "22",
  },
  {
    codigo: "3549250",
    municipio: "São João de Iracema",
    estado_codigo: "35",
  },
  {
    codigo: "3162500",
    municipio: "São João del Rei",
    estado_codigo: "31",
  },
  {
    codigo: "3305109",
    municipio: "São João de Meriti",
    estado_codigo: "33",
  },
  {
    codigo: "1507474",
    municipio: "São João de Pirabas",
    estado_codigo: "15",
  },
  {
    codigo: "1507508",
    municipio: "São João do Araguaia",
    estado_codigo: "15",
  },
  {
    codigo: "2209971",
    municipio: "São João do Arraial",
    estado_codigo: "22",
  },
  {
    codigo: "4124905",
    municipio: "São João do Caiuá",
    estado_codigo: "41",
  },
  {
    codigo: "2514008",
    municipio: "São João do Cariri",
    estado_codigo: "25",
  },
  {
    codigo: "2111029",
    municipio: "São João do Carú",
    estado_codigo: "21",
  },
  {
    codigo: "4216354",
    municipio: "São João do Itaperiú",
    estado_codigo: "42",
  },
  {
    codigo: "4125001",
    municipio: "São João do Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "2312502",
    municipio: "São João do Jaguaribe",
    estado_codigo: "23",
  },
  {
    codigo: "3162559",
    municipio: "São João do Manhuaçu",
    estado_codigo: "31",
  },
  {
    codigo: "3162575",
    municipio: "São João do Manteninha",
    estado_codigo: "31",
  },
  {
    codigo: "4216255",
    municipio: "São João do Oeste",
    estado_codigo: "42",
  },
  {
    codigo: "3162609",
    municipio: "São João do Oriente",
    estado_codigo: "31",
  },
  {
    codigo: "3162658",
    municipio: "São João do Pacuí",
    estado_codigo: "31",
  },
  {
    codigo: "2111052",
    municipio: "São João do Paraíso",
    estado_codigo: "21",
  },
  {
    codigo: "3162708",
    municipio: "São João do Paraíso",
    estado_codigo: "31",
  },
  {
    codigo: "3549300",
    municipio: "São João do Pau d'Alho",
    estado_codigo: "35",
  },
  {
    codigo: "2210003",
    municipio: "São João do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4318432",
    municipio: "São João do Polêsine",
    estado_codigo: "43",
  },
  {
    codigo: "2500700",
    municipio: "São João do Rio do Peixe",
    estado_codigo: "25",
  },
  {
    codigo: "2412104",
    municipio: "São João do Sabugi",
    estado_codigo: "24",
  },
  {
    codigo: "2111078",
    municipio: "São João do Soter",
    estado_codigo: "21",
  },
  {
    codigo: "2111102",
    municipio: "São João dos Patos",
    estado_codigo: "21",
  },
  {
    codigo: "4216404",
    municipio: "São João do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "2514107",
    municipio: "São João do Tigre",
    estado_codigo: "25",
  },
  {
    codigo: "4125100",
    municipio: "São João do Triunfo",
    estado_codigo: "41",
  },
  {
    codigo: "3162807",
    municipio: "São João Evangelista",
    estado_codigo: "31",
  },
  {
    codigo: "3162906",
    municipio: "São João Nepomuceno",
    estado_codigo: "31",
  },
  {
    codigo: "4216503",
    municipio: "São Joaquim",
    estado_codigo: "42",
  },
  {
    codigo: "3549409",
    municipio: "São Joaquim da Barra",
    estado_codigo: "35",
  },
  {
    codigo: "3162922",
    municipio: "São Joaquim de Bicas",
    estado_codigo: "31",
  },
  {
    codigo: "2613305",
    municipio: "São Joaquim do Monte",
    estado_codigo: "26",
  },
  {
    codigo: "4318440",
    municipio: "São Jorge",
    estado_codigo: "43",
  },
  {
    codigo: "4125209",
    municipio: "São Jorge d'Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "4125308",
    municipio: "São Jorge do Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "4125357",
    municipio: "São Jorge do Patrocínio",
    estado_codigo: "41",
  },
  {
    codigo: "4216602",
    municipio: "São José",
    estado_codigo: "42",
  },
  {
    codigo: "3162948",
    municipio: "São José da Barra",
    estado_codigo: "31",
  },
  {
    codigo: "3549508",
    municipio: "São José da Bela Vista",
    estado_codigo: "35",
  },
  {
    codigo: "4125407",
    municipio: "São José da Boa Vista",
    estado_codigo: "41",
  },
  {
    codigo: "2613404",
    municipio: "São José da Coroa Grande",
    estado_codigo: "26",
  },
  {
    codigo: "2514206",
    municipio: "São José da Lagoa Tapada",
    estado_codigo: "25",
  },
  {
    codigo: "2708303",
    municipio: "São José da Laje",
    estado_codigo: "27",
  },
  {
    codigo: "3162955",
    municipio: "São José da Lapa",
    estado_codigo: "31",
  },
  {
    codigo: "3163003",
    municipio: "São José da Safira",
    estado_codigo: "31",
  },
  {
    codigo: "4318457",
    municipio: "São José das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "4125456",
    municipio: "São José das Palmeiras",
    estado_codigo: "41",
  },
  {
    codigo: "2708402",
    municipio: "São José da Tapera",
    estado_codigo: "27",
  },
  {
    codigo: "3163102",
    municipio: "São José da Varginha",
    estado_codigo: "31",
  },
  {
    codigo: "2929354",
    municipio: "São José da Vitória",
    estado_codigo: "29",
  },
  {
    codigo: "2514305",
    municipio: "São José de Caiana",
    estado_codigo: "25",
  },
  {
    codigo: "2514404",
    municipio: "São José de Espinharas",
    estado_codigo: "25",
  },
  {
    codigo: "2412203",
    municipio: "São José de Mipibu",
    estado_codigo: "24",
  },
  {
    codigo: "2514503",
    municipio: "São José de Piranhas",
    estado_codigo: "25",
  },
  {
    codigo: "2514552",
    municipio: "São José de Princesa",
    estado_codigo: "25",
  },
  {
    codigo: "2111201",
    municipio: "São José de Ribamar",
    estado_codigo: "21",
  },
  {
    codigo: "3305133",
    municipio: "São José de Ubá",
    estado_codigo: "33",
  },
  {
    codigo: "3163201",
    municipio: "São José do Alegre",
    estado_codigo: "31",
  },
  {
    codigo: "3549607",
    municipio: "São José do Barreiro",
    estado_codigo: "35",
  },
  {
    codigo: "2613503",
    municipio: "São José do Belmonte",
    estado_codigo: "26",
  },
  {
    codigo: "2514602",
    municipio: "São José do Bonfim",
    estado_codigo: "25",
  },
  {
    codigo: "2514651",
    municipio: "São José do Brejo do Cruz",
    estado_codigo: "25",
  },
  {
    codigo: "3204807",
    municipio: "São José do Calçado",
    estado_codigo: "32",
  },
  {
    codigo: "2412302",
    municipio: "São José do Campestre",
    estado_codigo: "24",
  },
  {
    codigo: "4216701",
    municipio: "São José do Cedro",
    estado_codigo: "42",
  },
  {
    codigo: "4216800",
    municipio: "São José do Cerrito",
    estado_codigo: "42",
  },
  {
    codigo: "3163300",
    municipio: "São José do Divino",
    estado_codigo: "31",
  },
  {
    codigo: "2210052",
    municipio: "São José do Divino",
    estado_codigo: "22",
  },
  {
    codigo: "2613602",
    municipio: "São José do Egito",
    estado_codigo: "26",
  },
  {
    codigo: "3163409",
    municipio: "São José do Goiabal",
    estado_codigo: "31",
  },
  {
    codigo: "4318465",
    municipio: "São José do Herval",
    estado_codigo: "43",
  },
  {
    codigo: "4318481",
    municipio: "São José do Hortêncio",
    estado_codigo: "43",
  },
  {
    codigo: "4318499",
    municipio: "São José do Inhacorá",
    estado_codigo: "43",
  },
  {
    codigo: "2929370",
    municipio: "São José do Jacuípe",
    estado_codigo: "29",
  },
  {
    codigo: "3163508",
    municipio: "São José do Jacuri",
    estado_codigo: "31",
  },
  {
    codigo: "3163607",
    municipio: "São José do Mantimento",
    estado_codigo: "31",
  },
  {
    codigo: "4318507",
    municipio: "São José do Norte",
    estado_codigo: "43",
  },
  {
    codigo: "4318606",
    municipio: "São José do Ouro",
    estado_codigo: "43",
  },
  {
    codigo: "2210102",
    municipio: "São José do Peixe",
    estado_codigo: "22",
  },
  {
    codigo: "2210201",
    municipio: "São José do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "5107297",
    municipio: "São José do Povo",
    estado_codigo: "51",
  },
  {
    codigo: "5107305",
    municipio: "São José do Rio Claro",
    estado_codigo: "51",
  },
  {
    codigo: "3549706",
    municipio: "São José do Rio Pardo",
    estado_codigo: "35",
  },
  {
    codigo: "3549805",
    municipio: "São José do Rio Preto",
    estado_codigo: "35",
  },
  {
    codigo: "2514701",
    municipio: "São José do Sabugi",
    estado_codigo: "25",
  },
  {
    codigo: "4318622",
    municipio: "São José dos Ausentes",
    estado_codigo: "43",
  },
  {
    codigo: "2111250",
    municipio: "São José dos Basílios",
    estado_codigo: "21",
  },
  {
    codigo: "3549904",
    municipio: "São José dos Campos",
    estado_codigo: "35",
  },
  {
    codigo: "2514800",
    municipio: "São José dos Cordeiros",
    estado_codigo: "25",
  },
  {
    codigo: "2412401",
    municipio: "São José do Seridó",
    estado_codigo: "24",
  },
  {
    codigo: "4125506",
    municipio: "São José dos Pinhais",
    estado_codigo: "41",
  },
  {
    codigo: "5107107",
    municipio: "São José dos Quatro Marcos",
    estado_codigo: "51",
  },
  {
    codigo: "2514453",
    municipio: "São José dos Ramos",
    estado_codigo: "25",
  },
  {
    codigo: "4318614",
    municipio: "São José do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3305158",
    municipio: "São José do Vale do Rio Preto",
    estado_codigo: "33",
  },
  {
    codigo: "5107354",
    municipio: "São José do Xingu",
    estado_codigo: "51",
  },
  {
    codigo: "2210300",
    municipio: "São Julião",
    estado_codigo: "22",
  },
  {
    codigo: "4318705",
    municipio: "São Leopoldo",
    estado_codigo: "43",
  },
  {
    codigo: "3163706",
    municipio: "São Lourenço",
    estado_codigo: "31",
  },
  {
    codigo: "2613701",
    municipio: "São Lourenço da Mata",
    estado_codigo: "26",
  },
  {
    codigo: "3549953",
    municipio: "São Lourenço da Serra",
    estado_codigo: "35",
  },
  {
    codigo: "4216909",
    municipio: "São Lourenço do Oeste",
    estado_codigo: "42",
  },
  {
    codigo: "2210359",
    municipio: "São Lourenço do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "4318804",
    municipio: "São Lourenço do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4217006",
    municipio: "São Ludgero",
    estado_codigo: "42",
  },
  {
    codigo: "2111300",
    municipio: "São Luís",
    estado_codigo: "21",
  },
  {
    codigo: "5220108",
    municipio: "São Luís de Montes Belos",
    estado_codigo: "52",
  },
  {
    codigo: "2312601",
    municipio: "São Luís do Curu",
    estado_codigo: "23",
  },
  {
    codigo: "3550001",
    municipio: "São Luís do Paraitinga",
    estado_codigo: "35",
  },
  {
    codigo: "2210375",
    municipio: "São Luis do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2708501",
    municipio: "São Luís do Quitunde",
    estado_codigo: "27",
  },
  {
    codigo: "2111409",
    municipio: "São Luís Gonzaga do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "1400605",
    municipio: "São Luiz",
    estado_codigo: "14",
  },
  {
    codigo: "5220157",
    municipio: "São Luíz do Norte",
    estado_codigo: "52",
  },
  {
    codigo: "4318903",
    municipio: "São Luiz Gonzaga",
    estado_codigo: "43",
  },
  {
    codigo: "2514909",
    municipio: "São Mamede",
    estado_codigo: "25",
  },
  {
    codigo: "4125555",
    municipio: "São Manoel do Paraná",
    estado_codigo: "41",
  },
  {
    codigo: "3550100",
    municipio: "São Manuel",
    estado_codigo: "35",
  },
  {
    codigo: "4319000",
    municipio: "São Marcos",
    estado_codigo: "43",
  },
  {
    codigo: "4217105",
    municipio: "São Martinho",
    estado_codigo: "42",
  },
  {
    codigo: "4319109",
    municipio: "São Martinho",
    estado_codigo: "43",
  },
  {
    codigo: "4319125",
    municipio: "São Martinho da Serra",
    estado_codigo: "43",
  },
  {
    codigo: "3204906",
    municipio: "São Mateus",
    estado_codigo: "32",
  },
  {
    codigo: "2111508",
    municipio: "São Mateus do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "4125605",
    municipio: "São Mateus do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "2412500",
    municipio: "São Miguel",
    estado_codigo: "24",
  },
  {
    codigo: "3550209",
    municipio: "São Miguel Arcanjo",
    estado_codigo: "35",
  },
  {
    codigo: "2210383",
    municipio: "São Miguel da Baixa Grande",
    estado_codigo: "22",
  },
  {
    codigo: "4217154",
    municipio: "São Miguel da Boa Vista",
    estado_codigo: "42",
  },
  {
    codigo: "2929404",
    municipio: "São Miguel das Matas",
    estado_codigo: "29",
  },
  {
    codigo: "4319158",
    municipio: "São Miguel das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "2515005",
    municipio: "São Miguel de Taipu",
    estado_codigo: "25",
  },
  {
    codigo: "2807006",
    municipio: "São Miguel do Aleixo",
    estado_codigo: "28",
  },
  {
    codigo: "3163805",
    municipio: "São Miguel do Anta",
    estado_codigo: "31",
  },
  {
    codigo: "5220207",
    municipio: "São Miguel do Araguaia",
    estado_codigo: "52",
  },
  {
    codigo: "2210391",
    municipio: "São Miguel do Fidalgo",
    estado_codigo: "22",
  },
  {
    codigo: "2412559",
    municipio: "São Miguel do Gostoso",
    estado_codigo: "24",
  },
  {
    codigo: "1507607",
    municipio: "São Miguel do Guamá",
    estado_codigo: "15",
  },
  {
    codigo: "1100320",
    municipio: "São Miguel do Guaporé",
    estado_codigo: "11",
  },
  {
    codigo: "4125704",
    municipio: "São Miguel do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "4217204",
    municipio: "São Miguel do Oeste",
    estado_codigo: "42",
  },
  {
    codigo: "5220264",
    municipio: "São Miguel do Passa Quatro",
    estado_codigo: "52",
  },
  {
    codigo: "2708600",
    municipio: "São Miguel dos Campos",
    estado_codigo: "27",
  },
  {
    codigo: "2708709",
    municipio: "São Miguel dos Milagres",
    estado_codigo: "27",
  },
  {
    codigo: "2210409",
    municipio: "São Miguel do Tapuio",
    estado_codigo: "22",
  },
  {
    codigo: "1720200",
    municipio: "São Miguel do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "4319208",
    municipio: "São Nicolau",
    estado_codigo: "43",
  },
  {
    codigo: "5220280",
    municipio: "São Patrício",
    estado_codigo: "52",
  },
  {
    codigo: "3550308",
    municipio: "São Paulo",
    estado_codigo: "35",
  },
  {
    codigo: "4319307",
    municipio: "São Paulo das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "1303908",
    municipio: "São Paulo de Olivença",
    estado_codigo: "13",
  },
  {
    codigo: "2412609",
    municipio: "São Paulo do Potengi",
    estado_codigo: "24",
  },
  {
    codigo: "3550407",
    municipio: "São Pedro",
    estado_codigo: "35",
  },
  {
    codigo: "2412708",
    municipio: "São Pedro",
    estado_codigo: "24",
  },
  {
    codigo: "2111532",
    municipio: "São Pedro da Água Branca",
    estado_codigo: "21",
  },
  {
    codigo: "3305208",
    municipio: "São Pedro da Aldeia",
    estado_codigo: "33",
  },
  {
    codigo: "5107404",
    municipio: "São Pedro da Cipa",
    estado_codigo: "51",
  },
  {
    codigo: "4319356",
    municipio: "São Pedro da Serra",
    estado_codigo: "43",
  },
  {
    codigo: "4319364",
    municipio: "São Pedro das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "3163904",
    municipio: "São Pedro da União",
    estado_codigo: "31",
  },
  {
    codigo: "4217253",
    municipio: "São Pedro de Alcântara",
    estado_codigo: "42",
  },
  {
    codigo: "4319372",
    municipio: "São Pedro do Butiá",
    estado_codigo: "43",
  },
  {
    codigo: "4125753",
    municipio: "São Pedro do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "4125803",
    municipio: "São Pedro do Ivaí",
    estado_codigo: "41",
  },
  {
    codigo: "4125902",
    municipio: "São Pedro do Paraná",
    estado_codigo: "41",
  },
  {
    codigo: "2210508",
    municipio: "São Pedro do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2111573",
    municipio: "São Pedro dos Crentes",
    estado_codigo: "21",
  },
  {
    codigo: "3164001",
    municipio: "São Pedro dos Ferros",
    estado_codigo: "31",
  },
  {
    codigo: "3164100",
    municipio: "São Pedro do Suaçuí",
    estado_codigo: "31",
  },
  {
    codigo: "4319406",
    municipio: "São Pedro do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3550506",
    municipio: "São Pedro do Turvo",
    estado_codigo: "35",
  },
  {
    codigo: "2412807",
    municipio: "São Rafael",
    estado_codigo: "24",
  },
  {
    codigo: "2111607",
    municipio: "São Raimundo das Mangabeiras",
    estado_codigo: "21",
  },
  {
    codigo: "2111631",
    municipio: "São Raimundo do Doca Bezerra",
    estado_codigo: "21",
  },
  {
    codigo: "2210607",
    municipio: "São Raimundo Nonato",
    estado_codigo: "22",
  },
  {
    codigo: "2111672",
    municipio: "São Roberto",
    estado_codigo: "21",
  },
  {
    codigo: "3164209",
    municipio: "São Romão",
    estado_codigo: "31",
  },
  {
    codigo: "3550605",
    municipio: "São Roque",
    estado_codigo: "35",
  },
  {
    codigo: "3164308",
    municipio: "São Roque de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "3204955",
    municipio: "São Roque do Canaã",
    estado_codigo: "32",
  },
  {
    codigo: "1720259",
    municipio: "São Salvador do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2708808",
    municipio: "São Sebastião",
    estado_codigo: "27",
  },
  {
    codigo: "3550704",
    municipio: "São Sebastião",
    estado_codigo: "35",
  },
  {
    codigo: "4126009",
    municipio: "São Sebastião da Amoreira",
    estado_codigo: "41",
  },
  {
    codigo: "3164407",
    municipio: "São Sebastião da Bela Vista",
    estado_codigo: "31",
  },
  {
    codigo: "1507706",
    municipio: "São Sebastião da Boa Vista",
    estado_codigo: "15",
  },
  {
    codigo: "3550803",
    municipio: "São Sebastião da Grama",
    estado_codigo: "35",
  },
  {
    codigo: "3164431",
    municipio: "São Sebastião da Vargem Alegre",
    estado_codigo: "31",
  },
  {
    codigo: "2515104",
    municipio: "São Sebastião de Lagoa de Roça",
    estado_codigo: "25",
  },
  {
    codigo: "3305307",
    municipio: "São Sebastião do Alto",
    estado_codigo: "33",
  },
  {
    codigo: "3164472",
    municipio: "São Sebastião do Anta",
    estado_codigo: "31",
  },
  {
    codigo: "4319505",
    municipio: "São Sebastião do Caí",
    estado_codigo: "43",
  },
  {
    codigo: "3164506",
    municipio: "São Sebastião do Maranhão",
    estado_codigo: "31",
  },
  {
    codigo: "3164605",
    municipio: "São Sebastião do Oeste",
    estado_codigo: "31",
  },
  {
    codigo: "3164704",
    municipio: "São Sebastião do Paraíso",
    estado_codigo: "31",
  },
  {
    codigo: "2929503",
    municipio: "São Sebastião do Passé",
    estado_codigo: "29",
  },
  {
    codigo: "3164803",
    municipio: "São Sebastião do Rio Preto",
    estado_codigo: "31",
  },
  {
    codigo: "3164902",
    municipio: "São Sebastião do Rio Verde",
    estado_codigo: "31",
  },
  {
    codigo: "1720309",
    municipio: "São Sebastião do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "1303957",
    municipio: "São Sebastião do Uatumã",
    estado_codigo: "13",
  },
  {
    codigo: "2515203",
    municipio: "São Sebastião do Umbuzeiro",
    estado_codigo: "25",
  },
  {
    codigo: "4319604",
    municipio: "São Sepé",
    estado_codigo: "43",
  },
  {
    codigo: "5220405",
    municipio: "São Simão",
    estado_codigo: "52",
  },
  {
    codigo: "3550902",
    municipio: "São Simão",
    estado_codigo: "35",
  },
  {
    codigo: "3165206",
    municipio: "São Thomé das Letras",
    estado_codigo: "31",
  },
  {
    codigo: "3165008",
    municipio: "São Tiago",
    estado_codigo: "31",
  },
  {
    codigo: "3165107",
    municipio: "São Tomás de Aquino",
    estado_codigo: "31",
  },
  {
    codigo: "2412906",
    municipio: "São Tomé",
    estado_codigo: "24",
  },
  {
    codigo: "4126108",
    municipio: "São Tomé",
    estado_codigo: "41",
  },
  {
    codigo: "4319703",
    municipio: "São Valentim",
    estado_codigo: "43",
  },
  {
    codigo: "4319711",
    municipio: "São Valentim do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "1720499",
    municipio: "São Valério da Natividade",
    estado_codigo: "17",
  },
  {
    codigo: "4319737",
    municipio: "São Valério do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4319752",
    municipio: "São Vendelino",
    estado_codigo: "43",
  },
  {
    codigo: "3551009",
    municipio: "São Vicente",
    estado_codigo: "35",
  },
  {
    codigo: "2413003",
    municipio: "São Vicente",
    estado_codigo: "24",
  },
  {
    codigo: "3165305",
    municipio: "São Vicente de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4319802",
    municipio: "São Vicente do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2111706",
    municipio: "São Vicente Ferrer",
    estado_codigo: "21",
  },
  {
    codigo: "2613800",
    municipio: "São Vicente Ferrer",
    estado_codigo: "26",
  },
  {
    codigo: "2515302",
    municipio: "Sapé",
    estado_codigo: "25",
  },
  {
    codigo: "2929602",
    municipio: "Sapeaçu",
    estado_codigo: "29",
  },
  {
    codigo: "5107875",
    municipio: "Sapezal",
    estado_codigo: "51",
  },
  {
    codigo: "4319901",
    municipio: "Sapiranga",
    estado_codigo: "43",
  },
  {
    codigo: "4126207",
    municipio: "Sapopema",
    estado_codigo: "41",
  },
  {
    codigo: "3305406",
    municipio: "Sapucaia",
    estado_codigo: "33",
  },
  {
    codigo: "1507755",
    municipio: "Sapucaia",
    estado_codigo: "15",
  },
  {
    codigo: "4320008",
    municipio: "Sapucaia do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3165404",
    municipio: "Sapucaí-Mirim",
    estado_codigo: "31",
  },
  {
    codigo: "3305505",
    municipio: "Saquarema",
    estado_codigo: "33",
  },
  {
    codigo: "4320107",
    municipio: "Sarandi",
    estado_codigo: "43",
  },
  {
    codigo: "4126256",
    municipio: "Sarandi",
    estado_codigo: "41",
  },
  {
    codigo: "3551108",
    municipio: "Sarapuí",
    estado_codigo: "35",
  },
  {
    codigo: "3165503",
    municipio: "Sardoá",
    estado_codigo: "31",
  },
  {
    codigo: "3551207",
    municipio: "Sarutaiá",
    estado_codigo: "35",
  },
  {
    codigo: "3165537",
    municipio: "Sarzedo",
    estado_codigo: "31",
  },
  {
    codigo: "2929701",
    municipio: "Sátiro Dias",
    estado_codigo: "29",
  },
  {
    codigo: "2708907",
    municipio: "Satuba",
    estado_codigo: "27",
  },
  {
    codigo: "2111722",
    municipio: "Satubinha",
    estado_codigo: "21",
  },
  {
    codigo: "2929750",
    municipio: "Saubara",
    estado_codigo: "29",
  },
  {
    codigo: "4126272",
    municipio: "Saudade do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "4217303",
    municipio: "Saudades",
    estado_codigo: "42",
  },
  {
    codigo: "2929800",
    municipio: "Saúde",
    estado_codigo: "29",
  },
  {
    codigo: "4217402",
    municipio: "Schroeder",
    estado_codigo: "42",
  },
  {
    codigo: "2929909",
    municipio: "Seabra",
    estado_codigo: "29",
  },
  {
    codigo: "4217501",
    municipio: "Seara",
    estado_codigo: "42",
  },
  {
    codigo: "3551306",
    municipio: "Sebastianópolis do Sul",
    estado_codigo: "35",
  },
  {
    codigo: "2210623",
    municipio: "Sebastião Barros",
    estado_codigo: "22",
  },
  {
    codigo: "2930006",
    municipio: "Sebastião Laranjeiras",
    estado_codigo: "29",
  },
  {
    codigo: "2210631",
    municipio: "Sebastião Leal",
    estado_codigo: "22",
  },
  {
    codigo: "4320206",
    municipio: "Seberi",
    estado_codigo: "43",
  },
  {
    codigo: "4320230",
    municipio: "Sede Nova",
    estado_codigo: "43",
  },
  {
    codigo: "4320263",
    municipio: "Segredo",
    estado_codigo: "43",
  },
  {
    codigo: "4320305",
    municipio: "Selbach",
    estado_codigo: "43",
  },
  {
    codigo: "5007802",
    municipio: "Selvíria",
    estado_codigo: "50",
  },
  {
    codigo: "3165560",
    municipio: "Sem-Peixe",
    estado_codigo: "31",
  },
  {
    codigo: "2111748",
    municipio: "Senador Alexandre Costa",
    estado_codigo: "21",
  },
  {
    codigo: "3165578",
    municipio: "Senador Amaral",
    estado_codigo: "31",
  },
  {
    codigo: "5220454",
    municipio: "Senador Canedo",
    estado_codigo: "52",
  },
  {
    codigo: "3165602",
    municipio: "Senador Cortes",
    estado_codigo: "31",
  },
  {
    codigo: "2413102",
    municipio: "Senador Elói de Souza",
    estado_codigo: "24",
  },
  {
    codigo: "3165701",
    municipio: "Senador Firmino",
    estado_codigo: "31",
  },
  {
    codigo: "2413201",
    municipio: "Senador Georgino Avelino",
    estado_codigo: "24",
  },
  {
    codigo: "1200450",
    municipio: "Senador Guiomard",
    estado_codigo: "12",
  },
  {
    codigo: "3165800",
    municipio: "Senador José Bento",
    estado_codigo: "31",
  },
  {
    codigo: "1507805",
    municipio: "Senador José Porfírio",
    estado_codigo: "15",
  },
  {
    codigo: "2111763",
    municipio: "Senador La Rocque",
    estado_codigo: "21",
  },
  {
    codigo: "3165909",
    municipio: "Senador Modestino Gonçalves",
    estado_codigo: "31",
  },
  {
    codigo: "2312700",
    municipio: "Senador Pompeu",
    estado_codigo: "23",
  },
  {
    codigo: "2708956",
    municipio: "Senador Rui Palmeira",
    estado_codigo: "27",
  },
  {
    codigo: "2312809",
    municipio: "Senador Sá",
    estado_codigo: "23",
  },
  {
    codigo: "4320321",
    municipio: "Senador Salgado Filho",
    estado_codigo: "43",
  },
  {
    codigo: "1200500",
    municipio: "Sena Madureira",
    estado_codigo: "12",
  },
  {
    codigo: "4126306",
    municipio: "Sengés",
    estado_codigo: "41",
  },
  {
    codigo: "3166006",
    municipio: "Senhora de Oliveira",
    estado_codigo: "31",
  },
  {
    codigo: "3166105",
    municipio: "Senhora do Porto",
    estado_codigo: "31",
  },
  {
    codigo: "3166204",
    municipio: "Senhora dos Remédios",
    estado_codigo: "31",
  },
  {
    codigo: "2930105",
    municipio: "Senhor do Bonfim",
    estado_codigo: "29",
  },
  {
    codigo: "4320354",
    municipio: "Sentinela do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2930204",
    municipio: "Sento Sé",
    estado_codigo: "29",
  },
  {
    codigo: "4320404",
    municipio: "Serafina Corrêa",
    estado_codigo: "43",
  },
  {
    codigo: "3166303",
    municipio: "Sericita",
    estado_codigo: "31",
  },
  {
    codigo: "2515401",
    municipio: "Seridó",
    estado_codigo: "25",
  },
  {
    codigo: "1101500",
    municipio: "Seringueiras",
    estado_codigo: "11",
  },
  {
    codigo: "4320453",
    municipio: "Sério",
    estado_codigo: "43",
  },
  {
    codigo: "3166402",
    municipio: "Seritinga",
    estado_codigo: "31",
  },
  {
    codigo: "3305554",
    municipio: "Seropédica",
    estado_codigo: "33",
  },
  {
    codigo: "3205002",
    municipio: "Serra",
    estado_codigo: "32",
  },
  {
    codigo: "4217550",
    municipio: "Serra Alta",
    estado_codigo: "42",
  },
  {
    codigo: "3551405",
    municipio: "Serra Azul",
    estado_codigo: "35",
  },
  {
    codigo: "3166501",
    municipio: "Serra Azul de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2515500",
    municipio: "Serra Branca",
    estado_codigo: "25",
  },
  {
    codigo: "2515609",
    municipio: "Serra da Raiz",
    estado_codigo: "25",
  },
  {
    codigo: "3166600",
    municipio: "Serra da Saudade",
    estado_codigo: "31",
  },
  {
    codigo: "2413300",
    municipio: "Serra de São Bento",
    estado_codigo: "24",
  },
  {
    codigo: "2413359",
    municipio: "Serra do Mel",
    estado_codigo: "24",
  },
  {
    codigo: "1600055",
    municipio: "Serra do Navio",
    estado_codigo: "16",
  },
  {
    codigo: "2930154",
    municipio: "Serra do Ramalho",
    estado_codigo: "29",
  },
  {
    codigo: "3166709",
    municipio: "Serra dos Aimorés",
    estado_codigo: "31",
  },
  {
    codigo: "3166808",
    municipio: "Serra do Salitre",
    estado_codigo: "31",
  },
  {
    codigo: "2930303",
    municipio: "Serra Dourada",
    estado_codigo: "29",
  },
  {
    codigo: "2515708",
    municipio: "Serra Grande",
    estado_codigo: "25",
  },
  {
    codigo: "3551504",
    municipio: "Serrana",
    estado_codigo: "35",
  },
  {
    codigo: "3551603",
    municipio: "Serra Negra",
    estado_codigo: "35",
  },
  {
    codigo: "2413409",
    municipio: "Serra Negra do Norte",
    estado_codigo: "24",
  },
  {
    codigo: "3166907",
    municipio: "Serrania",
    estado_codigo: "31",
  },
  {
    codigo: "2111789",
    municipio: "Serrano do Maranhão",
    estado_codigo: "21",
  },
  {
    codigo: "5220504",
    municipio: "Serranópolis",
    estado_codigo: "52",
  },
  {
    codigo: "3166956",
    municipio: "Serranópolis de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4126355",
    municipio: "Serranópolis do Iguaçu",
    estado_codigo: "41",
  },
  {
    codigo: "3167004",
    municipio: "Serranos",
    estado_codigo: "31",
  },
  {
    codigo: "5107883",
    municipio: "Serra Nova Dourada",
    estado_codigo: "51",
  },
  {
    codigo: "2930402",
    municipio: "Serra Preta",
    estado_codigo: "29",
  },
  {
    codigo: "2515807",
    municipio: "Serra Redonda",
    estado_codigo: "25",
  },
  {
    codigo: "2515906",
    municipio: "Serraria",
    estado_codigo: "25",
  },
  {
    codigo: "2613909",
    municipio: "Serra Talhada",
    estado_codigo: "26",
  },
  {
    codigo: "2930501",
    municipio: "Serrinha",
    estado_codigo: "29",
  },
  {
    codigo: "2413508",
    municipio: "Serrinha",
    estado_codigo: "24",
  },
  {
    codigo: "2413557",
    municipio: "Serrinha dos Pintos",
    estado_codigo: "24",
  },
  {
    codigo: "2614006",
    municipio: "Serrita",
    estado_codigo: "26",
  },
  {
    codigo: "3167103",
    municipio: "Serro",
    estado_codigo: "31",
  },
  {
    codigo: "2930600",
    municipio: "Serrolândia",
    estado_codigo: "29",
  },
  {
    codigo: "4126405",
    municipio: "Sertaneja",
    estado_codigo: "41",
  },
  {
    codigo: "2614105",
    municipio: "Sertânia",
    estado_codigo: "26",
  },
  {
    codigo: "4126504",
    municipio: "Sertanópolis",
    estado_codigo: "41",
  },
  {
    codigo: "4320503",
    municipio: "Sertão",
    estado_codigo: "43",
  },
  {
    codigo: "4320552",
    municipio: "Sertão Santana",
    estado_codigo: "43",
  },
  {
    codigo: "3551702",
    municipio: "Sertãozinho",
    estado_codigo: "35",
  },
  {
    codigo: "2515930",
    municipio: "Sertãozinho",
    estado_codigo: "25",
  },
  {
    codigo: "3551801",
    municipio: "Sete Barras",
    estado_codigo: "35",
  },
  {
    codigo: "4320578",
    municipio: "Sete de Setembro",
    estado_codigo: "43",
  },
  {
    codigo: "3167202",
    municipio: "Sete Lagoas",
    estado_codigo: "31",
  },
  {
    codigo: "5007703",
    municipio: "Sete Quedas",
    estado_codigo: "50",
  },
  {
    codigo: "3165552",
    municipio: "Setubinha",
    estado_codigo: "31",
  },
  {
    codigo: "4320602",
    municipio: "Severiano de Almeida",
    estado_codigo: "43",
  },
  {
    codigo: "2413607",
    municipio: "Severiano Melo",
    estado_codigo: "24",
  },
  {
    codigo: "3551900",
    municipio: "Severínia",
    estado_codigo: "35",
  },
  {
    codigo: "4217600",
    municipio: "Siderópolis",
    estado_codigo: "42",
  },
  {
    codigo: "5007901",
    municipio: "Sidrolândia",
    estado_codigo: "50",
  },
  {
    codigo: "2210656",
    municipio: "Sigefredo Pacheco",
    estado_codigo: "22",
  },
  {
    codigo: "3305604",
    municipio: "Silva Jardim",
    estado_codigo: "33",
  },
  {
    codigo: "5220603",
    municipio: "Silvânia",
    estado_codigo: "52",
  },
  {
    codigo: "1720655",
    municipio: "Silvanópolis",
    estado_codigo: "17",
  },
  {
    codigo: "4320651",
    municipio: "Silveira Martins",
    estado_codigo: "43",
  },
  {
    codigo: "3167301",
    municipio: "Silveirânia",
    estado_codigo: "31",
  },
  {
    codigo: "3552007",
    municipio: "Silveiras",
    estado_codigo: "35",
  },
  {
    codigo: "1304005",
    municipio: "Silves",
    estado_codigo: "13",
  },
  {
    codigo: "3167400",
    municipio: "Silvianópolis",
    estado_codigo: "31",
  },
  {
    codigo: "2807105",
    municipio: "Simão Dias",
    estado_codigo: "28",
  },
  {
    codigo: "3167509",
    municipio: "Simão Pereira",
    estado_codigo: "31",
  },
  {
    codigo: "2210706",
    municipio: "Simões",
    estado_codigo: "22",
  },
  {
    codigo: "2930709",
    municipio: "Simões Filho",
    estado_codigo: "29",
  },
  {
    codigo: "5220686",
    municipio: "Simolândia",
    estado_codigo: "52",
  },
  {
    codigo: "3167608",
    municipio: "Simonésia",
    estado_codigo: "31",
  },
  {
    codigo: "2210805",
    municipio: "Simplício Mendes",
    estado_codigo: "22",
  },
  {
    codigo: "4320677",
    municipio: "Sinimbu",
    estado_codigo: "43",
  },
  {
    codigo: "5107909",
    municipio: "Sinop",
    estado_codigo: "51",
  },
  {
    codigo: "4126603",
    municipio: "Siqueira Campos",
    estado_codigo: "41",
  },
  {
    codigo: "2614204",
    municipio: "Sirinhaém",
    estado_codigo: "26",
  },
  {
    codigo: "2807204",
    municipio: "Siriri",
    estado_codigo: "28",
  },
  {
    codigo: "5220702",
    municipio: "Sítio d'Abadia",
    estado_codigo: "52",
  },
  {
    codigo: "2930758",
    municipio: "Sítio do Mato",
    estado_codigo: "29",
  },
  {
    codigo: "2930766",
    municipio: "Sítio do Quinto",
    estado_codigo: "29",
  },
  {
    codigo: "2111805",
    municipio: "Sítio Novo",
    estado_codigo: "21",
  },
  {
    codigo: "2413706",
    municipio: "Sítio Novo",
    estado_codigo: "24",
  },
  {
    codigo: "1720804",
    municipio: "Sítio Novo do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2930774",
    municipio: "Sobradinho",
    estado_codigo: "29",
  },
  {
    codigo: "4320701",
    municipio: "Sobradinho",
    estado_codigo: "43",
  },
  {
    codigo: "2515971",
    municipio: "Sobrado",
    estado_codigo: "25",
  },
  {
    codigo: "2312908",
    municipio: "Sobral",
    estado_codigo: "23",
  },
  {
    codigo: "3167707",
    municipio: "Sobrália",
    estado_codigo: "31",
  },
  {
    codigo: "3552106",
    municipio: "Socorro",
    estado_codigo: "35",
  },
  {
    codigo: "2210904",
    municipio: "Socorro do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2516003",
    municipio: "Solânea",
    estado_codigo: "25",
  },
  {
    codigo: "2516102",
    municipio: "Soledade",
    estado_codigo: "25",
  },
  {
    codigo: "4320800",
    municipio: "Soledade",
    estado_codigo: "43",
  },
  {
    codigo: "3167806",
    municipio: "Soledade de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2614402",
    municipio: "Solidão",
    estado_codigo: "26",
  },
  {
    codigo: "2313005",
    municipio: "Solonópole",
    estado_codigo: "23",
  },
  {
    codigo: "4217709",
    municipio: "Sombrio",
    estado_codigo: "42",
  },
  {
    codigo: "5007935",
    municipio: "Sonora",
    estado_codigo: "50",
  },
  {
    codigo: "3205010",
    municipio: "Sooretama",
    estado_codigo: "32",
  },
  {
    codigo: "3552205",
    municipio: "Sorocaba",
    estado_codigo: "35",
  },
  {
    codigo: "5107925",
    municipio: "Sorriso",
    estado_codigo: "51",
  },
  {
    codigo: "2516151",
    municipio: "Sossêgo",
    estado_codigo: "25",
  },
  {
    codigo: "1507904",
    municipio: "Soure",
    estado_codigo: "15",
  },
  {
    codigo: "2516201",
    municipio: "Sousa",
    estado_codigo: "25",
  },
  {
    codigo: "2930808",
    municipio: "Souto Soares",
    estado_codigo: "29",
  },
  {
    codigo: "1720853",
    municipio: "Sucupira",
    estado_codigo: "17",
  },
  {
    codigo: "2111904",
    municipio: "Sucupira do Norte",
    estado_codigo: "21",
  },
  {
    codigo: "2111953",
    municipio: "Sucupira do Riachão",
    estado_codigo: "21",
  },
  {
    codigo: "3552304",
    municipio: "Sud Mennucci",
    estado_codigo: "35",
  },
  {
    codigo: "4217758",
    municipio: "Sul Brasil",
    estado_codigo: "42",
  },
  {
    codigo: "4126652",
    municipio: "Sulina",
    estado_codigo: "41",
  },
  {
    codigo: "3552403",
    municipio: "Sumaré",
    estado_codigo: "35",
  },
  {
    codigo: "2516300",
    municipio: "Sumé",
    estado_codigo: "25",
  },
  {
    codigo: "3305703",
    municipio: "Sumidouro",
    estado_codigo: "33",
  },
  {
    codigo: "2614501",
    municipio: "Surubim",
    estado_codigo: "26",
  },
  {
    codigo: "2210938",
    municipio: "Sussuapara",
    estado_codigo: "22",
  },
  {
    codigo: "3552551",
    municipio: "Suzanápolis",
    estado_codigo: "35",
  },
  {
    codigo: "3552502",
    municipio: "Suzano",
    estado_codigo: "35",
  },
  {
    codigo: "4320859",
    municipio: "Tabaí",
    estado_codigo: "43",
  },
  {
    codigo: "5107941",
    municipio: "Tabaporã",
    estado_codigo: "51",
  },
  {
    codigo: "3552601",
    municipio: "Tabapuã",
    estado_codigo: "35",
  },
  {
    codigo: "1304062",
    municipio: "Tabatinga",
    estado_codigo: "13",
  },
  {
    codigo: "3552700",
    municipio: "Tabatinga",
    estado_codigo: "35",
  },
  {
    codigo: "2614600",
    municipio: "Tabira",
    estado_codigo: "26",
  },
  {
    codigo: "3552809",
    municipio: "Taboão da Serra",
    estado_codigo: "35",
  },
  {
    codigo: "2930907",
    municipio: "Tabocas do Brejo Velho",
    estado_codigo: "29",
  },
  {
    codigo: "2413805",
    municipio: "Taboleiro Grande",
    estado_codigo: "24",
  },
  {
    codigo: "3167905",
    municipio: "Tabuleiro",
    estado_codigo: "31",
  },
  {
    codigo: "2313104",
    municipio: "Tabuleiro do Norte",
    estado_codigo: "23",
  },
  {
    codigo: "2614709",
    municipio: "Tacaimbó",
    estado_codigo: "26",
  },
  {
    codigo: "2614808",
    municipio: "Tacaratu",
    estado_codigo: "26",
  },
  {
    codigo: "3552908",
    municipio: "Taciba",
    estado_codigo: "35",
  },
  {
    codigo: "5007950",
    municipio: "Tacuru",
    estado_codigo: "50",
  },
  {
    codigo: "3553005",
    municipio: "Taguaí",
    estado_codigo: "35",
  },
  {
    codigo: "1720903",
    municipio: "Taguatinga",
    estado_codigo: "17",
  },
  {
    codigo: "3553104",
    municipio: "Taiaçu",
    estado_codigo: "35",
  },
  {
    codigo: "1507953",
    municipio: "Tailândia",
    estado_codigo: "15",
  },
  {
    codigo: "4217808",
    municipio: "Taió",
    estado_codigo: "42",
  },
  {
    codigo: "3168002",
    municipio: "Taiobeiras",
    estado_codigo: "31",
  },
  {
    codigo: "1720937",
    municipio: "Taipas do Tocantins",
    estado_codigo: "17",
  },
  {
    codigo: "2413904",
    municipio: "Taipu",
    estado_codigo: "24",
  },
  {
    codigo: "3553203",
    municipio: "Taiúva",
    estado_codigo: "35",
  },
  {
    codigo: "1720978",
    municipio: "Talismã",
    estado_codigo: "17",
  },
  {
    codigo: "2614857",
    municipio: "Tamandaré",
    estado_codigo: "26",
  },
  {
    codigo: "4126678",
    municipio: "Tamarana",
    estado_codigo: "41",
  },
  {
    codigo: "3553302",
    municipio: "Tambaú",
    estado_codigo: "35",
  },
  {
    codigo: "4126702",
    municipio: "Tamboara",
    estado_codigo: "41",
  },
  {
    codigo: "2313203",
    municipio: "Tamboril",
    estado_codigo: "23",
  },
  {
    codigo: "2210953",
    municipio: "Tamboril do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "3553401",
    municipio: "Tanabi",
    estado_codigo: "35",
  },
  {
    codigo: "2414001",
    municipio: "Tangará",
    estado_codigo: "24",
  },
  {
    codigo: "4217907",
    municipio: "Tangará",
    estado_codigo: "42",
  },
  {
    codigo: "5107958",
    municipio: "Tangará da Serra",
    estado_codigo: "51",
  },
  {
    codigo: "3305752",
    municipio: "Tanguá",
    estado_codigo: "33",
  },
  {
    codigo: "2931004",
    municipio: "Tanhaçu",
    estado_codigo: "29",
  },
  {
    codigo: "2709004",
    municipio: "Tanque d'Arca",
    estado_codigo: "27",
  },
  {
    codigo: "2210979",
    municipio: "Tanque do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2931053",
    municipio: "Tanque Novo",
    estado_codigo: "29",
  },
  {
    codigo: "2931103",
    municipio: "Tanquinho",
    estado_codigo: "29",
  },
  {
    codigo: "3168051",
    municipio: "Taparuba",
    estado_codigo: "31",
  },
  {
    codigo: "1304104",
    municipio: "Tapauá",
    estado_codigo: "13",
  },
  {
    codigo: "4126801",
    municipio: "Tapejara",
    estado_codigo: "41",
  },
  {
    codigo: "4320909",
    municipio: "Tapejara",
    estado_codigo: "43",
  },
  {
    codigo: "4321006",
    municipio: "Tapera",
    estado_codigo: "43",
  },
  {
    codigo: "2516508",
    municipio: "Taperoá",
    estado_codigo: "25",
  },
  {
    codigo: "2931202",
    municipio: "Taperoá",
    estado_codigo: "29",
  },
  {
    codigo: "4321105",
    municipio: "Tapes",
    estado_codigo: "43",
  },
  {
    codigo: "3168101",
    municipio: "Tapira",
    estado_codigo: "31",
  },
  {
    codigo: "4126900",
    municipio: "Tapira",
    estado_codigo: "41",
  },
  {
    codigo: "3553500",
    municipio: "Tapiraí",
    estado_codigo: "35",
  },
  {
    codigo: "3168200",
    municipio: "Tapiraí",
    estado_codigo: "31",
  },
  {
    codigo: "2931301",
    municipio: "Tapiramutá",
    estado_codigo: "29",
  },
  {
    codigo: "3553609",
    municipio: "Tapiratiba",
    estado_codigo: "35",
  },
  {
    codigo: "5108006",
    municipio: "Tapurah",
    estado_codigo: "51",
  },
  {
    codigo: "4321204",
    municipio: "Taquara",
    estado_codigo: "43",
  },
  {
    codigo: "3168309",
    municipio: "Taquaraçu de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "3553658",
    municipio: "Taquaral",
    estado_codigo: "35",
  },
  {
    codigo: "5221007",
    municipio: "Taquaral de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "2709103",
    municipio: "Taquarana",
    estado_codigo: "27",
  },
  {
    codigo: "4321303",
    municipio: "Taquari",
    estado_codigo: "43",
  },
  {
    codigo: "3553708",
    municipio: "Taquaritinga",
    estado_codigo: "35",
  },
  {
    codigo: "2615003",
    municipio: "Taquaritinga do Norte",
    estado_codigo: "26",
  },
  {
    codigo: "3553807",
    municipio: "Taquarituba",
    estado_codigo: "35",
  },
  {
    codigo: "3553856",
    municipio: "Taquarivaí",
    estado_codigo: "35",
  },
  {
    codigo: "4321329",
    municipio: "Taquaruçu do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "5007976",
    municipio: "Taquarussu",
    estado_codigo: "50",
  },
  {
    codigo: "3553906",
    municipio: "Tarabai",
    estado_codigo: "35",
  },
  {
    codigo: "1200609",
    municipio: "Tarauacá",
    estado_codigo: "12",
  },
  {
    codigo: "2313252",
    municipio: "Tarrafas",
    estado_codigo: "23",
  },
  {
    codigo: "1600709",
    municipio: "Tartarugalzinho",
    estado_codigo: "16",
  },
  {
    codigo: "3553955",
    municipio: "Tarumã",
    estado_codigo: "35",
  },
  {
    codigo: "3168408",
    municipio: "Tarumirim",
    estado_codigo: "31",
  },
  {
    codigo: "2112001",
    municipio: "Tasso Fragoso",
    estado_codigo: "21",
  },
  {
    codigo: "3554003",
    municipio: "Tatuí",
    estado_codigo: "35",
  },
  {
    codigo: "2313302",
    municipio: "Tauá",
    estado_codigo: "23",
  },
  {
    codigo: "3554102",
    municipio: "Taubaté",
    estado_codigo: "35",
  },
  {
    codigo: "2516607",
    municipio: "Tavares",
    estado_codigo: "25",
  },
  {
    codigo: "4321352",
    municipio: "Tavares",
    estado_codigo: "43",
  },
  {
    codigo: "1304203",
    municipio: "Tefé",
    estado_codigo: "13",
  },
  {
    codigo: "2516706",
    municipio: "Teixeira",
    estado_codigo: "25",
  },
  {
    codigo: "2931350",
    municipio: "Teixeira de Freitas",
    estado_codigo: "29",
  },
  {
    codigo: "3168507",
    municipio: "Teixeiras",
    estado_codigo: "31",
  },
  {
    codigo: "4127007",
    municipio: "Teixeira Soares",
    estado_codigo: "41",
  },
  {
    codigo: "1101559",
    municipio: "Teixeirópolis",
    estado_codigo: "11",
  },
  {
    codigo: "2313351",
    municipio: "Tejuçuoca",
    estado_codigo: "23",
  },
  {
    codigo: "3554201",
    municipio: "Tejupá",
    estado_codigo: "35",
  },
  {
    codigo: "4127106",
    municipio: "Telêmaco Borba",
    estado_codigo: "41",
  },
  {
    codigo: "2807303",
    municipio: "Telha",
    estado_codigo: "28",
  },
  {
    codigo: "2414100",
    municipio: "Tenente Ananias",
    estado_codigo: "24",
  },
  {
    codigo: "2414159",
    municipio: "Tenente Laurentino Cruz",
    estado_codigo: "24",
  },
  {
    codigo: "4321402",
    municipio: "Tenente Portela",
    estado_codigo: "43",
  },
  {
    codigo: "2516755",
    municipio: "Tenório",
    estado_codigo: "25",
  },
  {
    codigo: "2931400",
    municipio: "Teodoro Sampaio",
    estado_codigo: "29",
  },
  {
    codigo: "3554300",
    municipio: "Teodoro Sampaio",
    estado_codigo: "35",
  },
  {
    codigo: "2931509",
    municipio: "Teofilândia",
    estado_codigo: "29",
  },
  {
    codigo: "3168606",
    municipio: "Teófilo Otoni",
    estado_codigo: "31",
  },
  {
    codigo: "2931608",
    municipio: "Teolândia",
    estado_codigo: "29",
  },
  {
    codigo: "2709152",
    municipio: "Teotônio Vilela",
    estado_codigo: "27",
  },
  {
    codigo: "5008008",
    municipio: "Terenos",
    estado_codigo: "50",
  },
  {
    codigo: "2211001",
    municipio: "Teresina",
    estado_codigo: "22",
  },
  {
    codigo: "5221080",
    municipio: "Teresina de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "3305802",
    municipio: "Teresópolis",
    estado_codigo: "33",
  },
  {
    codigo: "2615102",
    municipio: "Terezinha",
    estado_codigo: "26",
  },
  {
    codigo: "5221197",
    municipio: "Terezópolis de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "1507961",
    municipio: "Terra Alta",
    estado_codigo: "15",
  },
  {
    codigo: "4127205",
    municipio: "Terra Boa",
    estado_codigo: "41",
  },
  {
    codigo: "4321436",
    municipio: "Terra de Areia",
    estado_codigo: "43",
  },
  {
    codigo: "2615201",
    municipio: "Terra Nova",
    estado_codigo: "26",
  },
  {
    codigo: "2931707",
    municipio: "Terra Nova",
    estado_codigo: "29",
  },
  {
    codigo: "5108055",
    municipio: "Terra Nova do Norte",
    estado_codigo: "51",
  },
  {
    codigo: "4127304",
    municipio: "Terra Rica",
    estado_codigo: "41",
  },
  {
    codigo: "4127403",
    municipio: "Terra Roxa",
    estado_codigo: "41",
  },
  {
    codigo: "3554409",
    municipio: "Terra Roxa",
    estado_codigo: "35",
  },
  {
    codigo: "1507979",
    municipio: "Terra Santa",
    estado_codigo: "15",
  },
  {
    codigo: "5108105",
    municipio: "Tesouro",
    estado_codigo: "51",
  },
  {
    codigo: "4321451",
    municipio: "Teutônia",
    estado_codigo: "43",
  },
  {
    codigo: "1101609",
    municipio: "Theobroma",
    estado_codigo: "11",
  },
  {
    codigo: "2313401",
    municipio: "Tianguá",
    estado_codigo: "23",
  },
  {
    codigo: "4127502",
    municipio: "Tibagi",
    estado_codigo: "41",
  },
  {
    codigo: "2411056",
    municipio: "Tibau",
    estado_codigo: "24",
  },
  {
    codigo: "2414209",
    municipio: "Tibau do Sul",
    estado_codigo: "24",
  },
  {
    codigo: "3554508",
    municipio: "Tietê",
    estado_codigo: "35",
  },
  {
    codigo: "4217956",
    municipio: "Tigrinhos",
    estado_codigo: "42",
  },
  {
    codigo: "4218004",
    municipio: "Tijucas",
    estado_codigo: "42",
  },
  {
    codigo: "4127601",
    municipio: "Tijucas do Sul",
    estado_codigo: "41",
  },
  {
    codigo: "2615300",
    municipio: "Timbaúba",
    estado_codigo: "26",
  },
  {
    codigo: "2414308",
    municipio: "Timbaúba dos Batistas",
    estado_codigo: "24",
  },
  {
    codigo: "4218103",
    municipio: "Timbé do Sul",
    estado_codigo: "42",
  },
  {
    codigo: "2112100",
    municipio: "Timbiras",
    estado_codigo: "21",
  },
  {
    codigo: "4218202",
    municipio: "Timbó",
    estado_codigo: "42",
  },
  {
    codigo: "4218251",
    municipio: "Timbó Grande",
    estado_codigo: "42",
  },
  {
    codigo: "3554607",
    municipio: "Timburi",
    estado_codigo: "35",
  },
  {
    codigo: "2112209",
    municipio: "Timon",
    estado_codigo: "21",
  },
  {
    codigo: "3168705",
    municipio: "Timóteo",
    estado_codigo: "31",
  },
  {
    codigo: "4321469",
    municipio: "Tio Hugo",
    estado_codigo: "43",
  },
  {
    codigo: "3168804",
    municipio: "Tiradentes",
    estado_codigo: "31",
  },
  {
    codigo: "4321477",
    municipio: "Tiradentes do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3168903",
    municipio: "Tiros",
    estado_codigo: "31",
  },
  {
    codigo: "2807402",
    municipio: "Tobias Barreto",
    estado_codigo: "28",
  },
  {
    codigo: "1721109",
    municipio: "Tocantínia",
    estado_codigo: "17",
  },
  {
    codigo: "1721208",
    municipio: "Tocantinópolis",
    estado_codigo: "17",
  },
  {
    codigo: "3169000",
    municipio: "Tocantins",
    estado_codigo: "31",
  },
  {
    codigo: "3169059",
    municipio: "Tocos do Moji",
    estado_codigo: "31",
  },
  {
    codigo: "4127700",
    municipio: "Toledo",
    estado_codigo: "41",
  },
  {
    codigo: "3169109",
    municipio: "Toledo",
    estado_codigo: "31",
  },
  {
    codigo: "2807501",
    municipio: "Tomar do Geru",
    estado_codigo: "28",
  },
  {
    codigo: "4127809",
    municipio: "Tomazina",
    estado_codigo: "41",
  },
  {
    codigo: "3169208",
    municipio: "Tombos",
    estado_codigo: "31",
  },
  {
    codigo: "1508001",
    municipio: "Tomé-Açu",
    estado_codigo: "15",
  },
  {
    codigo: "1304237",
    municipio: "Tonantins",
    estado_codigo: "13",
  },
  {
    codigo: "2615409",
    municipio: "Toritama",
    estado_codigo: "26",
  },
  {
    codigo: "5108204",
    municipio: "Torixoréu",
    estado_codigo: "51",
  },
  {
    codigo: "4321493",
    municipio: "Toropi",
    estado_codigo: "43",
  },
  {
    codigo: "3554656",
    municipio: "Torre de Pedra",
    estado_codigo: "35",
  },
  {
    codigo: "4321501",
    municipio: "Torres",
    estado_codigo: "43",
  },
  {
    codigo: "3554706",
    municipio: "Torrinha",
    estado_codigo: "35",
  },
  {
    codigo: "2414407",
    municipio: "Touros",
    estado_codigo: "24",
  },
  {
    codigo: "3554755",
    municipio: "Trabiju",
    estado_codigo: "35",
  },
  {
    codigo: "1508035",
    municipio: "Tracuateua",
    estado_codigo: "15",
  },
  {
    codigo: "2615508",
    municipio: "Tracunhaém",
    estado_codigo: "26",
  },
  {
    codigo: "2709202",
    municipio: "Traipu",
    estado_codigo: "27",
  },
  {
    codigo: "1508050",
    municipio: "Trairão",
    estado_codigo: "15",
  },
  {
    codigo: "2313500",
    municipio: "Trairi",
    estado_codigo: "23",
  },
  {
    codigo: "3305901",
    municipio: "Trajano de Morais",
    estado_codigo: "33",
  },
  {
    codigo: "4321600",
    municipio: "Tramandaí",
    estado_codigo: "43",
  },
  {
    codigo: "4321626",
    municipio: "Travesseiro",
    estado_codigo: "43",
  },
  {
    codigo: "2931806",
    municipio: "Tremedal",
    estado_codigo: "29",
  },
  {
    codigo: "3554805",
    municipio: "Tremembé",
    estado_codigo: "35",
  },
  {
    codigo: "4321634",
    municipio: "Três Arroios",
    estado_codigo: "43",
  },
  {
    codigo: "4218301",
    municipio: "Três Barras",
    estado_codigo: "42",
  },
  {
    codigo: "4127858",
    municipio: "Três Barras do Paraná",
    estado_codigo: "41",
  },
  {
    codigo: "4321667",
    municipio: "Três Cachoeiras",
    estado_codigo: "43",
  },
  {
    codigo: "3169307",
    municipio: "Três Corações",
    estado_codigo: "31",
  },
  {
    codigo: "4321709",
    municipio: "Três Coroas",
    estado_codigo: "43",
  },
  {
    codigo: "4321808",
    municipio: "Três de Maio",
    estado_codigo: "43",
  },
  {
    codigo: "4321832",
    municipio: "Três Forquilhas",
    estado_codigo: "43",
  },
  {
    codigo: "3554904",
    municipio: "Três Fronteiras",
    estado_codigo: "35",
  },
  {
    codigo: "5008305",
    municipio: "Três Lagoas",
    estado_codigo: "50",
  },
  {
    codigo: "3169356",
    municipio: "Três Marias",
    estado_codigo: "31",
  },
  {
    codigo: "4321857",
    municipio: "Três Palmeiras",
    estado_codigo: "43",
  },
  {
    codigo: "4321907",
    municipio: "Três Passos",
    estado_codigo: "43",
  },
  {
    codigo: "3169406",
    municipio: "Três Pontas",
    estado_codigo: "31",
  },
  {
    codigo: "5221304",
    municipio: "Três Ranchos",
    estado_codigo: "52",
  },
  {
    codigo: "3306008",
    municipio: "Três Rios",
    estado_codigo: "33",
  },
  {
    codigo: "4218350",
    municipio: "Treviso",
    estado_codigo: "42",
  },
  {
    codigo: "4218400",
    municipio: "Treze de Maio",
    estado_codigo: "42",
  },
  {
    codigo: "4218509",
    municipio: "Treze Tílias",
    estado_codigo: "42",
  },
  {
    codigo: "5221403",
    municipio: "Trindade",
    estado_codigo: "52",
  },
  {
    codigo: "2615607",
    municipio: "Trindade",
    estado_codigo: "26",
  },
  {
    codigo: "4321956",
    municipio: "Trindade do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "2615706",
    municipio: "Triunfo",
    estado_codigo: "26",
  },
  {
    codigo: "2516805",
    municipio: "Triunfo",
    estado_codigo: "25",
  },
  {
    codigo: "4322004",
    municipio: "Triunfo",
    estado_codigo: "43",
  },
  {
    codigo: "2414456",
    municipio: "Triunfo Potiguar",
    estado_codigo: "24",
  },
  {
    codigo: "2112233",
    municipio: "Trizidela do Vale",
    estado_codigo: "21",
  },
  {
    codigo: "5221452",
    municipio: "Trombas",
    estado_codigo: "52",
  },
  {
    codigo: "4218608",
    municipio: "Trombudo Central",
    estado_codigo: "42",
  },
  {
    codigo: "4218707",
    municipio: "Tubarão",
    estado_codigo: "42",
  },
  {
    codigo: "2931905",
    municipio: "Tucano",
    estado_codigo: "29",
  },
  {
    codigo: "1508084",
    municipio: "Tucumã",
    estado_codigo: "15",
  },
  {
    codigo: "4322103",
    municipio: "Tucunduva",
    estado_codigo: "43",
  },
  {
    codigo: "1508100",
    municipio: "Tucuruí",
    estado_codigo: "15",
  },
  {
    codigo: "2112274",
    municipio: "Tufilândia",
    estado_codigo: "21",
  },
  {
    codigo: "3554953",
    municipio: "Tuiuti",
    estado_codigo: "35",
  },
  {
    codigo: "3169505",
    municipio: "Tumiritinga",
    estado_codigo: "31",
  },
  {
    codigo: "4218756",
    municipio: "Tunápolis",
    estado_codigo: "42",
  },
  {
    codigo: "4322152",
    municipio: "Tunas",
    estado_codigo: "43",
  },
  {
    codigo: "4127882",
    municipio: "Tunas do Paraná",
    estado_codigo: "41",
  },
  {
    codigo: "4127908",
    municipio: "Tuneiras do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "2112308",
    municipio: "Tuntum",
    estado_codigo: "21",
  },
  {
    codigo: "3555000",
    municipio: "Tupã",
    estado_codigo: "35",
  },
  {
    codigo: "3169604",
    municipio: "Tupaciguara",
    estado_codigo: "31",
  },
  {
    codigo: "2615805",
    municipio: "Tupanatinga",
    estado_codigo: "26",
  },
  {
    codigo: "4322186",
    municipio: "Tupanci do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "4322202",
    municipio: "Tupanciretã",
    estado_codigo: "43",
  },
  {
    codigo: "4322251",
    municipio: "Tupandi",
    estado_codigo: "43",
  },
  {
    codigo: "4322301",
    municipio: "Tuparendi",
    estado_codigo: "43",
  },
  {
    codigo: "2615904",
    municipio: "Tuparetama",
    estado_codigo: "26",
  },
  {
    codigo: "4127957",
    municipio: "Tupãssi",
    estado_codigo: "41",
  },
  {
    codigo: "3555109",
    municipio: "Tupi Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "1721257",
    municipio: "Tupirama",
    estado_codigo: "17",
  },
  {
    codigo: "1721307",
    municipio: "Tupiratins",
    estado_codigo: "17",
  },
  {
    codigo: "2112407",
    municipio: "Turiaçu",
    estado_codigo: "21",
  },
  {
    codigo: "2112456",
    municipio: "Turilândia",
    estado_codigo: "21",
  },
  {
    codigo: "3555208",
    municipio: "Turiúba",
    estado_codigo: "35",
  },
  {
    codigo: "3555307",
    municipio: "Turmalina",
    estado_codigo: "35",
  },
  {
    codigo: "3169703",
    municipio: "Turmalina",
    estado_codigo: "31",
  },
  {
    codigo: "4322327",
    municipio: "Turuçu",
    estado_codigo: "43",
  },
  {
    codigo: "2313559",
    municipio: "Tururu",
    estado_codigo: "23",
  },
  {
    codigo: "5221502",
    municipio: "Turvânia",
    estado_codigo: "52",
  },
  {
    codigo: "5221551",
    municipio: "Turvelândia",
    estado_codigo: "52",
  },
  {
    codigo: "4218806",
    municipio: "Turvo",
    estado_codigo: "42",
  },
  {
    codigo: "4127965",
    municipio: "Turvo",
    estado_codigo: "41",
  },
  {
    codigo: "3169802",
    municipio: "Turvolândia",
    estado_codigo: "31",
  },
  {
    codigo: "2112506",
    municipio: "Tutóia",
    estado_codigo: "21",
  },
  {
    codigo: "1304260",
    municipio: "Uarini",
    estado_codigo: "13",
  },
  {
    codigo: "2932002",
    municipio: "Uauá",
    estado_codigo: "29",
  },
  {
    codigo: "3169901",
    municipio: "Ubá",
    estado_codigo: "31",
  },
  {
    codigo: "3170008",
    municipio: "Ubaí",
    estado_codigo: "31",
  },
  {
    codigo: "2932101",
    municipio: "Ubaíra",
    estado_codigo: "29",
  },
  {
    codigo: "2932200",
    municipio: "Ubaitaba",
    estado_codigo: "29",
  },
  {
    codigo: "2313609",
    municipio: "Ubajara",
    estado_codigo: "23",
  },
  {
    codigo: "3170057",
    municipio: "Ubaporanga",
    estado_codigo: "31",
  },
  {
    codigo: "3555356",
    municipio: "Ubarana",
    estado_codigo: "35",
  },
  {
    codigo: "2932309",
    municipio: "Ubatã",
    estado_codigo: "29",
  },
  {
    codigo: "3555406",
    municipio: "Ubatuba",
    estado_codigo: "35",
  },
  {
    codigo: "3170107",
    municipio: "Uberaba",
    estado_codigo: "31",
  },
  {
    codigo: "3170206",
    municipio: "Uberlândia",
    estado_codigo: "31",
  },
  {
    codigo: "3555505",
    municipio: "Ubirajara",
    estado_codigo: "35",
  },
  {
    codigo: "4128005",
    municipio: "Ubiratã",
    estado_codigo: "41",
  },
  {
    codigo: "4322343",
    municipio: "Ubiretama",
    estado_codigo: "43",
  },
  {
    codigo: "3555604",
    municipio: "Uchoa",
    estado_codigo: "35",
  },
  {
    codigo: "2932408",
    municipio: "Uibaí",
    estado_codigo: "29",
  },
  {
    codigo: "1400704",
    municipio: "Uiramutã",
    estado_codigo: "14",
  },
  {
    codigo: "5221577",
    municipio: "Uirapuru",
    estado_codigo: "52",
  },
  {
    codigo: "2516904",
    municipio: "Uiraúna",
    estado_codigo: "25",
  },
  {
    codigo: "1508126",
    municipio: "Ulianópolis",
    estado_codigo: "15",
  },
  {
    codigo: "2313708",
    municipio: "Umari",
    estado_codigo: "23",
  },
  {
    codigo: "2414506",
    municipio: "Umarizal",
    estado_codigo: "24",
  },
  {
    codigo: "2807600",
    municipio: "Umbaúba",
    estado_codigo: "28",
  },
  {
    codigo: "2932457",
    municipio: "Umburanas",
    estado_codigo: "29",
  },
  {
    codigo: "3170305",
    municipio: "Umburatiba",
    estado_codigo: "31",
  },
  {
    codigo: "2517001",
    municipio: "Umbuzeiro",
    estado_codigo: "25",
  },
  {
    codigo: "2313757",
    municipio: "Umirim",
    estado_codigo: "23",
  },
  {
    codigo: "4128104",
    municipio: "Umuarama",
    estado_codigo: "41",
  },
  {
    codigo: "2932507",
    municipio: "Una",
    estado_codigo: "29",
  },
  {
    codigo: "3170404",
    municipio: "Unaí",
    estado_codigo: "31",
  },
  {
    codigo: "2211100",
    municipio: "União",
    estado_codigo: "22",
  },
  {
    codigo: "4322350",
    municipio: "União da Serra",
    estado_codigo: "43",
  },
  {
    codigo: "4128203",
    municipio: "União da Vitória",
    estado_codigo: "41",
  },
  {
    codigo: "3170438",
    municipio: "União de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "4218855",
    municipio: "União do Oeste",
    estado_codigo: "42",
  },
  {
    codigo: "2709301",
    municipio: "União dos Palmares",
    estado_codigo: "27",
  },
  {
    codigo: "5108303",
    municipio: "União do Sul",
    estado_codigo: "51",
  },
  {
    codigo: "3555703",
    municipio: "União Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "4128302",
    municipio: "Uniflor",
    estado_codigo: "41",
  },
  {
    codigo: "4322376",
    municipio: "Unistalda",
    estado_codigo: "43",
  },
  {
    codigo: "2414605",
    municipio: "Upanema",
    estado_codigo: "24",
  },
  {
    codigo: "4128401",
    municipio: "Uraí",
    estado_codigo: "41",
  },
  {
    codigo: "2932606",
    municipio: "Urandi",
    estado_codigo: "29",
  },
  {
    codigo: "3555802",
    municipio: "Urânia",
    estado_codigo: "35",
  },
  {
    codigo: "2112605",
    municipio: "Urbano Santos",
    estado_codigo: "21",
  },
  {
    codigo: "3555901",
    municipio: "Uru",
    estado_codigo: "35",
  },
  {
    codigo: "5221601",
    municipio: "Uruaçu",
    estado_codigo: "52",
  },
  {
    codigo: "5221700",
    municipio: "Uruana",
    estado_codigo: "52",
  },
  {
    codigo: "3170479",
    municipio: "Uruana de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "1508159",
    municipio: "Uruará",
    estado_codigo: "15",
  },
  {
    codigo: "4218905",
    municipio: "Urubici",
    estado_codigo: "42",
  },
  {
    codigo: "2313807",
    municipio: "Uruburetama",
    estado_codigo: "23",
  },
  {
    codigo: "3170503",
    municipio: "Urucânia",
    estado_codigo: "31",
  },
  {
    codigo: "1304302",
    municipio: "Urucará",
    estado_codigo: "13",
  },
  {
    codigo: "2932705",
    municipio: "Uruçuca",
    estado_codigo: "29",
  },
  {
    codigo: "2211209",
    municipio: "Uruçuí",
    estado_codigo: "22",
  },
  {
    codigo: "3170529",
    municipio: "Urucuia",
    estado_codigo: "31",
  },
  {
    codigo: "1304401",
    municipio: "Urucurituba",
    estado_codigo: "13",
  },
  {
    codigo: "4322400",
    municipio: "Uruguaiana",
    estado_codigo: "43",
  },
  {
    codigo: "2313906",
    municipio: "Uruoca",
    estado_codigo: "23",
  },
  {
    codigo: "1101708",
    municipio: "Urupá",
    estado_codigo: "11",
  },
  {
    codigo: "4218954",
    municipio: "Urupema",
    estado_codigo: "42",
  },
  {
    codigo: "3556008",
    municipio: "Urupês",
    estado_codigo: "35",
  },
  {
    codigo: "4219002",
    municipio: "Urussanga",
    estado_codigo: "42",
  },
  {
    codigo: "5221809",
    municipio: "Urutaí",
    estado_codigo: "52",
  },
  {
    codigo: "2932804",
    municipio: "Utinga",
    estado_codigo: "29",
  },
  {
    codigo: "4322509",
    municipio: "Vacaria",
    estado_codigo: "43",
  },
  {
    codigo: "5108352",
    municipio: "Vale de São Domingos",
    estado_codigo: "51",
  },
  {
    codigo: "1101757",
    municipio: "Vale do Anari",
    estado_codigo: "11",
  },
  {
    codigo: "1101807",
    municipio: "Vale do Paraíso",
    estado_codigo: "11",
  },
  {
    codigo: "4322533",
    municipio: "Vale do Sol",
    estado_codigo: "43",
  },
  {
    codigo: "3306107",
    municipio: "Valença",
    estado_codigo: "33",
  },
  {
    codigo: "2932903",
    municipio: "Valença",
    estado_codigo: "29",
  },
  {
    codigo: "2211308",
    municipio: "Valença do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2933000",
    municipio: "Valente",
    estado_codigo: "29",
  },
  {
    codigo: "3556107",
    municipio: "Valentim Gentil",
    estado_codigo: "35",
  },
  {
    codigo: "4322541",
    municipio: "Vale Real",
    estado_codigo: "43",
  },
  {
    codigo: "4322525",
    municipio: "Vale Verde",
    estado_codigo: "43",
  },
  {
    codigo: "3556206",
    municipio: "Valinhos",
    estado_codigo: "35",
  },
  {
    codigo: "3556305",
    municipio: "Valparaíso",
    estado_codigo: "35",
  },
  {
    codigo: "5221858",
    municipio: "Valparaíso de Goiás",
    estado_codigo: "52",
  },
  {
    codigo: "4322558",
    municipio: "Vanini",
    estado_codigo: "43",
  },
  {
    codigo: "4219101",
    municipio: "Vargeão",
    estado_codigo: "42",
  },
  {
    codigo: "3556354",
    municipio: "Vargem",
    estado_codigo: "35",
  },
  {
    codigo: "4219150",
    municipio: "Vargem",
    estado_codigo: "42",
  },
  {
    codigo: "3170578",
    municipio: "Vargem Alegre",
    estado_codigo: "31",
  },
  {
    codigo: "3205036",
    municipio: "Vargem Alta",
    estado_codigo: "32",
  },
  {
    codigo: "4219176",
    municipio: "Vargem Bonita",
    estado_codigo: "42",
  },
  {
    codigo: "3170602",
    municipio: "Vargem Bonita",
    estado_codigo: "31",
  },
  {
    codigo: "2112704",
    municipio: "Vargem Grande",
    estado_codigo: "21",
  },
  {
    codigo: "3170651",
    municipio: "Vargem Grande do Rio Pardo",
    estado_codigo: "31",
  },
  {
    codigo: "3556404",
    municipio: "Vargem Grande do Sul",
    estado_codigo: "35",
  },
  {
    codigo: "3556453",
    municipio: "Vargem Grande Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "3170701",
    municipio: "Varginha",
    estado_codigo: "31",
  },
  {
    codigo: "5221908",
    municipio: "Varjão",
    estado_codigo: "52",
  },
  {
    codigo: "3170750",
    municipio: "Varjão de Minas",
    estado_codigo: "31",
  },
  {
    codigo: "2313955",
    municipio: "Varjota",
    estado_codigo: "23",
  },
  {
    codigo: "3306156",
    municipio: "Varre-Sai",
    estado_codigo: "33",
  },
  {
    codigo: "2517100",
    municipio: "Várzea",
    estado_codigo: "25",
  },
  {
    codigo: "2414704",
    municipio: "Várzea",
    estado_codigo: "24",
  },
  {
    codigo: "2314003",
    municipio: "Várzea Alegre",
    estado_codigo: "23",
  },
  {
    codigo: "2211357",
    municipio: "Várzea Branca",
    estado_codigo: "22",
  },
  {
    codigo: "3170800",
    municipio: "Várzea da Palma",
    estado_codigo: "31",
  },
  {
    codigo: "2933059",
    municipio: "Várzea da Roça",
    estado_codigo: "29",
  },
  {
    codigo: "2933109",
    municipio: "Várzea do Poço",
    estado_codigo: "29",
  },
  {
    codigo: "2211407",
    municipio: "Várzea Grande",
    estado_codigo: "22",
  },
  {
    codigo: "5108402",
    municipio: "Várzea Grande",
    estado_codigo: "51",
  },
  {
    codigo: "2933158",
    municipio: "Várzea Nova",
    estado_codigo: "29",
  },
  {
    codigo: "3556503",
    municipio: "Várzea Paulista",
    estado_codigo: "35",
  },
  {
    codigo: "2933174",
    municipio: "Varzedo",
    estado_codigo: "29",
  },
  {
    codigo: "3170909",
    municipio: "Varzelândia",
    estado_codigo: "31",
  },
  {
    codigo: "3306206",
    municipio: "Vassouras",
    estado_codigo: "33",
  },
  {
    codigo: "3171006",
    municipio: "Vazante",
    estado_codigo: "31",
  },
  {
    codigo: "4322608",
    municipio: "Venâncio Aires",
    estado_codigo: "43",
  },
  {
    codigo: "3205069",
    municipio: "Venda Nova do Imigrante",
    estado_codigo: "32",
  },
  {
    codigo: "2414753",
    municipio: "Venha-Ver",
    estado_codigo: "24",
  },
  {
    codigo: "4128534",
    municipio: "Ventania",
    estado_codigo: "41",
  },
  {
    codigo: "2616001",
    municipio: "Venturosa",
    estado_codigo: "26",
  },
  {
    codigo: "5108501",
    municipio: "Vera",
    estado_codigo: "51",
  },
  {
    codigo: "3556602",
    municipio: "Vera Cruz",
    estado_codigo: "35",
  },
  {
    codigo: "2414803",
    municipio: "Vera Cruz",
    estado_codigo: "24",
  },
  {
    codigo: "2933208",
    municipio: "Vera Cruz",
    estado_codigo: "29",
  },
  {
    codigo: "4322707",
    municipio: "Vera Cruz",
    estado_codigo: "43",
  },
  {
    codigo: "4128559",
    municipio: "Vera Cruz do Oeste",
    estado_codigo: "41",
  },
  {
    codigo: "2211506",
    municipio: "Vera Mendes",
    estado_codigo: "22",
  },
  {
    codigo: "4322806",
    municipio: "Veranópolis",
    estado_codigo: "43",
  },
  {
    codigo: "2616100",
    municipio: "Verdejante",
    estado_codigo: "26",
  },
  {
    codigo: "3171030",
    municipio: "Verdelândia",
    estado_codigo: "31",
  },
  {
    codigo: "4128609",
    municipio: "Verê",
    estado_codigo: "41",
  },
  {
    codigo: "2933257",
    municipio: "Vereda",
    estado_codigo: "29",
  },
  {
    codigo: "3171071",
    municipio: "Veredinha",
    estado_codigo: "31",
  },
  {
    codigo: "3171105",
    municipio: "Veríssimo",
    estado_codigo: "31",
  },
  {
    codigo: "3171154",
    municipio: "Vermelho Novo",
    estado_codigo: "31",
  },
  {
    codigo: "2616183",
    municipio: "Vertente do Lério",
    estado_codigo: "26",
  },
  {
    codigo: "2616209",
    municipio: "Vertentes",
    estado_codigo: "26",
  },
  {
    codigo: "3171204",
    municipio: "Vespasiano",
    estado_codigo: "31",
  },
  {
    codigo: "4322855",
    municipio: "Vespasiano Correa",
    estado_codigo: "43",
  },
  {
    codigo: "4322905",
    municipio: "Viadutos",
    estado_codigo: "43",
  },
  {
    codigo: "4323002",
    municipio: "Viamão",
    estado_codigo: "43",
  },
  {
    codigo: "2112803",
    municipio: "Viana",
    estado_codigo: "21",
  },
  {
    codigo: "3205101",
    municipio: "Viana",
    estado_codigo: "32",
  },
  {
    codigo: "5222005",
    municipio: "Vianópolis",
    estado_codigo: "52",
  },
  {
    codigo: "2616308",
    municipio: "Vicência",
    estado_codigo: "26",
  },
  {
    codigo: "4323101",
    municipio: "Vicente Dutra",
    estado_codigo: "43",
  },
  {
    codigo: "5008404",
    municipio: "Vicentina",
    estado_codigo: "50",
  },
  {
    codigo: "5222054",
    municipio: "Vicentinópolis",
    estado_codigo: "52",
  },
  {
    codigo: "2414902",
    municipio: "Viçosa",
    estado_codigo: "24",
  },
  {
    codigo: "3171303",
    municipio: "Viçosa",
    estado_codigo: "31",
  },
  {
    codigo: "2709400",
    municipio: "Viçosa",
    estado_codigo: "27",
  },
  {
    codigo: "2314102",
    municipio: "Viçosa do Ceará",
    estado_codigo: "23",
  },
  {
    codigo: "4323200",
    municipio: "Victor Graeff",
    estado_codigo: "43",
  },
  {
    codigo: "4219200",
    municipio: "Vidal Ramos",
    estado_codigo: "42",
  },
  {
    codigo: "4219309",
    municipio: "Videira",
    estado_codigo: "42",
  },
  {
    codigo: "3171402",
    municipio: "Vieiras",
    estado_codigo: "31",
  },
  {
    codigo: "2517209",
    municipio: "Vieirópolis",
    estado_codigo: "25",
  },
  {
    codigo: "1508209",
    municipio: "Vigia",
    estado_codigo: "15",
  },
  {
    codigo: "5105507",
    municipio: "Vila Bela da Santíssima Trindade",
    estado_codigo: "51",
  },
  {
    codigo: "5222203",
    municipio: "Vila Boa",
    estado_codigo: "52",
  },
  {
    codigo: "2415008",
    municipio: "Vila Flor",
    estado_codigo: "24",
  },
  {
    codigo: "4323309",
    municipio: "Vila Flores",
    estado_codigo: "43",
  },
  {
    codigo: "4323358",
    municipio: "Vila Lângaro",
    estado_codigo: "43",
  },
  {
    codigo: "4323408",
    municipio: "Vila Maria",
    estado_codigo: "43",
  },
  {
    codigo: "2211605",
    municipio: "Vila Nova do Piauí",
    estado_codigo: "22",
  },
  {
    codigo: "2112852",
    municipio: "Vila Nova dos Martírios",
    estado_codigo: "21",
  },
  {
    codigo: "4323457",
    municipio: "Vila Nova do Sul",
    estado_codigo: "43",
  },
  {
    codigo: "3205150",
    municipio: "Vila Pavão",
    estado_codigo: "32",
  },
  {
    codigo: "5222302",
    municipio: "Vila Propício",
    estado_codigo: "52",
  },
  {
    codigo: "5108600",
    municipio: "Vila Rica",
    estado_codigo: "51",
  },
  {
    codigo: "3205176",
    municipio: "Vila Valério",
    estado_codigo: "32",
  },
  {
    codigo: "3205200",
    municipio: "Vila Velha",
    estado_codigo: "32",
  },
  {
    codigo: "1100304",
    municipio: "Vilhena",
    estado_codigo: "11",
  },
  {
    codigo: "3556701",
    municipio: "Vinhedo",
    estado_codigo: "35",
  },
  {
    codigo: "3556800",
    municipio: "Viradouro",
    estado_codigo: "35",
  },
  {
    codigo: "3171600",
    municipio: "Virgem da Lapa",
    estado_codigo: "31",
  },
  {
    codigo: "3171709",
    municipio: "Virgínia",
    estado_codigo: "31",
  },
  {
    codigo: "3171808",
    municipio: "Virginópolis",
    estado_codigo: "31",
  },
  {
    codigo: "3171907",
    municipio: "Virgolândia",
    estado_codigo: "31",
  },
  {
    codigo: "4128658",
    municipio: "Virmond",
    estado_codigo: "41",
  },
  {
    codigo: "3172004",
    municipio: "Visconde do Rio Branco",
    estado_codigo: "31",
  },
  {
    codigo: "1508308",
    municipio: "Viseu",
    estado_codigo: "15",
  },
  {
    codigo: "4323507",
    municipio: "Vista Alegre",
    estado_codigo: "43",
  },
  {
    codigo: "3556909",
    municipio: "Vista Alegre do Alto",
    estado_codigo: "35",
  },
  {
    codigo: "4323606",
    municipio: "Vista Alegre do Prata",
    estado_codigo: "43",
  },
  {
    codigo: "4323705",
    municipio: "Vista Gaúcha",
    estado_codigo: "43",
  },
  {
    codigo: "2505501",
    municipio: "Vista Serrana",
    estado_codigo: "25",
  },
  {
    codigo: "3205309",
    municipio: "Vitória",
    estado_codigo: "32",
  },
  {
    codigo: "3556958",
    municipio: "Vitória Brasil",
    estado_codigo: "35",
  },
  {
    codigo: "2933307",
    municipio: "Vitória da Conquista",
    estado_codigo: "29",
  },
  {
    codigo: "4323754",
    municipio: "Vitória das Missões",
    estado_codigo: "43",
  },
  {
    codigo: "2616407",
    municipio: "Vitória de Santo Antão",
    estado_codigo: "26",
  },
  {
    codigo: "1600808",
    municipio: "Vitória do Jari",
    estado_codigo: "16",
  },
  {
    codigo: "2112902",
    municipio: "Vitória do Mearim",
    estado_codigo: "21",
  },
  {
    codigo: "1508357",
    municipio: "Vitória do Xingu",
    estado_codigo: "15",
  },
  {
    codigo: "4128708",
    municipio: "Vitorino",
    estado_codigo: "41",
  },
  {
    codigo: "2113009",
    municipio: "Vitorino Freire",
    estado_codigo: "21",
  },
  {
    codigo: "4219358",
    municipio: "Vitor Meireles",
    estado_codigo: "42",
  },
  {
    codigo: "3172103",
    municipio: "Volta Grande",
    estado_codigo: "31",
  },
  {
    codigo: "3306305",
    municipio: "Volta Redonda",
    estado_codigo: "33",
  },
  {
    codigo: "3557006",
    municipio: "Votorantim",
    estado_codigo: "35",
  },
  {
    codigo: "3557105",
    municipio: "Votuporanga",
    estado_codigo: "35",
  },
  {
    codigo: "2933406",
    municipio: "Wagner",
    estado_codigo: "29",
  },
  {
    codigo: "2211704",
    municipio: "Wall Ferraz",
    estado_codigo: "22",
  },
  {
    codigo: "1722081",
    municipio: "Wanderlândia",
    estado_codigo: "17",
  },
  {
    codigo: "2933455",
    municipio: "Wanderley",
    estado_codigo: "29",
  },
  {
    codigo: "3172202",
    municipio: "Wenceslau Braz",
    estado_codigo: "31",
  },
  {
    codigo: "4128500",
    municipio: "Wenceslau Braz",
    estado_codigo: "41",
  },
  {
    codigo: "2933505",
    municipio: "Wenceslau Guimarães",
    estado_codigo: "29",
  },
  {
    codigo: "4323770",
    municipio: "Westfalia",
    estado_codigo: "43",
  },
  {
    codigo: "4219408",
    municipio: "Witmarsum",
    estado_codigo: "42",
  },
  {
    codigo: "1722107",
    municipio: "Xambioá",
    estado_codigo: "17",
  },
  {
    codigo: "4128807",
    municipio: "Xambrê",
    estado_codigo: "41",
  },
  {
    codigo: "4323804",
    municipio: "Xangri-lá",
    estado_codigo: "43",
  },
  {
    codigo: "4219507",
    municipio: "Xanxerê",
    estado_codigo: "42",
  },
  {
    codigo: "1200708",
    municipio: "Xapuri",
    estado_codigo: "12",
  },
  {
    codigo: "4219606",
    municipio: "Xavantina",
    estado_codigo: "42",
  },
  {
    codigo: "4219705",
    municipio: "Xaxim",
    estado_codigo: "42",
  },
  {
    codigo: "2616506",
    municipio: "Xexéu",
    estado_codigo: "26",
  },
  {
    codigo: "1508407",
    municipio: "Xinguara",
    estado_codigo: "15",
  },
  {
    codigo: "2933604",
    municipio: "Xique-Xique",
    estado_codigo: "29",
  },
  {
    codigo: "2517407",
    municipio: "Zabelê",
    estado_codigo: "25",
  },
  {
    codigo: "3557154",
    municipio: "Zacarias",
    estado_codigo: "35",
  },
  {
    codigo: "2114007",
    municipio: "Zé Doca",
    estado_codigo: "21",
  },
  {
    codigo: "4219853",
    municipio: "Zortéa",
    estado_codigo: "42",
  },
];
